// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../node_modules/animate.css/animate.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../custom_styles.css");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../node_modules/bootstrap/fonts/glyphicons-halflings-regular.eot");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../node_modules/bootstrap/fonts/glyphicons-halflings-regular.woff2");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../../node_modules/bootstrap/fonts/glyphicons-halflings-regular.woff");
var ___CSS_LOADER_URL_IMPORT_3___ = require("../../node_modules/bootstrap/fonts/glyphicons-halflings-regular.ttf");
var ___CSS_LOADER_URL_IMPORT_4___ = require("../../node_modules/bootstrap/fonts/glyphicons-halflings-regular.svg");
var ___CSS_LOADER_URL_IMPORT_5___ = require("../../node_modules/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0");
var ___CSS_LOADER_URL_IMPORT_6___ = require("../../node_modules/font-awesome/fonts/fontawesome-webfont.eot");
var ___CSS_LOADER_URL_IMPORT_7___ = require("../../node_modules/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0");
var ___CSS_LOADER_URL_IMPORT_8___ = require("../../node_modules/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0");
var ___CSS_LOADER_URL_IMPORT_9___ = require("../../node_modules/font-awesome/fonts/fontawesome-webfont.ttf?v=4.7.0");
var ___CSS_LOADER_URL_IMPORT_10___ = require("../../node_modules/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0");
var ___CSS_LOADER_URL_IMPORT_11___ = require("./fonts/icomoon.eot?xckv5r");
var ___CSS_LOADER_URL_IMPORT_12___ = require("./fonts/icomoon.ttf?xckv5r");
var ___CSS_LOADER_URL_IMPORT_13___ = require("./fonts/icomoon.woff?xckv5r");
var ___CSS_LOADER_URL_IMPORT_14___ = require("./fonts/icomoon.svg?xckv5r");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#glyphicons_halflingsregular" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___, { hash: "?#iefix&v=4.7.0" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "#fontawesomeregular" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Bootstrap v3.4.1 (https://getbootstrap.com/)
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */
html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block;
}
audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
[hidden],
template {
  display: none;
}
a {
  background-color: transparent;
}
a:active,
a:hover {
  outline: 0;
}
abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
b,
strong {
  font-weight: bold;
}
dfn {
  font-style: italic;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
mark {
  background: #ff0;
  color: #000;
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sup {
  top: -0.5em;
}
sub {
  bottom: -0.25em;
}
img {
  border: 0;
}
svg:not(:root) {
  overflow: hidden;
}
figure {
  margin: 1em 40px;
}
hr {
  box-sizing: content-box;
  height: 0;
}
pre {
  overflow: auto;
}
code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}
button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}
button {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}
button[disabled],
html input[disabled] {
  cursor: default;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
input {
  line-height: normal;
}
input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
input[type="search"] {
  -webkit-appearance: textfield;
  box-sizing: content-box;
}
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}
legend {
  border: 0;
  padding: 0;
}
textarea {
  overflow: auto;
}
optgroup {
  font-weight: bold;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
td,
th {
  padding: 0;
}
/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */
@media print {
  *,
  *:before,
  *:after {
    color: #000 !important;
    text-shadow: none !important;
    background: transparent !important;
    box-shadow: none !important;
  }
  a,
  a:visited {
    text-decoration: underline;
  }
  a[href]:after {
    content: " (" attr(href) ")";
  }
  abbr[title]:after {
    content: " (" attr(title) ")";
  }
  a[href^="#"]:after,
  a[href^="javascript:"]:after {
    content: "";
  }
  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  img {
    max-width: 100% !important;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  .navbar {
    display: none;
  }
  .btn > .caret,
  .dropup > .btn > .caret {
    border-top-color: #000 !important;
  }
  .label {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #ddd !important;
  }
}
@font-face {
  font-family: "Glyphicons Halflings";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
}
.glyphicon {
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: "Glyphicons Halflings";
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.glyphicon-asterisk:before {
  content: "\\002a";
}
.glyphicon-plus:before {
  content: "\\002b";
}
.glyphicon-euro:before,
.glyphicon-eur:before {
  content: "\\20ac";
}
.glyphicon-minus:before {
  content: "\\2212";
}
.glyphicon-cloud:before {
  content: "\\2601";
}
.glyphicon-envelope:before {
  content: "\\2709";
}
.glyphicon-pencil:before {
  content: "\\270f";
}
.glyphicon-glass:before {
  content: "\\e001";
}
.glyphicon-music:before {
  content: "\\e002";
}
.glyphicon-search:before {
  content: "\\e003";
}
.glyphicon-heart:before {
  content: "\\e005";
}
.glyphicon-star:before {
  content: "\\e006";
}
.glyphicon-star-empty:before {
  content: "\\e007";
}
.glyphicon-user:before {
  content: "\\e008";
}
.glyphicon-film:before {
  content: "\\e009";
}
.glyphicon-th-large:before {
  content: "\\e010";
}
.glyphicon-th:before {
  content: "\\e011";
}
.glyphicon-th-list:before {
  content: "\\e012";
}
.glyphicon-ok:before {
  content: "\\e013";
}
.glyphicon-remove:before {
  content: "\\e014";
}
.glyphicon-zoom-in:before {
  content: "\\e015";
}
.glyphicon-zoom-out:before {
  content: "\\e016";
}
.glyphicon-off:before {
  content: "\\e017";
}
.glyphicon-signal:before {
  content: "\\e018";
}
.glyphicon-cog:before {
  content: "\\e019";
}
.glyphicon-trash:before {
  content: "\\e020";
}
.glyphicon-home:before {
  content: "\\e021";
}
.glyphicon-file:before {
  content: "\\e022";
}
.glyphicon-time:before {
  content: "\\e023";
}
.glyphicon-road:before {
  content: "\\e024";
}
.glyphicon-download-alt:before {
  content: "\\e025";
}
.glyphicon-download:before {
  content: "\\e026";
}
.glyphicon-upload:before {
  content: "\\e027";
}
.glyphicon-inbox:before {
  content: "\\e028";
}
.glyphicon-play-circle:before {
  content: "\\e029";
}
.glyphicon-repeat:before {
  content: "\\e030";
}
.glyphicon-refresh:before {
  content: "\\e031";
}
.glyphicon-list-alt:before {
  content: "\\e032";
}
.glyphicon-lock:before {
  content: "\\e033";
}
.glyphicon-flag:before {
  content: "\\e034";
}
.glyphicon-headphones:before {
  content: "\\e035";
}
.glyphicon-volume-off:before {
  content: "\\e036";
}
.glyphicon-volume-down:before {
  content: "\\e037";
}
.glyphicon-volume-up:before {
  content: "\\e038";
}
.glyphicon-qrcode:before {
  content: "\\e039";
}
.glyphicon-barcode:before {
  content: "\\e040";
}
.glyphicon-tag:before {
  content: "\\e041";
}
.glyphicon-tags:before {
  content: "\\e042";
}
.glyphicon-book:before {
  content: "\\e043";
}
.glyphicon-bookmark:before {
  content: "\\e044";
}
.glyphicon-print:before {
  content: "\\e045";
}
.glyphicon-camera:before {
  content: "\\e046";
}
.glyphicon-font:before {
  content: "\\e047";
}
.glyphicon-bold:before {
  content: "\\e048";
}
.glyphicon-italic:before {
  content: "\\e049";
}
.glyphicon-text-height:before {
  content: "\\e050";
}
.glyphicon-text-width:before {
  content: "\\e051";
}
.glyphicon-align-left:before {
  content: "\\e052";
}
.glyphicon-align-center:before {
  content: "\\e053";
}
.glyphicon-align-right:before {
  content: "\\e054";
}
.glyphicon-align-justify:before {
  content: "\\e055";
}
.glyphicon-list:before {
  content: "\\e056";
}
.glyphicon-indent-left:before {
  content: "\\e057";
}
.glyphicon-indent-right:before {
  content: "\\e058";
}
.glyphicon-facetime-video:before {
  content: "\\e059";
}
.glyphicon-picture:before {
  content: "\\e060";
}
.glyphicon-map-marker:before {
  content: "\\e062";
}
.glyphicon-adjust:before {
  content: "\\e063";
}
.glyphicon-tint:before {
  content: "\\e064";
}
.glyphicon-edit:before {
  content: "\\e065";
}
.glyphicon-share:before {
  content: "\\e066";
}
.glyphicon-check:before {
  content: "\\e067";
}
.glyphicon-move:before {
  content: "\\e068";
}
.glyphicon-step-backward:before {
  content: "\\e069";
}
.glyphicon-fast-backward:before {
  content: "\\e070";
}
.glyphicon-backward:before {
  content: "\\e071";
}
.glyphicon-play:before {
  content: "\\e072";
}
.glyphicon-pause:before {
  content: "\\e073";
}
.glyphicon-stop:before {
  content: "\\e074";
}
.glyphicon-forward:before {
  content: "\\e075";
}
.glyphicon-fast-forward:before {
  content: "\\e076";
}
.glyphicon-step-forward:before {
  content: "\\e077";
}
.glyphicon-eject:before {
  content: "\\e078";
}
.glyphicon-chevron-left:before {
  content: "\\e079";
}
.glyphicon-chevron-right:before {
  content: "\\e080";
}
.glyphicon-plus-sign:before {
  content: "\\e081";
}
.glyphicon-minus-sign:before {
  content: "\\e082";
}
.glyphicon-remove-sign:before {
  content: "\\e083";
}
.glyphicon-ok-sign:before {
  content: "\\e084";
}
.glyphicon-question-sign:before {
  content: "\\e085";
}
.glyphicon-info-sign:before {
  content: "\\e086";
}
.glyphicon-screenshot:before {
  content: "\\e087";
}
.glyphicon-remove-circle:before {
  content: "\\e088";
}
.glyphicon-ok-circle:before {
  content: "\\e089";
}
.glyphicon-ban-circle:before {
  content: "\\e090";
}
.glyphicon-arrow-left:before {
  content: "\\e091";
}
.glyphicon-arrow-right:before {
  content: "\\e092";
}
.glyphicon-arrow-up:before {
  content: "\\e093";
}
.glyphicon-arrow-down:before {
  content: "\\e094";
}
.glyphicon-share-alt:before {
  content: "\\e095";
}
.glyphicon-resize-full:before {
  content: "\\e096";
}
.glyphicon-resize-small:before {
  content: "\\e097";
}
.glyphicon-exclamation-sign:before {
  content: "\\e101";
}
.glyphicon-gift:before {
  content: "\\e102";
}
.glyphicon-leaf:before {
  content: "\\e103";
}
.glyphicon-fire:before {
  content: "\\e104";
}
.glyphicon-eye-open:before {
  content: "\\e105";
}
.glyphicon-eye-close:before {
  content: "\\e106";
}
.glyphicon-warning-sign:before {
  content: "\\e107";
}
.glyphicon-plane:before {
  content: "\\e108";
}
.glyphicon-calendar:before {
  content: "\\e109";
}
.glyphicon-random:before {
  content: "\\e110";
}
.glyphicon-comment:before {
  content: "\\e111";
}
.glyphicon-magnet:before {
  content: "\\e112";
}
.glyphicon-chevron-up:before {
  content: "\\e113";
}
.glyphicon-chevron-down:before {
  content: "\\e114";
}
.glyphicon-retweet:before {
  content: "\\e115";
}
.glyphicon-shopping-cart:before {
  content: "\\e116";
}
.glyphicon-folder-close:before {
  content: "\\e117";
}
.glyphicon-folder-open:before {
  content: "\\e118";
}
.glyphicon-resize-vertical:before {
  content: "\\e119";
}
.glyphicon-resize-horizontal:before {
  content: "\\e120";
}
.glyphicon-hdd:before {
  content: "\\e121";
}
.glyphicon-bullhorn:before {
  content: "\\e122";
}
.glyphicon-bell:before {
  content: "\\e123";
}
.glyphicon-certificate:before {
  content: "\\e124";
}
.glyphicon-thumbs-up:before {
  content: "\\e125";
}
.glyphicon-thumbs-down:before {
  content: "\\e126";
}
.glyphicon-hand-right:before {
  content: "\\e127";
}
.glyphicon-hand-left:before {
  content: "\\e128";
}
.glyphicon-hand-up:before {
  content: "\\e129";
}
.glyphicon-hand-down:before {
  content: "\\e130";
}
.glyphicon-circle-arrow-right:before {
  content: "\\e131";
}
.glyphicon-circle-arrow-left:before {
  content: "\\e132";
}
.glyphicon-circle-arrow-up:before {
  content: "\\e133";
}
.glyphicon-circle-arrow-down:before {
  content: "\\e134";
}
.glyphicon-globe:before {
  content: "\\e135";
}
.glyphicon-wrench:before {
  content: "\\e136";
}
.glyphicon-tasks:before {
  content: "\\e137";
}
.glyphicon-filter:before {
  content: "\\e138";
}
.glyphicon-briefcase:before {
  content: "\\e139";
}
.glyphicon-fullscreen:before {
  content: "\\e140";
}
.glyphicon-dashboard:before {
  content: "\\e141";
}
.glyphicon-paperclip:before {
  content: "\\e142";
}
.glyphicon-heart-empty:before {
  content: "\\e143";
}
.glyphicon-link:before {
  content: "\\e144";
}
.glyphicon-phone:before {
  content: "\\e145";
}
.glyphicon-pushpin:before {
  content: "\\e146";
}
.glyphicon-usd:before {
  content: "\\e148";
}
.glyphicon-gbp:before {
  content: "\\e149";
}
.glyphicon-sort:before {
  content: "\\e150";
}
.glyphicon-sort-by-alphabet:before {
  content: "\\e151";
}
.glyphicon-sort-by-alphabet-alt:before {
  content: "\\e152";
}
.glyphicon-sort-by-order:before {
  content: "\\e153";
}
.glyphicon-sort-by-order-alt:before {
  content: "\\e154";
}
.glyphicon-sort-by-attributes:before {
  content: "\\e155";
}
.glyphicon-sort-by-attributes-alt:before {
  content: "\\e156";
}
.glyphicon-unchecked:before {
  content: "\\e157";
}
.glyphicon-expand:before {
  content: "\\e158";
}
.glyphicon-collapse-down:before {
  content: "\\e159";
}
.glyphicon-collapse-up:before {
  content: "\\e160";
}
.glyphicon-log-in:before {
  content: "\\e161";
}
.glyphicon-flash:before {
  content: "\\e162";
}
.glyphicon-log-out:before {
  content: "\\e163";
}
.glyphicon-new-window:before {
  content: "\\e164";
}
.glyphicon-record:before {
  content: "\\e165";
}
.glyphicon-save:before {
  content: "\\e166";
}
.glyphicon-open:before {
  content: "\\e167";
}
.glyphicon-saved:before {
  content: "\\e168";
}
.glyphicon-import:before {
  content: "\\e169";
}
.glyphicon-export:before {
  content: "\\e170";
}
.glyphicon-send:before {
  content: "\\e171";
}
.glyphicon-floppy-disk:before {
  content: "\\e172";
}
.glyphicon-floppy-saved:before {
  content: "\\e173";
}
.glyphicon-floppy-remove:before {
  content: "\\e174";
}
.glyphicon-floppy-save:before {
  content: "\\e175";
}
.glyphicon-floppy-open:before {
  content: "\\e176";
}
.glyphicon-credit-card:before {
  content: "\\e177";
}
.glyphicon-transfer:before {
  content: "\\e178";
}
.glyphicon-cutlery:before {
  content: "\\e179";
}
.glyphicon-header:before {
  content: "\\e180";
}
.glyphicon-compressed:before {
  content: "\\e181";
}
.glyphicon-earphone:before {
  content: "\\e182";
}
.glyphicon-phone-alt:before {
  content: "\\e183";
}
.glyphicon-tower:before {
  content: "\\e184";
}
.glyphicon-stats:before {
  content: "\\e185";
}
.glyphicon-sd-video:before {
  content: "\\e186";
}
.glyphicon-hd-video:before {
  content: "\\e187";
}
.glyphicon-subtitles:before {
  content: "\\e188";
}
.glyphicon-sound-stereo:before {
  content: "\\e189";
}
.glyphicon-sound-dolby:before {
  content: "\\e190";
}
.glyphicon-sound-5-1:before {
  content: "\\e191";
}
.glyphicon-sound-6-1:before {
  content: "\\e192";
}
.glyphicon-sound-7-1:before {
  content: "\\e193";
}
.glyphicon-copyright-mark:before {
  content: "\\e194";
}
.glyphicon-registration-mark:before {
  content: "\\e195";
}
.glyphicon-cloud-download:before {
  content: "\\e197";
}
.glyphicon-cloud-upload:before {
  content: "\\e198";
}
.glyphicon-tree-conifer:before {
  content: "\\e199";
}
.glyphicon-tree-deciduous:before {
  content: "\\e200";
}
.glyphicon-cd:before {
  content: "\\e201";
}
.glyphicon-save-file:before {
  content: "\\e202";
}
.glyphicon-open-file:before {
  content: "\\e203";
}
.glyphicon-level-up:before {
  content: "\\e204";
}
.glyphicon-copy:before {
  content: "\\e205";
}
.glyphicon-paste:before {
  content: "\\e206";
}
.glyphicon-alert:before {
  content: "\\e209";
}
.glyphicon-equalizer:before {
  content: "\\e210";
}
.glyphicon-king:before {
  content: "\\e211";
}
.glyphicon-queen:before {
  content: "\\e212";
}
.glyphicon-pawn:before {
  content: "\\e213";
}
.glyphicon-bishop:before {
  content: "\\e214";
}
.glyphicon-knight:before {
  content: "\\e215";
}
.glyphicon-baby-formula:before {
  content: "\\e216";
}
.glyphicon-tent:before {
  content: "\\26fa";
}
.glyphicon-blackboard:before {
  content: "\\e218";
}
.glyphicon-bed:before {
  content: "\\e219";
}
.glyphicon-apple:before {
  content: "\\f8ff";
}
.glyphicon-erase:before {
  content: "\\e221";
}
.glyphicon-hourglass:before {
  content: "\\231b";
}
.glyphicon-lamp:before {
  content: "\\e223";
}
.glyphicon-duplicate:before {
  content: "\\e224";
}
.glyphicon-piggy-bank:before {
  content: "\\e225";
}
.glyphicon-scissors:before {
  content: "\\e226";
}
.glyphicon-bitcoin:before {
  content: "\\e227";
}
.glyphicon-btc:before {
  content: "\\e227";
}
.glyphicon-xbt:before {
  content: "\\e227";
}
.glyphicon-yen:before {
  content: "\\00a5";
}
.glyphicon-jpy:before {
  content: "\\00a5";
}
.glyphicon-ruble:before {
  content: "\\20bd";
}
.glyphicon-rub:before {
  content: "\\20bd";
}
.glyphicon-scale:before {
  content: "\\e230";
}
.glyphicon-ice-lolly:before {
  content: "\\e231";
}
.glyphicon-ice-lolly-tasted:before {
  content: "\\e232";
}
.glyphicon-education:before {
  content: "\\e233";
}
.glyphicon-option-horizontal:before {
  content: "\\e234";
}
.glyphicon-option-vertical:before {
  content: "\\e235";
}
.glyphicon-menu-hamburger:before {
  content: "\\e236";
}
.glyphicon-modal-window:before {
  content: "\\e237";
}
.glyphicon-oil:before {
  content: "\\e238";
}
.glyphicon-grain:before {
  content: "\\e239";
}
.glyphicon-sunglasses:before {
  content: "\\e240";
}
.glyphicon-text-size:before {
  content: "\\e241";
}
.glyphicon-text-color:before {
  content: "\\e242";
}
.glyphicon-text-background:before {
  content: "\\e243";
}
.glyphicon-object-align-top:before {
  content: "\\e244";
}
.glyphicon-object-align-bottom:before {
  content: "\\e245";
}
.glyphicon-object-align-horizontal:before {
  content: "\\e246";
}
.glyphicon-object-align-left:before {
  content: "\\e247";
}
.glyphicon-object-align-vertical:before {
  content: "\\e248";
}
.glyphicon-object-align-right:before {
  content: "\\e249";
}
.glyphicon-triangle-right:before {
  content: "\\e250";
}
.glyphicon-triangle-left:before {
  content: "\\e251";
}
.glyphicon-triangle-bottom:before {
  content: "\\e252";
}
.glyphicon-triangle-top:before {
  content: "\\e253";
}
.glyphicon-console:before {
  content: "\\e254";
}
.glyphicon-superscript:before {
  content: "\\e255";
}
.glyphicon-subscript:before {
  content: "\\e256";
}
.glyphicon-menu-left:before {
  content: "\\e257";
}
.glyphicon-menu-right:before {
  content: "\\e258";
}
.glyphicon-menu-down:before {
  content: "\\e259";
}
.glyphicon-menu-up:before {
  content: "\\e260";
}
* {
  box-sizing: border-box;
}
*:before,
*:after {
  box-sizing: border-box;
}
html {
  font-size: 10px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: #1e293b;
  background-color: #eeeeee;
}
input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
a {
  color: #337ab7;
  text-decoration: none;
}
a:hover,
a:focus {
  color: #23527c;
  text-decoration: underline;
}
a:focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
figure {
  margin: 0;
}
img {
  vertical-align: middle;
}
.img-responsive,
.thumbnail > img,
.thumbnail a > img,
.carousel-inner > .item > img,
.carousel-inner > .item > a > img {
  display: block;
  max-width: 100%;
  height: auto;
}
.img-rounded {
  border-radius: 6px;
}
.img-thumbnail {
  padding: 4px;
  line-height: 1.42857143;
  background-color: #eeeeee;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: inline-block;
  max-width: 100%;
  height: auto;
}
.img-circle {
  border-radius: 50%;
}
hr {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #eeeeee;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}
[role="button"] {
  cursor: pointer;
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}
h1 small,
h2 small,
h3 small,
h4 small,
h5 small,
h6 small,
.h1 small,
.h2 small,
.h3 small,
.h4 small,
.h5 small,
.h6 small,
h1 .small,
h2 .small,
h3 .small,
h4 .small,
h5 .small,
h6 .small,
.h1 .small,
.h2 .small,
.h3 .small,
.h4 .small,
.h5 .small,
.h6 .small {
  font-weight: 400;
  line-height: 1;
  color: #777777;
}
h1,
.h1,
h2,
.h2,
h3,
.h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}
h1 small,
.h1 small,
h2 small,
.h2 small,
h3 small,
.h3 small,
h1 .small,
.h1 .small,
h2 .small,
.h2 .small,
h3 .small,
.h3 .small {
  font-size: 65%;
}
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 10px;
  margin-bottom: 10px;
}
h4 small,
.h4 small,
h5 small,
.h5 small,
h6 small,
.h6 small,
h4 .small,
.h4 .small,
h5 .small,
.h5 .small,
h6 .small,
.h6 .small {
  font-size: 75%;
}
h1,
.h1 {
  font-size: 36px;
}
h2,
.h2 {
  font-size: 30px;
}
h3,
.h3 {
  font-size: 24px;
}
h4,
.h4 {
  font-size: 18px;
}
h5,
.h5 {
  font-size: 14px;
}
h6,
.h6 {
  font-size: 12px;
}
p {
  margin: 0 0 10px;
}
.lead {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.4;
}
@media (min-width: 768px) {
  .lead {
    font-size: 21px;
  }
}
small,
.small {
  font-size: 85%;
}
mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.text-justify {
  text-align: justify;
}
.text-nowrap {
  white-space: nowrap;
}
.text-lowercase {
  text-transform: lowercase;
}
.text-uppercase {
  text-transform: uppercase;
}
.text-capitalize {
  text-transform: capitalize;
}
.text-muted {
  color: #777777;
}
.text-primary {
  color: #337ab7;
}
a.text-primary:hover,
a.text-primary:focus {
  color: #286090;
}
.text-success {
  color: #3c763d;
}
a.text-success:hover,
a.text-success:focus {
  color: #2b542c;
}
.text-info {
  color: #31708f;
}
a.text-info:hover,
a.text-info:focus {
  color: #245269;
}
.text-warning {
  color: #8a6d3b;
}
a.text-warning:hover,
a.text-warning:focus {
  color: #66512c;
}
.text-danger {
  color: #a94442;
}
a.text-danger:hover,
a.text-danger:focus {
  color: #843534;
}
.bg-primary {
  color: #fff;
  background-color: #337ab7;
}
a.bg-primary:hover,
a.bg-primary:focus {
  background-color: #286090;
}
.bg-success {
  background-color: #dff0d8;
}
a.bg-success:hover,
a.bg-success:focus {
  background-color: #c1e2b3;
}
.bg-info {
  background-color: #d9edf7;
}
a.bg-info:hover,
a.bg-info:focus {
  background-color: #afd9ee;
}
.bg-warning {
  background-color: #fcf8e3;
}
a.bg-warning:hover,
a.bg-warning:focus {
  background-color: #f7ecb5;
}
.bg-danger {
  background-color: #f2dede;
}
a.bg-danger:hover,
a.bg-danger:focus {
  background-color: #e4b9b9;
}
.page-header {
  padding-bottom: 9px;
  margin: 40px 0 20px;
  border-bottom: 1px solid #eeeeee;
}
ul,
ol {
  margin-top: 0;
  margin-bottom: 10px;
}
ul ul,
ol ul,
ul ol,
ol ol {
  margin-bottom: 0;
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}
.list-inline {
  padding-left: 0;
  list-style: none;
  margin-left: -5px;
}
.list-inline > li {
  display: inline-block;
  padding-right: 5px;
  padding-left: 5px;
}
dl {
  margin-top: 0;
  margin-bottom: 20px;
}
dt,
dd {
  line-height: 1.42857143;
}
dt {
  font-weight: 700;
}
dd {
  margin-left: 0;
}
@media (min-width: 768px) {
  .dl-horizontal dt {
    float: left;
    width: 160px;
    clear: left;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .dl-horizontal dd {
    margin-left: 180px;
  }
}
abbr[title],
abbr[data-original-title] {
  cursor: help;
}
.initialism {
  font-size: 90%;
  text-transform: uppercase;
}
blockquote {
  padding: 10px 20px;
  margin: 0 0 20px;
  font-size: 17.5px;
  border-left: 5px solid #eeeeee;
}
blockquote p:last-child,
blockquote ul:last-child,
blockquote ol:last-child {
  margin-bottom: 0;
}
blockquote footer,
blockquote small,
blockquote .small {
  display: block;
  font-size: 80%;
  line-height: 1.42857143;
  color: #777777;
}
blockquote footer:before,
blockquote small:before,
blockquote .small:before {
  content: "\\2014 \\00A0";
}
.blockquote-reverse,
blockquote.pull-right {
  padding-right: 15px;
  padding-left: 0;
  text-align: right;
  border-right: 5px solid #eeeeee;
  border-left: 0;
}
.blockquote-reverse footer:before,
blockquote.pull-right footer:before,
.blockquote-reverse small:before,
blockquote.pull-right small:before,
.blockquote-reverse .small:before,
blockquote.pull-right .small:before {
  content: "";
}
.blockquote-reverse footer:after,
blockquote.pull-right footer:after,
.blockquote-reverse small:after,
blockquote.pull-right small:after,
.blockquote-reverse .small:after,
blockquote.pull-right .small:after {
  content: "\\00A0 \\2014";
}
address {
  margin-bottom: 20px;
  font-style: normal;
  line-height: 1.42857143;
}
code,
kbd,
pre,
samp {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
}
code {
  padding: 2px 4px;
  font-size: 90%;
  color: #c7254e;
  background-color: #f9f2f4;
  border-radius: 4px;
}
kbd {
  padding: 2px 4px;
  font-size: 90%;
  color: #fff;
  background-color: #333;
  border-radius: 3px;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.25);
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
  box-shadow: none;
}
pre {
  display: block;
  padding: 9.5px;
  margin: 0 0 10px;
  font-size: 13px;
  line-height: 1.42857143;
  color: #333333;
  word-break: break-all;
  word-wrap: break-word;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
}
pre code {
  padding: 0;
  font-size: inherit;
  color: inherit;
  white-space: pre-wrap;
  background-color: transparent;
  border-radius: 0;
}
.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}
.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}
.container-fluid {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.row {
  margin-right: -15px;
  margin-left: -15px;
}
.row-no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.row-no-gutters [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}
.col-xs-1,
.col-sm-1,
.col-md-1,
.col-lg-1,
.col-xs-2,
.col-sm-2,
.col-md-2,
.col-lg-2,
.col-xs-3,
.col-sm-3,
.col-md-3,
.col-lg-3,
.col-xs-4,
.col-sm-4,
.col-md-4,
.col-lg-4,
.col-xs-5,
.col-sm-5,
.col-md-5,
.col-lg-5,
.col-xs-6,
.col-sm-6,
.col-md-6,
.col-lg-6,
.col-xs-7,
.col-sm-7,
.col-md-7,
.col-lg-7,
.col-xs-8,
.col-sm-8,
.col-md-8,
.col-lg-8,
.col-xs-9,
.col-sm-9,
.col-md-9,
.col-lg-9,
.col-xs-10,
.col-sm-10,
.col-md-10,
.col-lg-10,
.col-xs-11,
.col-sm-11,
.col-md-11,
.col-lg-11,
.col-xs-12,
.col-sm-12,
.col-md-12,
.col-lg-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
}
.col-xs-12 {
  width: 100%;
}
.col-xs-11 {
  width: 91.66666667%;
}
.col-xs-10 {
  width: 83.33333333%;
}
.col-xs-9 {
  width: 75%;
}
.col-xs-8 {
  width: 66.66666667%;
}
.col-xs-7 {
  width: 58.33333333%;
}
.col-xs-6 {
  width: 50%;
}
.col-xs-5 {
  width: 41.66666667%;
}
.col-xs-4 {
  width: 33.33333333%;
}
.col-xs-3 {
  width: 25%;
}
.col-xs-2 {
  width: 16.66666667%;
}
.col-xs-1 {
  width: 8.33333333%;
}
.col-xs-pull-12 {
  right: 100%;
}
.col-xs-pull-11 {
  right: 91.66666667%;
}
.col-xs-pull-10 {
  right: 83.33333333%;
}
.col-xs-pull-9 {
  right: 75%;
}
.col-xs-pull-8 {
  right: 66.66666667%;
}
.col-xs-pull-7 {
  right: 58.33333333%;
}
.col-xs-pull-6 {
  right: 50%;
}
.col-xs-pull-5 {
  right: 41.66666667%;
}
.col-xs-pull-4 {
  right: 33.33333333%;
}
.col-xs-pull-3 {
  right: 25%;
}
.col-xs-pull-2 {
  right: 16.66666667%;
}
.col-xs-pull-1 {
  right: 8.33333333%;
}
.col-xs-pull-0 {
  right: auto;
}
.col-xs-push-12 {
  left: 100%;
}
.col-xs-push-11 {
  left: 91.66666667%;
}
.col-xs-push-10 {
  left: 83.33333333%;
}
.col-xs-push-9 {
  left: 75%;
}
.col-xs-push-8 {
  left: 66.66666667%;
}
.col-xs-push-7 {
  left: 58.33333333%;
}
.col-xs-push-6 {
  left: 50%;
}
.col-xs-push-5 {
  left: 41.66666667%;
}
.col-xs-push-4 {
  left: 33.33333333%;
}
.col-xs-push-3 {
  left: 25%;
}
.col-xs-push-2 {
  left: 16.66666667%;
}
.col-xs-push-1 {
  left: 8.33333333%;
}
.col-xs-push-0 {
  left: auto;
}
.col-xs-offset-12 {
  margin-left: 100%;
}
.col-xs-offset-11 {
  margin-left: 91.66666667%;
}
.col-xs-offset-10 {
  margin-left: 83.33333333%;
}
.col-xs-offset-9 {
  margin-left: 75%;
}
.col-xs-offset-8 {
  margin-left: 66.66666667%;
}
.col-xs-offset-7 {
  margin-left: 58.33333333%;
}
.col-xs-offset-6 {
  margin-left: 50%;
}
.col-xs-offset-5 {
  margin-left: 41.66666667%;
}
.col-xs-offset-4 {
  margin-left: 33.33333333%;
}
.col-xs-offset-3 {
  margin-left: 25%;
}
.col-xs-offset-2 {
  margin-left: 16.66666667%;
}
.col-xs-offset-1 {
  margin-left: 8.33333333%;
}
.col-xs-offset-0 {
  margin-left: 0%;
}
@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-11 {
    width: 91.66666667%;
  }
  .col-sm-10 {
    width: 83.33333333%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-8 {
    width: 66.66666667%;
  }
  .col-sm-7 {
    width: 58.33333333%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-5 {
    width: 41.66666667%;
  }
  .col-sm-4 {
    width: 33.33333333%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-2 {
    width: 16.66666667%;
  }
  .col-sm-1 {
    width: 8.33333333%;
  }
  .col-sm-pull-12 {
    right: 100%;
  }
  .col-sm-pull-11 {
    right: 91.66666667%;
  }
  .col-sm-pull-10 {
    right: 83.33333333%;
  }
  .col-sm-pull-9 {
    right: 75%;
  }
  .col-sm-pull-8 {
    right: 66.66666667%;
  }
  .col-sm-pull-7 {
    right: 58.33333333%;
  }
  .col-sm-pull-6 {
    right: 50%;
  }
  .col-sm-pull-5 {
    right: 41.66666667%;
  }
  .col-sm-pull-4 {
    right: 33.33333333%;
  }
  .col-sm-pull-3 {
    right: 25%;
  }
  .col-sm-pull-2 {
    right: 16.66666667%;
  }
  .col-sm-pull-1 {
    right: 8.33333333%;
  }
  .col-sm-pull-0 {
    right: auto;
  }
  .col-sm-push-12 {
    left: 100%;
  }
  .col-sm-push-11 {
    left: 91.66666667%;
  }
  .col-sm-push-10 {
    left: 83.33333333%;
  }
  .col-sm-push-9 {
    left: 75%;
  }
  .col-sm-push-8 {
    left: 66.66666667%;
  }
  .col-sm-push-7 {
    left: 58.33333333%;
  }
  .col-sm-push-6 {
    left: 50%;
  }
  .col-sm-push-5 {
    left: 41.66666667%;
  }
  .col-sm-push-4 {
    left: 33.33333333%;
  }
  .col-sm-push-3 {
    left: 25%;
  }
  .col-sm-push-2 {
    left: 16.66666667%;
  }
  .col-sm-push-1 {
    left: 8.33333333%;
  }
  .col-sm-push-0 {
    left: auto;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66666667%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33333333%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66666667%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33333333%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66666667%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33333333%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66666667%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33333333%;
  }
  .col-sm-offset-0 {
    margin-left: 0%;
  }
}
@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-11 {
    width: 91.66666667%;
  }
  .col-md-10 {
    width: 83.33333333%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-8 {
    width: 66.66666667%;
  }
  .col-md-7 {
    width: 58.33333333%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-5 {
    width: 41.66666667%;
  }
  .col-md-4 {
    width: 33.33333333%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-2 {
    width: 16.66666667%;
  }
  .col-md-1 {
    width: 8.33333333%;
  }
  .col-md-pull-12 {
    right: 100%;
  }
  .col-md-pull-11 {
    right: 91.66666667%;
  }
  .col-md-pull-10 {
    right: 83.33333333%;
  }
  .col-md-pull-9 {
    right: 75%;
  }
  .col-md-pull-8 {
    right: 66.66666667%;
  }
  .col-md-pull-7 {
    right: 58.33333333%;
  }
  .col-md-pull-6 {
    right: 50%;
  }
  .col-md-pull-5 {
    right: 41.66666667%;
  }
  .col-md-pull-4 {
    right: 33.33333333%;
  }
  .col-md-pull-3 {
    right: 25%;
  }
  .col-md-pull-2 {
    right: 16.66666667%;
  }
  .col-md-pull-1 {
    right: 8.33333333%;
  }
  .col-md-pull-0 {
    right: auto;
  }
  .col-md-push-12 {
    left: 100%;
  }
  .col-md-push-11 {
    left: 91.66666667%;
  }
  .col-md-push-10 {
    left: 83.33333333%;
  }
  .col-md-push-9 {
    left: 75%;
  }
  .col-md-push-8 {
    left: 66.66666667%;
  }
  .col-md-push-7 {
    left: 58.33333333%;
  }
  .col-md-push-6 {
    left: 50%;
  }
  .col-md-push-5 {
    left: 41.66666667%;
  }
  .col-md-push-4 {
    left: 33.33333333%;
  }
  .col-md-push-3 {
    left: 25%;
  }
  .col-md-push-2 {
    left: 16.66666667%;
  }
  .col-md-push-1 {
    left: 8.33333333%;
  }
  .col-md-push-0 {
    left: auto;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
  .col-md-offset-11 {
    margin-left: 91.66666667%;
  }
  .col-md-offset-10 {
    margin-left: 83.33333333%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-8 {
    margin-left: 66.66666667%;
  }
  .col-md-offset-7 {
    margin-left: 58.33333333%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-5 {
    margin-left: 41.66666667%;
  }
  .col-md-offset-4 {
    margin-left: 33.33333333%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-2 {
    margin-left: 16.66666667%;
  }
  .col-md-offset-1 {
    margin-left: 8.33333333%;
  }
  .col-md-offset-0 {
    margin-left: 0%;
  }
}
@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
  }
  .col-lg-12 {
    width: 100%;
  }
  .col-lg-11 {
    width: 91.66666667%;
  }
  .col-lg-10 {
    width: 83.33333333%;
  }
  .col-lg-9 {
    width: 75%;
  }
  .col-lg-8 {
    width: 66.66666667%;
  }
  .col-lg-7 {
    width: 58.33333333%;
  }
  .col-lg-6 {
    width: 50%;
  }
  .col-lg-5 {
    width: 41.66666667%;
  }
  .col-lg-4 {
    width: 33.33333333%;
  }
  .col-lg-3 {
    width: 25%;
  }
  .col-lg-2 {
    width: 16.66666667%;
  }
  .col-lg-1 {
    width: 8.33333333%;
  }
  .col-lg-pull-12 {
    right: 100%;
  }
  .col-lg-pull-11 {
    right: 91.66666667%;
  }
  .col-lg-pull-10 {
    right: 83.33333333%;
  }
  .col-lg-pull-9 {
    right: 75%;
  }
  .col-lg-pull-8 {
    right: 66.66666667%;
  }
  .col-lg-pull-7 {
    right: 58.33333333%;
  }
  .col-lg-pull-6 {
    right: 50%;
  }
  .col-lg-pull-5 {
    right: 41.66666667%;
  }
  .col-lg-pull-4 {
    right: 33.33333333%;
  }
  .col-lg-pull-3 {
    right: 25%;
  }
  .col-lg-pull-2 {
    right: 16.66666667%;
  }
  .col-lg-pull-1 {
    right: 8.33333333%;
  }
  .col-lg-pull-0 {
    right: auto;
  }
  .col-lg-push-12 {
    left: 100%;
  }
  .col-lg-push-11 {
    left: 91.66666667%;
  }
  .col-lg-push-10 {
    left: 83.33333333%;
  }
  .col-lg-push-9 {
    left: 75%;
  }
  .col-lg-push-8 {
    left: 66.66666667%;
  }
  .col-lg-push-7 {
    left: 58.33333333%;
  }
  .col-lg-push-6 {
    left: 50%;
  }
  .col-lg-push-5 {
    left: 41.66666667%;
  }
  .col-lg-push-4 {
    left: 33.33333333%;
  }
  .col-lg-push-3 {
    left: 25%;
  }
  .col-lg-push-2 {
    left: 16.66666667%;
  }
  .col-lg-push-1 {
    left: 8.33333333%;
  }
  .col-lg-push-0 {
    left: auto;
  }
  .col-lg-offset-12 {
    margin-left: 100%;
  }
  .col-lg-offset-11 {
    margin-left: 91.66666667%;
  }
  .col-lg-offset-10 {
    margin-left: 83.33333333%;
  }
  .col-lg-offset-9 {
    margin-left: 75%;
  }
  .col-lg-offset-8 {
    margin-left: 66.66666667%;
  }
  .col-lg-offset-7 {
    margin-left: 58.33333333%;
  }
  .col-lg-offset-6 {
    margin-left: 50%;
  }
  .col-lg-offset-5 {
    margin-left: 41.66666667%;
  }
  .col-lg-offset-4 {
    margin-left: 33.33333333%;
  }
  .col-lg-offset-3 {
    margin-left: 25%;
  }
  .col-lg-offset-2 {
    margin-left: 16.66666667%;
  }
  .col-lg-offset-1 {
    margin-left: 8.33333333%;
  }
  .col-lg-offset-0 {
    margin-left: 0%;
  }
}
table {
  background-color: transparent;
}
table col[class*="col-"] {
  position: static;
  display: table-column;
  float: none;
}
table td[class*="col-"],
table th[class*="col-"] {
  position: static;
  display: table-cell;
  float: none;
}
caption {
  padding-top: 8px;
  padding-bottom: 8px;
  color: #777777;
  text-align: left;
}
th {
  text-align: left;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
}
.table > thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #ddd;
}
.table > caption + thead > tr:first-child > th,
.table > colgroup + thead > tr:first-child > th,
.table > thead:first-child > tr:first-child > th,
.table > caption + thead > tr:first-child > td,
.table > colgroup + thead > tr:first-child > td,
.table > thead:first-child > tr:first-child > td {
  border-top: 0;
}
.table > tbody + tbody {
  border-top: 2px solid #ddd;
}
.table .table {
  background-color: #eeeeee;
}
.table-condensed > thead > tr > th,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > tbody > tr > td,
.table-condensed > tfoot > tr > td {
  padding: 5px;
}
.table-bordered {
  border: 1px solid #ddd;
}
.table-bordered > thead > tr > th,
.table-bordered > tbody > tr > th,
.table-bordered > tfoot > tr > th,
.table-bordered > thead > tr > td,
.table-bordered > tbody > tr > td,
.table-bordered > tfoot > tr > td {
  border: 1px solid #ddd;
}
.table-bordered > thead > tr > th,
.table-bordered > thead > tr > td {
  border-bottom-width: 2px;
}
.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #f9f9f9;
}
.table-hover > tbody > tr:hover {
  background-color: #f5f5f5;
}
.table > thead > tr > td.active,
.table > tbody > tr > td.active,
.table > tfoot > tr > td.active,
.table > thead > tr > th.active,
.table > tbody > tr > th.active,
.table > tfoot > tr > th.active,
.table > thead > tr.active > td,
.table > tbody > tr.active > td,
.table > tfoot > tr.active > td,
.table > thead > tr.active > th,
.table > tbody > tr.active > th,
.table > tfoot > tr.active > th {
  background-color: #f5f5f5;
}
.table-hover > tbody > tr > td.active:hover,
.table-hover > tbody > tr > th.active:hover,
.table-hover > tbody > tr.active:hover > td,
.table-hover > tbody > tr:hover > .active,
.table-hover > tbody > tr.active:hover > th {
  background-color: #e8e8e8;
}
.table > thead > tr > td.success,
.table > tbody > tr > td.success,
.table > tfoot > tr > td.success,
.table > thead > tr > th.success,
.table > tbody > tr > th.success,
.table > tfoot > tr > th.success,
.table > thead > tr.success > td,
.table > tbody > tr.success > td,
.table > tfoot > tr.success > td,
.table > thead > tr.success > th,
.table > tbody > tr.success > th,
.table > tfoot > tr.success > th {
  background-color: #dff0d8;
}
.table-hover > tbody > tr > td.success:hover,
.table-hover > tbody > tr > th.success:hover,
.table-hover > tbody > tr.success:hover > td,
.table-hover > tbody > tr:hover > .success,
.table-hover > tbody > tr.success:hover > th {
  background-color: #d0e9c6;
}
.table > thead > tr > td.info,
.table > tbody > tr > td.info,
.table > tfoot > tr > td.info,
.table > thead > tr > th.info,
.table > tbody > tr > th.info,
.table > tfoot > tr > th.info,
.table > thead > tr.info > td,
.table > tbody > tr.info > td,
.table > tfoot > tr.info > td,
.table > thead > tr.info > th,
.table > tbody > tr.info > th,
.table > tfoot > tr.info > th {
  background-color: #d9edf7;
}
.table-hover > tbody > tr > td.info:hover,
.table-hover > tbody > tr > th.info:hover,
.table-hover > tbody > tr.info:hover > td,
.table-hover > tbody > tr:hover > .info,
.table-hover > tbody > tr.info:hover > th {
  background-color: #c4e3f3;
}
.table > thead > tr > td.warning,
.table > tbody > tr > td.warning,
.table > tfoot > tr > td.warning,
.table > thead > tr > th.warning,
.table > tbody > tr > th.warning,
.table > tfoot > tr > th.warning,
.table > thead > tr.warning > td,
.table > tbody > tr.warning > td,
.table > tfoot > tr.warning > td,
.table > thead > tr.warning > th,
.table > tbody > tr.warning > th,
.table > tfoot > tr.warning > th {
  background-color: #fcf8e3;
}
.table-hover > tbody > tr > td.warning:hover,
.table-hover > tbody > tr > th.warning:hover,
.table-hover > tbody > tr.warning:hover > td,
.table-hover > tbody > tr:hover > .warning,
.table-hover > tbody > tr.warning:hover > th {
  background-color: #faf2cc;
}
.table > thead > tr > td.danger,
.table > tbody > tr > td.danger,
.table > tfoot > tr > td.danger,
.table > thead > tr > th.danger,
.table > tbody > tr > th.danger,
.table > tfoot > tr > th.danger,
.table > thead > tr.danger > td,
.table > tbody > tr.danger > td,
.table > tfoot > tr.danger > td,
.table > thead > tr.danger > th,
.table > tbody > tr.danger > th,
.table > tfoot > tr.danger > th {
  background-color: #f2dede;
}
.table-hover > tbody > tr > td.danger:hover,
.table-hover > tbody > tr > th.danger:hover,
.table-hover > tbody > tr.danger:hover > td,
.table-hover > tbody > tr:hover > .danger,
.table-hover > tbody > tr.danger:hover > th {
  background-color: #ebcccc;
}
.table-responsive {
  min-height: 0.01%;
  overflow-x: auto;
}
@media screen and (max-width: 767px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    border: 1px solid #ddd;
  }
  .table-responsive > .table {
    margin-bottom: 0;
  }
  .table-responsive > .table > thead > tr > th,
  .table-responsive > .table > tbody > tr > th,
  .table-responsive > .table > tfoot > tr > th,
  .table-responsive > .table > thead > tr > td,
  .table-responsive > .table > tbody > tr > td,
  .table-responsive > .table > tfoot > tr > td {
    white-space: nowrap;
  }
  .table-responsive > .table-bordered {
    border: 0;
  }
  .table-responsive > .table-bordered > thead > tr > th:first-child,
  .table-responsive > .table-bordered > tbody > tr > th:first-child,
  .table-responsive > .table-bordered > tfoot > tr > th:first-child,
  .table-responsive > .table-bordered > thead > tr > td:first-child,
  .table-responsive > .table-bordered > tbody > tr > td:first-child,
  .table-responsive > .table-bordered > tfoot > tr > td:first-child {
    border-left: 0;
  }
  .table-responsive > .table-bordered > thead > tr > th:last-child,
  .table-responsive > .table-bordered > tbody > tr > th:last-child,
  .table-responsive > .table-bordered > tfoot > tr > th:last-child,
  .table-responsive > .table-bordered > thead > tr > td:last-child,
  .table-responsive > .table-bordered > tbody > tr > td:last-child,
  .table-responsive > .table-bordered > tfoot > tr > td:last-child {
    border-right: 0;
  }
  .table-responsive > .table-bordered > tbody > tr:last-child > th,
  .table-responsive > .table-bordered > tfoot > tr:last-child > th,
  .table-responsive > .table-bordered > tbody > tr:last-child > td,
  .table-responsive > .table-bordered > tfoot > tr:last-child > td {
    border-bottom: 0;
  }
}
fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  padding: 0;
  margin-bottom: 20px;
  font-size: 21px;
  line-height: inherit;
  color: #333333;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
}
label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
input[type="search"] {
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
       appearance: none;
}
input[type="radio"],
input[type="checkbox"] {
  margin: 4px 0 0;
  margin-top: 1px \\9;
  line-height: normal;
}
input[type="radio"][disabled],
input[type="checkbox"][disabled],
input[type="radio"].disabled,
input[type="checkbox"].disabled,
fieldset[disabled] input[type="radio"],
fieldset[disabled] input[type="checkbox"] {
  cursor: not-allowed;
}
input[type="file"] {
  display: block;
}
input[type="range"] {
  display: block;
  width: 100%;
}
select[multiple],
select[size] {
  height: auto;
}
input[type="file"]:focus,
input[type="radio"]:focus,
input[type="checkbox"]:focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
output {
  display: block;
  padding-top: 7px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555555;
}
.form-control {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
.form-control:focus {
  border-color: #66afe9;
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.form-control::-moz-placeholder {
  color: #999;
  opacity: 1;
}
.form-control:-ms-input-placeholder {
  color: #999;
}
.form-control::-webkit-input-placeholder {
  color: #999;
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control[disabled],
.form-control[readonly],
fieldset[disabled] .form-control {
  background-color: #eeeeee;
  opacity: 1;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  cursor: not-allowed;
}
textarea.form-control {
  height: auto;
}
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  input[type="date"].form-control,
  input[type="time"].form-control,
  input[type="datetime-local"].form-control,
  input[type="month"].form-control {
    line-height: 34px;
  }
  input[type="date"].input-sm,
  input[type="time"].input-sm,
  input[type="datetime-local"].input-sm,
  input[type="month"].input-sm,
  .input-group-sm input[type="date"],
  .input-group-sm input[type="time"],
  .input-group-sm input[type="datetime-local"],
  .input-group-sm input[type="month"] {
    line-height: 30px;
  }
  input[type="date"].input-lg,
  input[type="time"].input-lg,
  input[type="datetime-local"].input-lg,
  input[type="month"].input-lg,
  .input-group-lg input[type="date"],
  .input-group-lg input[type="time"],
  .input-group-lg input[type="datetime-local"],
  .input-group-lg input[type="month"] {
    line-height: 46px;
  }
}
.form-group {
  margin-bottom: 15px;
}
.radio,
.checkbox {
  position: relative;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}
.radio.disabled label,
.checkbox.disabled label,
fieldset[disabled] .radio label,
fieldset[disabled] .checkbox label {
  cursor: not-allowed;
}
.radio label,
.checkbox label {
  min-height: 20px;
  padding-left: 20px;
  margin-bottom: 0;
  font-weight: 400;
  cursor: pointer;
}
.radio input[type="radio"],
.radio-inline input[type="radio"],
.checkbox input[type="checkbox"],
.checkbox-inline input[type="checkbox"] {
  position: absolute;
  margin-top: 4px \\9;
  margin-left: -20px;
}
.radio + .radio,
.checkbox + .checkbox {
  margin-top: -5px;
}
.radio-inline,
.checkbox-inline {
  position: relative;
  display: inline-block;
  padding-left: 20px;
  margin-bottom: 0;
  font-weight: 400;
  vertical-align: middle;
  cursor: pointer;
}
.radio-inline.disabled,
.checkbox-inline.disabled,
fieldset[disabled] .radio-inline,
fieldset[disabled] .checkbox-inline {
  cursor: not-allowed;
}
.radio-inline + .radio-inline,
.checkbox-inline + .checkbox-inline {
  margin-top: 0;
  margin-left: 10px;
}
.form-control-static {
  min-height: 34px;
  padding-top: 7px;
  padding-bottom: 7px;
  margin-bottom: 0;
}
.form-control-static.input-lg,
.form-control-static.input-sm {
  padding-right: 0;
  padding-left: 0;
}
.input-sm {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}
select.input-sm {
  height: 30px;
  line-height: 30px;
}
textarea.input-sm,
select[multiple].input-sm {
  height: auto;
}
.form-group-sm .form-control {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}
.form-group-sm select.form-control {
  height: 30px;
  line-height: 30px;
}
.form-group-sm textarea.form-control,
.form-group-sm select[multiple].form-control {
  height: auto;
}
.form-group-sm .form-control-static {
  height: 30px;
  min-height: 32px;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.5;
}
.input-lg {
  height: 46px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.3333333;
  border-radius: 6px;
}
select.input-lg {
  height: 46px;
  line-height: 46px;
}
textarea.input-lg,
select[multiple].input-lg {
  height: auto;
}
.form-group-lg .form-control {
  height: 46px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.3333333;
  border-radius: 6px;
}
.form-group-lg select.form-control {
  height: 46px;
  line-height: 46px;
}
.form-group-lg textarea.form-control,
.form-group-lg select[multiple].form-control {
  height: auto;
}
.form-group-lg .form-control-static {
  height: 46px;
  min-height: 38px;
  padding: 11px 16px;
  font-size: 18px;
  line-height: 1.3333333;
}
.has-feedback {
  position: relative;
}
.has-feedback .form-control {
  padding-right: 42.5px;
}
.form-control-feedback {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  display: block;
  width: 34px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  pointer-events: none;
}
.input-lg + .form-control-feedback,
.input-group-lg + .form-control-feedback,
.form-group-lg .form-control + .form-control-feedback {
  width: 46px;
  height: 46px;
  line-height: 46px;
}
.input-sm + .form-control-feedback,
.input-group-sm + .form-control-feedback,
.form-group-sm .form-control + .form-control-feedback {
  width: 30px;
  height: 30px;
  line-height: 30px;
}
.has-success .help-block,
.has-success .control-label,
.has-success .radio,
.has-success .checkbox,
.has-success .radio-inline,
.has-success .checkbox-inline,
.has-success.radio label,
.has-success.checkbox label,
.has-success.radio-inline label,
.has-success.checkbox-inline label {
  color: #3c763d;
}
.has-success .form-control {
  border-color: #3c763d;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.has-success .form-control:focus {
  border-color: #2b542c;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #67b168;
}
.has-success .input-group-addon {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #3c763d;
}
.has-success .form-control-feedback {
  color: #3c763d;
}
.has-warning .help-block,
.has-warning .control-label,
.has-warning .radio,
.has-warning .checkbox,
.has-warning .radio-inline,
.has-warning .checkbox-inline,
.has-warning.radio label,
.has-warning.checkbox label,
.has-warning.radio-inline label,
.has-warning.checkbox-inline label {
  color: #8a6d3b;
}
.has-warning .form-control {
  border-color: #8a6d3b;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.has-warning .form-control:focus {
  border-color: #66512c;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #c0a16b;
}
.has-warning .input-group-addon {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #8a6d3b;
}
.has-warning .form-control-feedback {
  color: #8a6d3b;
}
.has-error .help-block,
.has-error .control-label,
.has-error .radio,
.has-error .checkbox,
.has-error .radio-inline,
.has-error .checkbox-inline,
.has-error.radio label,
.has-error.checkbox label,
.has-error.radio-inline label,
.has-error.checkbox-inline label {
  color: #a94442;
}
.has-error .form-control {
  border-color: #a94442;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.has-error .form-control:focus {
  border-color: #843534;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;
}
.has-error .input-group-addon {
  color: #a94442;
  background-color: #f2dede;
  border-color: #a94442;
}
.has-error .form-control-feedback {
  color: #a94442;
}
.has-feedback label ~ .form-control-feedback {
  top: 25px;
}
.has-feedback label.sr-only ~ .form-control-feedback {
  top: 0;
}
.help-block {
  display: block;
  margin-top: 5px;
  margin-bottom: 10px;
  color: #496490;
}
@media (min-width: 768px) {
  .form-inline .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-static {
    display: inline-block;
  }
  .form-inline .input-group {
    display: inline-table;
    vertical-align: middle;
  }
  .form-inline .input-group .input-group-addon,
  .form-inline .input-group .input-group-btn,
  .form-inline .input-group .form-control {
    width: auto;
  }
  .form-inline .input-group > .form-control {
    width: 100%;
  }
  .form-inline .control-label {
    margin-bottom: 0;
    vertical-align: middle;
  }
  .form-inline .radio,
  .form-inline .checkbox {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: middle;
  }
  .form-inline .radio label,
  .form-inline .checkbox label {
    padding-left: 0;
  }
  .form-inline .radio input[type="radio"],
  .form-inline .checkbox input[type="checkbox"] {
    position: relative;
    margin-left: 0;
  }
  .form-inline .has-feedback .form-control-feedback {
    top: 0;
  }
}
.form-horizontal .radio,
.form-horizontal .checkbox,
.form-horizontal .radio-inline,
.form-horizontal .checkbox-inline {
  padding-top: 7px;
  margin-top: 0;
  margin-bottom: 0;
}
.form-horizontal .radio,
.form-horizontal .checkbox {
  min-height: 27px;
}
.form-horizontal .form-group {
  margin-right: -15px;
  margin-left: -15px;
}
@media (min-width: 768px) {
  .form-horizontal .control-label {
    padding-top: 7px;
    margin-bottom: 0;
    text-align: right;
  }
}
.form-horizontal .has-feedback .form-control-feedback {
  right: 15px;
}
@media (min-width: 768px) {
  .form-horizontal .form-group-lg .control-label {
    padding-top: 11px;
    font-size: 18px;
  }
}
@media (min-width: 768px) {
  .form-horizontal .form-group-sm .control-label {
    padding-top: 6px;
    font-size: 12px;
  }
}
.btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  border-radius: 4px;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
.btn:focus,
.btn:active:focus,
.btn.active:focus,
.btn.focus,
.btn:active.focus,
.btn.active.focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
.btn:hover,
.btn:focus,
.btn.focus {
  color: #333;
  text-decoration: none;
}
.btn:active,
.btn.active {
  background-image: none;
  outline: 0;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn.disabled,
.btn[disabled],
fieldset[disabled] .btn {
  cursor: not-allowed;
  filter: alpha(opacity=65);
  opacity: 0.65;
  box-shadow: none;
}
a.btn.disabled,
fieldset[disabled] a.btn {
  pointer-events: none;
}
.btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc;
}
.btn-default:focus,
.btn-default.focus {
  color: #333;
  background-color: #e6e6e6;
  border-color: #8c8c8c;
}
.btn-default:hover {
  color: #333;
  background-color: #e6e6e6;
  border-color: #adadad;
}
.btn-default:active,
.btn-default.active,
.open > .dropdown-toggle.btn-default {
  color: #333;
  background-color: #e6e6e6;
  background-image: none;
  border-color: #adadad;
}
.btn-default:active:hover,
.btn-default.active:hover,
.open > .dropdown-toggle.btn-default:hover,
.btn-default:active:focus,
.btn-default.active:focus,
.open > .dropdown-toggle.btn-default:focus,
.btn-default:active.focus,
.btn-default.active.focus,
.open > .dropdown-toggle.btn-default.focus {
  color: #333;
  background-color: #d4d4d4;
  border-color: #8c8c8c;
}
.btn-default.disabled:hover,
.btn-default[disabled]:hover,
fieldset[disabled] .btn-default:hover,
.btn-default.disabled:focus,
.btn-default[disabled]:focus,
fieldset[disabled] .btn-default:focus,
.btn-default.disabled.focus,
.btn-default[disabled].focus,
fieldset[disabled] .btn-default.focus {
  background-color: #fff;
  border-color: #ccc;
}
.btn-default .badge {
  color: #fff;
  background-color: #333;
}
.btn-primary {
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
}
.btn-primary:focus,
.btn-primary.focus {
  color: #fff;
  background-color: #286090;
  border-color: #122b40;
}
.btn-primary:hover {
  color: #fff;
  background-color: #286090;
  border-color: #204d74;
}
.btn-primary:active,
.btn-primary.active,
.open > .dropdown-toggle.btn-primary {
  color: #fff;
  background-color: #286090;
  background-image: none;
  border-color: #204d74;
}
.btn-primary:active:hover,
.btn-primary.active:hover,
.open > .dropdown-toggle.btn-primary:hover,
.btn-primary:active:focus,
.btn-primary.active:focus,
.open > .dropdown-toggle.btn-primary:focus,
.btn-primary:active.focus,
.btn-primary.active.focus,
.open > .dropdown-toggle.btn-primary.focus {
  color: #fff;
  background-color: #204d74;
  border-color: #122b40;
}
.btn-primary.disabled:hover,
.btn-primary[disabled]:hover,
fieldset[disabled] .btn-primary:hover,
.btn-primary.disabled:focus,
.btn-primary[disabled]:focus,
fieldset[disabled] .btn-primary:focus,
.btn-primary.disabled.focus,
.btn-primary[disabled].focus,
fieldset[disabled] .btn-primary.focus {
  background-color: #337ab7;
  border-color: #2e6da4;
}
.btn-primary .badge {
  color: #337ab7;
  background-color: #fff;
}
.btn-success {
  color: #fff;
  background-color: #5cb85c;
  border-color: #4cae4c;
}
.btn-success:focus,
.btn-success.focus {
  color: #fff;
  background-color: #449d44;
  border-color: #255625;
}
.btn-success:hover {
  color: #fff;
  background-color: #449d44;
  border-color: #398439;
}
.btn-success:active,
.btn-success.active,
.open > .dropdown-toggle.btn-success {
  color: #fff;
  background-color: #449d44;
  background-image: none;
  border-color: #398439;
}
.btn-success:active:hover,
.btn-success.active:hover,
.open > .dropdown-toggle.btn-success:hover,
.btn-success:active:focus,
.btn-success.active:focus,
.open > .dropdown-toggle.btn-success:focus,
.btn-success:active.focus,
.btn-success.active.focus,
.open > .dropdown-toggle.btn-success.focus {
  color: #fff;
  background-color: #398439;
  border-color: #255625;
}
.btn-success.disabled:hover,
.btn-success[disabled]:hover,
fieldset[disabled] .btn-success:hover,
.btn-success.disabled:focus,
.btn-success[disabled]:focus,
fieldset[disabled] .btn-success:focus,
.btn-success.disabled.focus,
.btn-success[disabled].focus,
fieldset[disabled] .btn-success.focus {
  background-color: #5cb85c;
  border-color: #4cae4c;
}
.btn-success .badge {
  color: #5cb85c;
  background-color: #fff;
}
.btn-info {
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
}
.btn-info:focus,
.btn-info.focus {
  color: #fff;
  background-color: #31b0d5;
  border-color: #1b6d85;
}
.btn-info:hover {
  color: #fff;
  background-color: #31b0d5;
  border-color: #269abc;
}
.btn-info:active,
.btn-info.active,
.open > .dropdown-toggle.btn-info {
  color: #fff;
  background-color: #31b0d5;
  background-image: none;
  border-color: #269abc;
}
.btn-info:active:hover,
.btn-info.active:hover,
.open > .dropdown-toggle.btn-info:hover,
.btn-info:active:focus,
.btn-info.active:focus,
.open > .dropdown-toggle.btn-info:focus,
.btn-info:active.focus,
.btn-info.active.focus,
.open > .dropdown-toggle.btn-info.focus {
  color: #fff;
  background-color: #269abc;
  border-color: #1b6d85;
}
.btn-info.disabled:hover,
.btn-info[disabled]:hover,
fieldset[disabled] .btn-info:hover,
.btn-info.disabled:focus,
.btn-info[disabled]:focus,
fieldset[disabled] .btn-info:focus,
.btn-info.disabled.focus,
.btn-info[disabled].focus,
fieldset[disabled] .btn-info.focus {
  background-color: #5bc0de;
  border-color: #46b8da;
}
.btn-info .badge {
  color: #5bc0de;
  background-color: #fff;
}
.btn-warning {
  color: #fff;
  background-color: #f0ad4e;
  border-color: #eea236;
}
.btn-warning:focus,
.btn-warning.focus {
  color: #fff;
  background-color: #ec971f;
  border-color: #985f0d;
}
.btn-warning:hover {
  color: #fff;
  background-color: #ec971f;
  border-color: #d58512;
}
.btn-warning:active,
.btn-warning.active,
.open > .dropdown-toggle.btn-warning {
  color: #fff;
  background-color: #ec971f;
  background-image: none;
  border-color: #d58512;
}
.btn-warning:active:hover,
.btn-warning.active:hover,
.open > .dropdown-toggle.btn-warning:hover,
.btn-warning:active:focus,
.btn-warning.active:focus,
.open > .dropdown-toggle.btn-warning:focus,
.btn-warning:active.focus,
.btn-warning.active.focus,
.open > .dropdown-toggle.btn-warning.focus {
  color: #fff;
  background-color: #d58512;
  border-color: #985f0d;
}
.btn-warning.disabled:hover,
.btn-warning[disabled]:hover,
fieldset[disabled] .btn-warning:hover,
.btn-warning.disabled:focus,
.btn-warning[disabled]:focus,
fieldset[disabled] .btn-warning:focus,
.btn-warning.disabled.focus,
.btn-warning[disabled].focus,
fieldset[disabled] .btn-warning.focus {
  background-color: #f0ad4e;
  border-color: #eea236;
}
.btn-warning .badge {
  color: #f0ad4e;
  background-color: #fff;
}
.btn-danger {
  color: #fff;
  background-color: #d9534f;
  border-color: #d43f3a;
}
.btn-danger:focus,
.btn-danger.focus {
  color: #fff;
  background-color: #c9302c;
  border-color: #761c19;
}
.btn-danger:hover {
  color: #fff;
  background-color: #c9302c;
  border-color: #ac2925;
}
.btn-danger:active,
.btn-danger.active,
.open > .dropdown-toggle.btn-danger {
  color: #fff;
  background-color: #c9302c;
  background-image: none;
  border-color: #ac2925;
}
.btn-danger:active:hover,
.btn-danger.active:hover,
.open > .dropdown-toggle.btn-danger:hover,
.btn-danger:active:focus,
.btn-danger.active:focus,
.open > .dropdown-toggle.btn-danger:focus,
.btn-danger:active.focus,
.btn-danger.active.focus,
.open > .dropdown-toggle.btn-danger.focus {
  color: #fff;
  background-color: #ac2925;
  border-color: #761c19;
}
.btn-danger.disabled:hover,
.btn-danger[disabled]:hover,
fieldset[disabled] .btn-danger:hover,
.btn-danger.disabled:focus,
.btn-danger[disabled]:focus,
fieldset[disabled] .btn-danger:focus,
.btn-danger.disabled.focus,
.btn-danger[disabled].focus,
fieldset[disabled] .btn-danger.focus {
  background-color: #d9534f;
  border-color: #d43f3a;
}
.btn-danger .badge {
  color: #d9534f;
  background-color: #fff;
}
.btn-link {
  font-weight: 400;
  color: #337ab7;
  border-radius: 0;
}
.btn-link,
.btn-link:active,
.btn-link.active,
.btn-link[disabled],
fieldset[disabled] .btn-link {
  background-color: transparent;
  box-shadow: none;
}
.btn-link,
.btn-link:hover,
.btn-link:focus,
.btn-link:active {
  border-color: transparent;
}
.btn-link:hover,
.btn-link:focus {
  color: #23527c;
  text-decoration: underline;
  background-color: transparent;
}
.btn-link[disabled]:hover,
fieldset[disabled] .btn-link:hover,
.btn-link[disabled]:focus,
fieldset[disabled] .btn-link:focus {
  color: #777777;
  text-decoration: none;
}
.btn-lg,
.btn-group-lg > .btn {
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.3333333;
  border-radius: 6px;
}
.btn-sm,
.btn-group-sm > .btn {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}
.btn-xs,
.btn-group-xs > .btn {
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}
.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 5px;
}
input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%;
}
.fade {
  opacity: 0;
  transition: opacity 0.15s linear;
}
.fade.in {
  opacity: 1;
}
.collapse {
  display: none;
}
.collapse.in {
  display: block;
}
tr.collapse.in {
  display: table-row;
}
tbody.collapse.in {
  display: table-row-group;
}
.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition-property: height, visibility;
  transition-duration: 0.35s;
  transition-timing-function: ease;
}
.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}
.dropup,
.dropdown {
  position: relative;
}
.dropdown-toggle:focus {
  outline: 0;
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 160px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 14px;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
}
.dropdown-menu.pull-right {
  right: 0;
  left: auto;
}
.dropdown-menu .divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.dropdown-menu > li > a {
  display: block;
  padding: 3px 20px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333333;
  white-space: nowrap;
}
.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  color: #262626;
  text-decoration: none;
  background-color: #f5f5f5;
}
.dropdown-menu > .active > a,
.dropdown-menu > .active > a:hover,
.dropdown-menu > .active > a:focus {
  color: #fff;
  text-decoration: none;
  background-color: #337ab7;
  outline: 0;
}
.dropdown-menu > .disabled > a,
.dropdown-menu > .disabled > a:hover,
.dropdown-menu > .disabled > a:focus {
  color: #777777;
}
.dropdown-menu > .disabled > a:hover,
.dropdown-menu > .disabled > a:focus {
  text-decoration: none;
  cursor: not-allowed;
  background-color: transparent;
  background-image: none;
  filter: progid:DXImageTransform.Microsoft.gradient(enabled = false);
}
.open > .dropdown-menu {
  display: block;
}
.open > a {
  outline: 0;
}
.dropdown-menu-right {
  right: 0;
  left: auto;
}
.dropdown-menu-left {
  right: auto;
  left: 0;
}
.dropdown-header {
  display: block;
  padding: 3px 20px;
  font-size: 12px;
  line-height: 1.42857143;
  color: #777777;
  white-space: nowrap;
}
.dropdown-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 990;
}
.pull-right > .dropdown-menu {
  right: 0;
  left: auto;
}
.dropup .caret,
.navbar-fixed-bottom .dropdown .caret {
  content: "";
  border-top: 0;
  border-bottom: 4px dashed;
  border-bottom: 4px solid \\9;
}
.dropup .dropdown-menu,
.navbar-fixed-bottom .dropdown .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-bottom: 2px;
}
@media (min-width: 768px) {
  .navbar-right .dropdown-menu {
    right: 0;
    left: auto;
  }
  .navbar-right .dropdown-menu-left {
    right: auto;
    left: 0;
  }
}
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  float: left;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover,
.btn-group > .btn:focus,
.btn-group-vertical > .btn:focus,
.btn-group > .btn:active,
.btn-group-vertical > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn.active {
  z-index: 2;
}
.btn-group .btn + .btn,
.btn-group .btn + .btn-group,
.btn-group .btn-group + .btn,
.btn-group .btn-group + .btn-group {
  margin-left: -1px;
}
.btn-toolbar {
  margin-left: -5px;
}
.btn-toolbar .btn,
.btn-toolbar .btn-group,
.btn-toolbar .input-group {
  float: left;
}
.btn-toolbar > .btn,
.btn-toolbar > .btn-group,
.btn-toolbar > .input-group {
  margin-left: 5px;
}
.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
  border-radius: 0;
}
.btn-group > .btn:first-child {
  margin-left: 0;
}
.btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:last-child:not(:first-child),
.btn-group > .dropdown-toggle:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group > .btn-group {
  float: left;
}
.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}
.btn-group > .btn-group:first-child:not(:last-child) > .btn:last-child,
.btn-group > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group .dropdown-toggle:active,
.btn-group.open .dropdown-toggle {
  outline: 0;
}
.btn-group > .btn + .dropdown-toggle {
  padding-right: 8px;
  padding-left: 8px;
}
.btn-group > .btn-lg + .dropdown-toggle {
  padding-right: 12px;
  padding-left: 12px;
}
.btn-group.open .dropdown-toggle {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn-group.open .dropdown-toggle.btn-link {
  box-shadow: none;
}
.btn .caret {
  margin-left: 0;
}
.btn-lg .caret {
  border-width: 5px 5px 0;
  border-bottom-width: 0;
}
.dropup .btn-lg .caret {
  border-width: 0 5px 5px;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group,
.btn-group-vertical > .btn-group > .btn {
  display: block;
  float: none;
  width: 100%;
  max-width: 100%;
}
.btn-group-vertical > .btn-group > .btn {
  float: none;
}
.btn-group-vertical > .btn + .btn,
.btn-group-vertical > .btn + .btn-group,
.btn-group-vertical > .btn-group + .btn,
.btn-group-vertical > .btn-group + .btn-group {
  margin-top: -1px;
  margin-left: 0;
}
.btn-group-vertical > .btn:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.btn-group-vertical > .btn:first-child:not(:last-child) {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .btn:last-child,
.btn-group-vertical > .btn-group:first-child:not(:last-child) > .dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.btn-group-justified {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
}
.btn-group-justified > .btn,
.btn-group-justified > .btn-group {
  display: table-cell;
  float: none;
  width: 1%;
}
.btn-group-justified > .btn-group .btn {
  width: 100%;
}
.btn-group-justified > .btn-group .dropdown-menu {
  left: auto;
}
[data-toggle="buttons"] > .btn input[type="radio"],
[data-toggle="buttons"] > .btn-group > .btn input[type="radio"],
[data-toggle="buttons"] > .btn input[type="checkbox"],
[data-toggle="buttons"] > .btn-group > .btn input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.input-group {
  position: relative;
  display: table;
  border-collapse: separate;
}
.input-group[class*="col-"] {
  float: none;
  padding-right: 0;
  padding-left: 0;
}
.input-group .form-control {
  position: relative;
  z-index: 2;
  float: left;
  width: 100%;
  margin-bottom: 0;
}
.input-group .form-control:focus {
  z-index: 3;
}
.input-group-lg > .form-control,
.input-group-lg > .input-group-addon,
.input-group-lg > .input-group-btn > .btn {
  height: 46px;
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.3333333;
  border-radius: 6px;
}
select.input-group-lg > .form-control,
select.input-group-lg > .input-group-addon,
select.input-group-lg > .input-group-btn > .btn {
  height: 46px;
  line-height: 46px;
}
textarea.input-group-lg > .form-control,
textarea.input-group-lg > .input-group-addon,
textarea.input-group-lg > .input-group-btn > .btn,
select[multiple].input-group-lg > .form-control,
select[multiple].input-group-lg > .input-group-addon,
select[multiple].input-group-lg > .input-group-btn > .btn {
  height: auto;
}
.input-group-sm > .form-control,
.input-group-sm > .input-group-addon,
.input-group-sm > .input-group-btn > .btn {
  height: 30px;
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}
select.input-group-sm > .form-control,
select.input-group-sm > .input-group-addon,
select.input-group-sm > .input-group-btn > .btn {
  height: 30px;
  line-height: 30px;
}
textarea.input-group-sm > .form-control,
textarea.input-group-sm > .input-group-addon,
textarea.input-group-sm > .input-group-btn > .btn,
select[multiple].input-group-sm > .form-control,
select[multiple].input-group-sm > .input-group-addon,
select[multiple].input-group-sm > .input-group-btn > .btn {
  height: auto;
}
.input-group-addon,
.input-group-btn,
.input-group .form-control {
  display: table-cell;
}
.input-group-addon:not(:first-child):not(:last-child),
.input-group-btn:not(:first-child):not(:last-child),
.input-group .form-control:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.input-group-addon,
.input-group-btn {
  width: 1%;
  white-space: nowrap;
  vertical-align: middle;
}
.input-group-addon {
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555555;
  text-align: center;
  background-color: #eeeeee;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.input-group-addon.input-sm {
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 3px;
}
.input-group-addon.input-lg {
  padding: 10px 16px;
  font-size: 18px;
  border-radius: 6px;
}
.input-group-addon input[type="radio"],
.input-group-addon input[type="checkbox"] {
  margin-top: 0;
}
.input-group .form-control:first-child,
.input-group-addon:first-child,
.input-group-btn:first-child > .btn,
.input-group-btn:first-child > .btn-group > .btn,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group-btn:last-child > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group-addon:first-child {
  border-right: 0;
}
.input-group .form-control:last-child,
.input-group-addon:last-child,
.input-group-btn:last-child > .btn,
.input-group-btn:last-child > .btn-group > .btn,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child),
.input-group-btn:first-child > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group-addon:last-child {
  border-left: 0;
}
.input-group-btn {
  position: relative;
  font-size: 0;
  white-space: nowrap;
}
.input-group-btn > .btn {
  position: relative;
}
.input-group-btn > .btn + .btn {
  margin-left: -1px;
}
.input-group-btn > .btn:hover,
.input-group-btn > .btn:focus,
.input-group-btn > .btn:active {
  z-index: 2;
}
.input-group-btn:first-child > .btn,
.input-group-btn:first-child > .btn-group {
  margin-right: -1px;
}
.input-group-btn:last-child > .btn,
.input-group-btn:last-child > .btn-group {
  z-index: 2;
  margin-left: -1px;
}
.nav {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.nav > li {
  position: relative;
  display: block;
}
.nav > li > a {
  position: relative;
  display: block;
  padding: 10px 15px;
}
.nav > li > a:hover,
.nav > li > a:focus {
  text-decoration: none;
  background-color: #eeeeee;
}
.nav > li.disabled > a {
  color: #777777;
}
.nav > li.disabled > a:hover,
.nav > li.disabled > a:focus {
  color: #777777;
  text-decoration: none;
  cursor: not-allowed;
  background-color: transparent;
}
.nav .open > a,
.nav .open > a:hover,
.nav .open > a:focus {
  background-color: #eeeeee;
  border-color: #337ab7;
}
.nav .nav-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.nav > li > a > img {
  max-width: none;
}
.nav-tabs {
  border-bottom: 1px solid #ddd;
}
.nav-tabs > li {
  float: left;
  margin-bottom: -1px;
}
.nav-tabs > li > a {
  margin-right: 2px;
  line-height: 1.42857143;
  border: 1px solid transparent;
  border-radius: 4px 4px 0 0;
}
.nav-tabs > li > a:hover {
  border-color: #eeeeee #eeeeee #ddd;
}
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  color: #555555;
  cursor: default;
  background-color: #eeeeee;
  border: 1px solid #ddd;
  border-bottom-color: transparent;
}
.nav-tabs.nav-justified {
  width: 100%;
  border-bottom: 0;
}
.nav-tabs.nav-justified > li {
  float: none;
}
.nav-tabs.nav-justified > li > a {
  margin-bottom: 5px;
  text-align: center;
}
.nav-tabs.nav-justified > .dropdown .dropdown-menu {
  top: auto;
  left: auto;
}
@media (min-width: 768px) {
  .nav-tabs.nav-justified > li {
    display: table-cell;
    width: 1%;
  }
  .nav-tabs.nav-justified > li > a {
    margin-bottom: 0;
  }
}
.nav-tabs.nav-justified > li > a {
  margin-right: 0;
  border-radius: 4px;
}
.nav-tabs.nav-justified > .active > a,
.nav-tabs.nav-justified > .active > a:hover,
.nav-tabs.nav-justified > .active > a:focus {
  border: 1px solid #ddd;
}
@media (min-width: 768px) {
  .nav-tabs.nav-justified > li > a {
    border-bottom: 1px solid #ddd;
    border-radius: 4px 4px 0 0;
  }
  .nav-tabs.nav-justified > .active > a,
  .nav-tabs.nav-justified > .active > a:hover,
  .nav-tabs.nav-justified > .active > a:focus {
    border-bottom-color: #eeeeee;
  }
}
.nav-pills > li {
  float: left;
}
.nav-pills > li > a {
  border-radius: 4px;
}
.nav-pills > li + li {
  margin-left: 2px;
}
.nav-pills > li.active > a,
.nav-pills > li.active > a:hover,
.nav-pills > li.active > a:focus {
  color: #fff;
  background-color: #337ab7;
}
.nav-stacked > li {
  float: none;
}
.nav-stacked > li + li {
  margin-top: 2px;
  margin-left: 0;
}
.nav-justified {
  width: 100%;
}
.nav-justified > li {
  float: none;
}
.nav-justified > li > a {
  margin-bottom: 5px;
  text-align: center;
}
.nav-justified > .dropdown .dropdown-menu {
  top: auto;
  left: auto;
}
@media (min-width: 768px) {
  .nav-justified > li {
    display: table-cell;
    width: 1%;
  }
  .nav-justified > li > a {
    margin-bottom: 0;
  }
}
.nav-tabs-justified {
  border-bottom: 0;
}
.nav-tabs-justified > li > a {
  margin-right: 0;
  border-radius: 4px;
}
.nav-tabs-justified > .active > a,
.nav-tabs-justified > .active > a:hover,
.nav-tabs-justified > .active > a:focus {
  border: 1px solid #ddd;
}
@media (min-width: 768px) {
  .nav-tabs-justified > li > a {
    border-bottom: 1px solid #ddd;
    border-radius: 4px 4px 0 0;
  }
  .nav-tabs-justified > .active > a,
  .nav-tabs-justified > .active > a:hover,
  .nav-tabs-justified > .active > a:focus {
    border-bottom-color: #eeeeee;
  }
}
.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.navbar {
  position: relative;
  min-height: 50px;
  margin-bottom: 20px;
  border: 1px solid transparent;
}
@media (min-width: 768px) {
  .navbar {
    border-radius: 4px;
  }
}
@media (min-width: 768px) {
  .navbar-header {
    float: left;
  }
}
.navbar-collapse {
  padding-right: 15px;
  padding-left: 15px;
  overflow-x: visible;
  border-top: 1px solid transparent;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
  -webkit-overflow-scrolling: touch;
}
.navbar-collapse.in {
  overflow-y: auto;
}
@media (min-width: 768px) {
  .navbar-collapse {
    width: auto;
    border-top: 0;
    box-shadow: none;
  }
  .navbar-collapse.collapse {
    display: block !important;
    height: auto !important;
    padding-bottom: 0;
    overflow: visible !important;
  }
  .navbar-collapse.in {
    overflow-y: visible;
  }
  .navbar-fixed-top .navbar-collapse,
  .navbar-static-top .navbar-collapse,
  .navbar-fixed-bottom .navbar-collapse {
    padding-right: 0;
    padding-left: 0;
  }
}
.navbar-fixed-top,
.navbar-fixed-bottom {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 1030;
}
.navbar-fixed-top .navbar-collapse,
.navbar-fixed-bottom .navbar-collapse {
  max-height: 340px;
}
@media (max-device-width: 480px) and (orientation: landscape) {
  .navbar-fixed-top .navbar-collapse,
  .navbar-fixed-bottom .navbar-collapse {
    max-height: 200px;
  }
}
@media (min-width: 768px) {
  .navbar-fixed-top,
  .navbar-fixed-bottom {
    border-radius: 0;
  }
}
.navbar-fixed-top {
  top: 0;
  border-width: 0 0 1px;
}
.navbar-fixed-bottom {
  bottom: 0;
  margin-bottom: 0;
  border-width: 1px 0 0;
}
.container > .navbar-header,
.container-fluid > .navbar-header,
.container > .navbar-collapse,
.container-fluid > .navbar-collapse {
  margin-right: -15px;
  margin-left: -15px;
}
@media (min-width: 768px) {
  .container > .navbar-header,
  .container-fluid > .navbar-header,
  .container > .navbar-collapse,
  .container-fluid > .navbar-collapse {
    margin-right: 0;
    margin-left: 0;
  }
}
.navbar-static-top {
  z-index: 1000;
  border-width: 0 0 1px;
}
@media (min-width: 768px) {
  .navbar-static-top {
    border-radius: 0;
  }
}
.navbar-brand {
  float: left;
  height: 50px;
  padding: 15px 15px;
  font-size: 18px;
  line-height: 20px;
}
.navbar-brand:hover,
.navbar-brand:focus {
  text-decoration: none;
}
.navbar-brand > img {
  display: block;
}
@media (min-width: 768px) {
  .navbar > .container .navbar-brand,
  .navbar > .container-fluid .navbar-brand {
    margin-left: -15px;
  }
}
.navbar-toggle {
  position: relative;
  float: right;
  padding: 9px 10px;
  margin-right: 15px;
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: transparent;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
.navbar-toggle:focus {
  outline: 0;
}
.navbar-toggle .icon-bar {
  display: block;
  width: 22px;
  height: 2px;
  border-radius: 1px;
}
.navbar-toggle .icon-bar + .icon-bar {
  margin-top: 4px;
}
@media (min-width: 768px) {
  .navbar-toggle {
    display: none;
  }
}
.navbar-nav {
  margin: 7.5px -15px;
}
.navbar-nav > li > a {
  padding-top: 10px;
  padding-bottom: 10px;
  line-height: 20px;
}
@media (max-width: 767px) {
  .navbar-nav .open .dropdown-menu {
    position: static;
    float: none;
    width: auto;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
  }
  .navbar-nav .open .dropdown-menu > li > a,
  .navbar-nav .open .dropdown-menu .dropdown-header {
    padding: 5px 15px 5px 25px;
  }
  .navbar-nav .open .dropdown-menu > li > a {
    line-height: 20px;
  }
  .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-nav .open .dropdown-menu > li > a:focus {
    background-image: none;
  }
}
@media (min-width: 768px) {
  .navbar-nav {
    float: left;
    margin: 0;
  }
  .navbar-nav > li {
    float: left;
  }
  .navbar-nav > li > a {
    padding-top: 15px;
    padding-bottom: 15px;
  }
}
.navbar-form {
  padding: 10px 15px;
  margin-right: -15px;
  margin-left: -15px;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 1px 0 rgba(255, 255, 255, 0.1);
  margin-top: 8px;
  margin-bottom: 8px;
}
@media (min-width: 768px) {
  .navbar-form .form-group {
    display: inline-block;
    margin-bottom: 0;
    vertical-align: middle;
  }
  .navbar-form .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .navbar-form .form-control-static {
    display: inline-block;
  }
  .navbar-form .input-group {
    display: inline-table;
    vertical-align: middle;
  }
  .navbar-form .input-group .input-group-addon,
  .navbar-form .input-group .input-group-btn,
  .navbar-form .input-group .form-control {
    width: auto;
  }
  .navbar-form .input-group > .form-control {
    width: 100%;
  }
  .navbar-form .control-label {
    margin-bottom: 0;
    vertical-align: middle;
  }
  .navbar-form .radio,
  .navbar-form .checkbox {
    display: inline-block;
    margin-top: 0;
    margin-bottom: 0;
    vertical-align: middle;
  }
  .navbar-form .radio label,
  .navbar-form .checkbox label {
    padding-left: 0;
  }
  .navbar-form .radio input[type="radio"],
  .navbar-form .checkbox input[type="checkbox"] {
    position: relative;
    margin-left: 0;
  }
  .navbar-form .has-feedback .form-control-feedback {
    top: 0;
  }
}
@media (max-width: 767px) {
  .navbar-form .form-group {
    margin-bottom: 5px;
  }
  .navbar-form .form-group:last-child {
    margin-bottom: 0;
  }
}
@media (min-width: 768px) {
  .navbar-form {
    width: auto;
    padding-top: 0;
    padding-bottom: 0;
    margin-right: 0;
    margin-left: 0;
    border: 0;
    box-shadow: none;
  }
}
.navbar-nav > li > .dropdown-menu {
  margin-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {
  margin-bottom: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.navbar-btn {
  margin-top: 8px;
  margin-bottom: 8px;
}
.navbar-btn.btn-sm {
  margin-top: 10px;
  margin-bottom: 10px;
}
.navbar-btn.btn-xs {
  margin-top: 14px;
  margin-bottom: 14px;
}
.navbar-text {
  margin-top: 15px;
  margin-bottom: 15px;
}
@media (min-width: 768px) {
  .navbar-text {
    float: left;
    margin-right: 15px;
    margin-left: 15px;
  }
}
@media (min-width: 768px) {
  .navbar-left {
    float: left !important;
    float: left;
  }
  .navbar-right {
    float: right !important;
    float: right;
    margin-right: -15px;
  }
  .navbar-right ~ .navbar-right {
    margin-right: 0;
  }
}
.navbar-default {
  background-color: #f8f8f8;
  border-color: #e7e7e7;
}
.navbar-default .navbar-brand {
  color: #777;
}
.navbar-default .navbar-brand:hover,
.navbar-default .navbar-brand:focus {
  color: #5e5e5e;
  background-color: transparent;
}
.navbar-default .navbar-text {
  color: #777;
}
.navbar-default .navbar-nav > li > a {
  color: #777;
}
.navbar-default .navbar-nav > li > a:hover,
.navbar-default .navbar-nav > li > a:focus {
  color: #333;
  background-color: transparent;
}
.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:hover,
.navbar-default .navbar-nav > .active > a:focus {
  color: #555;
  background-color: #e7e7e7;
}
.navbar-default .navbar-nav > .disabled > a,
.navbar-default .navbar-nav > .disabled > a:hover,
.navbar-default .navbar-nav > .disabled > a:focus {
  color: #ccc;
  background-color: transparent;
}
.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:hover,
.navbar-default .navbar-nav > .open > a:focus {
  color: #555;
  background-color: #e7e7e7;
}
@media (max-width: 767px) {
  .navbar-default .navbar-nav .open .dropdown-menu > li > a {
    color: #777;
  }
  .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {
    color: #333;
    background-color: transparent;
  }
  .navbar-default .navbar-nav .open .dropdown-menu > .active > a,
  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > .active > a:focus {
    color: #555;
    background-color: #e7e7e7;
  }
  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a,
  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:hover,
  .navbar-default .navbar-nav .open .dropdown-menu > .disabled > a:focus {
    color: #ccc;
    background-color: transparent;
  }
}
.navbar-default .navbar-toggle {
  border-color: #ddd;
}
.navbar-default .navbar-toggle:hover,
.navbar-default .navbar-toggle:focus {
  background-color: #ddd;
}
.navbar-default .navbar-toggle .icon-bar {
  background-color: #888;
}
.navbar-default .navbar-collapse,
.navbar-default .navbar-form {
  border-color: #e7e7e7;
}
.navbar-default .navbar-link {
  color: #777;
}
.navbar-default .navbar-link:hover {
  color: #333;
}
.navbar-default .btn-link {
  color: #777;
}
.navbar-default .btn-link:hover,
.navbar-default .btn-link:focus {
  color: #333;
}
.navbar-default .btn-link[disabled]:hover,
fieldset[disabled] .navbar-default .btn-link:hover,
.navbar-default .btn-link[disabled]:focus,
fieldset[disabled] .navbar-default .btn-link:focus {
  color: #ccc;
}
.navbar-inverse {
  background-color: #222;
  border-color: #080808;
}
.navbar-inverse .navbar-brand {
  color: #9d9d9d;
}
.navbar-inverse .navbar-brand:hover,
.navbar-inverse .navbar-brand:focus {
  color: #fff;
  background-color: transparent;
}
.navbar-inverse .navbar-text {
  color: #9d9d9d;
}
.navbar-inverse .navbar-nav > li > a {
  color: #9d9d9d;
}
.navbar-inverse .navbar-nav > li > a:hover,
.navbar-inverse .navbar-nav > li > a:focus {
  color: #fff;
  background-color: transparent;
}
.navbar-inverse .navbar-nav > .active > a,
.navbar-inverse .navbar-nav > .active > a:hover,
.navbar-inverse .navbar-nav > .active > a:focus {
  color: #fff;
  background-color: #080808;
}
.navbar-inverse .navbar-nav > .disabled > a,
.navbar-inverse .navbar-nav > .disabled > a:hover,
.navbar-inverse .navbar-nav > .disabled > a:focus {
  color: #444;
  background-color: transparent;
}
.navbar-inverse .navbar-nav > .open > a,
.navbar-inverse .navbar-nav > .open > a:hover,
.navbar-inverse .navbar-nav > .open > a:focus {
  color: #fff;
  background-color: #080808;
}
@media (max-width: 767px) {
  .navbar-inverse .navbar-nav .open .dropdown-menu > .dropdown-header {
    border-color: #080808;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu .divider {
    background-color: #080808;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a {
    color: #9d9d9d;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > li > a:focus {
    color: #fff;
    background-color: transparent;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .active > a:focus {
    color: #fff;
    background-color: #080808;
  }
  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:hover,
  .navbar-inverse .navbar-nav .open .dropdown-menu > .disabled > a:focus {
    color: #444;
    background-color: transparent;
  }
}
.navbar-inverse .navbar-toggle {
  border-color: #333;
}
.navbar-inverse .navbar-toggle:hover,
.navbar-inverse .navbar-toggle:focus {
  background-color: #333;
}
.navbar-inverse .navbar-toggle .icon-bar {
  background-color: #fff;
}
.navbar-inverse .navbar-collapse,
.navbar-inverse .navbar-form {
  border-color: #101010;
}
.navbar-inverse .navbar-link {
  color: #9d9d9d;
}
.navbar-inverse .navbar-link:hover {
  color: #fff;
}
.navbar-inverse .btn-link {
  color: #9d9d9d;
}
.navbar-inverse .btn-link:hover,
.navbar-inverse .btn-link:focus {
  color: #fff;
}
.navbar-inverse .btn-link[disabled]:hover,
fieldset[disabled] .navbar-inverse .btn-link:hover,
.navbar-inverse .btn-link[disabled]:focus,
fieldset[disabled] .navbar-inverse .btn-link:focus {
  color: #444;
}
.breadcrumb {
  padding: 8px 15px;
  margin-bottom: 20px;
  list-style: none;
  background-color: #f5f5f5;
  border-radius: 4px;
}
.breadcrumb > li {
  display: inline-block;
}
.breadcrumb > li + li:before {
  padding: 0 5px;
  color: #ccc;
  content: "/\\00a0";
}
.breadcrumb > .active {
  color: #777777;
}
.pagination {
  display: inline-block;
  padding-left: 0;
  margin: 20px 0;
  border-radius: 4px;
}
.pagination > li {
  display: inline;
}
.pagination > li > a,
.pagination > li > span {
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
}
.pagination > li > a:hover,
.pagination > li > span:hover,
.pagination > li > a:focus,
.pagination > li > span:focus {
  z-index: 2;
  color: #23527c;
  background-color: #eeeeee;
  border-color: #ddd;
}
.pagination > li:first-child > a,
.pagination > li:first-child > span {
  margin-left: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.pagination > li:last-child > a,
.pagination > li:last-child > span {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.pagination > .active > a,
.pagination > .active > span,
.pagination > .active > a:hover,
.pagination > .active > span:hover,
.pagination > .active > a:focus,
.pagination > .active > span:focus {
  z-index: 3;
  color: #fff;
  cursor: default;
  background-color: #337ab7;
  border-color: #337ab7;
}
.pagination > .disabled > span,
.pagination > .disabled > span:hover,
.pagination > .disabled > span:focus,
.pagination > .disabled > a,
.pagination > .disabled > a:hover,
.pagination > .disabled > a:focus {
  color: #777777;
  cursor: not-allowed;
  background-color: #fff;
  border-color: #ddd;
}
.pagination-lg > li > a,
.pagination-lg > li > span {
  padding: 10px 16px;
  font-size: 18px;
  line-height: 1.3333333;
}
.pagination-lg > li:first-child > a,
.pagination-lg > li:first-child > span {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.pagination-lg > li:last-child > a,
.pagination-lg > li:last-child > span {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.pagination-sm > li > a,
.pagination-sm > li > span {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
}
.pagination-sm > li:first-child > a,
.pagination-sm > li:first-child > span {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.pagination-sm > li:last-child > a,
.pagination-sm > li:last-child > span {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
.pager {
  padding-left: 0;
  margin: 20px 0;
  text-align: center;
  list-style: none;
}
.pager li {
  display: inline;
}
.pager li > a,
.pager li > span {
  display: inline-block;
  padding: 5px 14px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 15px;
}
.pager li > a:hover,
.pager li > a:focus {
  text-decoration: none;
  background-color: #eeeeee;
}
.pager .next > a,
.pager .next > span {
  float: right;
}
.pager .previous > a,
.pager .previous > span {
  float: left;
}
.pager .disabled > a,
.pager .disabled > a:hover,
.pager .disabled > a:focus,
.pager .disabled > span {
  color: #777777;
  cursor: not-allowed;
  background-color: #fff;
}
.label {
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}
a.label:hover,
a.label:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}
.label:empty {
  display: none;
}
.btn .label {
  position: relative;
  top: -1px;
}
.label-default {
  background-color: #777777;
}
.label-default[href]:hover,
.label-default[href]:focus {
  background-color: #5e5e5e;
}
.label-primary {
  background-color: #337ab7;
}
.label-primary[href]:hover,
.label-primary[href]:focus {
  background-color: #286090;
}
.label-success {
  background-color: #5cb85c;
}
.label-success[href]:hover,
.label-success[href]:focus {
  background-color: #449d44;
}
.label-info {
  background-color: #5bc0de;
}
.label-info[href]:hover,
.label-info[href]:focus {
  background-color: #31b0d5;
}
.label-warning {
  background-color: #f0ad4e;
}
.label-warning[href]:hover,
.label-warning[href]:focus {
  background-color: #ec971f;
}
.label-danger {
  background-color: #d9534f;
}
.label-danger[href]:hover,
.label-danger[href]:focus {
  background-color: #c9302c;
}
.badge {
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  background-color: #777777;
  border-radius: 10px;
}
.badge:empty {
  display: none;
}
.btn .badge {
  position: relative;
  top: -1px;
}
.btn-xs .badge,
.btn-group-xs > .btn .badge {
  top: 0;
  padding: 1px 5px;
}
a.badge:hover,
a.badge:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}
.list-group-item.active > .badge,
.nav-pills > .active > a > .badge {
  color: #337ab7;
  background-color: #fff;
}
.list-group-item > .badge {
  float: right;
}
.list-group-item > .badge + .badge {
  margin-right: 5px;
}
.nav-pills > li > a > .badge {
  margin-left: 3px;
}
.jumbotron {
  padding-top: 30px;
  padding-bottom: 30px;
  margin-bottom: 30px;
  color: inherit;
  background-color: #eeeeee;
}
.jumbotron h1,
.jumbotron .h1 {
  color: inherit;
}
.jumbotron p {
  margin-bottom: 15px;
  font-size: 21px;
  font-weight: 200;
}
.jumbotron > hr {
  border-top-color: #d5d5d5;
}
.container .jumbotron,
.container-fluid .jumbotron {
  padding-right: 15px;
  padding-left: 15px;
  border-radius: 6px;
}
.jumbotron .container {
  max-width: 100%;
}
@media screen and (min-width: 768px) {
  .jumbotron {
    padding-top: 48px;
    padding-bottom: 48px;
  }
  .container .jumbotron,
  .container-fluid .jumbotron {
    padding-right: 60px;
    padding-left: 60px;
  }
  .jumbotron h1,
  .jumbotron .h1 {
    font-size: 63px;
  }
}
.thumbnail {
  display: block;
  padding: 4px;
  margin-bottom: 20px;
  line-height: 1.42857143;
  background-color: #eeeeee;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: border 0.2s ease-in-out;
}
.thumbnail > img,
.thumbnail a > img {
  margin-right: auto;
  margin-left: auto;
}
a.thumbnail:hover,
a.thumbnail:focus,
a.thumbnail.active {
  border-color: #337ab7;
}
.thumbnail .caption {
  padding: 9px;
  color: #1e293b;
}
.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}
.alert h4 {
  margin-top: 0;
  color: inherit;
}
.alert .alert-link {
  font-weight: bold;
}
.alert > p,
.alert > ul {
  margin-bottom: 0;
}
.alert > p + p {
  margin-top: 5px;
}
.alert-dismissable,
.alert-dismissible {
  padding-right: 35px;
}
.alert-dismissable .close,
.alert-dismissible .close {
  position: relative;
  top: -2px;
  right: -21px;
  color: inherit;
}
.alert-success {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}
.alert-success hr {
  border-top-color: #c9e2b3;
}
.alert-success .alert-link {
  color: #2b542c;
}
.alert-info {
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}
.alert-info hr {
  border-top-color: #a6e1ec;
}
.alert-info .alert-link {
  color: #245269;
}
.alert-warning {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
}
.alert-warning hr {
  border-top-color: #f7e1b5;
}
.alert-warning .alert-link {
  color: #66512c;
}
.alert-danger {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
}
.alert-danger hr {
  border-top-color: #e4b9c0;
}
.alert-danger .alert-link {
  color: #843534;
}
@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  height: 20px;
  margin-bottom: 20px;
  overflow: hidden;
  background-color: #f5f5f5;
  border-radius: 4px;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}
.progress-bar {
  float: left;
  width: 0%;
  height: 100%;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  text-align: center;
  background-color: #337ab7;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.15);
  transition: width 0.6s ease;
}
.progress-striped .progress-bar,
.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 40px 40px;
}
.progress.active .progress-bar,
.progress-bar.active {
  animation: progress-bar-stripes 2s linear infinite;
}
.progress-bar-success {
  background-color: #5cb85c;
}
.progress-striped .progress-bar-success {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-info {
  background-color: #5bc0de;
}
.progress-striped .progress-bar-info {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-warning {
  background-color: #f0ad4e;
}
.progress-striped .progress-bar-warning {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.progress-bar-danger {
  background-color: #d9534f;
}
.progress-striped .progress-bar-danger {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
}
.media {
  margin-top: 15px;
}
.media:first-child {
  margin-top: 0;
}
.media,
.media-body {
  overflow: hidden;
  zoom: 1;
}
.media-body {
  width: 10000px;
}
.media-object {
  display: block;
}
.media-object.img-thumbnail {
  max-width: none;
}
.media-right,
.media > .pull-right {
  padding-left: 10px;
}
.media-left,
.media > .pull-left {
  padding-right: 10px;
}
.media-left,
.media-right,
.media-body {
  display: table-cell;
  vertical-align: top;
}
.media-middle {
  vertical-align: middle;
}
.media-bottom {
  vertical-align: bottom;
}
.media-heading {
  margin-top: 0;
  margin-bottom: 5px;
}
.media-list {
  padding-left: 0;
  list-style: none;
}
.list-group {
  padding-left: 0;
  margin-bottom: 20px;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}
.list-group-item:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.list-group-item.disabled,
.list-group-item.disabled:hover,
.list-group-item.disabled:focus {
  color: #777777;
  cursor: not-allowed;
  background-color: #eeeeee;
}
.list-group-item.disabled .list-group-item-heading,
.list-group-item.disabled:hover .list-group-item-heading,
.list-group-item.disabled:focus .list-group-item-heading {
  color: inherit;
}
.list-group-item.disabled .list-group-item-text,
.list-group-item.disabled:hover .list-group-item-text,
.list-group-item.disabled:focus .list-group-item-text {
  color: #777777;
}
.list-group-item.active,
.list-group-item.active:hover,
.list-group-item.active:focus {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
}
.list-group-item.active .list-group-item-heading,
.list-group-item.active:hover .list-group-item-heading,
.list-group-item.active:focus .list-group-item-heading,
.list-group-item.active .list-group-item-heading > small,
.list-group-item.active:hover .list-group-item-heading > small,
.list-group-item.active:focus .list-group-item-heading > small,
.list-group-item.active .list-group-item-heading > .small,
.list-group-item.active:hover .list-group-item-heading > .small,
.list-group-item.active:focus .list-group-item-heading > .small {
  color: inherit;
}
.list-group-item.active .list-group-item-text,
.list-group-item.active:hover .list-group-item-text,
.list-group-item.active:focus .list-group-item-text {
  color: #c7ddef;
}
a.list-group-item,
button.list-group-item {
  color: #555;
}
a.list-group-item .list-group-item-heading,
button.list-group-item .list-group-item-heading {
  color: #333;
}
a.list-group-item:hover,
button.list-group-item:hover,
a.list-group-item:focus,
button.list-group-item:focus {
  color: #555;
  text-decoration: none;
  background-color: #f5f5f5;
}
button.list-group-item {
  width: 100%;
  text-align: left;
}
.list-group-item-success {
  color: #3c763d;
  background-color: #dff0d8;
}
a.list-group-item-success,
button.list-group-item-success {
  color: #3c763d;
}
a.list-group-item-success .list-group-item-heading,
button.list-group-item-success .list-group-item-heading {
  color: inherit;
}
a.list-group-item-success:hover,
button.list-group-item-success:hover,
a.list-group-item-success:focus,
button.list-group-item-success:focus {
  color: #3c763d;
  background-color: #d0e9c6;
}
a.list-group-item-success.active,
button.list-group-item-success.active,
a.list-group-item-success.active:hover,
button.list-group-item-success.active:hover,
a.list-group-item-success.active:focus,
button.list-group-item-success.active:focus {
  color: #fff;
  background-color: #3c763d;
  border-color: #3c763d;
}
.list-group-item-info {
  color: #31708f;
  background-color: #d9edf7;
}
a.list-group-item-info,
button.list-group-item-info {
  color: #31708f;
}
a.list-group-item-info .list-group-item-heading,
button.list-group-item-info .list-group-item-heading {
  color: inherit;
}
a.list-group-item-info:hover,
button.list-group-item-info:hover,
a.list-group-item-info:focus,
button.list-group-item-info:focus {
  color: #31708f;
  background-color: #c4e3f3;
}
a.list-group-item-info.active,
button.list-group-item-info.active,
a.list-group-item-info.active:hover,
button.list-group-item-info.active:hover,
a.list-group-item-info.active:focus,
button.list-group-item-info.active:focus {
  color: #fff;
  background-color: #31708f;
  border-color: #31708f;
}
.list-group-item-warning {
  color: #8a6d3b;
  background-color: #fcf8e3;
}
a.list-group-item-warning,
button.list-group-item-warning {
  color: #8a6d3b;
}
a.list-group-item-warning .list-group-item-heading,
button.list-group-item-warning .list-group-item-heading {
  color: inherit;
}
a.list-group-item-warning:hover,
button.list-group-item-warning:hover,
a.list-group-item-warning:focus,
button.list-group-item-warning:focus {
  color: #8a6d3b;
  background-color: #faf2cc;
}
a.list-group-item-warning.active,
button.list-group-item-warning.active,
a.list-group-item-warning.active:hover,
button.list-group-item-warning.active:hover,
a.list-group-item-warning.active:focus,
button.list-group-item-warning.active:focus {
  color: #fff;
  background-color: #8a6d3b;
  border-color: #8a6d3b;
}
.list-group-item-danger {
  color: #a94442;
  background-color: #f2dede;
}
a.list-group-item-danger,
button.list-group-item-danger {
  color: #a94442;
}
a.list-group-item-danger .list-group-item-heading,
button.list-group-item-danger .list-group-item-heading {
  color: inherit;
}
a.list-group-item-danger:hover,
button.list-group-item-danger:hover,
a.list-group-item-danger:focus,
button.list-group-item-danger:focus {
  color: #a94442;
  background-color: #ebcccc;
}
a.list-group-item-danger.active,
button.list-group-item-danger.active,
a.list-group-item-danger.active:hover,
button.list-group-item-danger.active:hover,
a.list-group-item-danger.active:focus,
button.list-group-item-danger.active:focus {
  color: #fff;
  background-color: #a94442;
  border-color: #a94442;
}
.list-group-item-heading {
  margin-top: 0;
  margin-bottom: 5px;
}
.list-group-item-text {
  margin-bottom: 0;
  line-height: 1.3;
}
.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
.panel-body {
  padding: 15px;
}
.panel-heading {
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.panel-heading > .dropdown .dropdown-toggle {
  color: inherit;
}
.panel-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 16px;
  color: inherit;
}
.panel-title > a,
.panel-title > small,
.panel-title > .small,
.panel-title > small > a,
.panel-title > .small > a {
  color: inherit;
}
.panel-footer {
  padding: 10px 15px;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}
.panel > .list-group,
.panel > .panel-collapse > .list-group {
  margin-bottom: 0;
}
.panel > .list-group .list-group-item,
.panel > .panel-collapse > .list-group .list-group-item {
  border-width: 1px 0;
  border-radius: 0;
}
.panel > .list-group:first-child .list-group-item:first-child,
.panel > .panel-collapse > .list-group:first-child .list-group-item:first-child {
  border-top: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.panel > .list-group:last-child .list-group-item:last-child,
.panel > .panel-collapse > .list-group:last-child .list-group-item:last-child {
  border-bottom: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}
.panel > .panel-heading + .panel-collapse > .list-group .list-group-item:first-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.panel-heading + .list-group .list-group-item:first-child {
  border-top-width: 0;
}
.list-group + .panel-footer {
  border-top-width: 0;
}
.panel > .table,
.panel > .table-responsive > .table,
.panel > .panel-collapse > .table {
  margin-bottom: 0;
}
.panel > .table caption,
.panel > .table-responsive > .table caption,
.panel > .panel-collapse > .table caption {
  padding-right: 15px;
  padding-left: 15px;
}
.panel > .table:first-child,
.panel > .table-responsive:first-child > .table:first-child {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.panel > .table:first-child > thead:first-child > tr:first-child,
.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child,
.panel > .table:first-child > tbody:first-child > tr:first-child,
.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.panel > .table:first-child > thead:first-child > tr:first-child td:first-child,
.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:first-child,
.panel > .table:first-child > tbody:first-child > tr:first-child td:first-child,
.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:first-child,
.panel > .table:first-child > thead:first-child > tr:first-child th:first-child,
.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:first-child,
.panel > .table:first-child > tbody:first-child > tr:first-child th:first-child,
.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:first-child {
  border-top-left-radius: 3px;
}
.panel > .table:first-child > thead:first-child > tr:first-child td:last-child,
.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child td:last-child,
.panel > .table:first-child > tbody:first-child > tr:first-child td:last-child,
.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child td:last-child,
.panel > .table:first-child > thead:first-child > tr:first-child th:last-child,
.panel > .table-responsive:first-child > .table:first-child > thead:first-child > tr:first-child th:last-child,
.panel > .table:first-child > tbody:first-child > tr:first-child th:last-child,
.panel > .table-responsive:first-child > .table:first-child > tbody:first-child > tr:first-child th:last-child {
  border-top-right-radius: 3px;
}
.panel > .table:last-child,
.panel > .table-responsive:last-child > .table:last-child {
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}
.panel > .table:last-child > tbody:last-child > tr:last-child,
.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child,
.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child {
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}
.panel > .table:last-child > tbody:last-child > tr:last-child td:first-child,
.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:first-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child td:first-child,
.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:first-child,
.panel > .table:last-child > tbody:last-child > tr:last-child th:first-child,
.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:first-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child th:first-child,
.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:first-child {
  border-bottom-left-radius: 3px;
}
.panel > .table:last-child > tbody:last-child > tr:last-child td:last-child,
.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child td:last-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child td:last-child,
.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child td:last-child,
.panel > .table:last-child > tbody:last-child > tr:last-child th:last-child,
.panel > .table-responsive:last-child > .table:last-child > tbody:last-child > tr:last-child th:last-child,
.panel > .table:last-child > tfoot:last-child > tr:last-child th:last-child,
.panel > .table-responsive:last-child > .table:last-child > tfoot:last-child > tr:last-child th:last-child {
  border-bottom-right-radius: 3px;
}
.panel > .panel-body + .table,
.panel > .panel-body + .table-responsive,
.panel > .table + .panel-body,
.panel > .table-responsive + .panel-body {
  border-top: 1px solid #ddd;
}
.panel > .table > tbody:first-child > tr:first-child th,
.panel > .table > tbody:first-child > tr:first-child td {
  border-top: 0;
}
.panel > .table-bordered,
.panel > .table-responsive > .table-bordered {
  border: 0;
}
.panel > .table-bordered > thead > tr > th:first-child,
.panel > .table-responsive > .table-bordered > thead > tr > th:first-child,
.panel > .table-bordered > tbody > tr > th:first-child,
.panel > .table-responsive > .table-bordered > tbody > tr > th:first-child,
.panel > .table-bordered > tfoot > tr > th:first-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > th:first-child,
.panel > .table-bordered > thead > tr > td:first-child,
.panel > .table-responsive > .table-bordered > thead > tr > td:first-child,
.panel > .table-bordered > tbody > tr > td:first-child,
.panel > .table-responsive > .table-bordered > tbody > tr > td:first-child,
.panel > .table-bordered > tfoot > tr > td:first-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > td:first-child {
  border-left: 0;
}
.panel > .table-bordered > thead > tr > th:last-child,
.panel > .table-responsive > .table-bordered > thead > tr > th:last-child,
.panel > .table-bordered > tbody > tr > th:last-child,
.panel > .table-responsive > .table-bordered > tbody > tr > th:last-child,
.panel > .table-bordered > tfoot > tr > th:last-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > th:last-child,
.panel > .table-bordered > thead > tr > td:last-child,
.panel > .table-responsive > .table-bordered > thead > tr > td:last-child,
.panel > .table-bordered > tbody > tr > td:last-child,
.panel > .table-responsive > .table-bordered > tbody > tr > td:last-child,
.panel > .table-bordered > tfoot > tr > td:last-child,
.panel > .table-responsive > .table-bordered > tfoot > tr > td:last-child {
  border-right: 0;
}
.panel > .table-bordered > thead > tr:first-child > td,
.panel > .table-responsive > .table-bordered > thead > tr:first-child > td,
.panel > .table-bordered > tbody > tr:first-child > td,
.panel > .table-responsive > .table-bordered > tbody > tr:first-child > td,
.panel > .table-bordered > thead > tr:first-child > th,
.panel > .table-responsive > .table-bordered > thead > tr:first-child > th,
.panel > .table-bordered > tbody > tr:first-child > th,
.panel > .table-responsive > .table-bordered > tbody > tr:first-child > th {
  border-bottom: 0;
}
.panel > .table-bordered > tbody > tr:last-child > td,
.panel > .table-responsive > .table-bordered > tbody > tr:last-child > td,
.panel > .table-bordered > tfoot > tr:last-child > td,
.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > td,
.panel > .table-bordered > tbody > tr:last-child > th,
.panel > .table-responsive > .table-bordered > tbody > tr:last-child > th,
.panel > .table-bordered > tfoot > tr:last-child > th,
.panel > .table-responsive > .table-bordered > tfoot > tr:last-child > th {
  border-bottom: 0;
}
.panel > .table-responsive {
  margin-bottom: 0;
  border: 0;
}
.panel-group {
  margin-bottom: 20px;
}
.panel-group .panel {
  margin-bottom: 0;
  border-radius: 4px;
}
.panel-group .panel + .panel {
  margin-top: 5px;
}
.panel-group .panel-heading {
  border-bottom: 0;
}
.panel-group .panel-heading + .panel-collapse > .panel-body,
.panel-group .panel-heading + .panel-collapse > .list-group {
  border-top: 1px solid #ddd;
}
.panel-group .panel-footer {
  border-top: 0;
}
.panel-group .panel-footer + .panel-collapse .panel-body {
  border-bottom: 1px solid #ddd;
}
.panel-default {
  border-color: #ddd;
}
.panel-default > .panel-heading {
  color: #333333;
  background-color: #f5f5f5;
  border-color: #ddd;
}
.panel-default > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #ddd;
}
.panel-default > .panel-heading .badge {
  color: #f5f5f5;
  background-color: #333333;
}
.panel-default > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #ddd;
}
.panel-primary {
  border-color: #337ab7;
}
.panel-primary > .panel-heading {
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
}
.panel-primary > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #337ab7;
}
.panel-primary > .panel-heading .badge {
  color: #337ab7;
  background-color: #fff;
}
.panel-primary > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #337ab7;
}
.panel-success {
  border-color: #d6e9c6;
}
.panel-success > .panel-heading {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}
.panel-success > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #d6e9c6;
}
.panel-success > .panel-heading .badge {
  color: #dff0d8;
  background-color: #3c763d;
}
.panel-success > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #d6e9c6;
}
.panel-info {
  border-color: #bce8f1;
}
.panel-info > .panel-heading {
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}
.panel-info > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #bce8f1;
}
.panel-info > .panel-heading .badge {
  color: #d9edf7;
  background-color: #31708f;
}
.panel-info > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #bce8f1;
}
.panel-warning {
  border-color: #faebcc;
}
.panel-warning > .panel-heading {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
}
.panel-warning > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #faebcc;
}
.panel-warning > .panel-heading .badge {
  color: #fcf8e3;
  background-color: #8a6d3b;
}
.panel-warning > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #faebcc;
}
.panel-danger {
  border-color: #ebccd1;
}
.panel-danger > .panel-heading {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
}
.panel-danger > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #ebccd1;
}
.panel-danger > .panel-heading .badge {
  color: #f2dede;
  background-color: #a94442;
}
.panel-danger > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #ebccd1;
}
.embed-responsive {
  position: relative;
  display: block;
  height: 0;
  padding: 0;
  overflow: hidden;
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.embed-responsive-16by9 {
  padding-bottom: 56.25%;
}
.embed-responsive-4by3 {
  padding-bottom: 75%;
}
.well {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}
.well blockquote {
  border-color: #ddd;
  border-color: rgba(0, 0, 0, 0.15);
}
.well-lg {
  padding: 24px;
  border-radius: 6px;
}
.well-sm {
  padding: 9px;
  border-radius: 3px;
}
.close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
  filter: alpha(opacity=50);
  opacity: 0.5;
}
button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
       appearance: none;
}
.modal-open {
  overflow: hidden;
}
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
.modal.fade .modal-dialog {
  transform: translate(0, -25%);
  transition: transform 0.3s ease-out;
}
.modal.in .modal-dialog {
  transform: translate(0, 0);
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}
.modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
.modal-content {
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #999;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  outline: 0;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}
.modal-backdrop.fade {
  filter: alpha(opacity=0);
  opacity: 0;
}
.modal-backdrop.in {
  filter: alpha(opacity=50);
  opacity: 0.5;
}
.modal-header {
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
}
.modal-header .close {
  margin-top: -2px;
}
.modal-title {
  margin: 0;
  line-height: 1.42857143;
}
.modal-body {
  position: relative;
  padding: 15px;
}
.modal-footer {
  padding: 15px;
  text-align: right;
  border-top: 1px solid #e5e5e5;
}
.modal-footer .btn + .btn {
  margin-bottom: 0;
  margin-left: 5px;
}
.modal-footer .btn-group .btn + .btn {
  margin-left: -1px;
}
.modal-footer .btn-block + .btn-block {
  margin-left: 0;
}
.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}
@media (min-width: 768px) {
  .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
  .modal-content {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  }
  .modal-sm {
    width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg {
    width: 900px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.42857143;
  line-break: auto;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: normal;
  font-size: 12px;
  filter: alpha(opacity=0);
  opacity: 0;
}
.tooltip.in {
  filter: alpha(opacity=90);
  opacity: 0.9;
}
.tooltip.top {
  padding: 5px 0;
  margin-top: -3px;
}
.tooltip.right {
  padding: 0 5px;
  margin-left: 3px;
}
.tooltip.bottom {
  padding: 5px 0;
  margin-top: 3px;
}
.tooltip.left {
  padding: 0 5px;
  margin-left: -3px;
}
.tooltip.top .tooltip-arrow {
  bottom: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.top-left .tooltip-arrow {
  right: 5px;
  bottom: 0;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.top-right .tooltip-arrow {
  bottom: 0;
  left: 5px;
  margin-bottom: -5px;
  border-width: 5px 5px 0;
  border-top-color: #000;
}
.tooltip.right .tooltip-arrow {
  top: 50%;
  left: 0;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #000;
}
.tooltip.left .tooltip-arrow {
  top: 50%;
  right: 0;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #000;
}
.tooltip.bottom .tooltip-arrow {
  top: 0;
  left: 50%;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip.bottom-left .tooltip-arrow {
  top: 0;
  right: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip.bottom-right .tooltip-arrow {
  top: 0;
  left: 5px;
  margin-top: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #000;
}
.tooltip-inner {
  max-width: 200px;
  padding: 3px 8px;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 4px;
}
.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: none;
  max-width: 276px;
  padding: 1px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.42857143;
  line-break: auto;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: normal;
  font-size: 14px;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}
.popover.top {
  margin-top: -10px;
}
.popover.right {
  margin-left: 10px;
}
.popover.bottom {
  margin-top: 10px;
}
.popover.left {
  margin-left: -10px;
}
.popover > .arrow {
  border-width: 11px;
}
.popover > .arrow,
.popover > .arrow:after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.popover > .arrow:after {
  content: "";
  border-width: 10px;
}
.popover.top > .arrow {
  bottom: -11px;
  left: 50%;
  margin-left: -11px;
  border-top-color: #999999;
  border-top-color: rgba(0, 0, 0, 0.25);
  border-bottom-width: 0;
}
.popover.top > .arrow:after {
  bottom: 1px;
  margin-left: -10px;
  content: " ";
  border-top-color: #fff;
  border-bottom-width: 0;
}
.popover.right > .arrow {
  top: 50%;
  left: -11px;
  margin-top: -11px;
  border-right-color: #999999;
  border-right-color: rgba(0, 0, 0, 0.25);
  border-left-width: 0;
}
.popover.right > .arrow:after {
  bottom: -10px;
  left: 1px;
  content: " ";
  border-right-color: #fff;
  border-left-width: 0;
}
.popover.bottom > .arrow {
  top: -11px;
  left: 50%;
  margin-left: -11px;
  border-top-width: 0;
  border-bottom-color: #999999;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.popover.bottom > .arrow:after {
  top: 1px;
  margin-left: -10px;
  content: " ";
  border-top-width: 0;
  border-bottom-color: #fff;
}
.popover.left > .arrow {
  top: 50%;
  right: -11px;
  margin-top: -11px;
  border-right-width: 0;
  border-left-color: #999999;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.popover.left > .arrow:after {
  right: 1px;
  bottom: -10px;
  content: " ";
  border-right-width: 0;
  border-left-color: #fff;
}
.popover-title {
  padding: 8px 14px;
  margin: 0;
  font-size: 14px;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-radius: 5px 5px 0 0;
}
.popover-content {
  padding: 9px 14px;
}
.carousel {
  position: relative;
}
.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner > .item {
  position: relative;
  display: none;
  transition: 0.6s ease-in-out left;
}
.carousel-inner > .item > img,
.carousel-inner > .item > a > img {
  line-height: 1;
}
@media all and (transform-3d), (-webkit-transform-3d) {
  .carousel-inner > .item {
    transition: transform 0.6s ease-in-out;
    backface-visibility: hidden;
    perspective: 1000px;
  }
  .carousel-inner > .item.next,
  .carousel-inner > .item.active.right {
    transform: translate3d(100%, 0, 0);
    left: 0;
  }
  .carousel-inner > .item.prev,
  .carousel-inner > .item.active.left {
    transform: translate3d(-100%, 0, 0);
    left: 0;
  }
  .carousel-inner > .item.next.left,
  .carousel-inner > .item.prev.right,
  .carousel-inner > .item.active {
    transform: translate3d(0, 0, 0);
    left: 0;
  }
}
.carousel-inner > .active,
.carousel-inner > .next,
.carousel-inner > .prev {
  display: block;
}
.carousel-inner > .active {
  left: 0;
}
.carousel-inner > .next,
.carousel-inner > .prev {
  position: absolute;
  top: 0;
  width: 100%;
}
.carousel-inner > .next {
  left: 100%;
}
.carousel-inner > .prev {
  left: -100%;
}
.carousel-inner > .next.left,
.carousel-inner > .prev.right {
  left: 0;
}
.carousel-inner > .active.left {
  left: -100%;
}
.carousel-inner > .active.right {
  left: 100%;
}
.carousel-control {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 15%;
  font-size: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
  background-color: rgba(0, 0, 0, 0);
  filter: alpha(opacity=50);
  opacity: 0.5;
}
.carousel-control.left {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.0001) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);
  background-repeat: repeat-x;
}
.carousel-control.right {
  right: 0;
  left: auto;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.0001) 0%, rgba(0, 0, 0, 0.5) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);
  background-repeat: repeat-x;
}
.carousel-control:hover,
.carousel-control:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  filter: alpha(opacity=90);
  opacity: 0.9;
}
.carousel-control .icon-prev,
.carousel-control .icon-next,
.carousel-control .glyphicon-chevron-left,
.carousel-control .glyphicon-chevron-right {
  position: absolute;
  top: 50%;
  z-index: 5;
  display: inline-block;
  margin-top: -10px;
}
.carousel-control .icon-prev,
.carousel-control .glyphicon-chevron-left {
  left: 50%;
  margin-left: -10px;
}
.carousel-control .icon-next,
.carousel-control .glyphicon-chevron-right {
  right: 50%;
  margin-right: -10px;
}
.carousel-control .icon-prev,
.carousel-control .icon-next {
  width: 20px;
  height: 20px;
  font-family: serif;
  line-height: 1;
}
.carousel-control .icon-prev:before {
  content: "\\2039";
}
.carousel-control .icon-next:before {
  content: "\\203a";
}
.carousel-indicators {
  position: absolute;
  bottom: 10px;
  left: 50%;
  z-index: 15;
  width: 60%;
  padding-left: 0;
  margin-left: -30%;
  text-align: center;
  list-style: none;
}
.carousel-indicators li {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 1px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #000 \\9;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #fff;
  border-radius: 10px;
}
.carousel-indicators .active {
  width: 12px;
  height: 12px;
  margin: 0;
  background-color: #fff;
}
.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}
.carousel-caption .btn {
  text-shadow: none;
}
@media screen and (min-width: 768px) {
  .carousel-control .glyphicon-chevron-left,
  .carousel-control .glyphicon-chevron-right,
  .carousel-control .icon-prev,
  .carousel-control .icon-next {
    width: 30px;
    height: 30px;
    margin-top: -10px;
    font-size: 30px;
  }
  .carousel-control .glyphicon-chevron-left,
  .carousel-control .icon-prev {
    margin-left: -10px;
  }
  .carousel-control .glyphicon-chevron-right,
  .carousel-control .icon-next {
    margin-right: -10px;
  }
  .carousel-caption {
    right: 20%;
    left: 20%;
    padding-bottom: 30px;
  }
  .carousel-indicators {
    bottom: 20px;
  }
}
.clearfix:before,
.clearfix:after,
.dl-horizontal dd:before,
.dl-horizontal dd:after,
.container:before,
.container:after,
.container-fluid:before,
.container-fluid:after,
.row:before,
.row:after,
.form-horizontal .form-group:before,
.form-horizontal .form-group:after,
.btn-toolbar:before,
.btn-toolbar:after,
.btn-group-vertical > .btn-group:before,
.btn-group-vertical > .btn-group:after,
.nav:before,
.nav:after,
.navbar:before,
.navbar:after,
.navbar-header:before,
.navbar-header:after,
.navbar-collapse:before,
.navbar-collapse:after,
.pager:before,
.pager:after,
.panel-body:before,
.panel-body:after,
.modal-header:before,
.modal-header:after,
.modal-footer:before,
.modal-footer:after {
  display: table;
  content: " ";
}
.clearfix:after,
.dl-horizontal dd:after,
.container:after,
.container-fluid:after,
.row:after,
.form-horizontal .form-group:after,
.btn-toolbar:after,
.btn-group-vertical > .btn-group:after,
.nav:after,
.navbar:after,
.navbar-header:after,
.navbar-collapse:after,
.pager:after,
.panel-body:after,
.modal-header:after,
.modal-footer:after {
  clear: both;
}
.center-block {
  display: block;
  margin-right: auto;
  margin-left: auto;
}
.pull-right {
  float: right !important;
}
.pull-left {
  float: left !important;
}
.hide {
  display: none !important;
}
.show {
  display: block !important;
}
.invisible {
  visibility: hidden;
}
.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}
.hidden {
  display: none !important;
}
.affix {
  position: fixed;
}
.visible-xs,
.visible-sm,
.visible-md,
.visible-lg {
  display: none !important;
}
.visible-xs-block,
.visible-xs-inline,
.visible-xs-inline-block,
.visible-sm-block,
.visible-sm-inline,
.visible-sm-inline-block,
.visible-md-block,
.visible-md-inline,
.visible-md-inline-block,
.visible-lg-block,
.visible-lg-inline,
.visible-lg-inline-block {
  display: none !important;
}
@media (max-width: 767px) {
  .visible-xs {
    display: block !important;
  }
  table.visible-xs {
    display: table !important;
  }
  tr.visible-xs {
    display: table-row !important;
  }
  th.visible-xs,
  td.visible-xs {
    display: table-cell !important;
  }
}
@media (max-width: 767px) {
  .visible-xs-block {
    display: block !important;
  }
}
@media (max-width: 767px) {
  .visible-xs-inline {
    display: inline !important;
  }
}
@media (max-width: 767px) {
  .visible-xs-inline-block {
    display: inline-block !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm {
    display: block !important;
  }
  table.visible-sm {
    display: table !important;
  }
  tr.visible-sm {
    display: table-row !important;
  }
  th.visible-sm,
  td.visible-sm {
    display: table-cell !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm-block {
    display: block !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm-inline {
    display: inline !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .visible-sm-inline-block {
    display: inline-block !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md {
    display: block !important;
  }
  table.visible-md {
    display: table !important;
  }
  tr.visible-md {
    display: table-row !important;
  }
  th.visible-md,
  td.visible-md {
    display: table-cell !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md-block {
    display: block !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md-inline {
    display: inline !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .visible-md-inline-block {
    display: inline-block !important;
  }
}
@media (min-width: 1200px) {
  .visible-lg {
    display: block !important;
  }
  table.visible-lg {
    display: table !important;
  }
  tr.visible-lg {
    display: table-row !important;
  }
  th.visible-lg,
  td.visible-lg {
    display: table-cell !important;
  }
}
@media (min-width: 1200px) {
  .visible-lg-block {
    display: block !important;
  }
}
@media (min-width: 1200px) {
  .visible-lg-inline {
    display: inline !important;
  }
}
@media (min-width: 1200px) {
  .visible-lg-inline-block {
    display: inline-block !important;
  }
}
@media (max-width: 767px) {
  .hidden-xs {
    display: none !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .hidden-sm {
    display: none !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .hidden-md {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .hidden-lg {
    display: none !important;
  }
}
.visible-print {
  display: none !important;
}
@media print {
  .visible-print {
    display: block !important;
  }
  table.visible-print {
    display: table !important;
  }
  tr.visible-print {
    display: table-row !important;
  }
  th.visible-print,
  td.visible-print {
    display: table-cell !important;
  }
}
.visible-print-block {
  display: none !important;
}
@media print {
  .visible-print-block {
    display: block !important;
  }
}
.visible-print-inline {
  display: none !important;
}
@media print {
  .visible-print-inline {
    display: inline !important;
  }
}
.visible-print-inline-block {
  display: none !important;
}
@media print {
  .visible-print-inline-block {
    display: inline-block !important;
  }
}
@media print {
  .hidden-print {
    display: none !important;
  }
}
/*!
 *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)
 */
/* FONT PATH
 * -------------------------- */
@font-face {
  font-family: 'FontAwesome';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('svg');
  font-weight: normal;
  font-style: normal;
}
.fa {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/* makes the font 33% larger relative to the icon container */
.fa-lg {
  font-size: 1.33333333em;
  line-height: 0.75em;
  vertical-align: -15%;
}
.fa-2x {
  font-size: 2em;
}
.fa-3x {
  font-size: 3em;
}
.fa-4x {
  font-size: 4em;
}
.fa-5x {
  font-size: 5em;
}
.fa-fw {
  width: 1.28571429em;
  text-align: center;
}
.fa-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}
.fa-ul > li {
  position: relative;
}
.fa-li {
  position: absolute;
  left: -2.14285714em;
  width: 2.14285714em;
  top: 0.14285714em;
  text-align: center;
}
.fa-li.fa-lg {
  left: -1.85714286em;
}
.fa-border {
  padding: 0.2em 0.25em 0.15em;
  border: solid 0.08em #eee;
  border-radius: 0.1em;
}
.fa-pull-left {
  float: left;
}
.fa-pull-right {
  float: right;
}
.fa.fa-pull-left {
  margin-right: 0.3em;
}
.fa.fa-pull-right {
  margin-left: 0.3em;
}
/* Deprecated as of 4.4.0 */
.pull-right {
  float: right;
}
.pull-left {
  float: left;
}
.fa.pull-left {
  margin-right: 0.3em;
}
.fa.pull-right {
  margin-left: 0.3em;
}
.fa-spin {
  animation: fa-spin 2s infinite linear;
}
.fa-pulse {
  animation: fa-spin 1s infinite steps(8);
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.fa-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg);
}
.fa-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg);
}
.fa-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg);
}
.fa-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1);
}
.fa-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1);
}
:root .fa-rotate-90,
:root .fa-rotate-180,
:root .fa-rotate-270,
:root .fa-flip-horizontal,
:root .fa-flip-vertical {
  filter: none;
}
.fa-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}
.fa-stack-1x,
.fa-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}
.fa-stack-1x {
  line-height: inherit;
}
.fa-stack-2x {
  font-size: 2em;
}
.fa-inverse {
  color: #fff;
}
/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
   readers do not read off random characters that represent icons */
.fa-glass:before {
  content: "\\f000";
}
.fa-music:before {
  content: "\\f001";
}
.fa-search:before {
  content: "\\f002";
}
.fa-envelope-o:before {
  content: "\\f003";
}
.fa-heart:before {
  content: "\\f004";
}
.fa-star:before {
  content: "\\f005";
}
.fa-star-o:before {
  content: "\\f006";
}
.fa-user:before {
  content: "\\f007";
}
.fa-film:before {
  content: "\\f008";
}
.fa-th-large:before {
  content: "\\f009";
}
.fa-th:before {
  content: "\\f00a";
}
.fa-th-list:before {
  content: "\\f00b";
}
.fa-check:before {
  content: "\\f00c";
}
.fa-remove:before,
.fa-close:before,
.fa-times:before {
  content: "\\f00d";
}
.fa-search-plus:before {
  content: "\\f00e";
}
.fa-search-minus:before {
  content: "\\f010";
}
.fa-power-off:before {
  content: "\\f011";
}
.fa-signal:before {
  content: "\\f012";
}
.fa-gear:before,
.fa-cog:before {
  content: "\\f013";
}
.fa-trash-o:before {
  content: "\\f014";
}
.fa-home:before {
  content: "\\f015";
}
.fa-file-o:before {
  content: "\\f016";
}
.fa-clock-o:before {
  content: "\\f017";
}
.fa-road:before {
  content: "\\f018";
}
.fa-download:before {
  content: "\\f019";
}
.fa-arrow-circle-o-down:before {
  content: "\\f01a";
}
.fa-arrow-circle-o-up:before {
  content: "\\f01b";
}
.fa-inbox:before {
  content: "\\f01c";
}
.fa-play-circle-o:before {
  content: "\\f01d";
}
.fa-rotate-right:before,
.fa-repeat:before {
  content: "\\f01e";
}
.fa-refresh:before {
  content: "\\f021";
}
.fa-list-alt:before {
  content: "\\f022";
}
.fa-lock:before {
  content: "\\f023";
}
.fa-flag:before {
  content: "\\f024";
}
.fa-headphones:before {
  content: "\\f025";
}
.fa-volume-off:before {
  content: "\\f026";
}
.fa-volume-down:before {
  content: "\\f027";
}
.fa-volume-up:before {
  content: "\\f028";
}
.fa-qrcode:before {
  content: "\\f029";
}
.fa-barcode:before {
  content: "\\f02a";
}
.fa-tag:before {
  content: "\\f02b";
}
.fa-tags:before {
  content: "\\f02c";
}
.fa-book:before {
  content: "\\f02d";
}
.fa-bookmark:before {
  content: "\\f02e";
}
.fa-print:before {
  content: "\\f02f";
}
.fa-camera:before {
  content: "\\f030";
}
.fa-font:before {
  content: "\\f031";
}
.fa-bold:before {
  content: "\\f032";
}
.fa-italic:before {
  content: "\\f033";
}
.fa-text-height:before {
  content: "\\f034";
}
.fa-text-width:before {
  content: "\\f035";
}
.fa-align-left:before {
  content: "\\f036";
}
.fa-align-center:before {
  content: "\\f037";
}
.fa-align-right:before {
  content: "\\f038";
}
.fa-align-justify:before {
  content: "\\f039";
}
.fa-list:before {
  content: "\\f03a";
}
.fa-dedent:before,
.fa-outdent:before {
  content: "\\f03b";
}
.fa-indent:before {
  content: "\\f03c";
}
.fa-video-camera:before {
  content: "\\f03d";
}
.fa-photo:before,
.fa-image:before,
.fa-picture-o:before {
  content: "\\f03e";
}
.fa-pencil:before {
  content: "\\f040";
}
.fa-map-marker:before {
  content: "\\f041";
}
.fa-adjust:before {
  content: "\\f042";
}
.fa-tint:before {
  content: "\\f043";
}
.fa-edit:before,
.fa-pencil-square-o:before {
  content: "\\f044";
}
.fa-share-square-o:before {
  content: "\\f045";
}
.fa-check-square-o:before {
  content: "\\f046";
}
.fa-arrows:before {
  content: "\\f047";
}
.fa-step-backward:before {
  content: "\\f048";
}
.fa-fast-backward:before {
  content: "\\f049";
}
.fa-backward:before {
  content: "\\f04a";
}
.fa-play:before {
  content: "\\f04b";
}
.fa-pause:before {
  content: "\\f04c";
}
.fa-stop:before {
  content: "\\f04d";
}
.fa-forward:before {
  content: "\\f04e";
}
.fa-fast-forward:before {
  content: "\\f050";
}
.fa-step-forward:before {
  content: "\\f051";
}
.fa-eject:before {
  content: "\\f052";
}
.fa-chevron-left:before {
  content: "\\f053";
}
.fa-chevron-right:before {
  content: "\\f054";
}
.fa-plus-circle:before {
  content: "\\f055";
}
.fa-minus-circle:before {
  content: "\\f056";
}
.fa-times-circle:before {
  content: "\\f057";
}
.fa-check-circle:before {
  content: "\\f058";
}
.fa-question-circle:before {
  content: "\\f059";
}
.fa-info-circle:before {
  content: "\\f05a";
}
.fa-crosshairs:before {
  content: "\\f05b";
}
.fa-times-circle-o:before {
  content: "\\f05c";
}
.fa-check-circle-o:before {
  content: "\\f05d";
}
.fa-ban:before {
  content: "\\f05e";
}
.fa-arrow-left:before {
  content: "\\f060";
}
.fa-arrow-right:before {
  content: "\\f061";
}
.fa-arrow-up:before {
  content: "\\f062";
}
.fa-arrow-down:before {
  content: "\\f063";
}
.fa-mail-forward:before,
.fa-share:before {
  content: "\\f064";
}
.fa-expand:before {
  content: "\\f065";
}
.fa-compress:before {
  content: "\\f066";
}
.fa-plus:before {
  content: "\\f067";
}
.fa-minus:before {
  content: "\\f068";
}
.fa-asterisk:before {
  content: "\\f069";
}
.fa-exclamation-circle:before {
  content: "\\f06a";
}
.fa-gift:before {
  content: "\\f06b";
}
.fa-leaf:before {
  content: "\\f06c";
}
.fa-fire:before {
  content: "\\f06d";
}
.fa-eye:before {
  content: "\\f06e";
}
.fa-eye-slash:before {
  content: "\\f070";
}
.fa-warning:before,
.fa-exclamation-triangle:before {
  content: "\\f071";
}
.fa-plane:before {
  content: "\\f072";
}
.fa-calendar:before {
  content: "\\f073";
}
.fa-random:before {
  content: "\\f074";
}
.fa-comment:before {
  content: "\\f075";
}
.fa-magnet:before {
  content: "\\f076";
}
.fa-chevron-up:before {
  content: "\\f077";
}
.fa-chevron-down:before {
  content: "\\f078";
}
.fa-retweet:before {
  content: "\\f079";
}
.fa-shopping-cart:before {
  content: "\\f07a";
}
.fa-folder:before {
  content: "\\f07b";
}
.fa-folder-open:before {
  content: "\\f07c";
}
.fa-arrows-v:before {
  content: "\\f07d";
}
.fa-arrows-h:before {
  content: "\\f07e";
}
.fa-bar-chart-o:before,
.fa-bar-chart:before {
  content: "\\f080";
}
.fa-twitter-square:before {
  content: "\\f081";
}
.fa-facebook-square:before {
  content: "\\f082";
}
.fa-camera-retro:before {
  content: "\\f083";
}
.fa-key:before {
  content: "\\f084";
}
.fa-gears:before,
.fa-cogs:before {
  content: "\\f085";
}
.fa-comments:before {
  content: "\\f086";
}
.fa-thumbs-o-up:before {
  content: "\\f087";
}
.fa-thumbs-o-down:before {
  content: "\\f088";
}
.fa-star-half:before {
  content: "\\f089";
}
.fa-heart-o:before {
  content: "\\f08a";
}
.fa-sign-out:before {
  content: "\\f08b";
}
.fa-linkedin-square:before {
  content: "\\f08c";
}
.fa-thumb-tack:before {
  content: "\\f08d";
}
.fa-external-link:before {
  content: "\\f08e";
}
.fa-sign-in:before {
  content: "\\f090";
}
.fa-trophy:before {
  content: "\\f091";
}
.fa-github-square:before {
  content: "\\f092";
}
.fa-upload:before {
  content: "\\f093";
}
.fa-lemon-o:before {
  content: "\\f094";
}
.fa-phone:before {
  content: "\\f095";
}
.fa-square-o:before {
  content: "\\f096";
}
.fa-bookmark-o:before {
  content: "\\f097";
}
.fa-phone-square:before {
  content: "\\f098";
}
.fa-twitter:before {
  content: "\\f099";
}
.fa-facebook-f:before,
.fa-facebook:before {
  content: "\\f09a";
}
.fa-github:before {
  content: "\\f09b";
}
.fa-unlock:before {
  content: "\\f09c";
}
.fa-credit-card:before {
  content: "\\f09d";
}
.fa-feed:before,
.fa-rss:before {
  content: "\\f09e";
}
.fa-hdd-o:before {
  content: "\\f0a0";
}
.fa-bullhorn:before {
  content: "\\f0a1";
}
.fa-bell:before {
  content: "\\f0f3";
}
.fa-certificate:before {
  content: "\\f0a3";
}
.fa-hand-o-right:before {
  content: "\\f0a4";
}
.fa-hand-o-left:before {
  content: "\\f0a5";
}
.fa-hand-o-up:before {
  content: "\\f0a6";
}
.fa-hand-o-down:before {
  content: "\\f0a7";
}
.fa-arrow-circle-left:before {
  content: "\\f0a8";
}
.fa-arrow-circle-right:before {
  content: "\\f0a9";
}
.fa-arrow-circle-up:before {
  content: "\\f0aa";
}
.fa-arrow-circle-down:before {
  content: "\\f0ab";
}
.fa-globe:before {
  content: "\\f0ac";
}
.fa-wrench:before {
  content: "\\f0ad";
}
.fa-tasks:before {
  content: "\\f0ae";
}
.fa-filter:before {
  content: "\\f0b0";
}
.fa-briefcase:before {
  content: "\\f0b1";
}
.fa-arrows-alt:before {
  content: "\\f0b2";
}
.fa-group:before,
.fa-users:before {
  content: "\\f0c0";
}
.fa-chain:before,
.fa-link:before {
  content: "\\f0c1";
}
.fa-cloud:before {
  content: "\\f0c2";
}
.fa-flask:before {
  content: "\\f0c3";
}
.fa-cut:before,
.fa-scissors:before {
  content: "\\f0c4";
}
.fa-copy:before,
.fa-files-o:before {
  content: "\\f0c5";
}
.fa-paperclip:before {
  content: "\\f0c6";
}
.fa-save:before,
.fa-floppy-o:before {
  content: "\\f0c7";
}
.fa-square:before {
  content: "\\f0c8";
}
.fa-navicon:before,
.fa-reorder:before,
.fa-bars:before {
  content: "\\f0c9";
}
.fa-list-ul:before {
  content: "\\f0ca";
}
.fa-list-ol:before {
  content: "\\f0cb";
}
.fa-strikethrough:before {
  content: "\\f0cc";
}
.fa-underline:before {
  content: "\\f0cd";
}
.fa-table:before {
  content: "\\f0ce";
}
.fa-magic:before {
  content: "\\f0d0";
}
.fa-truck:before {
  content: "\\f0d1";
}
.fa-pinterest:before {
  content: "\\f0d2";
}
.fa-pinterest-square:before {
  content: "\\f0d3";
}
.fa-google-plus-square:before {
  content: "\\f0d4";
}
.fa-google-plus:before {
  content: "\\f0d5";
}
.fa-money:before {
  content: "\\f0d6";
}
.fa-caret-down:before {
  content: "\\f0d7";
}
.fa-caret-up:before {
  content: "\\f0d8";
}
.fa-caret-left:before {
  content: "\\f0d9";
}
.fa-caret-right:before {
  content: "\\f0da";
}
.fa-columns:before {
  content: "\\f0db";
}
.fa-unsorted:before,
.fa-sort:before {
  content: "\\f0dc";
}
.fa-sort-down:before,
.fa-sort-desc:before {
  content: "\\f0dd";
}
.fa-sort-up:before,
.fa-sort-asc:before {
  content: "\\f0de";
}
.fa-envelope:before {
  content: "\\f0e0";
}
.fa-linkedin:before {
  content: "\\f0e1";
}
.fa-rotate-left:before,
.fa-undo:before {
  content: "\\f0e2";
}
.fa-legal:before,
.fa-gavel:before {
  content: "\\f0e3";
}
.fa-dashboard:before,
.fa-tachometer:before {
  content: "\\f0e4";
}
.fa-comment-o:before {
  content: "\\f0e5";
}
.fa-comments-o:before {
  content: "\\f0e6";
}
.fa-flash:before,
.fa-bolt:before {
  content: "\\f0e7";
}
.fa-sitemap:before {
  content: "\\f0e8";
}
.fa-umbrella:before {
  content: "\\f0e9";
}
.fa-paste:before,
.fa-clipboard:before {
  content: "\\f0ea";
}
.fa-lightbulb-o:before {
  content: "\\f0eb";
}
.fa-exchange:before {
  content: "\\f0ec";
}
.fa-cloud-download:before {
  content: "\\f0ed";
}
.fa-cloud-upload:before {
  content: "\\f0ee";
}
.fa-user-md:before {
  content: "\\f0f0";
}
.fa-stethoscope:before {
  content: "\\f0f1";
}
.fa-suitcase:before {
  content: "\\f0f2";
}
.fa-bell-o:before {
  content: "\\f0a2";
}
.fa-coffee:before {
  content: "\\f0f4";
}
.fa-cutlery:before {
  content: "\\f0f5";
}
.fa-file-text-o:before {
  content: "\\f0f6";
}
.fa-building-o:before {
  content: "\\f0f7";
}
.fa-hospital-o:before {
  content: "\\f0f8";
}
.fa-ambulance:before {
  content: "\\f0f9";
}
.fa-medkit:before {
  content: "\\f0fa";
}
.fa-fighter-jet:before {
  content: "\\f0fb";
}
.fa-beer:before {
  content: "\\f0fc";
}
.fa-h-square:before {
  content: "\\f0fd";
}
.fa-plus-square:before {
  content: "\\f0fe";
}
.fa-angle-double-left:before {
  content: "\\f100";
}
.fa-angle-double-right:before {
  content: "\\f101";
}
.fa-angle-double-up:before {
  content: "\\f102";
}
.fa-angle-double-down:before {
  content: "\\f103";
}
.fa-angle-left:before {
  content: "\\f104";
}
.fa-angle-right:before {
  content: "\\f105";
}
.fa-angle-up:before {
  content: "\\f106";
}
.fa-angle-down:before {
  content: "\\f107";
}
.fa-desktop:before {
  content: "\\f108";
}
.fa-laptop:before {
  content: "\\f109";
}
.fa-tablet:before {
  content: "\\f10a";
}
.fa-mobile-phone:before,
.fa-mobile:before {
  content: "\\f10b";
}
.fa-circle-o:before {
  content: "\\f10c";
}
.fa-quote-left:before {
  content: "\\f10d";
}
.fa-quote-right:before {
  content: "\\f10e";
}
.fa-spinner:before {
  content: "\\f110";
}
.fa-circle:before {
  content: "\\f111";
}
.fa-mail-reply:before,
.fa-reply:before {
  content: "\\f112";
}
.fa-github-alt:before {
  content: "\\f113";
}
.fa-folder-o:before {
  content: "\\f114";
}
.fa-folder-open-o:before {
  content: "\\f115";
}
.fa-smile-o:before {
  content: "\\f118";
}
.fa-frown-o:before {
  content: "\\f119";
}
.fa-meh-o:before {
  content: "\\f11a";
}
.fa-gamepad:before {
  content: "\\f11b";
}
.fa-keyboard-o:before {
  content: "\\f11c";
}
.fa-flag-o:before {
  content: "\\f11d";
}
.fa-flag-checkered:before {
  content: "\\f11e";
}
.fa-terminal:before {
  content: "\\f120";
}
.fa-code:before {
  content: "\\f121";
}
.fa-mail-reply-all:before,
.fa-reply-all:before {
  content: "\\f122";
}
.fa-star-half-empty:before,
.fa-star-half-full:before,
.fa-star-half-o:before {
  content: "\\f123";
}
.fa-location-arrow:before {
  content: "\\f124";
}
.fa-crop:before {
  content: "\\f125";
}
.fa-code-fork:before {
  content: "\\f126";
}
.fa-unlink:before,
.fa-chain-broken:before {
  content: "\\f127";
}
.fa-question:before {
  content: "\\f128";
}
.fa-info:before {
  content: "\\f129";
}
.fa-exclamation:before {
  content: "\\f12a";
}
.fa-superscript:before {
  content: "\\f12b";
}
.fa-subscript:before {
  content: "\\f12c";
}
.fa-eraser:before {
  content: "\\f12d";
}
.fa-puzzle-piece:before {
  content: "\\f12e";
}
.fa-microphone:before {
  content: "\\f130";
}
.fa-microphone-slash:before {
  content: "\\f131";
}
.fa-shield:before {
  content: "\\f132";
}
.fa-calendar-o:before {
  content: "\\f133";
}
.fa-fire-extinguisher:before {
  content: "\\f134";
}
.fa-rocket:before {
  content: "\\f135";
}
.fa-maxcdn:before {
  content: "\\f136";
}
.fa-chevron-circle-left:before {
  content: "\\f137";
}
.fa-chevron-circle-right:before {
  content: "\\f138";
}
.fa-chevron-circle-up:before {
  content: "\\f139";
}
.fa-chevron-circle-down:before {
  content: "\\f13a";
}
.fa-html5:before {
  content: "\\f13b";
}
.fa-css3:before {
  content: "\\f13c";
}
.fa-anchor:before {
  content: "\\f13d";
}
.fa-unlock-alt:before {
  content: "\\f13e";
}
.fa-bullseye:before {
  content: "\\f140";
}
.fa-ellipsis-h:before {
  content: "\\f141";
}
.fa-ellipsis-v:before {
  content: "\\f142";
}
.fa-rss-square:before {
  content: "\\f143";
}
.fa-play-circle:before {
  content: "\\f144";
}
.fa-ticket:before {
  content: "\\f145";
}
.fa-minus-square:before {
  content: "\\f146";
}
.fa-minus-square-o:before {
  content: "\\f147";
}
.fa-level-up:before {
  content: "\\f148";
}
.fa-level-down:before {
  content: "\\f149";
}
.fa-check-square:before {
  content: "\\f14a";
}
.fa-pencil-square:before {
  content: "\\f14b";
}
.fa-external-link-square:before {
  content: "\\f14c";
}
.fa-share-square:before {
  content: "\\f14d";
}
.fa-compass:before {
  content: "\\f14e";
}
.fa-toggle-down:before,
.fa-caret-square-o-down:before {
  content: "\\f150";
}
.fa-toggle-up:before,
.fa-caret-square-o-up:before {
  content: "\\f151";
}
.fa-toggle-right:before,
.fa-caret-square-o-right:before {
  content: "\\f152";
}
.fa-euro:before,
.fa-eur:before {
  content: "\\f153";
}
.fa-gbp:before {
  content: "\\f154";
}
.fa-dollar:before,
.fa-usd:before {
  content: "\\f155";
}
.fa-rupee:before,
.fa-inr:before {
  content: "\\f156";
}
.fa-cny:before,
.fa-rmb:before,
.fa-yen:before,
.fa-jpy:before {
  content: "\\f157";
}
.fa-ruble:before,
.fa-rouble:before,
.fa-rub:before {
  content: "\\f158";
}
.fa-won:before,
.fa-krw:before {
  content: "\\f159";
}
.fa-bitcoin:before,
.fa-btc:before {
  content: "\\f15a";
}
.fa-file:before {
  content: "\\f15b";
}
.fa-file-text:before {
  content: "\\f15c";
}
.fa-sort-alpha-asc:before {
  content: "\\f15d";
}
.fa-sort-alpha-desc:before {
  content: "\\f15e";
}
.fa-sort-amount-asc:before {
  content: "\\f160";
}
.fa-sort-amount-desc:before {
  content: "\\f161";
}
.fa-sort-numeric-asc:before {
  content: "\\f162";
}
.fa-sort-numeric-desc:before {
  content: "\\f163";
}
.fa-thumbs-up:before {
  content: "\\f164";
}
.fa-thumbs-down:before {
  content: "\\f165";
}
.fa-youtube-square:before {
  content: "\\f166";
}
.fa-youtube:before {
  content: "\\f167";
}
.fa-xing:before {
  content: "\\f168";
}
.fa-xing-square:before {
  content: "\\f169";
}
.fa-youtube-play:before {
  content: "\\f16a";
}
.fa-dropbox:before {
  content: "\\f16b";
}
.fa-stack-overflow:before {
  content: "\\f16c";
}
.fa-instagram:before {
  content: "\\f16d";
}
.fa-flickr:before {
  content: "\\f16e";
}
.fa-adn:before {
  content: "\\f170";
}
.fa-bitbucket:before {
  content: "\\f171";
}
.fa-bitbucket-square:before {
  content: "\\f172";
}
.fa-tumblr:before {
  content: "\\f173";
}
.fa-tumblr-square:before {
  content: "\\f174";
}
.fa-long-arrow-down:before {
  content: "\\f175";
}
.fa-long-arrow-up:before {
  content: "\\f176";
}
.fa-long-arrow-left:before {
  content: "\\f177";
}
.fa-long-arrow-right:before {
  content: "\\f178";
}
.fa-apple:before {
  content: "\\f179";
}
.fa-windows:before {
  content: "\\f17a";
}
.fa-android:before {
  content: "\\f17b";
}
.fa-linux:before {
  content: "\\f17c";
}
.fa-dribbble:before {
  content: "\\f17d";
}
.fa-skype:before {
  content: "\\f17e";
}
.fa-foursquare:before {
  content: "\\f180";
}
.fa-trello:before {
  content: "\\f181";
}
.fa-female:before {
  content: "\\f182";
}
.fa-male:before {
  content: "\\f183";
}
.fa-gittip:before,
.fa-gratipay:before {
  content: "\\f184";
}
.fa-sun-o:before {
  content: "\\f185";
}
.fa-moon-o:before {
  content: "\\f186";
}
.fa-archive:before {
  content: "\\f187";
}
.fa-bug:before {
  content: "\\f188";
}
.fa-vk:before {
  content: "\\f189";
}
.fa-weibo:before {
  content: "\\f18a";
}
.fa-renren:before {
  content: "\\f18b";
}
.fa-pagelines:before {
  content: "\\f18c";
}
.fa-stack-exchange:before {
  content: "\\f18d";
}
.fa-arrow-circle-o-right:before {
  content: "\\f18e";
}
.fa-arrow-circle-o-left:before {
  content: "\\f190";
}
.fa-toggle-left:before,
.fa-caret-square-o-left:before {
  content: "\\f191";
}
.fa-dot-circle-o:before {
  content: "\\f192";
}
.fa-wheelchair:before {
  content: "\\f193";
}
.fa-vimeo-square:before {
  content: "\\f194";
}
.fa-turkish-lira:before,
.fa-try:before {
  content: "\\f195";
}
.fa-plus-square-o:before {
  content: "\\f196";
}
.fa-space-shuttle:before {
  content: "\\f197";
}
.fa-slack:before {
  content: "\\f198";
}
.fa-envelope-square:before {
  content: "\\f199";
}
.fa-wordpress:before {
  content: "\\f19a";
}
.fa-openid:before {
  content: "\\f19b";
}
.fa-institution:before,
.fa-bank:before,
.fa-university:before {
  content: "\\f19c";
}
.fa-mortar-board:before,
.fa-graduation-cap:before {
  content: "\\f19d";
}
.fa-yahoo:before {
  content: "\\f19e";
}
.fa-google:before {
  content: "\\f1a0";
}
.fa-reddit:before {
  content: "\\f1a1";
}
.fa-reddit-square:before {
  content: "\\f1a2";
}
.fa-stumbleupon-circle:before {
  content: "\\f1a3";
}
.fa-stumbleupon:before {
  content: "\\f1a4";
}
.fa-delicious:before {
  content: "\\f1a5";
}
.fa-digg:before {
  content: "\\f1a6";
}
.fa-pied-piper-pp:before {
  content: "\\f1a7";
}
.fa-pied-piper-alt:before {
  content: "\\f1a8";
}
.fa-drupal:before {
  content: "\\f1a9";
}
.fa-joomla:before {
  content: "\\f1aa";
}
.fa-language:before {
  content: "\\f1ab";
}
.fa-fax:before {
  content: "\\f1ac";
}
.fa-building:before {
  content: "\\f1ad";
}
.fa-child:before {
  content: "\\f1ae";
}
.fa-paw:before {
  content: "\\f1b0";
}
.fa-spoon:before {
  content: "\\f1b1";
}
.fa-cube:before {
  content: "\\f1b2";
}
.fa-cubes:before {
  content: "\\f1b3";
}
.fa-behance:before {
  content: "\\f1b4";
}
.fa-behance-square:before {
  content: "\\f1b5";
}
.fa-steam:before {
  content: "\\f1b6";
}
.fa-steam-square:before {
  content: "\\f1b7";
}
.fa-recycle:before {
  content: "\\f1b8";
}
.fa-automobile:before,
.fa-car:before {
  content: "\\f1b9";
}
.fa-cab:before,
.fa-taxi:before {
  content: "\\f1ba";
}
.fa-tree:before {
  content: "\\f1bb";
}
.fa-spotify:before {
  content: "\\f1bc";
}
.fa-deviantart:before {
  content: "\\f1bd";
}
.fa-soundcloud:before {
  content: "\\f1be";
}
.fa-database:before {
  content: "\\f1c0";
}
.fa-file-pdf-o:before {
  content: "\\f1c1";
}
.fa-file-word-o:before {
  content: "\\f1c2";
}
.fa-file-excel-o:before {
  content: "\\f1c3";
}
.fa-file-powerpoint-o:before {
  content: "\\f1c4";
}
.fa-file-photo-o:before,
.fa-file-picture-o:before,
.fa-file-image-o:before {
  content: "\\f1c5";
}
.fa-file-zip-o:before,
.fa-file-archive-o:before {
  content: "\\f1c6";
}
.fa-file-sound-o:before,
.fa-file-audio-o:before {
  content: "\\f1c7";
}
.fa-file-movie-o:before,
.fa-file-video-o:before {
  content: "\\f1c8";
}
.fa-file-code-o:before {
  content: "\\f1c9";
}
.fa-vine:before {
  content: "\\f1ca";
}
.fa-codepen:before {
  content: "\\f1cb";
}
.fa-jsfiddle:before {
  content: "\\f1cc";
}
.fa-life-bouy:before,
.fa-life-buoy:before,
.fa-life-saver:before,
.fa-support:before,
.fa-life-ring:before {
  content: "\\f1cd";
}
.fa-circle-o-notch:before {
  content: "\\f1ce";
}
.fa-ra:before,
.fa-resistance:before,
.fa-rebel:before {
  content: "\\f1d0";
}
.fa-ge:before,
.fa-empire:before {
  content: "\\f1d1";
}
.fa-git-square:before {
  content: "\\f1d2";
}
.fa-git:before {
  content: "\\f1d3";
}
.fa-y-combinator-square:before,
.fa-yc-square:before,
.fa-hacker-news:before {
  content: "\\f1d4";
}
.fa-tencent-weibo:before {
  content: "\\f1d5";
}
.fa-qq:before {
  content: "\\f1d6";
}
.fa-wechat:before,
.fa-weixin:before {
  content: "\\f1d7";
}
.fa-send:before,
.fa-paper-plane:before {
  content: "\\f1d8";
}
.fa-send-o:before,
.fa-paper-plane-o:before {
  content: "\\f1d9";
}
.fa-history:before {
  content: "\\f1da";
}
.fa-circle-thin:before {
  content: "\\f1db";
}
.fa-header:before {
  content: "\\f1dc";
}
.fa-paragraph:before {
  content: "\\f1dd";
}
.fa-sliders:before {
  content: "\\f1de";
}
.fa-share-alt:before {
  content: "\\f1e0";
}
.fa-share-alt-square:before {
  content: "\\f1e1";
}
.fa-bomb:before {
  content: "\\f1e2";
}
.fa-soccer-ball-o:before,
.fa-futbol-o:before {
  content: "\\f1e3";
}
.fa-tty:before {
  content: "\\f1e4";
}
.fa-binoculars:before {
  content: "\\f1e5";
}
.fa-plug:before {
  content: "\\f1e6";
}
.fa-slideshare:before {
  content: "\\f1e7";
}
.fa-twitch:before {
  content: "\\f1e8";
}
.fa-yelp:before {
  content: "\\f1e9";
}
.fa-newspaper-o:before {
  content: "\\f1ea";
}
.fa-wifi:before {
  content: "\\f1eb";
}
.fa-calculator:before {
  content: "\\f1ec";
}
.fa-paypal:before {
  content: "\\f1ed";
}
.fa-google-wallet:before {
  content: "\\f1ee";
}
.fa-cc-visa:before {
  content: "\\f1f0";
}
.fa-cc-mastercard:before {
  content: "\\f1f1";
}
.fa-cc-discover:before {
  content: "\\f1f2";
}
.fa-cc-amex:before {
  content: "\\f1f3";
}
.fa-cc-paypal:before {
  content: "\\f1f4";
}
.fa-cc-stripe:before {
  content: "\\f1f5";
}
.fa-bell-slash:before {
  content: "\\f1f6";
}
.fa-bell-slash-o:before {
  content: "\\f1f7";
}
.fa-trash:before {
  content: "\\f1f8";
}
.fa-copyright:before {
  content: "\\f1f9";
}
.fa-at:before {
  content: "\\f1fa";
}
.fa-eyedropper:before {
  content: "\\f1fb";
}
.fa-paint-brush:before {
  content: "\\f1fc";
}
.fa-birthday-cake:before {
  content: "\\f1fd";
}
.fa-area-chart:before {
  content: "\\f1fe";
}
.fa-pie-chart:before {
  content: "\\f200";
}
.fa-line-chart:before {
  content: "\\f201";
}
.fa-lastfm:before {
  content: "\\f202";
}
.fa-lastfm-square:before {
  content: "\\f203";
}
.fa-toggle-off:before {
  content: "\\f204";
}
.fa-toggle-on:before {
  content: "\\f205";
}
.fa-bicycle:before {
  content: "\\f206";
}
.fa-bus:before {
  content: "\\f207";
}
.fa-ioxhost:before {
  content: "\\f208";
}
.fa-angellist:before {
  content: "\\f209";
}
.fa-cc:before {
  content: "\\f20a";
}
.fa-shekel:before,
.fa-sheqel:before,
.fa-ils:before {
  content: "\\f20b";
}
.fa-meanpath:before {
  content: "\\f20c";
}
.fa-buysellads:before {
  content: "\\f20d";
}
.fa-connectdevelop:before {
  content: "\\f20e";
}
.fa-dashcube:before {
  content: "\\f210";
}
.fa-forumbee:before {
  content: "\\f211";
}
.fa-leanpub:before {
  content: "\\f212";
}
.fa-sellsy:before {
  content: "\\f213";
}
.fa-shirtsinbulk:before {
  content: "\\f214";
}
.fa-simplybuilt:before {
  content: "\\f215";
}
.fa-skyatlas:before {
  content: "\\f216";
}
.fa-cart-plus:before {
  content: "\\f217";
}
.fa-cart-arrow-down:before {
  content: "\\f218";
}
.fa-diamond:before {
  content: "\\f219";
}
.fa-ship:before {
  content: "\\f21a";
}
.fa-user-secret:before {
  content: "\\f21b";
}
.fa-motorcycle:before {
  content: "\\f21c";
}
.fa-street-view:before {
  content: "\\f21d";
}
.fa-heartbeat:before {
  content: "\\f21e";
}
.fa-venus:before {
  content: "\\f221";
}
.fa-mars:before {
  content: "\\f222";
}
.fa-mercury:before {
  content: "\\f223";
}
.fa-intersex:before,
.fa-transgender:before {
  content: "\\f224";
}
.fa-transgender-alt:before {
  content: "\\f225";
}
.fa-venus-double:before {
  content: "\\f226";
}
.fa-mars-double:before {
  content: "\\f227";
}
.fa-venus-mars:before {
  content: "\\f228";
}
.fa-mars-stroke:before {
  content: "\\f229";
}
.fa-mars-stroke-v:before {
  content: "\\f22a";
}
.fa-mars-stroke-h:before {
  content: "\\f22b";
}
.fa-neuter:before {
  content: "\\f22c";
}
.fa-genderless:before {
  content: "\\f22d";
}
.fa-facebook-official:before {
  content: "\\f230";
}
.fa-pinterest-p:before {
  content: "\\f231";
}
.fa-whatsapp:before {
  content: "\\f232";
}
.fa-server:before {
  content: "\\f233";
}
.fa-user-plus:before {
  content: "\\f234";
}
.fa-user-times:before {
  content: "\\f235";
}
.fa-hotel:before,
.fa-bed:before {
  content: "\\f236";
}
.fa-viacoin:before {
  content: "\\f237";
}
.fa-train:before {
  content: "\\f238";
}
.fa-subway:before {
  content: "\\f239";
}
.fa-medium:before {
  content: "\\f23a";
}
.fa-yc:before,
.fa-y-combinator:before {
  content: "\\f23b";
}
.fa-optin-monster:before {
  content: "\\f23c";
}
.fa-opencart:before {
  content: "\\f23d";
}
.fa-expeditedssl:before {
  content: "\\f23e";
}
.fa-battery-4:before,
.fa-battery:before,
.fa-battery-full:before {
  content: "\\f240";
}
.fa-battery-3:before,
.fa-battery-three-quarters:before {
  content: "\\f241";
}
.fa-battery-2:before,
.fa-battery-half:before {
  content: "\\f242";
}
.fa-battery-1:before,
.fa-battery-quarter:before {
  content: "\\f243";
}
.fa-battery-0:before,
.fa-battery-empty:before {
  content: "\\f244";
}
.fa-mouse-pointer:before {
  content: "\\f245";
}
.fa-i-cursor:before {
  content: "\\f246";
}
.fa-object-group:before {
  content: "\\f247";
}
.fa-object-ungroup:before {
  content: "\\f248";
}
.fa-sticky-note:before {
  content: "\\f249";
}
.fa-sticky-note-o:before {
  content: "\\f24a";
}
.fa-cc-jcb:before {
  content: "\\f24b";
}
.fa-cc-diners-club:before {
  content: "\\f24c";
}
.fa-clone:before {
  content: "\\f24d";
}
.fa-balance-scale:before {
  content: "\\f24e";
}
.fa-hourglass-o:before {
  content: "\\f250";
}
.fa-hourglass-1:before,
.fa-hourglass-start:before {
  content: "\\f251";
}
.fa-hourglass-2:before,
.fa-hourglass-half:before {
  content: "\\f252";
}
.fa-hourglass-3:before,
.fa-hourglass-end:before {
  content: "\\f253";
}
.fa-hourglass:before {
  content: "\\f254";
}
.fa-hand-grab-o:before,
.fa-hand-rock-o:before {
  content: "\\f255";
}
.fa-hand-stop-o:before,
.fa-hand-paper-o:before {
  content: "\\f256";
}
.fa-hand-scissors-o:before {
  content: "\\f257";
}
.fa-hand-lizard-o:before {
  content: "\\f258";
}
.fa-hand-spock-o:before {
  content: "\\f259";
}
.fa-hand-pointer-o:before {
  content: "\\f25a";
}
.fa-hand-peace-o:before {
  content: "\\f25b";
}
.fa-trademark:before {
  content: "\\f25c";
}
.fa-registered:before {
  content: "\\f25d";
}
.fa-creative-commons:before {
  content: "\\f25e";
}
.fa-gg:before {
  content: "\\f260";
}
.fa-gg-circle:before {
  content: "\\f261";
}
.fa-tripadvisor:before {
  content: "\\f262";
}
.fa-odnoklassniki:before {
  content: "\\f263";
}
.fa-odnoklassniki-square:before {
  content: "\\f264";
}
.fa-get-pocket:before {
  content: "\\f265";
}
.fa-wikipedia-w:before {
  content: "\\f266";
}
.fa-safari:before {
  content: "\\f267";
}
.fa-chrome:before {
  content: "\\f268";
}
.fa-firefox:before {
  content: "\\f269";
}
.fa-opera:before {
  content: "\\f26a";
}
.fa-internet-explorer:before {
  content: "\\f26b";
}
.fa-tv:before,
.fa-television:before {
  content: "\\f26c";
}
.fa-contao:before {
  content: "\\f26d";
}
.fa-500px:before {
  content: "\\f26e";
}
.fa-amazon:before {
  content: "\\f270";
}
.fa-calendar-plus-o:before {
  content: "\\f271";
}
.fa-calendar-minus-o:before {
  content: "\\f272";
}
.fa-calendar-times-o:before {
  content: "\\f273";
}
.fa-calendar-check-o:before {
  content: "\\f274";
}
.fa-industry:before {
  content: "\\f275";
}
.fa-map-pin:before {
  content: "\\f276";
}
.fa-map-signs:before {
  content: "\\f277";
}
.fa-map-o:before {
  content: "\\f278";
}
.fa-map:before {
  content: "\\f279";
}
.fa-commenting:before {
  content: "\\f27a";
}
.fa-commenting-o:before {
  content: "\\f27b";
}
.fa-houzz:before {
  content: "\\f27c";
}
.fa-vimeo:before {
  content: "\\f27d";
}
.fa-black-tie:before {
  content: "\\f27e";
}
.fa-fonticons:before {
  content: "\\f280";
}
.fa-reddit-alien:before {
  content: "\\f281";
}
.fa-edge:before {
  content: "\\f282";
}
.fa-credit-card-alt:before {
  content: "\\f283";
}
.fa-codiepie:before {
  content: "\\f284";
}
.fa-modx:before {
  content: "\\f285";
}
.fa-fort-awesome:before {
  content: "\\f286";
}
.fa-usb:before {
  content: "\\f287";
}
.fa-product-hunt:before {
  content: "\\f288";
}
.fa-mixcloud:before {
  content: "\\f289";
}
.fa-scribd:before {
  content: "\\f28a";
}
.fa-pause-circle:before {
  content: "\\f28b";
}
.fa-pause-circle-o:before {
  content: "\\f28c";
}
.fa-stop-circle:before {
  content: "\\f28d";
}
.fa-stop-circle-o:before {
  content: "\\f28e";
}
.fa-shopping-bag:before {
  content: "\\f290";
}
.fa-shopping-basket:before {
  content: "\\f291";
}
.fa-hashtag:before {
  content: "\\f292";
}
.fa-bluetooth:before {
  content: "\\f293";
}
.fa-bluetooth-b:before {
  content: "\\f294";
}
.fa-percent:before {
  content: "\\f295";
}
.fa-gitlab:before {
  content: "\\f296";
}
.fa-wpbeginner:before {
  content: "\\f297";
}
.fa-wpforms:before {
  content: "\\f298";
}
.fa-envira:before {
  content: "\\f299";
}
.fa-universal-access:before {
  content: "\\f29a";
}
.fa-wheelchair-alt:before {
  content: "\\f29b";
}
.fa-question-circle-o:before {
  content: "\\f29c";
}
.fa-blind:before {
  content: "\\f29d";
}
.fa-audio-description:before {
  content: "\\f29e";
}
.fa-volume-control-phone:before {
  content: "\\f2a0";
}
.fa-braille:before {
  content: "\\f2a1";
}
.fa-assistive-listening-systems:before {
  content: "\\f2a2";
}
.fa-asl-interpreting:before,
.fa-american-sign-language-interpreting:before {
  content: "\\f2a3";
}
.fa-deafness:before,
.fa-hard-of-hearing:before,
.fa-deaf:before {
  content: "\\f2a4";
}
.fa-glide:before {
  content: "\\f2a5";
}
.fa-glide-g:before {
  content: "\\f2a6";
}
.fa-signing:before,
.fa-sign-language:before {
  content: "\\f2a7";
}
.fa-low-vision:before {
  content: "\\f2a8";
}
.fa-viadeo:before {
  content: "\\f2a9";
}
.fa-viadeo-square:before {
  content: "\\f2aa";
}
.fa-snapchat:before {
  content: "\\f2ab";
}
.fa-snapchat-ghost:before {
  content: "\\f2ac";
}
.fa-snapchat-square:before {
  content: "\\f2ad";
}
.fa-pied-piper:before {
  content: "\\f2ae";
}
.fa-first-order:before {
  content: "\\f2b0";
}
.fa-yoast:before {
  content: "\\f2b1";
}
.fa-themeisle:before {
  content: "\\f2b2";
}
.fa-google-plus-circle:before,
.fa-google-plus-official:before {
  content: "\\f2b3";
}
.fa-fa:before,
.fa-font-awesome:before {
  content: "\\f2b4";
}
.fa-handshake-o:before {
  content: "\\f2b5";
}
.fa-envelope-open:before {
  content: "\\f2b6";
}
.fa-envelope-open-o:before {
  content: "\\f2b7";
}
.fa-linode:before {
  content: "\\f2b8";
}
.fa-address-book:before {
  content: "\\f2b9";
}
.fa-address-book-o:before {
  content: "\\f2ba";
}
.fa-vcard:before,
.fa-address-card:before {
  content: "\\f2bb";
}
.fa-vcard-o:before,
.fa-address-card-o:before {
  content: "\\f2bc";
}
.fa-user-circle:before {
  content: "\\f2bd";
}
.fa-user-circle-o:before {
  content: "\\f2be";
}
.fa-user-o:before {
  content: "\\f2c0";
}
.fa-id-badge:before {
  content: "\\f2c1";
}
.fa-drivers-license:before,
.fa-id-card:before {
  content: "\\f2c2";
}
.fa-drivers-license-o:before,
.fa-id-card-o:before {
  content: "\\f2c3";
}
.fa-quora:before {
  content: "\\f2c4";
}
.fa-free-code-camp:before {
  content: "\\f2c5";
}
.fa-telegram:before {
  content: "\\f2c6";
}
.fa-thermometer-4:before,
.fa-thermometer:before,
.fa-thermometer-full:before {
  content: "\\f2c7";
}
.fa-thermometer-3:before,
.fa-thermometer-three-quarters:before {
  content: "\\f2c8";
}
.fa-thermometer-2:before,
.fa-thermometer-half:before {
  content: "\\f2c9";
}
.fa-thermometer-1:before,
.fa-thermometer-quarter:before {
  content: "\\f2ca";
}
.fa-thermometer-0:before,
.fa-thermometer-empty:before {
  content: "\\f2cb";
}
.fa-shower:before {
  content: "\\f2cc";
}
.fa-bathtub:before,
.fa-s15:before,
.fa-bath:before {
  content: "\\f2cd";
}
.fa-podcast:before {
  content: "\\f2ce";
}
.fa-window-maximize:before {
  content: "\\f2d0";
}
.fa-window-minimize:before {
  content: "\\f2d1";
}
.fa-window-restore:before {
  content: "\\f2d2";
}
.fa-times-rectangle:before,
.fa-window-close:before {
  content: "\\f2d3";
}
.fa-times-rectangle-o:before,
.fa-window-close-o:before {
  content: "\\f2d4";
}
.fa-bandcamp:before {
  content: "\\f2d5";
}
.fa-grav:before {
  content: "\\f2d6";
}
.fa-etsy:before {
  content: "\\f2d7";
}
.fa-imdb:before {
  content: "\\f2d8";
}
.fa-ravelry:before {
  content: "\\f2d9";
}
.fa-eercast:before {
  content: "\\f2da";
}
.fa-microchip:before {
  content: "\\f2db";
}
.fa-snowflake-o:before {
  content: "\\f2dc";
}
.fa-superpowers:before {
  content: "\\f2dd";
}
.fa-wpexplorer:before {
  content: "\\f2de";
}
.fa-meetup:before {
  content: "\\f2e0";
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}
.breadcrumb {
  background-color: transparent;
  border-radius: none;
  padding: 15px 0;
  margin-bottom: 2px;
  display: inline-block;
  margin-left: 8px;
}
.breadcrumb > .active a {
  /*color: @breadcrumb-active-color;*/
  color: #475569;
}
.edit-user {
  margin-left: 15px;
  position: relative;
  top: -5px;
}
.breadcrumb a,
.edit-user {
  color: #475569;
}
.breadcrumb {
  margin-top: -7px;
}
.company-list {
  margin-top: 40px;
}
@media (max-width: 767px) {
  .company-list {
    margin-top: 20px;
  }
}
.company-list .company-item {
  display: block;
  padding: 15px 30px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #849099;
  box-shadow: 2px 2px 2px #999;
}
.company-list .company-item h4 {
  font-family: "Lato", sans-serif;
  font-size: 18px;
  font-weight: bold;
  color: #154261;
  margin: 0 0 10px 0;
}
.company-list .company-item:hover,
.company-list .company-item:focus,
.company-list .company-item:active {
  background-color: #F7FBFC;
  text-decoration: none;
  box-shadow: 2px 2px 2px #ccc;
}
.company-header {
  margin-top: 40px;
}
@media (max-width: 767px) {
  .company-header {
    margin-top: 0;
  }
}
.avatar {
  display: block;
  width: 52px;
  height: 52px;
  line-height: 52px;
  border-radius: 32px;
  border: 1px solid #366382;
  text-align: center;
  text-transform: uppercase;
}
.customer-list-header {
  padding: 20px;
  display: flex;
  margin: 0 -15px;
}
.customer-list-header-right-col,
.customer-list-header-left-col {
  flex: 1;
  display: flex;
  align-items: center;
}
.customer-list-header-middle-col {
  flex: 1;
  display: flex;
  align-items: right;
}
.customer-list-header-left-col {
  overflow: hidden;
}
.customer-list-header-right-col {
  justify-content: flex-end;
}
.customer-list-header-title {
  font-size: 24px;
  line-height: 1;
  font-family: "Lato", sans-serif;
}
.customer-list-header-extra {
  margin-left: 5px;
  font-size: 18px;
  padding: 15px;
}
.customer-single-element {
  display: flex;
  align-items: center;
  min-width: 250px;
}
.customer-list-row .customer-single-element {
  min-width: 300px;
}
.customer-single-element-right {
  margin-left: 20px;
}
.customer-sub-title {
  margin-top: 0;
  margin-bottom: 5px;
  color: #1e293b;
  display: inline-block;
}
.customer-single-element-right-phone {
  color: #1e293b;
}
.customer-list {
  margin: 0 -15px;
}
.no-video-container {
  background: linear-gradient(135deg, var(--surface-color) 0%, #1e293b 100%);
  border: 1px dashed var(--border-color);
  border-radius: var(--radius-lg);
  display: flex;
  justify-content: center;
  align-items: center;
}
.no-video-container h3 {
  text-align: center;
  color: var(--text-secondary);
  font-weight: 500;
}
.customer-list-row {
  padding: 25px 40px;
  display: block;
  border-bottom: 1px solid #d6d6d6;
  display: flex;
}
.customer-list-row:hover,
.customer-list-row:active,
.customer-list-row:focus {
  text-decoration: none;
  background: rgba(0, 0, 0, 0.025);
}
.customer-list-row-last-event {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.customer-list-row-last-event-time-clock {
  color: #1e293b;
  margin-left: 20px;
  display: inline-block;
}
.customer-list-row-text {
  color: black;
}
.customer-list-row-text-small {
  color: #777;
  font-size: 12px;
}
.customer-list-row-deleted {
  background-color: #cecece;
}
@media (max-width: 1199px) {
  .customer-list-header-title {
    font-size: 20px;
  }
}
@media (max-width: 767px) {
  .customer-list-header-title {
    font-size: 16px;
    line-height: 1.3;
  }
  .customer-list-header {
    padding: 30px 15px;
  }
  .customer-single-element-right {
    margin-left: 15px;
  }
  .customer-list-header-extra {
    margin-left: 10px;
  }
  .customer-list-row {
    padding: 20px 15px;
    flex-direction: column;
    position: relative;
  }
  .customer-list-row-last-event {
    margin-left: 0;
  }
  .customer-list-row-last-event-time {
    position: absolute;
    right: 15px;
    top: 46px;
  }
  .customer-list-row-last-event-text,
  .customer-list-row-last-event-empty,
  .customer-list-row-text {
    margin-top: 15px;
    display: block;
  }
}
/* ============================================================
   EVENT LIST (Right Column – Timeline)
   ============================================================ */
.middle {
  flex: 1;
  display: flex;
  overflow: hidden;
  position: relative;
}
.no-entries {
  margin: 16px;
  display: block;
  font-size: 13px;
  color: var(--text-muted);
  text-align: center;
  padding: 32px 0;
}
.spread {
  width: 100%;
}
.event-items {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
  -webkit-overflow-scrolling: touch;
  padding: 12px 0 8px;
  scrollbar-width: thin;
  scrollbar-color: var(--surface-3) transparent;
}
.event-items::-webkit-scrollbar {
  width: 4px;
}
.event-items::-webkit-scrollbar-track {
  background: transparent;
}
.event-items::-webkit-scrollbar-thumb {
  background: var(--surface-3);
  border-radius: 4px;
}
/* ── Individual call entry group ── */
.call {
  position: relative;
  box-sizing: border-box;
  /* Vertical timeline connector */
}
.call.dragging {
  border: 1px dashed var(--primary-color);
  opacity: 0.8;
}
.call:first-child {
  margin-top: 0;
}
.call.show-dots::before {
  content: '';
  border-left: 2px dashed rgba(255, 255, 255, 0.06);
  top: 28px;
  bottom: 20px;
  left: 51px;
  position: absolute;
  z-index: 1;
}
.call-title {
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 500;
  margin: auto;
  margin-left: 0;
}
.remove-event {
  cursor: pointer;
  color: var(--danger-color);
  opacity: 0.5;
  transition: opacity var(--transition-fast);
}
.remove-event:hover,
.remove-event:active,
.remove-event:focus {
  opacity: 1;
}
.can-drag {
  cursor: move;
}
/* ── Event card ── */
.event-row {
  display: flex;
  min-height: 60px;
  position: relative;
  padding: 12px 14px;
  box-sizing: border-box;
  background: var(--surface-2);
  margin: 6px 10px;
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  animation: fadeInUp 0.3s ease-out both;
  z-index: 2;
  transition: border-color var(--transition-fast), background var(--transition-fast);
}
.event-row:last-child {
  margin-bottom: 16px;
}
.event-row:hover {
  background: var(--surface-3);
  border-color: rgba(255, 255, 255, 0.1);
}
.event-row.has-order {
  padding-bottom: 18px;
}
.event-row .avatar {
  background: transparent;
  width: 36px;
  height: 36px;
  line-height: 36px;
  border: 1.5px solid var(--primary-color);
  color: var(--primary-color);
  font-size: 12px;
  font-weight: 700;
  border-radius: 50%;
  text-align: center;
  flex-shrink: 0;
}
/* ── Event: call begin (green accent) ── */
.call-begin {
  background: rgba(34, 197, 94, 0.05);
  border-color: rgba(34, 197, 94, 0.15);
}
.call-begin:hover {
  background: rgba(34, 197, 94, 0.08);
  border-color: rgba(34, 197, 94, 0.2);
}
/* ── Event: call end (red accent) ── */
.call-end {
  background: rgba(239, 68, 68, 0.05);
  border-color: rgba(239, 68, 68, 0.15);
}
.call-end:hover {
  background: rgba(239, 68, 68, 0.08);
  border-color: rgba(239, 68, 68, 0.2);
}
/* ── Event row layout ── */
.event-row-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex: 0 0 50px;
  overflow: visible;
}
.event-row-header > *:not(:first-child) {
  margin-left: 10px;
}
.event-row-header .event-row-text {
  margin-right: 0;
}
.event-row-header-date-time {
  text-align: right;
  font-size: 11px;
  color: var(--text-muted);
  white-space: nowrap;
}
.event-row-body {
  display: flex;
}
.event-row-left-col,
.event-row-right-col {
  display: flex;
}
.event-row-left-col {
  flex: 0 0 48px;
}
.event-row-right-col {
  flex: 1;
  flex-direction: column;
  max-width: calc(100% - 48px);
}
@media (max-width: 767px) {
  .event-row-right-col {
    max-width: calc(100% - 36px);
  }
}
.event-row-right-col-waiting {
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
}
.event-row-text {
  color: var(--text-primary);
  font-size: 13px;
  margin-right: 0;
  flex: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.event-row-text textarea.form-control {
  margin-top: 10px;
  background: var(--surface-3);
  color: var(--text-primary);
  border: 1px solid var(--border);
}
@media (max-width: 1199px) {
  .event-row-text {
    margin-right: 0;
  }
}
@media (max-width: 767px) {
  .event-row-text {
    margin-right: 0;
    flex-direction: column;
    align-items: flex-start;
  }
}
.event-row-text p {
  flex: 1;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 13px;
  color: var(--text-secondary);
}
.valign {
  display: flex;
  align-items: center;
}
.img-thumbnail {
  width: 33%;
}
/* ── Event icon circle ── */
.event-icon {
  background: transparent;
  width: 36px;
  height: 36px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
.event-icon i {
  font-size: 14px;
}
/* ── Keyframe animation ── */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 8px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.vertical-center {
  position: relative;
}
.vertical-center * {
  position: absolute;
  top: -50%;
  transform: translateY(50%);
}
/* ── Ordered in label ── */
.ordered-in {
  color: var(--text-muted);
  font-size: 12px;
  display: flex;
  margin: auto;
  margin-left: 0;
  overflow-x: hidden;
}
.ordered-in > *:not(:first-child) {
  margin-left: 6px;
}
.ordered-in a {
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
  color: var(--primary-color);
}
.event-row-text-end-note {
  font-size: 13px;
  color: var(--text-secondary);
}
.drag-handle {
  font-size: 16px;
  cursor: move;
  color: var(--text-muted);
  transition: color var(--transition-fast);
}
.drag-handle:hover {
  color: var(--text-secondary);
}
@media (max-width: 767px) {
  .drag-handle {
    display: none;
  }
}
.note-without-call {
  position: relative;
}
.no-flex {
  display: block;
}
/* ── Modal ── */
.lh-modal {
  z-index: 20000000;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  background: var(--surface);
  border: 1px solid var(--border);
  padding: 32px;
  border-radius: var(--radius-xl);
  position: fixed;
  max-width: 560px;
  box-shadow: var(--shadow-xl);
}
@media (max-width: 767px) {
  .lh-modal {
    max-width: 100%;
    padding: 20px;
  }
}
.lh-modal p {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-secondary);
}
.call-end-modal-title {
  margin-top: 0;
  font-size: 20px;
}
@media (max-width: 767px) {
  .call-end-modal-title {
    font-size: 18px;
  }
}
.call-end-modal-duration-title {
  margin-top: 16px;
}
.call-end-modal-note-is-ended {
  margin: 16px 0;
}
.call-end-modal-duration-value {
  margin-top: 4px;
  font-weight: 600;
}
.call-end-modal-end-note {
  margin: 24px 0;
}
.call-end-modal-select {
  margin-top: 16px;
}
.call-end-modal-submit {
  margin-top: 16px;
}
.call-end-modal-textarea {
  padding: 12px !important;
}
/* ── Responsive ── */
@media (max-width: 767px) {
  .call.show-dots::before {
    left: 21px;
  }
  .event-row {
    min-height: 50px;
    padding: 10px;
    margin: 4px 8px;
  }
  .event-row .avatar {
    height: 28px;
    width: 28px;
    line-height: 28px;
    font-size: 10px;
    margin-top: 4px;
  }
  .event-row-left-col {
    padding-left: 0;
    flex: 0 0 36px;
  }
  .event-row-text {
    font-size: 13px;
  }
  .event-row-text-waiting {
    margin-right: 0;
  }
  .event-icon {
    height: 28px;
    width: 28px;
  }
  .event-icon i {
    font-size: 12px;
  }
  .event-row-right-col-date {
    top: 5px;
  }
  .event-row-right-col-date .dropdown {
    position: absolute;
    right: -10px;
    top: 24px;
  }
  .call-end .event-row-left-col,
  .call-begin .event-row-left-col {
    align-items: center;
  }
}
@font-face {
  font-family: 'icomoon';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('embedded-opentype'), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('svg');
  font-weight: normal;
  font-style: normal;
}
[class^="icon-"],
[class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon', 'Lucida Grande' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-auftraege:before {
  content: "\\e900";
}
.icon-auftrag-download:before {
  content: "\\e901";
}
.icon-auftrag-edit:before {
  content: "\\e902";
}
.icon-auftrag-settings:before {
  content: "\\e903";
}
.icon-auftrag-success:before {
  content: "\\e904";
}
.icon-auftrag:before {
  content: "\\e905";
}
.icon-bank:before {
  content: "\\e906";
}
.icon-phone-down2:before {
  content: "\\e907";
}
.icon-call-end2:before {
  content: "\\e908";
}
.icon-call-time:before {
  content: "\\e909";
}
.icon-phone2:before {
  content: "\\e90a";
}
.icon-camera-turn:before {
  content: "\\e90b";
}
.icon-camera:before {
  content: "\\e90c";
}
.icon-datum:before {
  content: "\\e90d";
}
.icon-edit2:before {
  content: "\\e90e";
}
.icon-fail:before {
  content: "\\e90f";
}
.icon-fullscreen:before {
  content: "\\e910";
}
.icon-fullsreen2:before {
  content: "\\e911";
}
.icon-lock:before {
  content: "\\e912";
}
.icon-mail:before {
  content: "\\e913";
}
.icon-notiz:before {
  content: "\\e914";
}
.icon-plus:before {
  content: "\\e915";
}
.icon-small-menu:before {
  content: "\\e916";
}
.icon-sms:before {
  content: "\\e917";
}
.icon-user-remove:before {
  content: "\\e918";
}
.icon-user-settings:before {
  content: "\\e919";
}
.icon-user-success:before {
  content: "\\e91a";
}
.icon-user:before {
  content: "\\e91b";
}
.icon-userliste:before {
  content: "\\e91c";
}
.icon-video-placeholder:before {
  content: "\\e91d";
}
.icon-paper-clip:before {
  content: "\\e001";
}
.icon-mic:before {
  content: "\\e00f";
}
.icon-mic_none:before {
  content: "\\e010";
}
.icon-mic_off:before {
  content: "\\e011";
}
.icon-screen2:before {
  content: "\\e016";
}
.icon-ring_volume:before {
  content: "\\e05a";
}
.icon-head:before {
  content: "\\e074";
}
.icon-screen:before {
  content: "\\e108";
}
.icon-down:before {
  content: "\\e10f";
}
.icon-left:before {
  content: "\\e110";
}
.icon-right:before {
  content: "\\e111";
}
.icon-up:before {
  content: "\\e112";
}
.icon-file:before {
  content: "\\e124";
}
.icon-music_note:before {
  content: "\\e197";
}
.icon-bubble:before {
  content: "\\e601";
}
.icon-phone:before {
  content: "\\e602";
}
.icon-phone-down:before {
  content: "\\e603";
}
.icon-video2:before {
  content: "\\e604";
}
.icon-bubble2:before {
  content: "\\e605";
}
.icon-params:before {
  content: "\\e606";
}
.spinner {
  margin: 50px auto 50px;
  width: 60px;
  text-align: center;
}
.spinner.inline {
  display: inline-block;
  margin: 0 10px;
  transform: translateY(2px);
}
.spinner.flex {
  display: flex;
  align-items: center;
}
.spinner > div {
  width: 18px;
  height: 18px;
  background-color: #999;
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}
.spinner .bounce1 {
  animation-delay: -0.32s;
}
.spinner .bounce2 {
  animation-delay: -0.16s;
}
@media (max-width: 1199px) {
  .spinner {
    margin: 0 auto 0px;
    width: 35px;
  }
  .spinner.inline {
    margin: 0;
  }
  .spinner > div {
    width: 9px;
    height: 9px;
  }
}
@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
/* ============================================================
   DESIGN SYSTEM – Dark Theme (Global)
   Inspired by the mockup: deep navy bg, elevated surface panels,
   accent blue, clean Inter typography.
   ============================================================ */
:root {
  /* Background hierarchy */
  --bg: #0d1117;
  /* outermost – page background */
  --surface: #161b27;
  /* panels / cards */
  --surface-2: #1e2636;
  /* elevated items within panels */
  --surface-3: #28334a;
  /* hover states, inputs */
  /* Legacy aliases (some components still reference these) */
  --bg-color: var(--bg);
  --surface-color: var(--surface);
  /* Text */
  --text-primary: #f0f4ff;
  --text-secondary: #8899aa;
  --text-muted: #505e70;
  /* Border */
  --border: rgba(255, 255, 255, 0.07);
  --border-color: var(--border);
  /* Brand / Accents */
  --primary-color: #0284c7;
  --primary-hover: #2563eb;
  --primary-glow: rgba(2, 132, 199, 0.25);
  --success-color: #22c55e;
  --success-glow: rgba(34, 197, 94, 0.2);
  --danger-color: #ef4444;
  --danger-glow: rgba(239, 68, 68, 0.2);
  --warning-color: #f59e0b;
  /* Menu links */
  --menu-color: #8899aa;
  /* Shadows */
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.4);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.5);
  --shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.6);
  --shadow-xl: 0 16px 40px rgba(0, 0, 0, 0.7);
  /* Border radius */
  --radius-xs: 6px;
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;
  --radius-pill: 9999px;
  /* Transitions */
  --transition-fast: 0.12s ease;
  --transition-normal: 0.2s ease;
  --transition-slow: 0.35s ease;
}
/* ============================================================
   BASE RESET
   ============================================================ */
*,
*::before,
*::after {
  box-sizing: border-box;
}
body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: var(--text-primary);
  background-color: var(--bg);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--text-primary);
  margin-top: 0;
}
a {
  color: var(--primary-color);
  text-decoration: none;
  transition: color var(--transition-fast);
}
a:hover {
  color: var(--primary-hover);
  text-decoration: none;
}
p {
  margin: 0;
}
/* ============================================================
   NAVBAR – Modern pill/link style over dark background
   ============================================================ */
.navbar.navbar-default {
  background: var(--surface) !important;
  border: none !important;
  border-bottom: 1px solid var(--border) !important;
  border-radius: 0 !important;
  min-height: 56px;
  margin-bottom: 0;
  box-shadow: var(--shadow-sm);
  /* Breadcrumb separator */
}
.navbar.navbar-default .navbar-brand {
  color: var(--text-primary) !important;
  font-weight: 700;
  font-size: 16px;
  padding: 16px 20px;
}
.navbar.navbar-default .navbar-brand:hover {
  color: var(--primary-color) !important;
}
.navbar.navbar-default .navbar-toggle {
  border-color: var(--border);
}
.navbar.navbar-default .navbar-toggle .icon-bar {
  background-color: var(--text-secondary);
}
.navbar.navbar-default .navbar-toggle:hover {
  background: var(--surface-2);
}
.navbar.navbar-default .navbar-nav > li > a {
  color: var(--text-secondary) !important;
  font-size: 13px;
  font-weight: 500;
  padding: 18px 14px;
  transition: color var(--transition-fast);
}
.navbar.navbar-default .navbar-nav > li > a:hover,
.navbar.navbar-default .navbar-nav > li > a:focus {
  color: var(--text-primary) !important;
  background: transparent !important;
}
.navbar.navbar-default .navbar-nav > li.active > a {
  color: var(--text-primary) !important;
  background: transparent !important;
}
.navbar.navbar-default .breadcrumb-menu li:not(:first-child)::before {
  content: '/';
  color: var(--text-muted);
  margin: 0 4px;
}
/* ============================================================
   FORMS
   ============================================================ */
.form-control {
  background: var(--surface-2) !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border) !important;
  border-radius: var(--radius-md) !important;
  height: 40px;
  padding: 8px 14px;
  font-size: 13px;
  font-family: 'Inter', sans-serif;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}
.form-control:focus {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 3px var(--primary-glow) !important;
  outline: none !important;
}
.form-control::placeholder,
.form-control::-webkit-input-placeholder {
  color: var(--text-muted) !important;
}
.search-input .form-control {
  height: 36px;
}
.chat-input .form-control {
  height: 36px;
  padding: 6px 14px;
  background: var(--surface-2) !important;
  border-radius: var(--radius-sm) !important;
}
/* ============================================================
   UTILITY
   ============================================================ */
.text-muted,
.customer-sub-title {
  color: var(--text-secondary) !important;
  font-size: 12px;
}
.panel-title {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 14px;
  margin: 0;
}
.Lato {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 400;
}
.box-shadow {
  box-shadow: var(--shadow-lg);
}
.small-box-shadow {
  box-shadow: var(--shadow-md);
}
.roundcorners {
  border-radius: var(--radius-md);
}
.gradient_blue {
  background: var(--primary-color);
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 100%);
}
.bold {
  font-weight: bold;
}
.max400 {
  max-width: 400px;
  display: inline-block;
}
.flex {
  display: flex;
  justify-content: center;
  min-height: 100vh;
}
.flex h1 {
  margin-bottom: 30px;
}
@media (min-width: 480px) {
  .w-xs {
    width: 400px;
    margin-left: auto;
    margin-right: auto;
  }
}
@media (min-width: 768px) {
  .w-sm {
    width: 640px;
    margin-left: auto;
    margin-right: auto;
  }
}
.m40 {
  margin-top: 20px;
  margin-bottom: 20px;
}
@media (min-width: 480px) {
  .m40 {
    margin-top: 40px;
    margin-bottom: 40px;
  }
}
.content-block {
  display: inline-block;
  background: #FFFFFF;
  padding: 15px;
  flex-direction: column;
  box-shadow: var(--shadow-lg);
}
.flex-box {
  display: flex;
  height: calc(100vh - 80px);
  background: #FFFFFF;
  padding: 15px;
  padding-top: 0;
  flex-direction: column;
  overflow-y: scroll;
  box-shadow: var(--shadow-lg);
}
@media (min-width: 480px) {
  .flex-box {
    width: 400px;
    margin-left: auto;
    margin-right: auto;
  }
}
select {
  padding: 10px;
  border: 0 none;
  width: 100%;
  margin-bottom: 10px;
  border: 1px solid #E3EDF7;
  border-radius: var(--radius-md);
}
select:hover {
  border-color: #bbd4ec;
}
select:focus {
  border-color: #94bae0;
  border-width: 1px;
  outline: none;
}
.home-content {
  padding-top: 15px;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 15px;
  display: inline-block;
}
.home-content h3 {
  font-weight: normal;
}
.home-content h3,
.home-content p {
  margin: 0 0 20px 0;
}
.w750 {
  max-width: 550px !important;
}
.room-content {
  padding: 40px;
  display: inline-block;
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  max-width: 833px;
}
@media (max-width: 767px) {
  .room-content {
    padding-top: 0;
    border-left: 0px!important;
  }
}
.room-content h3 {
  font-weight: normal;
}
.room-content h3,
.room-content p {
  margin: 0 0 30px 0;
}
.inputfield {
  width: 100%;
  height: 50px;
  text-align: left;
  padding: 0 15px;
  border: none;
  border-radius: 0;
  color: #1D5F96;
  background: #E3EDF7;
  border-radius: var(--radius-md);
}
.inputfield:hover {
  border: 1px solid #3383C4;
  padding: 0 14px;
}
.inputfield:focus {
  border: 1px solid #3383C4;
  padding: 0 14px;
  outline: none;
}
.inputfield:-moz-placeholder {
  color: #1e293b;
}
.inputfield:placeholder-shown {
  color: #1e293b;
}
.inputfield::-webkit-input-placeholder {
  /* Safari, Chrome and Opera */
  color: #1e293b;
}
.login-page {
  max-width: 833px;
}
.login-row {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}
@media (max-width: 767px) {
  .login-row {
    flex-direction: column;
  }
}
.tools {
  position: absolute;
  z-index: 9;
  font-family: "Lato", sans-serif;
  display: flex;
  left: auto;
  right: 15px;
  width: 50px;
  bottom: 15px;
}
@media (max-width: 991px) {
  .tools {
    width: 40px;
  }
}
.tools .middle {
  flex: 1;
  justify-content: center;
  /*height: 100px;*/
  display: flex;
  align-items: center;
  /*@media (max-width: @screen-lg-max) {*/
  flex-direction: column;
  height: auto;
  /*}*/
}
.tools .button {
  display: block;
  width: 55px;
  height: 55px;
  margin: 5px 0;
  font-size: 24px;
  text-align: center;
  background: var(--glass-bg);
  line-height: 55px;
  cursor: pointer;
  color: var(--danger-color);
  border-radius: var(--radius-pill);
  border: 1px solid var(--glass-border);
  box-shadow: var(--shadow-sm);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: all var(--transition-fast);
}
.tools .button:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: var(--shadow-md);
}
@media (max-width: 991px) {
  .tools .button {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    margin: 4px 0;
  }
  .tools .button:first-child {
    margin-top: 0;
  }
}
.tools .button.active {
  color: var(--primary-color);
}
.tools .button-phone-down {
  color: white;
  background: var(--danger-color);
  border: none;
}
/*.landscape {
    .fullscreen {
        .tools {
            position: fixed;
            right: 20px;
            @media (max-width: @screen-sm-max) {
                right: 10px;
            }
        }
        .timer {
            position: fixed;
        }
    }
}

.portrait {
    .fullscreen, .video-wrapper.customer {
        .tools {
            width: 300px;
            left: ~"calc(50% - 150px)";
            .middle {
                flex-direction: row;
            }
            .button {
                margin: 0 5px;
            }
        }
    }
}*/
.video-chat-embedded .tools .camera-form {
  display: none;
}
.video-chat-embedded .tools .remote-picture {
  display: inline-block !important;
}
/*@media (max-width: @screen-md-max) {*/
/*.tools {*/
/*bottom: -20px;*/
/*.button {*/
/*width: 36px;*/
/*height: 36px;*/
/*font-size: 14px;*/
/*line-height: 36px;*/
/*}*/
/*}*/
/*}*/
.highlighted {
  color: #ef4444 !important;
}
.costIndicator {
  position: absolute;
  left: 15px;
  bottom: 15px;
}
.costIndicator .button {
  position: relative;
  display: block;
  width: 55px;
  height: 55px;
  margin: 5px 0;
  font-size: 24px;
  text-align: center;
  background: var(--glass-bg);
  line-height: 55px;
  color: var(--primary-color);
  border-radius: var(--radius-pill);
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  transition: all var(--transition-fast);
}
.costIndicator .button:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: var(--shadow-md);
}
@media (max-width: 991px) {
  .costIndicator .button {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    margin: 4px 0;
  }
  .costIndicator .button:first-child {
    margin-top: 0;
  }
}
.costIndicator .button .crossed {
  position: absolute;
  color: #ef4444;
}
/* ============================================================
   VIDEO CHAT LAYOUT – Modern 3-Column Dashboard
   Matches the provided mockup: dark panels, rounded corners,
   center video box, event stream on right.
   ============================================================ */
/* ── Opentok / Video wrappers ── */
.video-wrapper {
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: center;
  background: transparent;
}
video {
  background: transparent;
}
body:has(.publisher-video-screen),
html:has(.publisher-video-screen) {
  overflow: hidden !important;
  position: fixed !important;
  width: 100% !important;
  height: 100% !important;
}
.publisher-video-screen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  justify-content: center;
  align-items: center;
  display: flex;
  overflow: hidden;
  z-index: 9999;
}
.publisher-video-screen #opentok-container {
  width: 100%;
  height: 100%;
}
.videomode:not(.fullscreen) #opentok-container.horizontal {
  align-self: center;
  margin: auto;
  width: 100%;
  height: 100%;
  max-width: 854px;
  max-height: 480px;
}
.videomode:not(.fullscreen) .video-box.embedded #opentok-container.horizontal {
  width: 100%;
  height: 100%;
}
.videomode:not(.fullscreen) #opentok-container.vertical {
  align-self: center;
  margin: auto;
  width: 100%;
  height: 100%;
  max-width: 480px;
  max-height: 640px;
}
.videomode:not(.fullscreen) .video-box.embedded #opentok-container.vertical {
  width: 100%;
  height: 100%;
}
@media (max-width: 639px) {
  .videomode.customer:not(.fullscreen) #opentok-container {
    width: 100vw;
    height: 100vh;
  }
}
.fullscreen #opentok-container.horizontal {
  align-self: center;
  margin: auto;
  width: 100%;
  height: 100%;
  max-width: 1280px;
  max-height: 720px;
}
.fullscreen #opentok-container.vertical {
  align-self: center;
  margin: auto;
  width: 100%;
  height: 100%;
  max-width: 720px;
  max-height: 1280px;
}
/* ============================================================
   CUSTOMER SINGLE PAGE – Root wrapper
   ============================================================ */
.customer-single {
  flex: auto;
  display: flex;
  flex-direction: column;
  background: transparent;
  min-height: calc(100vh - 56px);
  /* 56px = navbar height */
  color: var(--text-primary);
}
/* ============================================================
   3-COLUMN LAYOUT
   ============================================================ */
.layout-3-col {
  display: flex;
  flex-direction: row;
  flex: 1;
  gap: 16px;
  padding: 16px;
  min-height: calc(100vh - 56px);
  box-sizing: border-box;
  align-items: stretch;
}
@media (max-width: 992px) {
  .layout-3-col {
    flex-direction: column;
    height: auto;
    overflow-y: visible;
  }
}
/* ── LEFT: Project sidebar ── */
.layout-left {
  flex: 0 0 260px;
  background: var(--surface);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
@media (max-width: 1280px) {
  .layout-left {
    flex: 0 0 220px;
  }
}
@media (max-width: 992px) {
  .layout-left {
    flex: none;
    height: auto;
  }
}
/* ── CENTER: Video ── */
.layout-center {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  gap: 0;
}
/* ── RIGHT: Events stream ── */
.layout-right {
  flex: 0 0 340px;
  background: var(--surface);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
@media (max-width: 1280px) {
  .layout-right {
    flex: 0 0 300px;
  }
}
@media (max-width: 992px) {
  .layout-right {
    flex: none;
  }
}
/* ============================================================
   CENTER COLUMN: CUSTOMER HEADER BAR
   ============================================================ */
.video-chat-header {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--surface);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border);
  padding: 12px 18px;
  flex-shrink: 0;
  /* Reset old Bootstrap negative margins */
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0 !important;
}
.video-chat-header-left-col {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  /* allow text truncation */
}
.video-chat-header-right-col {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
}
/* URL input + copy row */
.customer-begincall-url-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0 !important;
}
.customer-begincall {
  align-self: center;
  line-height: 36px;
}
/* ============================================================
   CENTER COLUMN: VIDEO BOX
   ============================================================ */
.video-status-container {
  flex: 1;
  display: flex;
  justify-content: stretch;
  background: transparent;
  position: relative;
  min-height: 0;
}
@media (max-width: 767px) {
  .video-status-container {
    min-height: 200px;
  }
}
.video-status-container .video-status-message {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--surface);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border);
  font-size: 16px;
  font-weight: 500;
  color: var(--text-secondary);
  letter-spacing: 0;
}
.video-status-container .video-status-error {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(239, 68, 68, 0.08);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: var(--radius-xl);
  font-size: 14px;
  color: var(--text-secondary);
}
/* ============================================================
   VIDEO ELEMENTS
   ============================================================ */
.video-chat {
  width: 100%;
  min-height: 100%;
  background: transparent;
}
.video-box {
  flex: 1;
  display: flex;
  text-align: center;
  position: relative;
  background: transparent;
  line-height: 0;
}
.video-box.active {
  padding-top: 0;
}
.video-container {
  position: relative;
  line-height: 0;
  width: 100%;
  padding-top: 56.25%;
}
.video-container.active {
  padding-top: 0;
}
.video-container video {
  background: transparent;
  transition: 0.5s all ease-in-out;
}
@media (max-height: 767px) {
  .video-container video {
    margin-top: 20px;
  }
}
.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 16px;
  text-align: center;
  color: var(--text-primary);
  background: rgba(13, 17, 23, 0.85);
  backdrop-filter: blur(8px);
  z-index: 5;
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
}
.video-overlay-scribbled {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background: rgba(13, 17, 23, 0.5);
  z-index: 5;
}
.video-state {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  align-items: center;
  justify-content: center;
  font-size: 80px;
}
.video-state:not(.active) {
  display: flex;
  background: rgba(0, 0, 0, 0.4);
}
.video-state:not(.active) .fa-stack-1x {
  color: rgba(255, 255, 255, 0.6);
}
.video-state:not(.active) .fa-stack-2x {
  color: rgba(239, 68, 68, 0.8);
}
.video-state.paused {
  display: flex;
  background: var(--bg);
}
.video-state.paused .fa-stack-1x {
  color: rgba(0, 0, 0, 0.5);
}
.video-state.paused .fa-stack-2x {
  color: #f0442e;
}
/* ============================================================
   CALL CONTROLS BAR (bottom of center column)
   ============================================================ */
.timer {
  color: var(--text-primary);
  font-weight: 600;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  padding: 8px 12px;
  border-radius: var(--radius-pill);
  border: 1px solid var(--border);
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 6;
}
.touch {
  position: absolute;
  display: block;
  z-index: 10000000000;
  background: rgba(255, 255, 255, 0.4);
  border: 2px solid rgba(255, 255, 255, 0.7);
}
.volume-meter {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
}
.volume-meter .volume-level {
  display: block;
  height: 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 3px;
  margin: 0 10px 5px;
}
.volume-meter .volume-level.active {
  background: rgba(255, 255, 255, 0.6);
}
.volume-meter .volume-icon {
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 3px;
  color: white;
  font-size: 20px;
  text-align: center;
}
.volume-meter.speaking:not(.muted) .volume-level {
  border-color: var(--success-color);
}
.volume-meter.speaking:not(.muted) .volume-level.active {
  background: var(--success-color);
}
.volume-meter.speaking:not(.muted) .volume-icon {
  color: var(--success-color);
}
.volume-meter.muted .volume-level {
  background: transparent;
}
.volume-meter.muted .volume-icon {
  background: rgba(239, 68, 68, 0.4);
}
.volume-meter:not(.active) .volume-level {
  background: transparent;
  border-color: rgba(239, 68, 68, 0.4);
}
.volume-meter:not(.active) .volume-icon {
  color: rgba(239, 68, 68, 0.6);
}
/* ============================================================
   VIDEO EMBEDDED / FULLSCREEN
   ============================================================ */
.remote-picture {
  display: none !important;
}
.video-chat-embedded {
  align-items: center;
  position: relative;
  flex: 1;
  margin: 0;
  width: 100%;
  height: 100%;
}
.video-chat-embedded.active {
  /* Kept for backwards compatibility if needed */
}
.video-chat-embedded .text-center {
  transform: translateY(-50px);
}
.fullscreen {
  background: transparent;
  top: 0 !important;
  left: 0;
  right: 0;
  bottom: 0;
}
.fullscreen .tools {
  bottom: 105px;
}
.OT_widget-container {
  z-index: 5;
}
/* ============================================================
   START CALL / COMMON BUTTONS
   ============================================================ */
.start-call {
  width: auto !important;
}
@media (max-width: 767px) {
  .start-call {
    width: 100%;
  }
}
/* ============================================================
   CHAT INPUT (bottom of right column)
   ============================================================ */
.chat-input {
  flex-shrink: 0;
  padding: 12px;
  border-top: 1px solid var(--border);
  background: var(--surface);
}
.chat-input .input-group {
  display: flex;
  gap: 8px;
}
.chat-input .input-group .form-control {
  flex: 1;
  border-radius: var(--radius-md) !important;
}
.chat-input .input-group .input-group-btn {
  flex: 0 0 auto;
}
.chat-input .input-group .input-group-btn .btn {
  border-radius: var(--radius-md) !important;
  background: var(--primary-color);
  color: white;
  border: none;
  font-size: 13px;
  font-weight: 500;
  height: 36px;
  padding: 0 14px;
  cursor: pointer;
  transition: background var(--transition-fast);
}
.chat-input .input-group .input-group-btn .btn:hover {
  background: var(--primary-hover);
}
/* ============================================================
   CAMERA INPUT (hidden file input)
   ============================================================ */
.camera-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.camera-input-label {
  display: inline-block;
}
.camera-input,
.camera-input-label {
  cursor: pointer;
}
.camera-input:focus + label {
  outline: 2px solid var(--primary-color);
}
.camera-input + label * {
  pointer-events: none;
}
.flexCenter {
  display: flex;
  align-items: center;
}
/* ============================================================
   AUDIO REQUEST MODAL
   ============================================================ */
.audio-request-modal {
  position: absolute;
  background: rgba(0, 0, 0, 0.1);
  /* Very light background so the glass pops out */
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.audio-request-modal .content {
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(25px) saturate(200%);
  -webkit-backdrop-filter: blur(25px) saturate(200%);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-top: 1px solid rgba(255, 255, 255, 0.8);
  border-left: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.25);
  border-radius: 20px;
  padding: 32px;
  max-width: 420px;
  width: 90%;
  position: relative;
  text-align: center;
}
.audio-request-modal .content .close-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.4);
  font-size: 20px;
}
.audio-request-modal .content .close-icon:hover {
  color: rgba(0, 0, 0, 0.8);
}
.audio-request-modal .content h3 {
  color: #1d1d1f;
  font-size: 20px;
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: 600;
  line-height: 1.3;
}
.audio-request-modal .content p {
  color: #374151;
  font-size: 15px;
  line-height: 1.5;
  margin-bottom: 24px;
}
.audio-request-modal .buttons {
  display: flex;
  justify-content: center;
  gap: 12px;
}
.audio-request-modal .buttons button {
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 15px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}
.audio-request-modal .buttons .lh-btn-primary {
  background: rgba(0, 122, 255, 0.85);
  color: white;
  box-shadow: 0 4px 12px rgba(0, 122, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.audio-request-modal .buttons .lh-btn-primary:hover {
  background: rgba(0, 98, 204, 0.95);
  transform: translateY(-1px);
}
.audio-request-modal .buttons .lh-btn-primary:active {
  transform: translateY(1px);
}
.audio-request-modal .buttons .lh-btn-default {
  background: rgba(255, 255, 255, 0.4);
  color: #1d1d1f;
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.audio-request-modal .buttons .lh-btn-default:hover {
  background: rgba(255, 255, 255, 0.6);
}
.audio-request-modal .buttons .lh-btn-default:active {
  background: rgba(255, 255, 255, 0.8);
}
@media (max-width: 767px) {
  .audio-request-modal .content {
    padding: 24px;
  }
  .audio-request-modal .buttons {
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }
  .audio-request-modal .buttons button {
    width: 100%;
    margin: 0;
  }
}
/* ============================================================
   VIDEO CHAT ERROR STATE
   ============================================================ */
.video-chat-error {
  font-size: 16px;
  padding: 40px 30px;
  text-align: center;
  color: var(--text-secondary);
}
.video-chat-error p {
  margin-bottom: 1em;
}
.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 18px;
  color: var(--text-secondary);
  transition: color var(--transition-fast);
}
.close-icon:hover {
  color: var(--text-primary);
}
/* ============================================================
   RESPONSIVE BREAKPOINTS
   ============================================================ */
@media (max-width: 1199px) {
  .start-call,
  .btn-danger {
    padding: 7px 12px;
    font-size: 13px;
    border-radius: var(--radius-md);
  }
}
@media (max-width: 767px) {
  .video-chat-header {
    flex-wrap: wrap;
    padding: 10px 12px;
    gap: 8px;
  }
  .video-chat-header .customer-single-element {
    min-width: auto;
  }
  .video-chat-header .avatar {
    font-size: 10px;
    width: 32px;
    height: 32px;
    line-height: 32px;
    border-radius: 16px;
  }
  .video-chat-header .customer-sub-title {
    font-size: 13px;
    margin: 0;
    padding: 0;
    margin-bottom: 2px;
  }
}
/* line 3, ../sass/_offline-theme-base-indicator.sass */
.offline-ui,
.offline-ui *,
.offline-ui::before,
.offline-ui::after,
.offline-ui *::before,
.offline-ui *::after {
  box-sizing: border-box;
}
/* line 6, ../sass/_offline-theme-base-indicator.sass */
.offline-ui {
  display: none;
  position: fixed;
  background: white;
  z-index: 2000;
  display: inline-block;
}
/* line 13, ../sass/_offline-theme-base-indicator.sass */
.offline-ui .offline-ui-retry {
  display: none;
}
/* line 16, ../sass/_offline-theme-base-indicator.sass */
.offline-ui .offline-ui-up {
  display: block;
}
/* line 19, ../sass/_offline-theme-base-indicator.sass */
.offline-ui .offline-ui-down {
  display: block;
}
/* line 8, ../sass/offline-theme-chrome-indicator.sass */
.offline-ui {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  -ms-border-radius: 4px 4px 0 0;
  -o-border-radius: 4px 4px 0 0;
  font-family: "Lucida Grande", sans-serif;
  font-size: 12px;
  padding: 7px;
  background: #f6f6f6;
  color: #888;
  left: 0;
  bottom: 80px;
  border-radius: 0 4px 4px 0;
}
@media (max-width: 767px) {
  .offline-ui {
    bottom: auto !important;
    top: 0 !important;
    border-radius: 0 0 4px 4px !important;
    left: 55px !important;
    right: auto;
  }
}
/* line 19, ../sass/offline-theme-chrome-indicator.sass */
.offline-ui .offline-ui-content {
  padding-left: 16px;
}
/* line 22, ../sass/offline-theme-chrome-indicator.sass */
.offline-ui .offline-ui-up .offline-ui-content::after {
  border-radius: 50%;
  content: " ";
  display: block;
  position: absolute;
  top: 0;
  bottom: 1px;
  left: 8px;
  margin: 10px auto;
  height: 9px;
  width: 9px;
}
/* line 22, ../sass/offline-theme-chrome-indicator.sass */
.offline-ui .offline-ui-down .offline-ui-content::after {
  border-radius: 50%;
  content: " ";
  display: block;
  position: absolute;
  top: 0;
  bottom: 1px;
  left: 8px;
  margin: 10px auto;
  height: 9px;
  width: 9px;
}
/* line 36, ../sass/offline-theme-chrome-indicator.sass */
.offline-ui .offline-ui-up .offline-ui-content::after {
  background: #80d580;
}
/* line 41, ../sass/offline-theme-chrome-indicator.sass */
.offline-ui .offline-ui-down .offline-ui-content::after {
  background: #ec8787;
}
/* line 19, ../sass/offline-theme-chrome-indicator.sass */
.offline-ui .member-ui-content {
  padding-left: 6px;
  display: inline-block;
  font-family: "Lucida Grande", sans-serif;
}
/* line 5, ../sass/offline-language-german-indicator.sass */
.offline-ui .offline-ui-up .offline-ui-content::before {
  content: "Online";
}
/* line 10, ../sass/offline-language-german-indicator.sass */
.offline-ui .offline-ui-down .offline-ui-content::before {
  content: "Offline";
}
/* ============================================================
   ORDER SIDEBAR (Left Column)
   Modern dark nav style matching the mockup
   ============================================================ */
.inner-middle {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.order-sidebar {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0;
  background: transparent;
  text-align: left;
  width: 100%;
  scrollbar-width: thin;
  scrollbar-color: var(--surface-3) transparent;
  /* "Alle Ereignisse" button at top */
  /* Section heading */
  /* Individual project items */
}
.order-sidebar::-webkit-scrollbar {
  width: 4px;
}
.order-sidebar::-webkit-scrollbar-track {
  background: transparent;
}
.order-sidebar::-webkit-scrollbar-thumb {
  background: var(--surface-3);
  border-radius: 4px;
}
.order-sidebar .orders-wrapper {
  overflow-y: auto;
  padding: 0 8px;
  height: 100%;
}
.order-sidebar .orders-wrapper a {
  display: block;
}
.order-sidebar .orders-wrapper a:hover,
.order-sidebar .orders-wrapper a:focus,
.order-sidebar .orders-wrapper a:active {
  text-decoration: none;
}
.order-sidebar .orders {
  list-style: none;
  padding: 0;
  margin: 0;
}
.order-sidebar .order.all-events {
  margin-bottom: 8px;
}
.order-sidebar .order.all-events .text {
  display: block;
  padding: 9px 14px;
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  color: var(--text-secondary);
  background: transparent;
  border: 1px solid transparent;
  transition: all var(--transition-fast);
}
.order-sidebar .order.all-events.active .text,
.order-sidebar .order.all-events:hover .text {
  color: var(--text-primary);
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(59, 130, 246, 0.3);
}
.order-sidebar h4 {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
  padding: 16px 14px 8px;
  margin: 0;
}
.order-sidebar h4 a,
.order-sidebar h4 small {
  font-size: 10px;
  color: var(--text-muted);
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  margin-left: 6px;
  transition: color var(--transition-fast);
}
.order-sidebar h4 a:hover,
.order-sidebar h4 small:hover {
  color: var(--text-secondary);
}
.order-sidebar .order {
  margin-bottom: 2px;
  display: flex;
  align-items: center;
}
.order-sidebar .order .text {
  flex: 1;
  padding: 8px 14px;
  border-radius: var(--radius-md);
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  color: var(--text-secondary);
  background: transparent;
  border: 1px solid transparent;
  transition: all var(--transition-fast);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.order-sidebar .order.over .text {
  color: var(--success-color);
  background: var(--success-glow);
}
.order-sidebar .order.active .text,
.order-sidebar .order:hover .text {
  color: var(--text-primary);
  background: rgba(59, 130, 246, 0.1);
  border-color: rgba(59, 130, 246, 0.25);
  text-decoration: none;
}
.order-sidebar .order i.finish {
  flex: 0 0 20px;
  color: var(--success-color);
  opacity: 0.4;
  margin-left: 4px;
  font-size: 12px;
  transition: opacity var(--transition-fast);
}
.order-sidebar .order i.finish:hover {
  opacity: 1;
}
.order-sidebar .order i.finish.active {
  opacity: 0.2;
}
.order-sidebar .order i.finish.active:hover,
.order-sidebar .order i.finish.active:active,
.order-sidebar .order i.finish.active:focus {
  opacity: 1;
}
/* ── New project input ── */
.new-order {
  margin: 12px 14px 0;
  padding: 9px 14px;
  font-size: 13px;
  font-family: 'Inter', sans-serif;
  color: var(--text-primary);
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  width: calc(100% - 28px);
  box-sizing: border-box;
  transition: border-color var(--transition-fast);
}
.new-order:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px var(--primary-glow);
}
.new-order::placeholder,
.new-order::-webkit-input-placeholder {
  color: var(--text-muted);
}
/* ── Order header (inside right panel when order is selected) ── */
.order-header {
  border-bottom: 1px solid var(--border);
  padding: 14px 16px;
  flex-shrink: 0;
  background: var(--surface);
}
.order-header-title {
  text-align: left;
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: var(--text-primary);
}
.order-header-title > *:not(:first-child) {
  padding-left: 7px;
}
@media (max-width: 991px) {
  .order-header-title {
    font-size: 13px;
  }
}
.order-header-button {
  margin-left: 16px;
}
.order-header-mobile {
  padding: 5px;
  border-bottom: 1px solid var(--border);
  display: none;
}
.order-header-back,
.order-header-mobile-toggle,
.order-sidebar-toggle {
  font-size: 24px;
  color: var(--text-secondary);
  margin-right: 16px;
  cursor: pointer;
  display: none;
}
.order-header-back:hover,
.order-header-mobile-toggle:hover,
.order-sidebar-toggle:hover,
.order-header-back:focus,
.order-header-mobile-toggle:focus,
.order-sidebar-toggle:focus,
.order-header-back:active,
.order-header-mobile-toggle:active,
.order-sidebar-toggle:active {
  text-decoration: none;
  color: var(--text-primary);
}
.order-sidebar-toggle {
  right: 15px;
}
.order-header-close {
  position: absolute;
  color: var(--text-secondary);
  right: 16px;
  top: 12px;
  font-size: 24px;
  cursor: pointer;
  border-radius: var(--radius-md);
  border: none;
  background: transparent;
  transition: all var(--transition-fast);
}
.order-header-close:active,
.order-header-close:focus,
.order-header-close:hover {
  color: var(--text-primary);
  background: var(--surface-2);
}
.order-rename-form {
  display: flex;
}
.order-rename-form .form-group {
  margin-bottom: 0;
}
.order-rename-form button {
  margin-left: 8px;
}
.order-header-mobile-toggle {
  font-size: 28px;
}
/* ── Responsive: slide-out sidebar on mobile ── */
@media (max-width: 991px) {
  .order-sidebar {
    transform: translateX(-300px);
    flex: 0;
    position: absolute;
    padding-top: 5px;
    background: var(--surface);
    border-right: 1px solid var(--border);
    height: 100%;
    z-index: 100;
    transition: transform var(--transition-normal);
  }
  .order-sidebar.active {
    transform: translateX(0);
  }
  .order-sidebar-wrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: 200px;
  }
  .order-sidebar-toggle {
    align-self: flex-end;
    transform: translateX(30px);
    padding-bottom: 5px;
  }
  .order-header-mobile {
    display: block;
    z-index: 1;
    background: var(--surface);
  }
  .order-header-back,
  .order-header-mobile-toggle,
  .order-sidebar-toggle {
    display: inline-block;
  }
  .order-header-close {
    display: none;
  }
}
.lh-btn {
  font-family: "Lato", sans-serif;
  display: inline-block;
  align-items: center;
  width: auto;
  font-size: 14px;
  padding: 15px 25px !important;
  text-transform: uppercase;
  border-radius: 3px;
  border: none;
  text-align: center;
  text-decoration: none;
}
.lh-btn::before {
  display: none !important;
}
.lh-btn:hover,
.lh-btn:focus,
.lh-btn:active {
  text-decoration: none;
}
.lh-btn > *:not(:first-child) {
  padding-left: 5px;
}
.lh-btn-flex {
  display: flex;
}
.lh-btn-default {
  background-color: var(--surface-color);
  background: var(--surface-color);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}
.lh-btn-default:hover {
  color: var(--text-primary);
  filter: brightness(1.2);
}
.lh-btn-primary {
  background-color: #26A7DF !important;
  background: -webkit-linear-gradient(top, #26A7DF, #1494E0) !important;
  color: #fff;
}
.lh-btn-primary:hover {
  color: #eee;
}
.lh-btn-primary:disabled {
  color: #dedede;
}
.lh-btn-warning {
  background-color: #26A7DF !important;
  background: -webkit-linear-gradient(top, #f15b5b, #ef4444) !important;
  color: #fff;
}
.lh-btn-warning:hover {
  color: #eee;
}
.lh-btn-small {
  padding: 11px 12px !important;
  font-size: 12px;
}
.lh-btn-extra-small {
  font-size: 10px !important;
}
.lh-btn-block {
  width: 100%;
}
.lh-button-event-list-call-end {
  max-height: 44px !important;
  padding: 0 12px !important;
}
/**
 * React Select
 * ============
 * Created by Jed Watson and Joss Mackison for KeystoneJS, http://www.keystonejs.com/
 * https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs
 * MIT License: https://github.com/JedWatson/react-select
*/
.Select {
  position: relative;
}
.Select,
.Select div,
.Select input,
.Select span {
  box-sizing: border-box;
}
.Select.is-disabled > .Select-control {
  background-color: #f9f9f9;
}
.Select.is-disabled > .Select-control:hover {
  box-shadow: none;
}
.Select.is-disabled .Select-arrow-zone {
  cursor: default;
  pointer-events: none;
}
.Select-control {
  background-color: #fff;
  border-color: #d9d9d9 #ccc #b3b3b3;
  border-radius: 4px;
  border: 1px solid #ccc;
  color: #333;
  cursor: default;
  display: table;
  border-spacing: 0;
  border-collapse: separate;
  height: 36px;
  outline: none;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.Select-control:hover {
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
}
.Select-control .Select-input:focus {
  outline: none;
}
.is-searchable.is-open > .Select-control {
  cursor: text;
}
.is-open > .Select-control {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  background: #fff;
  border-color: #b3b3b3 #ccc #d9d9d9;
}
.is-open > .Select-control > .Select-arrow {
  border-color: transparent transparent #999;
  border-width: 0 5px 5px;
}
.is-searchable.is-focused:not(.is-open) > .Select-control {
  cursor: text;
}
.is-focused:not(.is-open) > .Select-control {
  border-color: #007eff;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1);
}
.Select-placeholder,
.Select--single > .Select-control .Select-value {
  bottom: 0;
  color: #aaa;
  left: 0;
  line-height: 34px;
  padding-left: 10px;
  padding-right: 10px;
  position: absolute;
  right: 0;
  top: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.has-value.Select--single > .Select-control .Select-value .Select-value-label,
.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label {
  color: #333;
}
.has-value.Select--single > .Select-control .Select-value a.Select-value-label,
.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label {
  cursor: pointer;
  text-decoration: none;
}
.has-value.Select--single > .Select-control .Select-value a.Select-value-label:hover,
.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:hover,
.has-value.Select--single > .Select-control .Select-value a.Select-value-label:focus,
.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:focus {
  color: #007eff;
  outline: none;
  text-decoration: underline;
}
.Select-input {
  height: 34px;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.Select-input > input {
  width: 100%;
  background: none transparent;
  border: 0 none;
  box-shadow: none;
  cursor: default;
  display: inline-block;
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  outline: none;
  line-height: 14px;
  /* For IE 8 compatibility */
  padding: 8px 0 12px;
  /* For IE 8 compatibility */
  -webkit-appearance: none;
}
.is-focused .Select-input > input {
  cursor: text;
}
.has-value.is-pseudo-focused .Select-input {
  opacity: 0;
}
.Select-control:not(.is-searchable) > .Select-input {
  outline: none;
}
.Select-loading-zone {
  cursor: pointer;
  display: table-cell;
  position: relative;
  text-align: center;
  vertical-align: middle;
  width: 16px;
}
.Select-loading {
  animation: Select-animation-spin 400ms infinite linear;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  border-radius: 50%;
  border: 2px solid #ccc;
  border-right-color: #333;
  display: inline-block;
  position: relative;
  vertical-align: middle;
}
.Select-clear-zone {
  animation: Select-animation-fadeIn 200ms;
  color: #999;
  cursor: pointer;
  display: table-cell;
  position: relative;
  text-align: center;
  vertical-align: middle;
  width: 17px;
}
.Select-clear-zone:hover {
  color: #D0021B;
}
.Select-clear {
  display: inline-block;
  font-size: 18px;
  line-height: 1;
}
.Select--multi .Select-clear-zone {
  width: 17px;
}
.Select-arrow-zone {
  cursor: pointer;
  display: table-cell;
  position: relative;
  text-align: center;
  vertical-align: middle;
  width: 25px;
  padding-right: 5px;
}
.Select-arrow {
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  display: inline-block;
  height: 0;
  width: 0;
}
.is-open .Select-arrow,
.Select-arrow-zone:hover > .Select-arrow {
  border-top-color: #666;
}
.Select--multi .Select-multi-value-wrapper {
  display: inline-block;
}
.Select .Select-aria-only {
  display: inline-block;
  height: 1px;
  width: 1px;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  overflow: hidden;
}
@keyframes Select-animation-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.Select-menu-outer {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top-color: #e6e6e6;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  margin-top: -1px;
  max-height: 200px;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 1;
  -webkit-overflow-scrolling: touch;
}
.Select-menu {
  max-height: 198px;
  overflow-y: auto;
}
.Select-option {
  box-sizing: border-box;
  background-color: #fff;
  color: #666666;
  cursor: pointer;
  display: block;
  padding: 8px 10px;
}
.Select-option:last-child {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.Select-option.is-selected {
  background-color: #f5faff;
  /* Fallback color for IE 8 */
  background-color: rgba(0, 126, 255, 0.04);
  color: #333;
}
.Select-option.is-focused {
  background-color: #ebf5ff;
  /* Fallback color for IE 8 */
  background-color: rgba(0, 126, 255, 0.08);
  color: #333;
}
.Select-option.is-disabled {
  color: #cccccc;
  cursor: default;
}
.Select-noresults {
  box-sizing: border-box;
  color: #999999;
  cursor: default;
  display: block;
  padding: 8px 10px;
}
.Select--multi .Select-input {
  vertical-align: middle;
  margin-left: 10px;
  padding: 0;
}
.Select--multi.has-value .Select-input {
  margin-left: 5px;
}
.Select--multi .Select-value {
  background-color: #ebf5ff;
  /* Fallback color for IE 8 */
  background-color: rgba(0, 126, 255, 0.08);
  border-radius: 2px;
  border: 1px solid #c2e0ff;
  /* Fallback color for IE 8 */
  border: 1px solid rgba(0, 126, 255, 0.24);
  color: #007eff;
  display: inline-block;
  font-size: 0.9em;
  line-height: 1.4;
  margin-left: 5px;
  margin-top: 5px;
  vertical-align: top;
}
.Select--multi .Select-value-icon,
.Select--multi .Select-value-label {
  display: inline-block;
  vertical-align: middle;
}
.Select--multi .Select-value-label {
  border-bottom-right-radius: 2px;
  border-top-right-radius: 2px;
  cursor: default;
  padding: 2px 5px;
}
.Select--multi a.Select-value-label {
  color: #007eff;
  cursor: pointer;
  text-decoration: none;
}
.Select--multi a.Select-value-label:hover {
  text-decoration: underline;
}
.Select--multi .Select-value-icon {
  cursor: pointer;
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
  border-right: 1px solid #c2e0ff;
  /* Fallback color for IE 8 */
  border-right: 1px solid rgba(0, 126, 255, 0.24);
  padding: 1px 5px 3px;
}
.Select--multi .Select-value-icon:hover,
.Select--multi .Select-value-icon:focus {
  background-color: #d8eafd;
  /* Fallback color for IE 8 */
  background-color: rgba(0, 113, 230, 0.08);
  color: #0071e6;
}
.Select--multi .Select-value-icon:active {
  background-color: #c2e0ff;
  /* Fallback color for IE 8 */
  background-color: rgba(0, 126, 255, 0.24);
}
.Select--multi.is-disabled .Select-value {
  background-color: #fcfcfc;
  border: 1px solid #e3e3e3;
  color: #333;
}
.Select--multi.is-disabled .Select-value-icon {
  cursor: not-allowed;
  border-right: 1px solid #e3e3e3;
}
.Select--multi.is-disabled .Select-value-icon:hover,
.Select--multi.is-disabled .Select-value-icon:focus,
.Select--multi.is-disabled .Select-value-icon:active {
  background-color: #fcfcfc;
}
@keyframes Select-animation-spin {
  to {
    transform: rotate(1turn);
  }
}
/* ============================================================
   CUSTOM STYLES – Full modern dark redesign.
   This must be the LAST import so it takes precedence.
   ============================================================ */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Inter', sans-serif;
  font-weight: 900;
  letter-spacing: -0.025em;
  color: var(--text-primary);
}
.text-sm,
.text-muted,
.customer-sub-title {
  font-size: 0.875rem;
  color: var(--text-secondary);
}
body {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  color: var(--text-primary);
  background-color: var(--bg-color);
}
p {
  margin: 0;
}
a {
  font-size: 15px;
}
.relative {
  position: relative;
}
.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-header {
  margin-top: 22px;
  text-align: right;
  position: absolute;
  right: 40px;
}
.user-header a {
  margin-left: 20px;
}
.panel-title {
  font-weight: 900;
  letter-spacing: -0.025em;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 18px;
  color: inherit;
}
.media-body h4 {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 400;
  font-size: 18px;
  color: #154261;
}
.media-body span {
  color: #849099;
  margin-right: 5px;
}
.list-group {
  margin: 20px 0 0 0;
}
.list-group .picture {
  height: 240px;
}
a.list-group-item:hover {
  background-color: #F7FBFC;
}
@media (min-width: 480px) {
  .list-group {
    margin: 40px 0 0 0;
  }
  .list-group-item {
    padding: 20px 15px;
  }
}
.form-control {
  background: var(--surface-color);
  color: var(--text-primary);
  height: 50px;
  box-sizing: border-box;
  border-radius: var(--radius-md);
  padding: 8px 15px;
  border: 1px solid var(--border-color);
  transition: all var(--transition-fast);
  box-shadow: var(--shadow-sm);
}
.form-control:hover {
  border-color: var(--primary-hover);
}
.form-control:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
  outline: none;
}
.form-control:-moz-placeholder {
  color: var(--text-secondary);
}
.form-control:placeholder-shown {
  color: var(--text-secondary);
}
.form-control::-webkit-input-placeholder {
  color: var(--text-secondary);
}
.search-input .form-control {
  height: 34px;
}
.chat-input .form-control {
  height: 34px;
  padding: 6px 12px;
  line-height: 1.42857143;
  background: var(--surface-color);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-color);
}
.row-centered {
  display: flex;
  justify-content: center;
}
.btn-green {
  background: var(--success-color);
  color: white;
  font-weight: 500;
  transition: all var(--transition-fast);
  border-radius: var(--radius-md);
  border: none;
}
.btn-green:hover {
  color: white;
  filter: brightness(0.9);
  box-shadow: var(--shadow-md);
}
.btn-green:active,
.btn-green:focus {
  color: white;
  filter: brightness(0.8);
}
#app {
  overflow-x: hidden;
  overflow-y: auto;
}
.user-header i {
  display: none;
}
@media (max-width: 1199px) {
  .header .edit-user {
    top: 0;
    position: absolute;
    right: 15px;
  }
  .container.shrink {
    padding: 0;
  }
  .user-header {
    margin-top: 0;
    left: 0;
    padding: 15px;
    overflow: hidden;
    z-index: 19999;
    transform: translateZ(0);
    transform: translateX(-139px);
    transition: 0.2s linear all;
    text-align: left;
    background: rgba(255, 255, 255, 0);
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    border-left: 1px solid rgba(0, 0, 0, 0);
    right: auto !important;
  }
  .user-header i {
    font-size: 20px;
    display: block;
    text-align: right;
    padding-right: 5px;
  }
  .user-header .menu {
    margin-top: 10px;
    margin-right: 42px;
    text-align: left;
    background: #ffffff;
  }
  .user-header .menu > * {
    display: block;
    margin-left: 0;
    margin-bottom: 10px;
  }
  .user-header.active {
    transform: translateX(0);
    background: #ffffff;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-left: 1px solid rgba(0, 0, 0, 0.1);
  }
  .back-link {
    display: none;
  }
}
.container {
  overflow: hidden;
}
.navigation {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.navigation > .navbar {
  flex: none;
  border: none;
  margin-bottom: 0;
  background-color: transparent;
}
.navigation .navbar-default {
  background-color: transparent;
  border: none;
}
.navigation .navbar-default .navbar-nav > li > a {
  color: var(--text-secondary);
}
.navigation .navbar-default .navbar-nav > li > a:hover,
.navigation .navbar-default .navbar-nav > li > a:focus {
  color: var(--text-primary);
}
.navigation .navbar-default .navbar-brand {
  color: var(--text-primary);
}
.navigation .navbar-default .navbar-brand:hover,
.navigation .navbar-default .navbar-brand:focus {
  color: var(--text-primary);
}
.navigation > .content-bg {
  flex: auto;
  display: flex;
  flex-direction: column;
  background: transparent;
  overflow-y: auto;
}
@media (max-width: 767px) {
  .navigation > .content-bg {
    width: 100%;
  }
}
.navbar-right {
  display: flex;
  align-items: center;
  margin-right: 0;
}
@media (max-width: 767px) {
  .navbar-right {
    padding-left: 10px;
    flex-direction: column;
    align-items: flex-start;
  }
}
@media (max-width: 767px) {
  .navbar-collapse a {
    text-align: left;
  }
}
@media (max-width: 767px) {
  .breadcrumb-menu {
    border-bottom: 1px solid #d6d6d6;
    text-align: center;
    padding-bottom: 10px;
  }
}
@media (max-width: 767px) {
  .user-menu {
    margin-top: 10px;
  }
  .user-menu span,
  .user-menu a {
    padding: 10px 0 !important;
  }
}
pre {
  border-radius: 3px;
  border-color: #d6d6d6;
}
.help-block {
  overflow: hidden;
}
.dropdown-menu > li > a {
  white-space: pre-wrap;
}
.company-name,
.customer-name {
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-menu li a,
.user-menu li span {
  max-width: 200px;
  max-height: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 1199px) {
  .hide-md {
    display: none !important;
  }
}
.menu-item-responsive i {
  display: none;
}
@media (max-width: 1199px) {
  .menu-item-responsive i {
    display: inline-block;
  }
}
@media (min-width: 768px) and (max-width: 1199px) {
  .menu-item-responsive span {
    display: none;
  }
}
.lh-modal p {
  max-width: 560px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lh-btn-group {
  display: flex;
}
.lh-btn-group > * {
  height: 44px;
  margin: 0;
  line-height: 44px;
  padding: 0 18px !important;
}
.lh-btn-group pre {
  flex: 1;
}
.lh-btn-group button {
  flex: 0;
}
.lh-btn-group > *:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.lh-btn-group > *:first-child:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.lh-btn-group > *:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.lh-btn-group * + * {
  margin-left: -1px;
}
@media (max-width: 767px) {
  .lh-btn-group pre {
    display: none;
  }
  .lh-btn-group > * {
    border-radius: 3px !important;
  }
}
.dropdown-menu {
  max-width: calc(100vw - 150px);
}
.dropdown-menu > li > a {
  overflow: hidden;
  text-overflow: ellipsis;
}
.terms h1 {
  font-size: 34px;
}
.terms h2 {
  font-size: 28px;
}
.terms h3 {
  font-size: 22px;
}
.terms p {
  margin-bottom: 10px;
}
@media (max-width: 1199px) {
  .terms {
    padding: 30px;
  }
}
img.logo {
  width: 400px;
}
@media (max-width: 991px) {
  img.logo {
    width: 300px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.less","webpack://./node_modules/bootstrap/less/normalize.less","webpack://./node_modules/bootstrap/less/print.less","webpack://./node_modules/bootstrap/less/glyphicons.less","webpack://./node_modules/bootstrap/less/scaffolding.less","webpack://./node_modules/bootstrap/less/mixins/vendor-prefixes.less","webpack://./node_modules/bootstrap/less/mixins/tab-focus.less","webpack://./node_modules/bootstrap/less/mixins/image.less","webpack://./node_modules/bootstrap/less/type.less","webpack://./node_modules/bootstrap/less/mixins/text-emphasis.less","webpack://./node_modules/bootstrap/less/mixins/background-variant.less","webpack://./node_modules/bootstrap/less/mixins/text-overflow.less","webpack://./node_modules/bootstrap/less/code.less","webpack://./node_modules/bootstrap/less/grid.less","webpack://./node_modules/bootstrap/less/mixins/grid.less","webpack://./node_modules/bootstrap/less/mixins/grid-framework.less","webpack://./node_modules/bootstrap/less/tables.less","webpack://./node_modules/bootstrap/less/mixins/table-row.less","webpack://./node_modules/bootstrap/less/forms.less","webpack://./node_modules/bootstrap/less/mixins/forms.less","webpack://./node_modules/bootstrap/less/buttons.less","webpack://./node_modules/bootstrap/less/mixins/buttons.less","webpack://./node_modules/bootstrap/less/mixins/opacity.less","webpack://./node_modules/bootstrap/less/component-animations.less","webpack://./node_modules/bootstrap/less/dropdowns.less","webpack://./node_modules/bootstrap/less/mixins/nav-divider.less","webpack://./node_modules/bootstrap/less/mixins/reset-filter.less","webpack://./node_modules/bootstrap/less/button-groups.less","webpack://./node_modules/bootstrap/less/mixins/border-radius.less","webpack://./node_modules/bootstrap/less/input-groups.less","webpack://./node_modules/bootstrap/less/navs.less","webpack://./node_modules/bootstrap/less/navbar.less","webpack://./node_modules/bootstrap/less/mixins/nav-vertical-align.less","webpack://./node_modules/bootstrap/less/utilities.less","webpack://./node_modules/font-awesome/less/bordered-pulled.less","webpack://./node_modules/bootstrap/less/breadcrumbs.less","webpack://./node_modules/bootstrap/less/pagination.less","webpack://./node_modules/bootstrap/less/mixins/pagination.less","webpack://./node_modules/bootstrap/less/pager.less","webpack://./node_modules/bootstrap/less/labels.less","webpack://./node_modules/bootstrap/less/mixins/labels.less","webpack://./node_modules/bootstrap/less/badges.less","webpack://./node_modules/bootstrap/less/jumbotron.less","webpack://./node_modules/bootstrap/less/thumbnails.less","webpack://./node_modules/bootstrap/less/alerts.less","webpack://./node_modules/bootstrap/less/mixins/alerts.less","webpack://./node_modules/bootstrap/less/progress-bars.less","webpack://./node_modules/bootstrap/less/mixins/gradients.less","webpack://./node_modules/bootstrap/less/mixins/progress-bar.less","webpack://./node_modules/bootstrap/less/media.less","webpack://./node_modules/bootstrap/less/list-group.less","webpack://./node_modules/bootstrap/less/mixins/list-group.less","webpack://./node_modules/bootstrap/less/panels.less","webpack://./node_modules/bootstrap/less/mixins/panels.less","webpack://./node_modules/bootstrap/less/responsive-embed.less","webpack://./node_modules/bootstrap/less/wells.less","webpack://./node_modules/bootstrap/less/close.less","webpack://./node_modules/bootstrap/less/modals.less","webpack://./node_modules/bootstrap/less/tooltip.less","webpack://./node_modules/bootstrap/less/mixins/reset-text.less","webpack://./node_modules/bootstrap/less/popovers.less","webpack://./node_modules/bootstrap/less/carousel.less","webpack://./node_modules/bootstrap/less/mixins/clearfix.less","webpack://./node_modules/bootstrap/less/mixins/center-block.less","webpack://./node_modules/bootstrap/less/mixins/hide-text.less","webpack://./node_modules/bootstrap/less/responsive-utilities.less","webpack://./node_modules/bootstrap/less/mixins/responsive-visibility.less","webpack://./node_modules/font-awesome/less/path.less","webpack://./node_modules/font-awesome/less/core.less","webpack://./node_modules/font-awesome/less/larger.less","webpack://./node_modules/font-awesome/less/fixed-width.less","webpack://./node_modules/font-awesome/less/list.less","webpack://./node_modules/font-awesome/less/animated.less","webpack://./node_modules/font-awesome/less/rotated-flipped.less","webpack://./node_modules/font-awesome/less/mixins.less","webpack://./node_modules/font-awesome/less/stacked.less","webpack://./node_modules/font-awesome/less/icons.less","webpack://./node_modules/font-awesome/less/screen-reader.less","webpack://./src/styles/breadcrumb.less","webpack://./src/styles/company.less","webpack://./src/styles/customer.less","webpack://./src/styles/event.less","webpack://./src/styles/fonts.less","webpack://./src/styles/loader.less","webpack://./src/styles/theme.less","webpack://./src/styles/lookhere_vars.less","webpack://./src/styles/home.less","webpack://./src/styles/tools.less","webpack://./src/styles/video-chat.less","webpack://./src/styles/offline.less","webpack://./src/styles/offline-german-indicator.less","webpack://./src/styles/order.less","webpack://./src/styles/lh-btn.less","webpack://./src/styles/react-select.less"],"names":[],"mappings":"AAAA;;;;EAIE;AACF,2EAA2E;ACK3E;EACE,uBAAA;EACA,0BAAA;EACA,8BAAA;ADAF;ACOA;EACE,SAAA;ADLF;ACkBA;;;;;;;;;;;;;EAaE,cAAA;ADhBF;ACwBA;;;;EAIE,qBAAA;EACA,wBAAA;ADtBF;AC8BA;EACE,aAAA;EACA,SAAA;AD5BF;ACoCA;;EAEE,aAAA;ADlCF;AC4CA;EACE,6BAAA;AD1CF;ACkDA;;EAEE,UAAA;ADhDF;AC2DA;EACE,mBAAA;EACA,0BAAA;EACA,yCAAA;UAAA,iCAAA;ADzDF;ACgEA;;EAEE,iBAAA;AD9DF;ACqEA;EACE,kBAAA;ADnEF;AC2EA;EACE,cAAA;EACA,gBAAA;ADzEF;ACgFA;EACE,gBAAA;EACA,WAAA;AD9EF;ACqFA;EACE,cAAA;ADnFF;AC0FA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;ADxFF;AC2FA;EACE,WAAA;ADzFF;AC4FA;EACE,eAAA;AD1FF;ACoGA;EACE,SAAA;ADlGF;ACyGA;EACE,gBAAA;ADvGF;ACiHA;EACE,gBAAA;AD/GF;ACsHA;EACE,uBAAA;EACA,SAAA;ADpHF;AC2HA;EACE,cAAA;ADzHF;ACgIA;;;;EAIE,iCAAA;EACA,cAAA;AD9HF;ACgJA;;;;;EAKE,cAAA;EACA,aAAA;EACA,SAAA;AD9IF;ACqJA;EACE,iBAAA;ADnJF;AC6JA;;EAEE,oBAAA;AD3JF;ACsKA;;;;EAIE,0BAAA;EACA,eAAA;ADpKF;AC2KA;;EAEE,eAAA;ADzKF;ACgLA;;EAEE,SAAA;EACA,UAAA;AD9KF;ACsLA;EACE,mBAAA;ADpLF;AC+LA;;EAEE,sBAAA;EACA,UAAA;AD7LF;ACsMA;;EAEE,YAAA;ADpMF;AC4MA;EACE,6BAAA;EACA,uBAAA;AD1MF;ACmNA;;EAEE,wBAAA;ADjNF;ACwNA;EACE,yBAAA;EACA,aAAA;EACA,8BAAA;ADtNF;AC8NA;EACE,SAAA;EACA,UAAA;AD5NF;ACmOA;EACE,cAAA;ADjOF;ACyOA;EACE,iBAAA;ADvOF;ACiPA;EACE,yBAAA;EACA,iBAAA;AD/OF;ACkPA;;EAEE,UAAA;ADhPF;AACA,oFAAoF;AEnLpF;EACE;;;IAGE,sBAAA;IACA,4BAAA;IACA,kCAAA;IACA,2BAAA;EFqLF;EElLA;;IAEE,0BAAA;EFoLF;EEjLA;IACE,4BAAA;EFmLF;EEhLA;IACE,6BAAA;EFkLF;EE7KA;;IAEE,WAAA;EF+KF;EE5KA;;IAEE,sBAAA;IACA,wBAAA;EF8KF;EE3KA;IACE,2BAAA;EF6KF;EE1KA;;IAEE,wBAAA;EF4KF;EEzKA;IACE,0BAAA;EF2KF;EExKA;;;IAGE,UAAA;IACA,SAAA;EF0KF;EEvKA;;IAEE,uBAAA;EFyKF;EEnKA;IACE,aAAA;EFqKF;EEnKA;;IAGI,iCAAA;EFoKJ;EEjKA;IACE,sBAAA;EFmKF;EEhKA;IACE,oCAAA;EFkKF;EEnKA;;IAKI,iCAAA;EFkKJ;EE/JA;;IAGI,iCAAA;EFgKJ;AACF;AGtPA;EACE,mCAAA;EACA,4CAAA;EACA,4SAAA;AHwPF;AGhPA;EACE,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;AHkPF;AG9OoC;EAAW,gBAAA;AHiP/C;AGhPoC;EAAW,gBAAA;AHmP/C;AGjPoC;;EAAW,gBAAA;AHqP/C;AGpPoC;EAAW,gBAAA;AHuP/C;AGtPoC;EAAW,gBAAA;AHyP/C;AGxPoC;EAAW,gBAAA;AH2P/C;AG1PoC;EAAW,gBAAA;AH6P/C;AG5PoC;EAAW,gBAAA;AH+P/C;AG9PoC;EAAW,gBAAA;AHiQ/C;AGhQoC;EAAW,gBAAA;AHmQ/C;AGlQoC;EAAW,gBAAA;AHqQ/C;AGpQoC;EAAW,gBAAA;AHuQ/C;AGtQoC;EAAW,gBAAA;AHyQ/C;AGxQoC;EAAW,gBAAA;AH2Q/C;AG1QoC;EAAW,gBAAA;AH6Q/C;AG5QoC;EAAW,gBAAA;AH+Q/C;AG9QoC;EAAW,gBAAA;AHiR/C;AGhRoC;EAAW,gBAAA;AHmR/C;AGlRoC;EAAW,gBAAA;AHqR/C;AGpRoC;EAAW,gBAAA;AHuR/C;AGtRoC;EAAW,gBAAA;AHyR/C;AGxRoC;EAAW,gBAAA;AH2R/C;AG1RoC;EAAW,gBAAA;AH6R/C;AG5RoC;EAAW,gBAAA;AH+R/C;AG9RoC;EAAW,gBAAA;AHiS/C;AGhSoC;EAAW,gBAAA;AHmS/C;AGlSoC;EAAW,gBAAA;AHqS/C;AGpSoC;EAAW,gBAAA;AHuS/C;AGtSoC;EAAW,gBAAA;AHyS/C;AGxSoC;EAAW,gBAAA;AH2S/C;AG1SoC;EAAW,gBAAA;AH6S/C;AG5SoC;EAAW,gBAAA;AH+S/C;AG9SoC;EAAW,gBAAA;AHiT/C;AGhToC;EAAW,gBAAA;AHmT/C;AGlToC;EAAW,gBAAA;AHqT/C;AGpToC;EAAW,gBAAA;AHuT/C;AGtToC;EAAW,gBAAA;AHyT/C;AGxToC;EAAW,gBAAA;AH2T/C;AG1ToC;EAAW,gBAAA;AH6T/C;AG5ToC;EAAW,gBAAA;AH+T/C;AG9ToC;EAAW,gBAAA;AHiU/C;AGhUoC;EAAW,gBAAA;AHmU/C;AGlUoC;EAAW,gBAAA;AHqU/C;AGpUoC;EAAW,gBAAA;AHuU/C;AGtUoC;EAAW,gBAAA;AHyU/C;AGxUoC;EAAW,gBAAA;AH2U/C;AG1UoC;EAAW,gBAAA;AH6U/C;AG5UoC;EAAW,gBAAA;AH+U/C;AG9UoC;EAAW,gBAAA;AHiV/C;AGhVoC;EAAW,gBAAA;AHmV/C;AGlVoC;EAAW,gBAAA;AHqV/C;AGpVoC;EAAW,gBAAA;AHuV/C;AGtVoC;EAAW,gBAAA;AHyV/C;AGxVoC;EAAW,gBAAA;AH2V/C;AG1VoC;EAAW,gBAAA;AH6V/C;AG5VoC;EAAW,gBAAA;AH+V/C;AG9VoC;EAAW,gBAAA;AHiW/C;AGhWoC;EAAW,gBAAA;AHmW/C;AGlWoC;EAAW,gBAAA;AHqW/C;AGpWoC;EAAW,gBAAA;AHuW/C;AGtWoC;EAAW,gBAAA;AHyW/C;AGxWoC;EAAW,gBAAA;AH2W/C;AG1WoC;EAAW,gBAAA;AH6W/C;AG5WoC;EAAW,gBAAA;AH+W/C;AG9WoC;EAAW,gBAAA;AHiX/C;AGhXoC;EAAW,gBAAA;AHmX/C;AGlXoC;EAAW,gBAAA;AHqX/C;AGpXoC;EAAW,gBAAA;AHuX/C;AGtXoC;EAAW,gBAAA;AHyX/C;AGxXoC;EAAW,gBAAA;AH2X/C;AG1XoC;EAAW,gBAAA;AH6X/C;AG5XoC;EAAW,gBAAA;AH+X/C;AG9XoC;EAAW,gBAAA;AHiY/C;AGhYoC;EAAW,gBAAA;AHmY/C;AGlYoC;EAAW,gBAAA;AHqY/C;AGpYoC;EAAW,gBAAA;AHuY/C;AGtYoC;EAAW,gBAAA;AHyY/C;AGxYoC;EAAW,gBAAA;AH2Y/C;AG1YoC;EAAW,gBAAA;AH6Y/C;AG5YoC;EAAW,gBAAA;AH+Y/C;AG9YoC;EAAW,gBAAA;AHiZ/C;AGhZoC;EAAW,gBAAA;AHmZ/C;AGlZoC;EAAW,gBAAA;AHqZ/C;AGpZoC;EAAW,gBAAA;AHuZ/C;AGtZoC;EAAW,gBAAA;AHyZ/C;AGxZoC;EAAW,gBAAA;AH2Z/C;AG1ZoC;EAAW,gBAAA;AH6Z/C;AG5ZoC;EAAW,gBAAA;AH+Z/C;AG9ZoC;EAAW,gBAAA;AHia/C;AGhaoC;EAAW,gBAAA;AHma/C;AGlaoC;EAAW,gBAAA;AHqa/C;AGpaoC;EAAW,gBAAA;AHua/C;AGtaoC;EAAW,gBAAA;AHya/C;AGxaoC;EAAW,gBAAA;AH2a/C;AG1aoC;EAAW,gBAAA;AH6a/C;AG5aoC;EAAW,gBAAA;AH+a/C;AG9aoC;EAAW,gBAAA;AHib/C;AGhboC;EAAW,gBAAA;AHmb/C;AGlboC;EAAW,gBAAA;AHqb/C;AGpboC;EAAW,gBAAA;AHub/C;AGtboC;EAAW,gBAAA;AHyb/C;AGxboC;EAAW,gBAAA;AH2b/C;AG1boC;EAAW,gBAAA;AH6b/C;AG5boC;EAAW,gBAAA;AH+b/C;AG9boC;EAAW,gBAAA;AHic/C;AGhcoC;EAAW,gBAAA;AHmc/C;AGlcoC;EAAW,gBAAA;AHqc/C;AGpcoC;EAAW,gBAAA;AHuc/C;AGtcoC;EAAW,gBAAA;AHyc/C;AGxcoC;EAAW,gBAAA;AH2c/C;AG1coC;EAAW,gBAAA;AH6c/C;AG5coC;EAAW,gBAAA;AH+c/C;AG9coC;EAAW,gBAAA;AHid/C;AGhdoC;EAAW,gBAAA;AHmd/C;AGldoC;EAAW,gBAAA;AHqd/C;AGpdoC;EAAW,gBAAA;AHud/C;AGtdoC;EAAW,gBAAA;AHyd/C;AGxdoC;EAAW,gBAAA;AH2d/C;AG1doC;EAAW,gBAAA;AH6d/C;AG5doC;EAAW,gBAAA;AH+d/C;AG9doC;EAAW,gBAAA;AHie/C;AGheoC;EAAW,gBAAA;AHme/C;AGleoC;EAAW,gBAAA;AHqe/C;AGpeoC;EAAW,gBAAA;AHue/C;AGteoC;EAAW,gBAAA;AHye/C;AGxeoC;EAAW,gBAAA;AH2e/C;AG1eoC;EAAW,gBAAA;AH6e/C;AG5eoC;EAAW,gBAAA;AH+e/C;AG9eoC;EAAW,gBAAA;AHif/C;AGhfoC;EAAW,gBAAA;AHmf/C;AGlfoC;EAAW,gBAAA;AHqf/C;AGpfoC;EAAW,gBAAA;AHuf/C;AGtfoC;EAAW,gBAAA;AHyf/C;AGxfoC;EAAW,gBAAA;AH2f/C;AG1foC;EAAW,gBAAA;AH6f/C;AG5foC;EAAW,gBAAA;AH+f/C;AG9foC;EAAW,gBAAA;AHigB/C;AGhgBoC;EAAW,gBAAA;AHmgB/C;AGlgBoC;EAAW,gBAAA;AHqgB/C;AGpgBoC;EAAW,gBAAA;AHugB/C;AGtgBoC;EAAW,gBAAA;AHygB/C;AGxgBoC;EAAW,gBAAA;AH2gB/C;AG1gBoC;EAAW,gBAAA;AH6gB/C;AG5gBoC;EAAW,gBAAA;AH+gB/C;AG9gBoC;EAAW,gBAAA;AHihB/C;AGhhBoC;EAAW,gBAAA;AHmhB/C;AGlhBoC;EAAW,gBAAA;AHqhB/C;AGphBoC;EAAW,gBAAA;AHuhB/C;AGthBoC;EAAW,gBAAA;AHyhB/C;AGxhBoC;EAAW,gBAAA;AH2hB/C;AG1hBoC;EAAW,gBAAA;AH6hB/C;AG5hBoC;EAAW,gBAAA;AH+hB/C;AG9hBoC;EAAW,gBAAA;AHiiB/C;AGhiBoC;EAAW,gBAAA;AHmiB/C;AGliBoC;EAAW,gBAAA;AHqiB/C;AGpiBoC;EAAW,gBAAA;AHuiB/C;AGtiBoC;EAAW,gBAAA;AHyiB/C;AGxiBoC;EAAW,gBAAA;AH2iB/C;AG1iBoC;EAAW,gBAAA;AH6iB/C;AG5iBoC;EAAW,gBAAA;AH+iB/C;AG9iBoC;EAAW,gBAAA;AHijB/C;AGhjBoC;EAAW,gBAAA;AHmjB/C;AGljBoC;EAAW,gBAAA;AHqjB/C;AGpjBoC;EAAW,gBAAA;AHujB/C;AGtjBoC;EAAW,gBAAA;AHyjB/C;AGxjBoC;EAAW,gBAAA;AH2jB/C;AG1jBoC;EAAW,gBAAA;AH6jB/C;AG5jBoC;EAAW,gBAAA;AH+jB/C;AG9jBoC;EAAW,gBAAA;AHikB/C;AGhkBoC;EAAW,gBAAA;AHmkB/C;AGlkBoC;EAAW,gBAAA;AHqkB/C;AGpkBoC;EAAW,gBAAA;AHukB/C;AGtkBoC;EAAW,gBAAA;AHykB/C;AGxkBoC;EAAW,gBAAA;AH2kB/C;AG1kBoC;EAAW,gBAAA;AH6kB/C;AG5kBoC;EAAW,gBAAA;AH+kB/C;AG9kBoC;EAAW,gBAAA;AHilB/C;AGhlBoC;EAAW,gBAAA;AHmlB/C;AGllBoC;EAAW,gBAAA;AHqlB/C;AGplBoC;EAAW,gBAAA;AHulB/C;AGtlBoC;EAAW,gBAAA;AHylB/C;AGxlBoC;EAAW,gBAAA;AH2lB/C;AG1lBoC;EAAW,gBAAA;AH6lB/C;AG5lBoC;EAAW,gBAAA;AH+lB/C;AG9lBoC;EAAW,gBAAA;AHimB/C;AGhmBoC;EAAW,gBAAA;AHmmB/C;AGlmBoC;EAAW,gBAAA;AHqmB/C;AGpmBoC;EAAW,gBAAA;AHumB/C;AGtmBoC;EAAW,gBAAA;AHymB/C;AGxmBoC;EAAW,gBAAA;AH2mB/C;AG1mBoC;EAAW,gBAAA;AH6mB/C;AG5mBoC;EAAW,gBAAA;AH+mB/C;AG9mBoC;EAAW,gBAAA;AHinB/C;AGhnBoC;EAAW,gBAAA;AHmnB/C;AGlnBoC;EAAW,gBAAA;AHqnB/C;AGpnBoC;EAAW,gBAAA;AHunB/C;AGtnBoC;EAAW,gBAAA;AHynB/C;AGxnBoC;EAAW,gBAAA;AH2nB/C;AG1nBoC;EAAW,gBAAA;AH6nB/C;AG5nBoC;EAAW,gBAAA;AH+nB/C;AG9nBoC;EAAW,gBAAA;AHioB/C;AGhoBoC;EAAW,gBAAA;AHmoB/C;AGloBoC;EAAW,gBAAA;AHqoB/C;AGpoBoC;EAAW,gBAAA;AHuoB/C;AGtoBoC;EAAW,gBAAA;AHyoB/C;AGxoBoC;EAAW,gBAAA;AH2oB/C;AGloBoC;EAAW,gBAAA;AHqoB/C;AGpoBoC;EAAW,gBAAA;AHuoB/C;AGtoBoC;EAAW,gBAAA;AHyoB/C;AGxoBoC;EAAW,gBAAA;AH2oB/C;AG1oBoC;EAAW,gBAAA;AH6oB/C;AG5oBoC;EAAW,gBAAA;AH+oB/C;AG9oBoC;EAAW,gBAAA;AHipB/C;AGhpBoC;EAAW,gBAAA;AHmpB/C;AGlpBoC;EAAW,gBAAA;AHqpB/C;AGppBoC;EAAW,gBAAA;AHupB/C;AGtpBoC;EAAW,gBAAA;AHypB/C;AGxpBoC;EAAW,gBAAA;AH2pB/C;AG1pBoC;EAAW,gBAAA;AH6pB/C;AG5pBoC;EAAW,gBAAA;AH+pB/C;AG9pBoC;EAAW,gBAAA;AHiqB/C;AGhqBoC;EAAW,gBAAA;AHmqB/C;AGlqBoC;EAAW,gBAAA;AHqqB/C;AGpqBoC;EAAW,gBAAA;AHuqB/C;AGtqBoC;EAAW,gBAAA;AHyqB/C;AGxqBoC;EAAW,gBAAA;AH2qB/C;AG1qBoC;EAAW,gBAAA;AH6qB/C;AG5qBoC;EAAW,gBAAA;AH+qB/C;AG9qBoC;EAAW,gBAAA;AHirB/C;AGhrBoC;EAAW,gBAAA;AHmrB/C;AGlrBoC;EAAW,gBAAA;AHqrB/C;AGprBoC;EAAW,gBAAA;AHurB/C;AGtrBoC;EAAW,gBAAA;AHyrB/C;AGxrBoC;EAAW,gBAAA;AH2rB/C;AG1rBoC;EAAW,gBAAA;AH6rB/C;AG5rBoC;EAAW,gBAAA;AH+rB/C;AG9rBoC;EAAW,gBAAA;AHisB/C;AGhsBoC;EAAW,gBAAA;AHmsB/C;AGlsBoC;EAAW,gBAAA;AHqsB/C;AGpsBoC;EAAW,gBAAA;AHusB/C;AGtsBoC;EAAW,gBAAA;AHysB/C;AGxsBoC;EAAW,gBAAA;AH2sB/C;AG1sBoC;EAAW,gBAAA;AH6sB/C;AG5sBoC;EAAW,gBAAA;AH+sB/C;AG9sBoC;EAAW,gBAAA;AHitB/C;AGhtBoC;EAAW,gBAAA;AHmtB/C;AGltBoC;EAAW,gBAAA;AHqtB/C;AGptBoC;EAAW,gBAAA;AHutB/C;AGttBoC;EAAW,gBAAA;AHytB/C;AGxtBoC;EAAW,gBAAA;AH2tB/C;AG1tBoC;EAAW,gBAAA;AH6tB/C;AG5tBoC;EAAW,gBAAA;AH+tB/C;AG9tBoC;EAAW,gBAAA;AHiuB/C;AGhuBoC;EAAW,gBAAA;AHmuB/C;AGluBoC;EAAW,gBAAA;AHquB/C;AGpuBoC;EAAW,gBAAA;AHuuB/C;AGtuBoC;EAAW,gBAAA;AHyuB/C;AGxuBoC;EAAW,gBAAA;AH2uB/C;AG1uBoC;EAAW,gBAAA;AH6uB/C;AG5uBoC;EAAW,gBAAA;AH+uB/C;AG9uBoC;EAAW,gBAAA;AHivB/C;AGhvBoC;EAAW,gBAAA;AHmvB/C;AI3hCA;ECoEU,sBAAA;AL49BV;AI7hCA;;ECiEU,sBAAA;ALk+BV;AI3hCA;EACE,eAAA;EACA,6CAAA;AJ6hCF;AI1hCA;EACE,2DAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,yBAAA;AJ4hCF;AIxhCA;;;;EAIE,oBAAA;EACA,kBAAA;EACA,oBAAA;AJ0hCF;AIphCA;EACE,cAAA;EACA,qBAAA;AJshCF;AIphCE;;EAEE,cAAA;EACA,0BAAA;AJshCJ;AInhCE;EEnDA,0CAAA;EACA,oBAAA;ANykCF;AI5gCA;EACE,SAAA;AJ8gCF;AIxgCA;EACE,sBAAA;AJ0gCF;AItgCA;;;;;EG1EE,cAAA;EACA,eAAA;EACA,YAAA;APulCF;AI1gCA;EACE,kBAAA;AJ4gCF;AItgCA;EACE,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;ECiGQ,gCAAA;EE5LR,qBAAA;EACA,eAAA;EACA,YAAA;APumCF;AItgCA;EACE,kBAAA;AJwgCF;AIlgCA;EACE,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;AJogCF;AI5/BA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AJ8/BF;AIt/BE;;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;AJw/BJ;AI7+BA;EACE,eAAA;AJ++BF;AQpoCA;;;;;;;;;;;;EAEE,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;ARgpCF;AQrpCA;;;;;;;;;;;;;;;;;;;;;;;;EASI,gBAAA;EACA,cAAA;EACA,cAAA;ARsqCJ;AQlqCA;;;;;;EAGE,gBAAA;EACA,mBAAA;ARuqCF;AQ3qCA;;;;;;;;;;;;EAQI,cAAA;ARirCJ;AQ9qCA;;;;;;EAGE,gBAAA;EACA,mBAAA;ARmrCF;AQvrCA;;;;;;;;;;;;EAQI,cAAA;AR6rCJ;AQzrCA;;EAAU,eAAA;AR6rCV;AQ5rCA;;EAAU,eAAA;ARgsCV;AQ/rCA;;EAAU,eAAA;ARmsCV;AQlsCA;;EAAU,eAAA;ARssCV;AQrsCA;;EAAU,eAAA;ARysCV;AQxsCA;;EAAU,eAAA;AR4sCV;AQtsCA;EACE,gBAAA;ARwsCF;AQrsCA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ARusCF;AQrsCE;EAAA;IACE,eAAA;ERwsCF;AACF;AQhsCA;;EAEE,cAAA;ARksCF;AQ/rCA;;EAEE,cAAA;EACA,yBAAA;ARisCF;AQ7rCA;EAAuB,gBAAA;ARgsCvB;AQ/rCA;EAAuB,iBAAA;ARksCvB;AQjsCA;EAAuB,kBAAA;ARosCvB;AQnsCA;EAAuB,mBAAA;ARssCvB;AQrsCA;EAAuB,mBAAA;ARwsCvB;AQrsCA;EAAuB,yBAAA;ARwsCvB;AQvsCA;EAAuB,yBAAA;AR0sCvB;AQzsCA;EAAuB,0BAAA;AR4sCvB;AQzsCA;EACE,cAAA;AR2sCF;AQzsCA;ECvGE,cAAA;ATmzCF;ASlzCE;;EAEE,cAAA;ATozCJ;AQ7sCA;EC1GE,cAAA;AT0zCF;ASzzCE;;EAEE,cAAA;AT2zCJ;AQjtCA;EC7GE,cAAA;ATi0CF;ASh0CE;;EAEE,cAAA;ATk0CJ;AQrtCA;EChHE,cAAA;ATw0CF;ASv0CE;;EAEE,cAAA;ATy0CJ;AQztCA;ECnHE,cAAA;AT+0CF;AS90CE;;EAEE,cAAA;ATg1CJ;AQztCA;EAGE,WAAA;EE7HA,yBAAA;AVu1CF;AUt1CE;;EAEE,yBAAA;AVw1CJ;AQ3tCA;EEhIE,yBAAA;AV81CF;AU71CE;;EAEE,yBAAA;AV+1CJ;AQ/tCA;EEnIE,yBAAA;AVq2CF;AUp2CE;;EAEE,yBAAA;AVs2CJ;AQnuCA;EEtIE,yBAAA;AV42CF;AU32CE;;EAEE,yBAAA;AV62CJ;AQvuCA;EEzIE,yBAAA;AVm3CF;AUl3CE;;EAEE,yBAAA;AVo3CJ;AQtuCA;EACE,mBAAA;EACA,mBAAA;EACA,gCAAA;ARwuCF;AQhuCA;;EAEE,aAAA;EACA,mBAAA;ARkuCF;AQruCA;;;;EAMI,gBAAA;ARquCJ;AQ9tCA;EACE,eAAA;EACA,gBAAA;ARguCF;AQ5tCA;EALE,eAAA;EACA,gBAAA;EAMA,iBAAA;AR+tCF;AQjuCA;EAKI,qBAAA;EACA,kBAAA;EACA,iBAAA;AR+tCJ;AQ1tCA;EACE,aAAA;EACA,mBAAA;AR4tCF;AQ1tCA;;EAEE,uBAAA;AR4tCF;AQ1tCA;EACE,gBAAA;AR4tCF;AQ1tCA;EACE,cAAA;AR4tCF;AQ/sCE;EAAA;IAEI,WAAA;IACA,YAAA;IACA,WAAA;IACA,iBAAA;IGxNJ,gBAAA;IACA,uBAAA;IACA,mBAAA;EX06CA;EQztCA;IASI,kBAAA;ERmtCJ;AACF;AQzsCA;;EAEE,YAAA;AR2sCF;AQxsCA;EACE,cAAA;EA9IqB,yBAAA;ARy1CvB;AQtsCA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;ARwsCF;AQnsCI;;;EACE,gBAAA;ARusCN;AQjtCA;;;EAmBI,cAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;ARmsCJ;AQjsCI;;;EACE,sBAAA;ARqsCN;AQ7rCA;;EAEE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,cAAA;AR+rCF;AQzrCI;;;;;;EAAW,WAAA;ARisCf;AQhsCI;;;;;;EACE,sBAAA;ARusCN;AQjsCA;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;ARmsCF;AY3+CA;;;;EAIE,8DAAA;AZ6+CF;AYz+CA;EACE,gBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AZ2+CF;AYv+CA;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,8CAAA;AZy+CF;AY/+CA;EASI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AZy+CJ;AYp+CA;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AZs+CF;AYj/CA;EAeI,UAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,gBAAA;AZq+CJ;AYh+CA;EACE,iBAAA;EACA,kBAAA;AZk+CF;Aa5hDA;ECHE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AdkiDF;Aa/hDE;EAAA;IACE,YAAA;EbkiDF;AACF;AajiDE;EAAA;IACE,YAAA;EboiDF;AACF;AaniDE;EAAA;IACE,aAAA;EbsiDF;AACF;Aa7hDA;ECvBE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AdujDF;Aa1hDA;ECvBE,mBAAA;EACA,kBAAA;AdojDF;Aa1hDA;EACE,eAAA;EACA,cAAA;Ab4hDF;Aa9hDA;EAKI,gBAAA;EACA,eAAA;Ab4hDJ;Ae5jDK;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EACC,kBAAA;EAEA,eAAA;EAEA,mBAAA;EACA,kBAAA;Af2mDN;Ae3lDK;;;;;;;;;;;;EACC,WAAA;AfwmDN;AejmDG;EACC,WAAA;AfmmDJ;AepmDG;EACC,mBAAA;AfsmDJ;AevmDG;EACC,mBAAA;AfymDJ;Ae1mDG;EACC,UAAA;Af4mDJ;Ae7mDG;EACC,mBAAA;Af+mDJ;AehnDG;EACC,mBAAA;AfknDJ;AennDG;EACC,UAAA;AfqnDJ;AetnDG;EACC,mBAAA;AfwnDJ;AeznDG;EACC,mBAAA;Af2nDJ;Ae5nDG;EACC,UAAA;Af8nDJ;Ae/nDG;EACC,mBAAA;AfioDJ;AeloDG;EACC,kBAAA;AfooDJ;AetnDG;EACC,WAAA;AfwnDJ;AeznDG;EACC,mBAAA;Af2nDJ;Ae5nDG;EACC,mBAAA;Af8nDJ;Ae/nDG;EACC,UAAA;AfioDJ;AeloDG;EACC,mBAAA;AfooDJ;AeroDG;EACC,mBAAA;AfuoDJ;AexoDG;EACC,UAAA;Af0oDJ;Ae3oDG;EACC,mBAAA;Af6oDJ;Ae9oDG;EACC,mBAAA;AfgpDJ;AejpDG;EACC,UAAA;AfmpDJ;AeppDG;EACC,mBAAA;AfspDJ;AevpDG;EACC,kBAAA;AfypDJ;AerpDG;EACC,WAAA;AfupDJ;AevqDG;EACC,UAAA;AfyqDJ;Ae1qDG;EACC,kBAAA;Af4qDJ;Ae7qDG;EACC,kBAAA;Af+qDJ;AehrDG;EACC,SAAA;AfkrDJ;AenrDG;EACC,kBAAA;AfqrDJ;AetrDG;EACC,kBAAA;AfwrDJ;AezrDG;EACC,SAAA;Af2rDJ;Ae5rDG;EACC,kBAAA;Af8rDJ;Ae/rDG;EACC,kBAAA;AfisDJ;AelsDG;EACC,SAAA;AfosDJ;AersDG;EACC,kBAAA;AfusDJ;AexsDG;EACC,iBAAA;Af0sDJ;AetsDG;EACC,UAAA;AfwsDJ;Ae1rDG;EACC,iBAAA;Af4rDJ;Ae7rDG;EACC,yBAAA;Af+rDJ;AehsDG;EACC,yBAAA;AfksDJ;AensDG;EACC,gBAAA;AfqsDJ;AetsDG;EACC,yBAAA;AfwsDJ;AezsDG;EACC,yBAAA;Af2sDJ;Ae5sDG;EACC,gBAAA;Af8sDJ;Ae/sDG;EACC,yBAAA;AfitDJ;AeltDG;EACC,yBAAA;AfotDJ;AertDG;EACC,gBAAA;AfutDJ;AextDG;EACC,yBAAA;Af0tDJ;Ae3tDG;EACC,wBAAA;Af6tDJ;Ae9tDG;EACC,eAAA;AfguDJ;Aa/tDA;EEnCK;;;;;;;;;;;;IACC,WAAA;EfgxDJ;EezwDC;IACC,WAAA;Ef2wDF;Ee5wDC;IACC,mBAAA;Ef8wDF;Ee/wDC;IACC,mBAAA;EfixDF;EelxDC;IACC,UAAA;EfoxDF;EerxDC;IACC,mBAAA;EfuxDF;EexxDC;IACC,mBAAA;Ef0xDF;Ee3xDC;IACC,UAAA;Ef6xDF;Ee9xDC;IACC,mBAAA;EfgyDF;EejyDC;IACC,mBAAA;EfmyDF;EepyDC;IACC,UAAA;EfsyDF;EevyDC;IACC,mBAAA;EfyyDF;Ee1yDC;IACC,kBAAA;Ef4yDF;Ee9xDC;IACC,WAAA;EfgyDF;EejyDC;IACC,mBAAA;EfmyDF;EepyDC;IACC,mBAAA;EfsyDF;EevyDC;IACC,UAAA;EfyyDF;Ee1yDC;IACC,mBAAA;Ef4yDF;Ee7yDC;IACC,mBAAA;Ef+yDF;EehzDC;IACC,UAAA;EfkzDF;EenzDC;IACC,mBAAA;EfqzDF;EetzDC;IACC,mBAAA;EfwzDF;EezzDC;IACC,UAAA;Ef2zDF;Ee5zDC;IACC,mBAAA;Ef8zDF;Ee/zDC;IACC,kBAAA;Efi0DF;Ee7zDC;IACC,WAAA;Ef+zDF;Ee/0DC;IACC,UAAA;Efi1DF;Eel1DC;IACC,kBAAA;Efo1DF;Eer1DC;IACC,kBAAA;Efu1DF;Eex1DC;IACC,SAAA;Ef01DF;Ee31DC;IACC,kBAAA;Ef61DF;Ee91DC;IACC,kBAAA;Efg2DF;Eej2DC;IACC,SAAA;Efm2DF;Eep2DC;IACC,kBAAA;Efs2DF;Eev2DC;IACC,kBAAA;Efy2DF;Ee12DC;IACC,SAAA;Ef42DF;Ee72DC;IACC,kBAAA;Ef+2DF;Eeh3DC;IACC,iBAAA;Efk3DF;Ee92DC;IACC,UAAA;Efg3DF;Eel2DC;IACC,iBAAA;Efo2DF;Eer2DC;IACC,yBAAA;Efu2DF;Eex2DC;IACC,yBAAA;Ef02DF;Ee32DC;IACC,gBAAA;Ef62DF;Ee92DC;IACC,yBAAA;Efg3DF;Eej3DC;IACC,yBAAA;Efm3DF;Eep3DC;IACC,gBAAA;Efs3DF;Eev3DC;IACC,yBAAA;Efy3DF;Ee13DC;IACC,yBAAA;Ef43DF;Ee73DC;IACC,gBAAA;Ef+3DF;Eeh4DC;IACC,yBAAA;Efk4DF;Een4DC;IACC,wBAAA;Efq4DF;Eet4DC;IACC,eAAA;Efw4DF;AACF;Aa/3DA;EE5CK;;;;;;;;;;;;IACC,WAAA;Efy7DJ;Eel7DC;IACC,WAAA;Efo7DF;Eer7DC;IACC,mBAAA;Efu7DF;Eex7DC;IACC,mBAAA;Ef07DF;Ee37DC;IACC,UAAA;Ef67DF;Ee97DC;IACC,mBAAA;Efg8DF;Eej8DC;IACC,mBAAA;Efm8DF;Eep8DC;IACC,UAAA;Efs8DF;Eev8DC;IACC,mBAAA;Efy8DF;Ee18DC;IACC,mBAAA;Ef48DF;Ee78DC;IACC,UAAA;Ef+8DF;Eeh9DC;IACC,mBAAA;Efk9DF;Een9DC;IACC,kBAAA;Efq9DF;Eev8DC;IACC,WAAA;Efy8DF;Ee18DC;IACC,mBAAA;Ef48DF;Ee78DC;IACC,mBAAA;Ef+8DF;Eeh9DC;IACC,UAAA;Efk9DF;Een9DC;IACC,mBAAA;Efq9DF;Eet9DC;IACC,mBAAA;Efw9DF;Eez9DC;IACC,UAAA;Ef29DF;Ee59DC;IACC,mBAAA;Ef89DF;Ee/9DC;IACC,mBAAA;Efi+DF;Eel+DC;IACC,UAAA;Efo+DF;Eer+DC;IACC,mBAAA;Efu+DF;Eex+DC;IACC,kBAAA;Ef0+DF;Eet+DC;IACC,WAAA;Efw+DF;Eex/DC;IACC,UAAA;Ef0/DF;Ee3/DC;IACC,kBAAA;Ef6/DF;Ee9/DC;IACC,kBAAA;EfggEF;EejgEC;IACC,SAAA;EfmgEF;EepgEC;IACC,kBAAA;EfsgEF;EevgEC;IACC,kBAAA;EfygEF;Ee1gEC;IACC,SAAA;Ef4gEF;Ee7gEC;IACC,kBAAA;Ef+gEF;EehhEC;IACC,kBAAA;EfkhEF;EenhEC;IACC,SAAA;EfqhEF;EethEC;IACC,kBAAA;EfwhEF;EezhEC;IACC,iBAAA;Ef2hEF;EevhEC;IACC,UAAA;EfyhEF;Ee3gEC;IACC,iBAAA;Ef6gEF;Ee9gEC;IACC,yBAAA;EfghEF;EejhEC;IACC,yBAAA;EfmhEF;EephEC;IACC,gBAAA;EfshEF;EevhEC;IACC,yBAAA;EfyhEF;Ee1hEC;IACC,yBAAA;Ef4hEF;Ee7hEC;IACC,gBAAA;Ef+hEF;EehiEC;IACC,yBAAA;EfkiEF;EeniEC;IACC,yBAAA;EfqiEF;EetiEC;IACC,gBAAA;EfwiEF;EeziEC;IACC,yBAAA;Ef2iEF;Ee5iEC;IACC,wBAAA;Ef8iEF;Ee/iEC;IACC,eAAA;EfijEF;AACF;Aa/hEA;EErDK;;;;;;;;;;;;IACC,WAAA;EfkmEJ;Ee3lEC;IACC,WAAA;Ef6lEF;Ee9lEC;IACC,mBAAA;EfgmEF;EejmEC;IACC,mBAAA;EfmmEF;EepmEC;IACC,UAAA;EfsmEF;EevmEC;IACC,mBAAA;EfymEF;Ee1mEC;IACC,mBAAA;Ef4mEF;Ee7mEC;IACC,UAAA;Ef+mEF;EehnEC;IACC,mBAAA;EfknEF;EennEC;IACC,mBAAA;EfqnEF;EetnEC;IACC,UAAA;EfwnEF;EeznEC;IACC,mBAAA;Ef2nEF;Ee5nEC;IACC,kBAAA;Ef8nEF;EehnEC;IACC,WAAA;EfknEF;EennEC;IACC,mBAAA;EfqnEF;EetnEC;IACC,mBAAA;EfwnEF;EeznEC;IACC,UAAA;Ef2nEF;Ee5nEC;IACC,mBAAA;Ef8nEF;Ee/nEC;IACC,mBAAA;EfioEF;EeloEC;IACC,UAAA;EfooEF;EeroEC;IACC,mBAAA;EfuoEF;EexoEC;IACC,mBAAA;Ef0oEF;Ee3oEC;IACC,UAAA;Ef6oEF;Ee9oEC;IACC,mBAAA;EfgpEF;EejpEC;IACC,kBAAA;EfmpEF;Ee/oEC;IACC,WAAA;EfipEF;EejqEC;IACC,UAAA;EfmqEF;EepqEC;IACC,kBAAA;EfsqEF;EevqEC;IACC,kBAAA;EfyqEF;Ee1qEC;IACC,SAAA;Ef4qEF;Ee7qEC;IACC,kBAAA;Ef+qEF;EehrEC;IACC,kBAAA;EfkrEF;EenrEC;IACC,SAAA;EfqrEF;EetrEC;IACC,kBAAA;EfwrEF;EezrEC;IACC,kBAAA;Ef2rEF;Ee5rEC;IACC,SAAA;Ef8rEF;Ee/rEC;IACC,kBAAA;EfisEF;EelsEC;IACC,iBAAA;EfosEF;EehsEC;IACC,UAAA;EfksEF;EeprEC;IACC,iBAAA;EfsrEF;EevrEC;IACC,yBAAA;EfyrEF;Ee1rEC;IACC,yBAAA;Ef4rEF;Ee7rEC;IACC,gBAAA;Ef+rEF;EehsEC;IACC,yBAAA;EfksEF;EensEC;IACC,yBAAA;EfqsEF;EetsEC;IACC,gBAAA;EfwsEF;EezsEC;IACC,yBAAA;Ef2sEF;Ee5sEC;IACC,yBAAA;Ef8sEF;Ee/sEC;IACC,gBAAA;EfitEF;EeltEC;IACC,yBAAA;EfotEF;EertEC;IACC,wBAAA;EfutEF;EextEC;IACC,eAAA;Ef0tEF;AACF;AgB5xEA;EACE,6BAAA;AhB8xEF;AgB/xEA;EAQI,gBAAA;EACA,qBAAA;EACA,WAAA;AhB0xEJ;AgBrxEI;;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;AhBwxEN;AgBnxEA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AhBqxEF;AgBlxEA;EACE,gBAAA;AhBoxEF;AgB9wEA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AhBgxEF;AgBnxEA;;;;;;EAWQ,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;AhBgxER;AgB9xEA;EAoBI,sBAAA;EACA,6BAAA;AhB6wEJ;AgBlyEA;;;;;;EA8BQ,aAAA;AhB4wER;AgB1yEA;EAoCI,0BAAA;AhBywEJ;AgB7yEA;EAyCI,yBAAA;AhBuwEJ;AgBhwEA;;;;;;EAOQ,YAAA;AhBiwER;AgBtvEA;EACE,sBAAA;AhBwvEF;AgBzvEA;;;;;;EAQQ,sBAAA;AhByvER;AgBjwEA;;EAeM,wBAAA;AhBsvEN;AgB5uEA;EAEI,yBAAA;AhB6uEJ;AgBpuEA;EAEI,yBAAA;AhBquEJ;AiBp3EE;;;;;;;;;;;;EAOI,yBAAA;AjB23EN;AiBr3EE;;;;;EAMI,yBAAA;AjBs3EN;AiBz4EE;;;;;;;;;;;;EAOI,yBAAA;AjBg5EN;AiB14EE;;;;;EAMI,yBAAA;AjB24EN;AiB95EE;;;;;;;;;;;;EAOI,yBAAA;AjBq6EN;AiB/5EE;;;;;EAMI,yBAAA;AjBg6EN;AiBn7EE;;;;;;;;;;;;EAOI,yBAAA;AjB07EN;AiBp7EE;;;;;EAMI,yBAAA;AjBq7EN;AiBx8EE;;;;;;;;;;;;EAOI,yBAAA;AjB+8EN;AiBz8EE;;;;;EAMI,yBAAA;AjB08EN;AgBtzEA;EACE,iBAAA;EACA,gBAAA;AhBwzEF;AgBtzEE;EAAA;IACE,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,4CAAA;IACA,sBAAA;EhByzEF;EgB9zEA;IASI,gBAAA;EhBwzEJ;EgBj0EA;;;;;;IAkBU,mBAAA;EhBuzEV;EgBz0EA;IA0BI,SAAA;EhBkzEJ;EgB50EA;;;;;;IAmCU,cAAA;EhBizEV;EgBp1EA;;;;;;IAuCU,eAAA;EhBqzEV;EgB51EA;;;;IAoDU,gBAAA;EhB8yEV;AACF;AkBxgFA;EAIE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AlBugFF;AkBpgFA;EACE,cAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,SAAA;EACA,gCAAA;AlBsgFF;AkBngFA;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AlBqgFF;AkB3/EA;Eb+BU,sBAAA;EarBR,wBAAA;EACA,qBAAA;OAAA,gBAAA;AlBu/EF;AkBn/EA;;EAEE,eAAA;EACA,kBAAA;EACA,mBAAA;AlBq/EF;AkB/+EE;;;;;;EAGE,mBAAA;AlBo/EJ;AkBh/EA;EACE,cAAA;AlBk/EF;AkB9+EA;EACE,cAAA;EACA,WAAA;AlBg/EF;AkB5+EA;;EAEE,YAAA;AlB8+EF;AkB1+EA;;;EZ1FE,0CAAA;EACA,oBAAA;ANykFF;AkBz+EA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;AlB2+EF;AkBj9EA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;Eb1EQ,gDAAA;EA2HA,sEAAA;ALu6EV;AmBjjFE;EACE,qBAAA;EACA,UAAA;EdaM,iFAAA;ALwiFV;AKvgFE;EACE,WAAA;EACA,UAAA;ALygFJ;AKvgFE;EAA0B,WAAA;AL0gF5B;AKzgFE;EAAgC,WAAA;AL4gFlC;AkB79EE;EACE,6BAAA;EACA,SAAA;AlB+9EJ;AkBv9EE;;;EAGE,yBAAA;EACA,UAAA;AlBy9EJ;AkBt9EE;;EAEE,mBAAA;AlBw9EJ;AkBp9EE;EACE,YAAA;AlBs9EJ;AkBx8EA;EAKI;;;;IACE,iBAAA;ElBy8EJ;EkBt8EE;;;;;;;;IAEE,iBAAA;ElB88EJ;EkB38EE;;;;;;;;IAEE,iBAAA;ElBm9EJ;AACF;AkBz8EA;EACE,mBAAA;AlB28EF;AkBn8EA;;EAEE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AlBq8EF;AkBl8EE;;;;EAGI,mBAAA;AlBq8EN;AkBh9EA;;EAgBI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AlBo8EJ;AkBj8EA;;;;EAIE,kBAAA;EACA,kBAAA;EACA,kBAAA;AlBm8EF;AkBh8EA;;EAEE,gBAAA;AlBk8EF;AkB97EA;;EAEE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AlBg8EF;AkB77EE;;;;EAEE,mBAAA;AlBi8EJ;AkB97EA;;EAEE,aAAA;EACA,iBAAA;AlBg8EF;AkBv7EA;EACE,gBAAA;EAEA,gBAAA;EACA,mBAAA;EAEA,gBAAA;AlBu7EF;AkBr7EE;;EAEE,gBAAA;EACA,eAAA;AlBu7EJ;AkB16EA;EC3PE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AnBwqFF;AmBtqFE;EACE,YAAA;EACA,iBAAA;AnBwqFJ;AmBrqFE;;EAEE,YAAA;AnBuqFJ;AkBt7EA;EAEI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AlBu7EJ;AkB77EA;EASI,YAAA;EACA,iBAAA;AlBu7EJ;AkBj8EA;;EAcI,YAAA;AlBu7EJ;AkBr8EA;EAiBI,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AlBu7EJ;AkBn7EA;ECvRE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AnB6sFF;AmB3sFE;EACE,YAAA;EACA,iBAAA;AnB6sFJ;AmB1sFE;;EAEE,YAAA;AnB4sFJ;AkB/7EA;EAEI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AlBg8EJ;AkBt8EA;EASI,YAAA;EACA,iBAAA;AlBg8EJ;AkB18EA;;EAcI,YAAA;AlBg8EJ;AkB98EA;EAiBI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AlBg8EJ;AkBv7EA;EAEE,kBAAA;AlBw7EF;AkB17EA;EAMI,qBAAA;AlBu7EJ;AkBn7EA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AlBq7EF;AkBn7EA;;;EAGE,WAAA;EACA,YAAA;EACA,iBAAA;AlBq7EF;AkBn7EA;;;EAGE,WAAA;EACA,YAAA;EACA,iBAAA;AlBq7EF;AkBj7EA;;;;;;;;;;EClZI,cAAA;AnB+0FJ;AkB77EA;EC9YI,qBAAA;EdkDM,gDAAA;AL8xFV;AmB90FI;EACE,qBAAA;Ed+CI,iEAAA;ALmyFV;AkBv8EA;ECpYI,cAAA;EACA,yBAAA;EACA,qBAAA;AnB80FJ;AkB58EA;EC9XI,cAAA;AnB60FJ;AkB58EA;;;;;;;;;;ECrZI,cAAA;AnB62FJ;AkBx9EA;ECjZI,qBAAA;EdkDM,gDAAA;AL4zFV;AmB52FI;EACE,qBAAA;Ed+CI,iEAAA;ALi0FV;AkBl+EA;ECvYI,cAAA;EACA,yBAAA;EACA,qBAAA;AnB42FJ;AkBv+EA;ECjYI,cAAA;AnB22FJ;AkBv+EA;;;;;;;;;;ECxZI,cAAA;AnB24FJ;AkBn/EA;ECpZI,qBAAA;EdkDM,gDAAA;AL01FV;AmB14FI;EACE,qBAAA;Ed+CI,iEAAA;AL+1FV;AkB7/EA;EC1YI,cAAA;EACA,yBAAA;EACA,qBAAA;AnB04FJ;AkBlgFA;ECpYI,cAAA;AnBy4FJ;AkB9/EE;EACE,SAAA;AlBggFJ;AkB9/EE;EACE,MAAA;AlBggFJ;AkBt/EA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AlBw/EF;AkBt+EE;EAAA;IAGI,qBAAA;IACA,gBAAA;IACA,sBAAA;ElBu+EJ;EkB5+EA;IAUI,qBAAA;IACA,WAAA;IACA,sBAAA;ElBq+EJ;EkBj/EA;IAiBI,qBAAA;ElBm+EJ;EkBp/EA;IAqBI,qBAAA;IACA,sBAAA;ElBk+EJ;EkBx/EA;;;IA2BM,WAAA;ElBk+EN;EkB7/EA;IAiCI,WAAA;ElB+9EJ;EkBhgFA;IAqCI,gBAAA;IACA,sBAAA;ElB89EJ;EkBpgFA;;IA6CI,qBAAA;IACA,aAAA;IACA,gBAAA;IACA,sBAAA;ElB29EJ;EkB3gFA;;IAmDM,eAAA;ElB49EN;EkB/gFA;;IAwDI,kBAAA;IACA,cAAA;ElB29EJ;EkBphFA;IA8DI,MAAA;ElBy9EJ;AACF;AkB/8EA;;;;EASI,gBAAA;EACA,aAAA;EACA,gBAAA;AlB48EJ;AkBv9EA;;EAiBI,gBAAA;AlB08EJ;AkB39EA;EJ9gBE,mBAAA;EACA,kBAAA;Ad4+FF;AkBp8EE;EAAA;IAEI,gBAAA;IACA,gBAAA;IACA,iBAAA;ElBs8EJ;AACF;AkBt+EA;EAwCI,WAAA;AlBi8EJ;AkBz7EI;EAAA;IAEI,iBAAA;IACA,eAAA;ElB27EN;AACF;AkBv7EI;EAAA;IAEI,gBAAA;IACA,eAAA;ElBy7EN;AACF;AoBxgGA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;ECoCA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBqKA,yBAAA;EACG,sBAAA;EAEK,iBAAA;ALm0FV;AoB3gGI;;;;;;EdrBF,0CAAA;EACA,oBAAA;ANwiGF;AoB9gGE;;;EAGE,WAAA;EACA,qBAAA;ApBghGJ;AoB7gGE;;EAEE,sBAAA;EACA,UAAA;Ef4BM,gDAAA;ALq/FV;AoB7gGE;;;EAGE,mBAAA;EE9CF,yBAAA;EACA,aAAA;EjBkEQ,gBAAA;AL8/FV;AoB7gGI;;EAEE,oBAAA;ApB+gGN;AoBtgGA;EC7DE,WAAA;EACA,sBAAA;EACA,kBAAA;ArBskGF;AqBpkGE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBskGJ;AqBpkGE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBskGJ;AqBpkGE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArBskGJ;AqBpkGI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB4kGN;AqBtkGI;;;;;;;;;EAGE,sBAAA;EACA,kBAAA;ArB8kGN;AoBvjGA;EClBI,WAAA;EACA,sBAAA;ArB4kGJ;AoBxjGA;EChEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB2nGF;AqBznGE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB2nGJ;AqBznGE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB2nGJ;AqBznGE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArB2nGJ;AqBznGI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBioGN;AqB3nGI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArBmoGN;AoBzmGA;ECrBI,cAAA;EACA,sBAAA;ArBioGJ;AoBzmGA;ECpEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBgrGF;AqB9qGE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBgrGJ;AqB9qGE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBgrGJ;AqB9qGE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArBgrGJ;AqB9qGI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBsrGN;AqBhrGI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArBwrGN;AoB1pGA;ECzBI,cAAA;EACA,sBAAA;ArBsrGJ;AoB1pGA;ECxEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBquGF;AqBnuGE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBquGJ;AqBnuGE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBquGJ;AqBnuGE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArBquGJ;AqBnuGI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB2uGN;AqBruGI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArB6uGN;AoB3sGA;EC7BI,cAAA;EACA,sBAAA;ArB2uGJ;AoB3sGA;EC5EE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB0xGF;AqBxxGE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB0xGJ;AqBxxGE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB0xGJ;AqBxxGE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArB0xGJ;AqBxxGI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBgyGN;AqB1xGI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArBkyGN;AoB5vGA;ECjCI,cAAA;EACA,sBAAA;ArBgyGJ;AoB5vGA;EChFE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB+0GF;AqB70GE;;EAEE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB+0GJ;AqB70GE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArB+0GJ;AqB70GE;;;EAGE,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;ArB+0GJ;AqB70GI;;;;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBq1GN;AqB/0GI;;;;;;;;;EAGE,yBAAA;EACA,qBAAA;ArBu1GN;AoB7yGA;ECrCI,cAAA;EACA,sBAAA;ArBq1GJ;AoBxyGA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;ApB0yGF;AoBxyGE;;;;;EAKE,6BAAA;EflCM,gBAAA;AL80GV;AoBzyGE;;;;EAIE,yBAAA;ApB2yGJ;AoBzyGE;;EAEE,cAAA;EACA,0BAAA;EACA,6BAAA;ApB2yGJ;AoBvyGI;;;;EAEE,cAAA;EACA,qBAAA;ApB2yGN;AoBlyGA;;EC9EE,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;ArBo3GF;AoBryGA;;EClFE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;ArB23GF;AoBxyGA;;ECtFE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;ArBk4GF;AoBvyGA;EACE,cAAA;EACA,WAAA;ApByyGF;AoBryGA;EACE,eAAA;ApBuyGF;AoBhyGE;;;EACE,WAAA;ApBoyGJ;AuB97GA;EACE,UAAA;ElBsLQ,gCAAA;AL6wGV;AuBh8GE;EACE,UAAA;AvBk8GJ;AuB97GA;EACE,aAAA;AvBg8GF;AuB97GE;EAAY,cAAA;AvBi8Gd;AuBh8GE;EAAY,kBAAA;AvBm8Gd;AuBl8GE;EAAY,wBAAA;AvBq8Gd;AuBl8GA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ElBuKQ,uCAAA;EAQA,0BAAA;EAIA,gCAAA;ALuxGV;AwBn+GA;EACE,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;AxBq+GF;AwBj+GA;;EAEE,kBAAA;AxBm+GF;AwB/9GA;EACE,UAAA;AxBi+GF;AwB79GA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,qCAAA;EACA,kBAAA;EnBwBQ,2CAAA;ALy8GV;AwB39GE;EACE,QAAA;EACA,UAAA;AxB69GJ;AwBt/GA;ECzBE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;AzBkhHF;AwB5/GA;EAmCI,cAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AxB49GJ;AwB19GI;;EAEE,cAAA;EACA,qBAAA;EACA,yBAAA;AxB49GN;AwBr9GE;;;EAGE,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,UAAA;AxBu9GJ;AwB98GE;;;EAGE,cAAA;AxBg9GJ;AwB58GE;;EAEE,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;EEzGF,mEAAA;A1BwjHF;AwBz8GA;EAGI,cAAA;AxBy8GJ;AwB58GA;EAQI,UAAA;AxBu8GJ;AwB/7GA;EACE,QAAA;EACA,UAAA;AxBi8GF;AwBz7GA;EACE,WAAA;EACA,OAAA;AxB27GF;AwBv7GA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,mBAAA;AxBy7GF;AwBr7GA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;AxBu7GF;AwBn7GA;EACE,QAAA;EACA,UAAA;AxBq7GF;AwB76GA;;EAII,WAAA;EACA,aAAA;EACA,yBAAA;EACA,2BAAA;AxB66GJ;AwBp7GA;;EAWI,SAAA;EACA,YAAA;EACA,kBAAA;AxB66GJ;AwBp6GA;EACE;IApEA,QAAA;IACA,UAAA;ExB2+GA;EwBx6GA;IA1DA,WAAA;IACA,OAAA;ExBq+GA;AACF;A2BhnHA;;EAEE,kBAAA;EACA,qBAAA;EACA,sBAAA;A3BknHF;A2BtnHA;;EAMI,kBAAA;EACA,WAAA;A3BonHJ;A2BlnHI;;;;;;;;EAIE,UAAA;A3BwnHN;A2BlnHA;;;;EAKI,iBAAA;A3BmnHJ;A2B9mHA;EACE,iBAAA;A3BgnHF;A2BjnHA;;;EAOI,WAAA;A3B+mHJ;A2BtnHA;;;EAYI,gBAAA;A3B+mHJ;A2B3mHA;EACE,gBAAA;A3B6mHF;A2BzmHA;EACE,cAAA;A3B2mHF;A2B1mHE;ECpDA,0BAAA;EACA,6BAAA;A5BiqHF;A2BzmHA;;ECjDE,yBAAA;EACA,4BAAA;A5B8pHF;A2BxmHA;EACE,WAAA;A3B0mHF;A2BxmHA;EACE,gBAAA;A3B0mHF;A2BxmHA;;ECrEE,0BAAA;EACA,6BAAA;A5BirHF;A2BvmHA;ECnEE,yBAAA;EACA,4BAAA;A5B6qHF;A2BtmHA;;EAEE,UAAA;A3BwmHF;A2BvlHA;EACE,kBAAA;EACA,iBAAA;A3BylHF;A2BvlHA;EACE,mBAAA;EACA,kBAAA;A3BylHF;A2BplHA;EtB9CU,gDAAA;ALsoHV;A2BplHE;EtBlDQ,gBAAA;AL0oHV;A2BjlHA;EACE,cAAA;A3BmlHF;A2BhlHA;EACE,uBAAA;EACA,sBAAA;A3BklHF;A2B/kHA;EACE,uBAAA;A3BilHF;A2B1kHA;;;EAII,cAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;A3B2kHJ;A2BllHA;EAcM,WAAA;A3BukHN;A2BrlHA;;;;EAsBI,gBAAA;EACA,cAAA;A3BqkHJ;A2BhkHE;EACE,gBAAA;A3BkkHJ;A2BhkHE;EC7KA,2BAAA;EACA,4BAAA;EAOA,6BAAA;EACA,4BAAA;A5B0uHF;A2BlkHE;ECjLA,yBAAA;EACA,0BAAA;EAOA,+BAAA;EACA,8BAAA;A5BgvHF;A2BnkHA;EACE,gBAAA;A3BqkHF;A2BnkHA;;ECjLE,6BAAA;EACA,4BAAA;A5BwvHF;A2BlkHA;EC/LE,yBAAA;EACA,0BAAA;A5BowHF;A2B9jHA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;A3BgkHF;A2BpkHA;;EAOI,mBAAA;EACA,WAAA;EACA,SAAA;A3BikHJ;A2B1kHA;EAYI,WAAA;A3BikHJ;A2B7kHA;EAgBI,UAAA;A3BgkHJ;A2B/iHA;;;;EAKM,kBAAA;EACA,sBAAA;EACA,oBAAA;A3BgjHN;A6B1xHA;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;A7B4xHF;A6BzxHE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;A7B2xHJ;A6BpyHA;EAeI,kBAAA;EACA,UAAA;EAKA,WAAA;EAEA,WAAA;EACA,gBAAA;A7BmxHJ;A6BjxHI;EACE,UAAA;A7BmxHN;A6BzwHA;;;EVwBE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AnBsvHF;AmBpvHE;;;EACE,YAAA;EACA,iBAAA;AnBwvHJ;AmBrvHE;;;;;;EAEE,YAAA;AnB2vHJ;A6B3xHA;;;EVmBE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AnB6wHF;AmB3wHE;;;EACE,YAAA;EACA,iBAAA;AnB+wHJ;AmB5wHE;;;;;;EAEE,YAAA;AnBkxHJ;A6BzyHA;;;EAGE,mBAAA;A7B2yHF;A6BzyHE;;;EACE,gBAAA;A7B6yHJ;A6BzyHA;;EAEE,SAAA;EACA,mBAAA;EACA,sBAAA;A7B2yHF;A6BtyHA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;A7BwyHF;A6BryHE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;A7BuyHJ;A6BryHE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;A7BuyHJ;A6B3zHA;;EA0BI,aAAA;A7BqyHJ;A6BhyHA;;;;;;;EDtGE,0BAAA;EACA,6BAAA;A5B+4HF;A6BjyHA;EACE,eAAA;A7BmyHF;A6BjyHA;;;;;;;ED1GE,yBAAA;EACA,4BAAA;A5Bo5HF;A6BlyHA;EACE,cAAA;A7BoyHF;A6B/xHA;EACE,kBAAA;EAGA,YAAA;EACA,mBAAA;A7B+xHF;A6BpyHA;EAUI,kBAAA;A7B6xHJ;A6BvyHA;EAYM,iBAAA;A7B8xHN;A6B3xHI;;;EAGE,UAAA;A7B6xHN;A6BxxHE;;EAGI,kBAAA;A7ByxHN;A6BtxHE;;EAGI,UAAA;EACA,iBAAA;A7BuxHN;A8Bt7HA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;A9Bw7HF;A8B37HA;EAOI,kBAAA;EACA,cAAA;A9Bu7HJ;A8B/7HA;EAWM,kBAAA;EACA,cAAA;EACA,kBAAA;A9Bu7HN;A8Bt7HM;;EAEE,qBAAA;EACA,yBAAA;A9Bw7HR;A8Bn7HI;EACE,cAAA;A9Bq7HN;A8Bn7HM;;EAEE,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;A9Bq7HR;A8B96HI;;;EAGE,yBAAA;EACA,qBAAA;A9Bg7HN;A8Bz9HA;ELLE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;AzBi+HF;A8B/9HA;EA0DI,eAAA;A9Bw6HJ;A8B/5HA;EACE,6BAAA;A9Bi6HF;A8Bl6HA;EAGI,WAAA;EAEA,mBAAA;A9Bi6HJ;A8Bt6HA;EASM,iBAAA;EACA,uBAAA;EACA,6BAAA;EACA,0BAAA;A9Bg6HN;A8B/5HM;EACE,kCAAA;A9Bi6HR;A8B35HM;;;EAGE,cAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,gCAAA;A9B65HR;A8Bx5HE;EAqDA,WAAA;EA8BA,gBAAA;A9By0HF;A8B55HE;EAwDE,WAAA;A9Bu2HJ;A8B/5HE;EA0DI,kBAAA;EACA,kBAAA;A9Bw2HN;A8Bn6HE;EAgEE,SAAA;EACA,UAAA;A9Bs2HJ;A8Bn2HE;EAAA;IAEI,mBAAA;IACA,SAAA;E9Bq2HJ;E8Bx2HA;IAKM,gBAAA;E9Bs2HN;AACF;A8Bh7HE;EAuFE,eAAA;EACA,kBAAA;A9B41HJ;A8Bp7HE;;;EA8FE,sBAAA;A9B21HJ;A8Bx1HE;EAAA;IAEI,6BAAA;IACA,0BAAA;E9B01HJ;E8B71HA;;;IAQI,4BAAA;E9B01HJ;AACF;A8B37HA;EAEI,WAAA;A9B47HJ;A8B97HA;EAMM,kBAAA;A9B27HN;A8Bj8HA;EASM,gBAAA;A9B27HN;A8Bt7HM;;;EAGE,WAAA;EACA,yBAAA;A9Bw7HR;A8Bh7HA;EAEI,WAAA;A9Bi7HJ;A8Bn7HA;EAIM,eAAA;EACA,cAAA;A9Bk7HN;A8Bt6HA;EACE,WAAA;A9Bw6HF;A8Bz6HA;EAII,WAAA;A9Bw6HJ;A8B56HA;EAMM,kBAAA;EACA,kBAAA;A9By6HN;A8Bh7HA;EAYI,SAAA;EACA,UAAA;A9Bu6HJ;A8Bp6HE;EAAA;IAEI,mBAAA;IACA,SAAA;E9Bs6HJ;E8Bz6HA;IAKM,gBAAA;E9Bu6HN;AACF;A8B/5HA;EACE,gBAAA;A9Bi6HF;A8Bl6HA;EAKI,eAAA;EACA,kBAAA;A9Bg6HJ;A8Bt6HA;;;EAYI,sBAAA;A9B+5HJ;A8B55HE;EAAA;IAEI,6BAAA;IACA,0BAAA;E9B85HJ;E8Bj6HA;;;IAQI,4BAAA;E9B85HJ;AACF;A8Br5HA;EAEI,aAAA;A9Bs5HJ;A8Bx5HA;EAKI,cAAA;A9Bs5HJ;A8B74HA;EAEE,gBAAA;EF7OA,yBAAA;EACA,0BAAA;A5B4nIF;A+BpnIA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;A/BsnIF;A+BjnIE;EAAA;IACE,kBAAA;E/BonIF;AACF;A+BxmIE;EAAA;IACE,WAAA;E/B2mIF;AACF;A+B7lIA;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,kDAAA;EAEA,iCAAA;A/B8lIF;A+B5lIE;EACE,gBAAA;A/B8lIJ;A+B3lIE;EAAA;IACE,WAAA;IACA,aAAA;IACA,gBAAA;E/B8lIF;E+B5lIE;IACE,yBAAA;IACA,uBAAA;IACA,iBAAA;IACA,4BAAA;E/B8lIJ;E+B3lIE;IACE,mBAAA;E/B6lIJ;E+BxlIE;;;IAGE,gBAAA;IACA,eAAA;E/B0lIJ;AACF;A+BtlIA;;EAWE,eAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;A/B+kIF;A+B7lIA;;EAGI,iBAAA;A/B8lIJ;A+B5lII;EAAA;;IACE,iBAAA;E/BgmIJ;AACF;A+BtlIE;EAAA;;IACE,gBAAA;E/B0lIF;AACF;A+BvlIA;EACE,MAAA;EACA,qBAAA;A/BylIF;A+BvlIA;EACE,SAAA;EACA,gBAAA;EACA,qBAAA;A/BylIF;A+BjlIA;;;;EAII,mBAAA;EACA,kBAAA;A/BmlIJ;A+BjlII;EAAA;;;;IACE,eAAA;IACA,cAAA;E/BulIJ;AACF;A+B3kIA;EACE,aAAA;EACA,qBAAA;A/B6kIF;A+B3kIE;EAAA;IACE,gBAAA;E/B8kIF;AACF;A+BxkIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;A/B0kIF;A+BxkIE;;EAEE,qBAAA;A/B0kIJ;A+BnlIA;EAaI,cAAA;A/BykIJ;A+BtkIE;EACE;;IAEE,kBAAA;E/BwkIJ;AACF;A+B9jIA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EC9LA,eAAA;EACA,kBAAA;ED+LA,6BAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;A/BikIF;A+B7jIE;EACE,UAAA;A/B+jIJ;A+B7kIA;EAmBI,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;A/B6jIJ;A+BnlIA;EAyBI,eAAA;A/B6jIJ;A+B1jIE;EAAA;IACE,aAAA;E/B6jIF;AACF;A+BpjIA;EACE,mBAAA;A/BsjIF;A+BvjIA;EAII,iBAAA;EACA,oBAAA;EACA,iBAAA;A/BsjIJ;A+BnjIE;EAAA;IAGI,gBAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;IACA,6BAAA;IACA,SAAA;IACA,gBAAA;E/BojIJ;E+B7jIA;;IAYM,0BAAA;E/BqjIN;E+BjkIA;IAeM,iBAAA;E/BqjIN;E+BpjIM;;IAEE,sBAAA;E/BsjIR;AACF;A+BhjIE;EAAA;IACE,WAAA;IACA,SAAA;E/BmjIF;E+BrjIA;IAKI,WAAA;E/BmjIJ;E+BxjIA;IAOM,iBAAA;IACA,oBAAA;E/BojIN;AACF;A+BziIA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oCAAA;E1B3NQ,oFAAA;E2BjER,eAAA;EACA,kBAAA;AhC00IF;AkB73HE;EAAA;IAGI,qBAAA;IACA,gBAAA;IACA,sBAAA;ElB83HJ;EkBn4HA;IAUI,qBAAA;IACA,WAAA;IACA,sBAAA;ElB43HJ;EkBx4HA;IAiBI,qBAAA;ElB03HJ;EkB34HA;IAqBI,qBAAA;IACA,sBAAA;ElBy3HJ;EkB/4HA;;;IA2BM,WAAA;ElBy3HN;EkBp5HA;IAiCI,WAAA;ElBs3HJ;EkBv5HA;IAqCI,gBAAA;IACA,sBAAA;ElBq3HJ;EkB35HA;;IA6CI,qBAAA;IACA,aAAA;IACA,gBAAA;IACA,sBAAA;ElBk3HJ;EkBl6HA;;IAmDM,eAAA;ElBm3HN;EkBt6HA;;IAwDI,kBAAA;IACA,cAAA;ElBk3HJ;EkB36HA;IA8DI,MAAA;ElBg3HJ;AACF;A+BzlII;EAAA;IACE,kBAAA;E/B4lIJ;E+B1lII;IACE,gBAAA;E/B4lIN;AACF;A+BplIE;EAAA;IACE,WAAA;IACA,cAAA;IACA,iBAAA;IACA,eAAA;IACA,cAAA;IACA,SAAA;I1BtPM,gBAAA;EL+0IR;AACF;A+BjlIA;EACE,aAAA;EHpUA,yBAAA;EACA,0BAAA;A5Bw5IF;A+BjlIA;EACE,gBAAA;EHzUA,2BAAA;EACA,4BAAA;EAOA,6BAAA;EACA,4BAAA;A5Bu5IF;A+B7kIA;EChVE,eAAA;EACA,kBAAA;AhCg6IF;A+B9kIE;ECnVA,gBAAA;EACA,mBAAA;AhCo6IF;A+B/kIE;ECtVA,gBAAA;EACA,mBAAA;AhCw6IF;A+BzkIA;EChWE,gBAAA;EACA,mBAAA;AhC46IF;A+B1kIE;EAAA;IACE,WAAA;IACA,kBAAA;IACA,iBAAA;E/B6kIF;AACF;A+BjkIA;EACE;IEtWA,sBAAA;ICDW,WAAA;ElC46IX;E+BpkIA;IE1WA,uBAAA;ICCY,YAAA;IH2WV,mBAAA;E/BukIF;E+BzkIA;IAKI,eAAA;E/BukIJ;AACF;A+B9jIA;EACE,yBAAA;EACA,qBAAA;A/BgkIF;A+BlkIA;EAKI,WAAA;A/BgkIJ;A+B/jII;;EAEE,cAAA;EACA,6BAAA;A/BikIN;A+B1kIA;EAcI,WAAA;A/B+jIJ;A+B7kIA;EAmBM,WAAA;A/B6jIN;A+B3jIM;;EAEE,WAAA;EACA,6BAAA;A/B6jIR;A+BzjIM;;;EAGE,WAAA;EACA,yBAAA;A/B2jIR;A+BvjIM;;;EAGE,WAAA;EACA,6BAAA;A/ByjIR;A+BljIM;;;EAGE,WAAA;EACA,yBAAA;A/BojIR;A+BhjII;EAAA;IAIM,WAAA;E/BgjIR;E+B/iIQ;;IAEE,WAAA;IACA,6BAAA;E/BijIV;E+B7iIQ;;;IAGE,WAAA;IACA,yBAAA;E/B+iIV;E+B3iIQ;;;IAGE,WAAA;IACA,6BAAA;E/B6iIV;AACF;A+B7nIA;EAuFI,kBAAA;A/ByiIJ;A+BxiII;;EAEE,sBAAA;A/B0iIN;A+BpoIA;EA6FM,sBAAA;A/B0iIN;A+BvoIA;;EAmGI,qBAAA;A/BwiIJ;A+B3oIA;EA4GI,WAAA;A/BkiIJ;A+BjiII;EACE,WAAA;A/BmiIN;A+BjpIA;EAmHI,WAAA;A/BiiIJ;A+BhiII;;EAEE,WAAA;A/BkiIN;A+B9hIM;;;;EAEE,WAAA;A/BkiIR;A+B1hIA;EACE,sBAAA;EACA,qBAAA;A/B4hIF;A+B9hIA;EAKI,cAAA;A/B4hIJ;A+B3hII;;EAEE,WAAA;EACA,6BAAA;A/B6hIN;A+BtiIA;EAcI,cAAA;A/B2hIJ;A+BziIA;EAmBM,cAAA;A/ByhIN;A+BvhIM;;EAEE,WAAA;EACA,6BAAA;A/ByhIR;A+BrhIM;;;EAGE,WAAA;EACA,yBAAA;A/BuhIR;A+BnhIM;;;EAGE,WAAA;EACA,6BAAA;A/BqhIR;A+B/gIM;;;EAGE,WAAA;EACA,yBAAA;A/BihIR;A+B7gII;EAAA;IAIM,qBAAA;E/B6gIR;E+BjhIE;IAOM,yBAAA;E/B6gIR;E+BphIE;IAUM,cAAA;E/B6gIR;E+B5gIQ;;IAEE,WAAA;IACA,6BAAA;E/B8gIV;E+B1gIQ;;;IAGE,WAAA;IACA,yBAAA;E/B4gIV;E+BxgIQ;;;IAGE,WAAA;IACA,6BAAA;E/B0gIV;AACF;A+B/lIA;EA6FI,kBAAA;A/BqgIJ;A+BpgII;;EAEE,sBAAA;A/BsgIN;A+BtmIA;EAmGM,sBAAA;A/BsgIN;A+BzmIA;;EAyGI,qBAAA;A/BogIJ;A+B7mIA;EA6GI,cAAA;A/BmgIJ;A+BlgII;EACE,WAAA;A/BogIN;A+BnnIA;EAoHI,cAAA;A/BkgIJ;A+BjgII;;EAEE,WAAA;A/BmgIN;A+B//HM;;;;EAEE,WAAA;A/BmgIR;AmCzoJA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AnC2oJF;AmChpJA;EAQI,qBAAA;AnC2oJJ;AmCnpJA;EAWM,cAAA;EACA,WAAA;EACA,iBAAA;AnC2oJN;AmCxpJA;EAkBI,cAAA;AnCyoJJ;AoC7pJA;EACE,qBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ApC+pJF;AoCnqJA;EAOI,eAAA;ApC+pJJ;AoCtqJA;;EAUM,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;ApCgqJN;AoC9pJM;;;;EAEE,UAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;ApCkqJR;AoC/pJI;;EAGI,cAAA;ERnBN,2BAAA;EACA,8BAAA;A5BorJF;AoC9pJI;;ER/BF,4BAAA;EACA,+BAAA;A5BisJF;AoCzpJI;;;;;;EAGE,UAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;ApC8pJN;AoCltJA;;;;;;EA+DM,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;ApC2pJN;AoClpJA;;ECxEM,kBAAA;EACA,eAAA;EACA,sBAAA;ArC8tJN;AqC5tJI;;ETKF,2BAAA;EACA,8BAAA;A5B2tJF;AqC3tJI;;ETTF,4BAAA;EACA,+BAAA;A5BwuJF;AoC7pJA;;EC7EM,iBAAA;EACA,eAAA;EACA,gBAAA;ArC8uJN;AqC5uJI;;ETKF,2BAAA;EACA,8BAAA;A5B2uJF;AqC3uJI;;ETTF,4BAAA;EACA,+BAAA;A5BwvJF;AsC3vJA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AtC6vJF;AsCjwJA;EAOI,eAAA;AtC6vJJ;AsCpwJA;;EAUM,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AtC8vJN;AsC5wJA;;EAmBM,qBAAA;EACA,yBAAA;AtC6vJN;AsCjxJA;;EA2BM,YAAA;AtC0vJN;AsCrxJA;;EAkCM,WAAA;AtCuvJN;AsCzxJA;;;;EA2CM,cAAA;EACA,mBAAA;EACA,sBAAA;AtCovJN;AuClyJA;EACE,eAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;AvCoyJF;AuChyJI;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;AvCkyJN;AuC7xJE;EACE,aAAA;AvC+xJJ;AuC3xJE;EACE,kBAAA;EACA,SAAA;AvC6xJJ;AuCtxJA;ECtCE,yBAAA;AxC+zJF;AwC5zJI;;EAEE,yBAAA;AxC8zJN;AuCzxJA;EC1CE,yBAAA;AxCs0JF;AwCn0JI;;EAEE,yBAAA;AxCq0JN;AuC5xJA;EC9CE,yBAAA;AxC60JF;AwC10JI;;EAEE,yBAAA;AxC40JN;AuC/xJA;EClDE,yBAAA;AxCo1JF;AwCj1JI;;EAEE,yBAAA;AxCm1JN;AuClyJA;ECtDE,yBAAA;AxC21JF;AwCx1JI;;EAEE,yBAAA;AxC01JN;AuCryJA;EC1DE,yBAAA;AxCk2JF;AwC/1JI;;EAEE,yBAAA;AxCi2JN;AyCn2JA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AzCq2JF;AyCl2JE;EACE,aAAA;AzCo2JJ;AyCh2JE;EACE,kBAAA;EACA,SAAA;AzCk2JJ;AyC/1JE;;EAEE,MAAA;EACA,gBAAA;AzCi2JJ;AyC51JI;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;AzC81JN;AyCz1JE;;EAEE,cAAA;EACA,sBAAA;AzC21JJ;AyCx1JE;EACE,YAAA;AzC01JJ;AyCv1JE;EACE,iBAAA;AzCy1JJ;AyCt1JE;EACE,gBAAA;AzCw1JJ;A0Cl5JA;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;A1Co5JF;A0Cz5JA;;EASI,cAAA;A1Co5JJ;A0C75JA;EAaI,mBAAA;EACA,eAAA;EACA,gBAAA;A1Cm5JJ;A0Cl6JA;EAmBI,yBAAA;A1Ck5JJ;A0C/4JE;;EAEE,mBAAA;EACA,kBAAA;EACA,kBAAA;A1Ci5JJ;A0C36JA;EA8BI,eAAA;A1Cg5JJ;A0C74JE;EAAA;IACE,iBAAA;IACA,oBAAA;E1Cg5JF;E0C94JE;;IAEE,mBAAA;IACA,kBAAA;E1Cg5JJ;E0Cv5JA;;IAYI,eAAA;E1C+4JJ;AACF;A2C17JA;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EtCmLQ,mCAAA;AL4wJV;A2Ct8JA;;EAaI,kBAAA;EACA,iBAAA;A3C67JJ;A2Cz7JE;;;EAGE,qBAAA;A3C27JJ;A2Ch9JA;EA0BI,YAAA;EACA,cAAA;A3Cy7JJ;A4Cp9JA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;A5Cs9JF;A4C19JA;EAQI,aAAA;EACA,cAAA;A5Cq9JJ;A4C99JA;EAcI,iBAAA;A5Cm9JJ;A4Cj+JA;;EAoBI,gBAAA;A5Ci9JJ;A4Cr+JA;EAwBI,eAAA;A5Cg9JJ;A4Cv8JA;;EAEE,mBAAA;A5Cy8JF;A4C38JA;;EAMI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;A5Cy8JJ;A4Cj8JA;ECvDE,cAAA;EACA,yBAAA;EACA,qBAAA;A7C2/JF;A4Ct8JA;EClDI,yBAAA;A7C2/JJ;A4Cz8JA;EC9CI,cAAA;A7C0/JJ;A4Cx8JA;EC3DE,cAAA;EACA,yBAAA;EACA,qBAAA;A7CsgKF;A4C78JA;ECtDI,yBAAA;A7CsgKJ;A4Ch9JA;EClDI,cAAA;A7CqgKJ;A4C/8JA;EC/DE,cAAA;EACA,yBAAA;EACA,qBAAA;A7CihKF;A4Cp9JA;EC1DI,yBAAA;A7CihKJ;A4Cv9JA;ECtDI,cAAA;A7CghKJ;A4Ct9JA;ECnEE,cAAA;EACA,yBAAA;EACA,qBAAA;A7C4hKF;A4C39JA;EC9DI,yBAAA;A7C4hKJ;A4C99JA;EC1DI,cAAA;A7C2hKJ;A8CthKA;EACE;IAAQ,2BAAA;E9CiiKR;E8ChiKA;IAAQ,wBAAA;E9CmiKR;AACF;A8C5hKA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EzCuCQ,8CAAA;ALy/JV;A8C3hKA;EACE,WAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EzC0BQ,8CAAA;EA2HA,2BAAA;AL64JV;A8CxhKA;;ECCI,qMAAA;EDEF,0BAAA;A9C4hKF;A8CrhKA;;EzC1CU,kDAAA;ALqkKV;A8ClhKA;EEvEE,yBAAA;AhD4lKF;AgDzlKE;EDkDE,qMAAA;A/C4iKJ;A8CthKA;EE3EE,yBAAA;AhDomKF;AgDjmKE;EDkDE,qMAAA;A/CojKJ;A8C1hKA;EE/EE,yBAAA;AhD4mKF;AgDzmKE;EDkDE,qMAAA;A/C4jKJ;A8C9hKA;EEnFE,yBAAA;AhDonKF;AgDjnKE;EDkDE,qMAAA;A/CokKJ;AiD5nKA;EAEE,gBAAA;AjD6nKF;AiD3nKE;EACE,aAAA;AjD6nKJ;AiDznKA;;EAEE,gBAAA;EACA,OAAA;AjD2nKF;AiDxnKA;EACE,cAAA;AjD0nKF;AiDvnKA;EACE,cAAA;AjDynKF;AiDtnKE;EACE,eAAA;AjDwnKJ;AiDpnKA;;EAEE,kBAAA;AjDsnKF;AiDnnKA;;EAEE,mBAAA;AjDqnKF;AiDlnKA;;;EAGE,mBAAA;EACA,mBAAA;AjDonKF;AiDjnKA;EACE,sBAAA;AjDmnKF;AiDhnKA;EACE,sBAAA;AjDknKF;AiD9mKA;EACE,aAAA;EACA,kBAAA;AjDgnKF;AiD1mKA;EACE,eAAA;EACA,gBAAA;AjD4mKF;AkDjqKA;EAEE,eAAA;EACA,mBAAA;AlDkqKF;AkD1pKA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EAEA,mBAAA;EACA,sBAAA;EACA,sBAAA;AlD2pKF;AkDxpKE;EtB7BA,2BAAA;EACA,4BAAA;A5BwrKF;AkDzpKE;EACE,gBAAA;EtBzBF,+BAAA;EACA,8BAAA;A5BqrKF;AkDxpKE;;;EAGE,cAAA;EACA,mBAAA;EACA,yBAAA;AlD0pKJ;AkD/pKE;;;EASI,cAAA;AlD2pKN;AkDpqKE;;;EAYI,cAAA;AlD6pKN;AkDxpKE;;;EAGE,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AlD0pKJ;AkDhqKE;;;;;;;;;EAYI,cAAA;AlD+pKN;AkD3qKE;;;EAeI,cAAA;AlDiqKN;AkDtpKA;;EAEE,WAAA;AlDwpKF;AkD1pKA;;EAKI,WAAA;AlDypKJ;AkDrpKE;;;;EAEE,WAAA;EACA,qBAAA;EACA,yBAAA;AlDypKJ;AkDrpKA;EACE,WAAA;EACA,gBAAA;AlDupKF;AmD3vKG;EACC,cAAA;EACA,yBAAA;AnD6vKJ;AmD3vKI;;EAEE,cAAA;AnD6vKN;AmD/vKI;;EAKI,cAAA;AnD8vKR;AmD3vKM;;;;EAEE,cAAA;EACA,yBAAA;AnD+vKR;AmD7vKM;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AnDkwKR;AmDxxKG;EACC,cAAA;EACA,yBAAA;AnD0xKJ;AmDxxKI;;EAEE,cAAA;AnD0xKN;AmD5xKI;;EAKI,cAAA;AnD2xKR;AmDxxKM;;;;EAEE,cAAA;EACA,yBAAA;AnD4xKR;AmD1xKM;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AnD+xKR;AmDrzKG;EACC,cAAA;EACA,yBAAA;AnDuzKJ;AmDrzKI;;EAEE,cAAA;AnDuzKN;AmDzzKI;;EAKI,cAAA;AnDwzKR;AmDrzKM;;;;EAEE,cAAA;EACA,yBAAA;AnDyzKR;AmDvzKM;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AnD4zKR;AmDl1KG;EACC,cAAA;EACA,yBAAA;AnDo1KJ;AmDl1KI;;EAEE,cAAA;AnDo1KN;AmDt1KI;;EAKI,cAAA;AnDq1KR;AmDl1KM;;;;EAEE,cAAA;EACA,yBAAA;AnDs1KR;AmDp1KM;;;;;;EAGE,WAAA;EACA,yBAAA;EACA,qBAAA;AnDy1KR;AkDxvKA;EACE,aAAA;EACA,kBAAA;AlD0vKF;AkDxvKA;EACE,gBAAA;EACA,gBAAA;AlD0vKF;AoDl3KA;EACE,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,kBAAA;E/C2DQ,yCAAA;AL2zKV;AoDj3KA;EACE,aAAA;ApDm3KF;AoD92KA;EACE,kBAAA;EACA,oCAAA;ExBtBA,2BAAA;EACA,4BAAA;A5Bu4KF;AoDp3KA;EAMI,cAAA;ApDi3KJ;AoD52KA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;ApD82KF;AoDl3KA;;;;;EAWI,cAAA;ApD82KJ;AoDz2KA;EACE,kBAAA;EACA,yBAAA;EACA,0BAAA;ExB1CA,+BAAA;EACA,8BAAA;A5Bs5KF;AoDn2KA;;EAGI,gBAAA;ApDo2KJ;AoDv2KA;;EAMM,mBAAA;EACA,gBAAA;ApDq2KN;AoDj2KI;;EAEI,aAAA;ExBzEN,2BAAA;EACA,4BAAA;A5B66KF;AoD/1KI;;EAEI,gBAAA;ExBzEN,+BAAA;EACA,8BAAA;A5B26KF;AoDx3KA;ExB5DE,yBAAA;EACA,0BAAA;A5Bu7KF;AoD31KA;EAEI,mBAAA;ApD41KJ;AoDz1KA;EACE,mBAAA;ApD21KF;AoDn1KA;;;EAII,gBAAA;ApDo1KJ;AoDx1KA;;;EAOM,mBAAA;EACA,kBAAA;ApDs1KN;AoD91KA;;ExB3GE,2BAAA;EACA,4BAAA;A5B68KF;AoDn2KA;;;;EAmBQ,2BAAA;EACA,4BAAA;ApDs1KR;AoD12KA;;;;;;;;EAwBU,2BAAA;ApD41KV;AoDp3KA;;;;;;;;EA4BU,4BAAA;ApDk2KV;AoD93KA;;ExBnGE,+BAAA;EACA,8BAAA;A5Bq+KF;AoDn4KA;;;;EAyCQ,+BAAA;EACA,8BAAA;ApDg2KR;AoD14KA;;;;;;;;EA8CU,8BAAA;ApDs2KV;AoDp5KA;;;;;;;;EAkDU,+BAAA;ApD42KV;AoD95KA;;;;EA2DI,0BAAA;ApDy2KJ;AoDp6KA;;EA+DI,aAAA;ApDy2KJ;AoDx6KA;;EAmEI,SAAA;ApDy2KJ;AoD56KA;;;;;;;;;;;;EA0EU,cAAA;ApDg3KV;AoD17KA;;;;;;;;;;;;EA8EU,eAAA;ApD03KV;AoDx8KA;;;;;;;;EAuFU,gBAAA;ApD23KV;AoDl9KA;;;;;;;;EAgGU,gBAAA;ApD43KV;AoD59KA;EAsGI,gBAAA;EACA,SAAA;ApDy3KJ;AoD/2KA;EACE,mBAAA;ApDi3KF;AoDl3KA;EAKI,gBAAA;EACA,kBAAA;ApDg3KJ;AoDt3KA;EASM,eAAA;ApDg3KN;AoDz3KA;EAcI,gBAAA;ApD82KJ;AoD53KA;;EAkBM,0BAAA;ApD82KN;AoDh4KA;EAuBI,aAAA;ApD42KJ;AoDn4KA;EAyBM,6BAAA;ApD62KN;AoDt2KA;EC5PE,kBAAA;ArDqmLF;AqDnmLE;EACE,cAAA;EACA,yBAAA;EACA,kBAAA;ArDqmLJ;AqDxmLE;EAMI,sBAAA;ArDqmLN;AqD3mLE;EASI,cAAA;EACA,yBAAA;ArDqmLN;AqDlmLE;EAEI,yBAAA;ArDmmLN;AoDr3KA;EC/PE,qBAAA;ArDunLF;AqDrnLE;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArDunLJ;AqD1nLE;EAMI,yBAAA;ArDunLN;AqD7nLE;EASI,cAAA;EACA,sBAAA;ArDunLN;AqDpnLE;EAEI,4BAAA;ArDqnLN;AoDp4KA;EClQE,qBAAA;ArDyoLF;AqDvoLE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ArDyoLJ;AqD5oLE;EAMI,yBAAA;ArDyoLN;AqD/oLE;EASI,cAAA;EACA,yBAAA;ArDyoLN;AqDtoLE;EAEI,4BAAA;ArDuoLN;AoDn5KA;ECrQE,qBAAA;ArD2pLF;AqDzpLE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ArD2pLJ;AqD9pLE;EAMI,yBAAA;ArD2pLN;AqDjqLE;EASI,cAAA;EACA,yBAAA;ArD2pLN;AqDxpLE;EAEI,4BAAA;ArDypLN;AoDl6KA;ECxQE,qBAAA;ArD6qLF;AqD3qLE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ArD6qLJ;AqDhrLE;EAMI,yBAAA;ArD6qLN;AqDnrLE;EASI,cAAA;EACA,yBAAA;ArD6qLN;AqD1qLE;EAEI,4BAAA;ArD2qLN;AoDj7KA;EC3QE,qBAAA;ArD+rLF;AqD7rLE;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ArD+rLJ;AqDlsLE;EAMI,yBAAA;ArD+rLN;AqDrsLE;EASI,cAAA;EACA,yBAAA;ArD+rLN;AqD5rLE;EAEI,4BAAA;ArD6rLN;AsD7sLA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AtD+sLF;AsDptLA;;;;;EAYI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AtD+sLJ;AsD1sLA;EACE,sBAAA;AtD4sLF;AsDxsLA;EACE,mBAAA;AtD0sLF;AuDruLA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;ElD2DQ,+CAAA;AL8qLV;AuD/uLA;EASI,kBAAA;EACA,iCAAA;AvDyuLJ;AuDpuLA;EACE,aAAA;EACA,kBAAA;AvDsuLF;AuDpuLA;EACE,YAAA;EACA,kBAAA;AvDsuLF;AwD1vLA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;ElCTA,yBAAA;EACA,YAAA;AtBswLF;AwD3vLE;;EAEE,WAAA;EACA,qBAAA;EACA,eAAA;ElChBF,yBAAA;EACA,YAAA;AtB8wLF;AwDvvLE;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,wBAAA;EACA,qBAAA;OAAA,gBAAA;AxDyvLJ;AyDjxLA;EACE,gBAAA;AzDmxLF;AyD/wLA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EAIA,UAAA;AzD8wLF;AyD3wLE;EpDoHQ,6BAAA;EAqEA,mCAAA;AL4lLV;AyDjxLE;EpDgHQ,0BAAA;ALuqLV;AyDrxLA;EACE,kBAAA;EACA,gBAAA;AzDuxLF;AyDnxLA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AzDqxLF;AyDjxLA;EACE,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EpDeQ,wCAAA;EoDZR,UAAA;AzDmxLF;AyD/wLA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;AzDixLF;AyD/wLE;EnCpEA,wBAAA;EACA,UAAA;AtBs1LF;AyDlxLE;EnCrEA,yBAAA;EACA,YAAA;AtB01LF;AyDjxLA;EACE,aAAA;EACA,gCAAA;AzDmxLF;AyD/wLA;EACE,gBAAA;AzDixLF;AyD7wLA;EACE,SAAA;EACA,uBAAA;AzD+wLF;AyD1wLA;EACE,kBAAA;EACA,aAAA;AzD4wLF;AyDxwLA;EACE,aAAA;EACA,iBAAA;EACA,6BAAA;AzD0wLF;AyD7wLA;EAQI,gBAAA;EACA,gBAAA;AzDwwLJ;AyDjxLA;EAaI,iBAAA;AzDuwLJ;AyDpxLA;EAiBI,cAAA;AzDswLJ;AyDjwLA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AzDmwLF;AyD/vLA;EAEE;IACE,YAAA;IACA,iBAAA;EzDgwLF;EyD9vLA;IpDpEQ,yCAAA;ELs0LR;EyD7vLA;IAAY,YAAA;EzDgwLZ;AACF;AyD9vLA;EACE;IAAY,YAAA;EzDiwLZ;AACF;A0Dh5LA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;ECRA,2DAAA;EAEA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EDHA,eAAA;EpCTA,wBAAA;EACA,UAAA;AtBw6LF;A0D55LE;EpCbA,yBAAA;EACA,YAAA;AtB46LF;A0D/5LE;EACE,cAAA;EACA,gBAAA;A1Di6LJ;A0D/5LE;EACE,cAAA;EACA,gBAAA;A1Di6LJ;A0D/5LE;EACE,cAAA;EACA,eAAA;A1Di6LJ;A0D/5LE;EACE,cAAA;EACA,iBAAA;A1Di6LJ;A0D75LE;EACE,SAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,sBAAA;A1D+5LJ;A0D75LE;EACE,UAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;A1D+5LJ;A0D75LE;EACE,SAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;A1D+5LJ;A0D75LE;EACE,QAAA;EACA,OAAA;EACA,gBAAA;EACA,2BAAA;EACA,wBAAA;A1D+5LJ;A0D75LE;EACE,QAAA;EACA,QAAA;EACA,gBAAA;EACA,2BAAA;EACA,uBAAA;A1D+5LJ;A0D75LE;EACE,MAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;A1D+5LJ;A0D75LE;EACE,MAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;A1D+5LJ;A0D75LE;EACE,MAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;A1D+5LJ;A0D15LA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;A1D45LF;A0Dx5LA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;A1D05LF;A4DngMA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EDXA,2DAAA;EAEA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;ECAA,eAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EvDkDQ,yCAAA;ALi+LV;A4D/gME;EAAQ,iBAAA;A5DkhMV;A4DjhME;EAAU,iBAAA;A5DohMZ;A4DnhME;EAAW,gBAAA;A5DshMb;A4DrhME;EAAS,kBAAA;A5DwhMX;A4D/iMA;EA4BI,kBAAA;A5DshMJ;A4DphMI;;EAEE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;A5DshMN;A4DnhMI;EACE,WAAA;EACA,kBAAA;A5DqhMN;A4DjhME;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,qCAAA;EACA,sBAAA;A5DmhMJ;A4DlhMI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;A5DohMN;A4DjhME;EACE,QAAA;EACA,WAAA;EACA,iBAAA;EACA,2BAAA;EACA,uCAAA;EACA,oBAAA;A5DmhMJ;A4DlhMI;EACE,aAAA;EACA,SAAA;EACA,YAAA;EACA,wBAAA;EACA,oBAAA;A5DohMN;A4DjhME;EACE,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;EACA,wCAAA;A5DmhMJ;A4DlhMI;EACE,QAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;A5DohMN;A4DhhME;EACE,QAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,0BAAA;EACA,sCAAA;A5DkhMJ;A4DjhMI;EACE,UAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;A5DmhMN;A4D9gMA;EACE,iBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,gCAAA;EACA,0BAAA;A5DghMF;A4D7gMA;EACE,iBAAA;A5D+gMF;A6DnoMA;EACE,kBAAA;A7DqoMF;A6DloMA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A7DooMF;A6DvoMA;EAMI,kBAAA;EACA,aAAA;ExD+KM,iCAAA;ALw9LV;A6D9oMA;;EAcM,cAAA;A7DooMN;A6DhoMI;EAAA;IxD0LM,sCAAA;IA3JA,2BAAA;IAiHA,mBAAA;EL6/LR;E6DxoMI;;IxDoHI,kCAAA;IwDjHF,OAAA;E7D2oMN;E6DzoMI;;IxD+GI,mCAAA;IwD5GF,OAAA;E7D4oMN;E6D1oMI;;;IxD0GI,+BAAA;IwDtGF,OAAA;E7D6oMN;AACF;A6DnrMA;;;EA6CI,cAAA;A7D2oMJ;A6DxrMA;EAiDI,OAAA;A7D0oMJ;A6D3rMA;;EAsDI,kBAAA;EACA,MAAA;EACA,WAAA;A7DyoMJ;A6DjsMA;EA4DI,UAAA;A7DwoMJ;A6DpsMA;EA+DI,WAAA;A7DwoMJ;A6DvsMA;;EAmEI,OAAA;A7DwoMJ;A6D3sMA;EAuEI,WAAA;A7DuoMJ;A6D9sMA;EA0EI,UAAA;A7DuoMJ;A6D/nMA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,kCAAA;EvCpGA,yBAAA;EACA,YAAA;AtBsuMF;A6D7nME;EdnGE,8FAAA;EACA,sHAAA;EACA,2BAAA;A/CquMJ;A6DjoME;EACE,QAAA;EACA,UAAA;EdxGA,8FAAA;EACA,sHAAA;EACA,2BAAA;A/C8uMJ;A6DnoME;;EAEE,WAAA;EACA,qBAAA;EACA,UAAA;EvCxHF,yBAAA;EACA,YAAA;AtB8vMF;A6DrqMA;;;;EAuCI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;EACA,iBAAA;A7DooMJ;A6D/qMA;;EA+CI,SAAA;EACA,kBAAA;A7DooMJ;A6DprMA;;EAoDI,UAAA;EACA,mBAAA;A7DooMJ;A6DzrMA;;EAyDI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;A7DooMJ;A6DhoMI;EACE,gBAAA;A7DkoMN;A6D9nMI;EACE,gBAAA;A7DgoMN;A6DtnMA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;A7DwnMF;A6DjoMA;EAYI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EAUA,yBAAA;EACA,kCAAA;EAEA,sBAAA;EACA,mBAAA;A7D8mMJ;A6D7oMA;EAmCI,WAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;A7D6mMJ;A6DtmMA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;A7DwmMF;A6DtmME;EACE,iBAAA;A7DwmMJ;A6DlmMA;EAGE;;;;IAKI,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;E7DimMJ;E6DzmMA;;IAYI,kBAAA;E7DimMJ;E6D7mMA;;IAgBI,mBAAA;E7DimMJ;E6D5lMA;IACE,UAAA;IACA,SAAA;IACA,oBAAA;E7D8lMF;E6D1lMA;IACE,YAAA;E7D4lMF;AACF;A8D91ME;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAEE,cAAA;EACA,YAAA;A9D83MJ;A8D53ME;;;;;;;;;;;;;;;;EACE,WAAA;A9D64MJ;AiCn5MA;E8BVE,cAAA;EACA,kBAAA;EACA,iBAAA;A/Dg6MF;AiCr5MA;EACE,uBAAA;AjCu5MF;AiCr5MA;EACE,sBAAA;AjCu5MF;AiC/4MA;EACE,wBAAA;AjCi5MF;AiC/4MA;EACE,yBAAA;AjCi5MF;AiC/4MA;EACE,kBAAA;AjCi5MF;AiC/4MA;E+BzBE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AhE26MF;AiC74MA;EACE,wBAAA;AjC+4MF;AiCx4MA;EACE,eAAA;AjC04MF;AiEp6MA;;;;EClBE,wBAAA;AlE+7MF;AiEt6MA;;;;;;;;;;;;EAYE,wBAAA;AjEw6MF;AiEp6ME;EAAA;ICjDA,yBAAA;ElEy9MA;EkEx9MA;IAAU,yBAAA;ElE29MV;EkE19MA;IAAU,6BAAA;ElE69MV;EkE59MA;;IACU,8BAAA;ElE+9MV;AACF;AiE96ME;EAAA;IACE,yBAAA;EjEi7MF;AACF;AiE96ME;EAAA;IACE,0BAAA;EjEi7MF;AACF;AiE96ME;EAAA;IACE,gCAAA;EjEi7MF;AACF;AiE76ME;EAAA;ICtEA,yBAAA;ElEu/MA;EkEt/MA;IAAU,yBAAA;ElEy/MV;EkEx/MA;IAAU,6BAAA;ElE2/MV;EkE1/MA;;IACU,8BAAA;ElE6/MV;AACF;AiEv7ME;EAAA;IACE,yBAAA;EjE07MF;AACF;AiEv7ME;EAAA;IACE,0BAAA;EjE07MF;AACF;AiEv7ME;EAAA;IACE,gCAAA;EjE07MF;AACF;AiEt7ME;EAAA;IC3FA,yBAAA;ElEqhNA;EkEphNA;IAAU,yBAAA;ElEuhNV;EkEthNA;IAAU,6BAAA;ElEyhNV;EkExhNA;;IACU,8BAAA;ElE2hNV;AACF;AiEh8ME;EAAA;IACE,yBAAA;EjEm8MF;AACF;AiEh8ME;EAAA;IACE,0BAAA;EjEm8MF;AACF;AiEh8ME;EAAA;IACE,gCAAA;EjEm8MF;AACF;AiE/7ME;EAAA;IChHA,yBAAA;ElEmjNA;EkEljNA;IAAU,yBAAA;ElEqjNV;EkEpjNA;IAAU,6BAAA;ElEujNV;EkEtjNA;;IACU,8BAAA;ElEyjNV;AACF;AiEz8ME;EAAA;IACE,yBAAA;EjE48MF;AACF;AiEz8ME;EAAA;IACE,0BAAA;EjE48MF;AACF;AiEz8ME;EAAA;IACE,gCAAA;EjE48MF;AACF;AiEx8ME;EAAA;IC7HA,wBAAA;ElEykNA;AACF;AiEx8ME;EAAA;IClIA,wBAAA;ElE8kNA;AACF;AiEx8ME;EAAA;ICvIA,wBAAA;ElEmlNA;AACF;AiEx8ME;EAAA;IC5IA,wBAAA;ElEwlNA;AACF;AiEl8MA;ECvJE,wBAAA;AlE4lNF;AiEl8ME;EAAA;IClKA,yBAAA;ElEwmNA;EkEvmNA;IAAU,yBAAA;ElE0mNV;EkEzmNA;IAAU,6BAAA;ElE4mNV;EkE3mNA;;IACU,8BAAA;ElE8mNV;AACF;AiE78MA;EACE,wBAAA;AjE+8MF;AiE78ME;EAAA;IACE,yBAAA;EjEg9MF;AACF;AiE98MA;EACE,wBAAA;AjEg9MF;AiE98ME;EAAA;IACE,0BAAA;EjEi9MF;AACF;AiE/8MA;EACE,wBAAA;AjEi9MF;AiE/8ME;EAAA;IACE,gCAAA;EjEk9MF;AACF;AiE98ME;EAAA;ICrLA,wBAAA;ElEuoNA;AACF;AACA;;;EAGE;AACF;+BAC+B;AmEtpN/B;EACE,0BAAA;EACA,4CAAA;EACA,8SAAA;EAMA,mBAAA;EACA,kBAAA;AnEmpNF;AoE7pNC;EACC,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;ApE+pNF;AACA,6DAA6D;AqErqN5D;EACC,uBAAA;EACA,mBAAA;EACA,oBAAA;ArEuqNF;AqErqNC;EAAsB,cAAA;ArEwqNvB;AqEvqNC;EAAsB,cAAA;ArE0qNvB;AqEzqNC;EAAsB,cAAA;ArE4qNvB;AqE3qNC;EAAsB,cAAA;ArE8qNvB;AsExrNC;EACC,mBAAA;EACA,kBAAA;AtE0rNF;AuE3rNC;EACC,eAAA;EACA,yBAAA;EACA,qBAAA;AvE6rNF;AuEhsNC;EAIQ,kBAAA;AvE+rNT;AuE7rNC;EACC,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AvE+rNF;AuE9rNG;EACC,mBAAA;AvEgsNJ;AkC7sNC;EACC,4BAAA;EACA,yBAAA;EACA,oBAAA;AlC+sNF;AkC5sNC;EAA6B,WAAA;AlC+sN9B;AkC9sNC;EAA8B,YAAA;AlCitN/B;AkC9sNG;EAA8B,mBAAA;AlCitNjC;AkChtNG;EAA+B,kBAAA;AlCmtNlC;AACA,2BAA2B;AkChtN3B;EAAc,YAAA;AlCmtNd;AkCltNA;EAAa,WAAA;AlCqtNb;AkCltNE;EAAc,mBAAA;AlCqtNhB;AkCptNE;EAAe,kBAAA;AlCutNjB;AwE3uNC;EAES,qCAAA;AxE6uNV;AwE1uNC;EAES,uCAAA;AxE4uNV;AwE9tNA;EACE;IAEU,uBAAA;ExE0uNV;EwExuNA;IAEU,yBAAA;ExE0uNV;AACF;AyEvwNC;ECWC,sEAAA;EAGQ,wBAAA;A1E+vNV;AyE5wNC;ECUC,sEAAA;EAGQ,yBAAA;A1EqwNV;AyEjxNC;ECSC,sEAAA;EAGQ,yBAAA;A1E2wNV;AyErxNC;ECcC,gFAAA;EAGQ,uBAAA;A1E0wNV;AyE1xNC;ECaC,gFAAA;EAGQ,uBAAA;A1EgxNV;AyE3xNC;;;;;EAKC,YAAA;AzE6xNF;A2E5yNC;EACC,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;A3E8yNF;A2E5yNC;;EACC,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;A3E+yNF;A2E7yNC;EAA4B,oBAAA;A3EgzN7B;A2E/yNC;EAA4B,cAAA;A3EkzN7B;A2EjzNC;EAA2B,WAAA;A3EozN5B;AACA;mEACmE;A4Et0NlE;EAAgC,gBAAA;A5Ey0NjC;A4Ex0NC;EAAgC,gBAAA;A5E20NjC;A4E10NC;EAAiC,gBAAA;A5E60NlC;A4E50NC;EAAqC,gBAAA;A5E+0NtC;A4E90NC;EAAgC,gBAAA;A5Ei1NjC;A4Eh1NC;EAA+B,gBAAA;A5Em1NhC;A4El1NC;EAAiC,gBAAA;A5Eq1NlC;A4Ep1NC;EAA+B,gBAAA;A5Eu1NhC;A4Et1NC;EAA+B,gBAAA;A5Ey1NhC;A4Ex1NC;EAAmC,gBAAA;A5E21NpC;A4E11NC;EAA6B,gBAAA;A5E61N9B;A4E51NC;EAAkC,gBAAA;A5E+1NnC;A4E91NC;EAAgC,gBAAA;A5Ei2NjC;A4Eh2NC;;;EAEgC,gBAAA;A5Em2NjC;A4El2NC;EAAsC,gBAAA;A5Eq2NvC;A4Ep2NC;EAAuC,gBAAA;A5Eu2NxC;A4Et2NC;EAAoC,gBAAA;A5Ey2NrC;A4Ex2NC;EAAiC,gBAAA;A5E22NlC;A4E12NC;;EAC8B,gBAAA;A5E62N/B;A4E52NC;EAAkC,gBAAA;A5E+2NnC;A4E92NC;EAA+B,gBAAA;A5Ei3NhC;A4Eh3NC;EAAiC,gBAAA;A5Em3NlC;A4El3NC;EAAkC,gBAAA;A5Eq3NnC;A4Ep3NC;EAA+B,gBAAA;A5Eu3NhC;A4Et3NC;EAAmC,gBAAA;A5Ey3NpC;A4Ex3NC;EAA8C,gBAAA;A5E23N/C;A4E13NC;EAA4C,gBAAA;A5E63N7C;A4E53NC;EAAgC,gBAAA;A5E+3NjC;A4E93NC;EAAwC,gBAAA;A5Ei4NzC;A4Eh4NC;;EACiC,gBAAA;A5Em4NlC;A4El4NC;EAAkC,gBAAA;A5Eq4NnC;A4Ep4NC;EAAmC,gBAAA;A5Eu4NpC;A4Et4NC;EAA+B,gBAAA;A5Ey4NhC;A4Ex4NC;EAA+B,gBAAA;A5E24NhC;A4E14NC;EAAqC,gBAAA;A5E64NtC;A4E54NC;EAAqC,gBAAA;A5E+4NtC;A4E94NC;EAAsC,gBAAA;A5Ei5NvC;A4Eh5NC;EAAoC,gBAAA;A5Em5NrC;A4El5NC;EAAiC,gBAAA;A5Eq5NlC;A4Ep5NC;EAAkC,gBAAA;A5Eu5NnC;A4Et5NC;EAA8B,gBAAA;A5Ey5N/B;A4Ex5NC;EAA+B,gBAAA;A5E25NhC;A4E15NC;EAA+B,gBAAA;A5E65NhC;A4E55NC;EAAmC,gBAAA;A5E+5NpC;A4E95NC;EAAgC,gBAAA;A5Ei6NjC;A4Eh6NC;EAAiC,gBAAA;A5Em6NlC;A4El6NC;EAA+B,gBAAA;A5Eq6NhC;A4Ep6NC;EAA+B,gBAAA;A5Eu6NhC;A4Et6NC;EAAiC,gBAAA;A5Ey6NlC;A4Ex6NC;EAAsC,gBAAA;A5E26NvC;A4E16NC;EAAqC,gBAAA;A5E66NtC;A4E56NC;EAAqC,gBAAA;A5E+6NtC;A4E96NC;EAAuC,gBAAA;A5Ei7NxC;A4Eh7NC;EAAsC,gBAAA;A5Em7NvC;A4El7NC;EAAwC,gBAAA;A5Eq7NzC;A4Ep7NC;EAA+B,gBAAA;A5Eu7NhC;A4Et7NC;;EACkC,gBAAA;A5Ey7NnC;A4Ex7NC;EAAiC,gBAAA;A5E27NlC;A4E17NC;EAAuC,gBAAA;A5E67NxC;A4E57NC;;;EAEoC,gBAAA;A5E+7NrC;A4E97NC;EAAiC,gBAAA;A5Ei8NlC;A4Eh8NC;EAAqC,gBAAA;A5Em8NtC;A4El8NC;EAAiC,gBAAA;A5Eq8NlC;A4Ep8NC;EAA+B,gBAAA;A5Eu8NhC;A4Et8NC;;EAC0C,gBAAA;A5Ey8N3C;A4Ex8NC;EAAyC,gBAAA;A5E28N1C;A4E18NC;EAAyC,gBAAA;A5E68N1C;A4E58NC;EAAiC,gBAAA;A5E+8NlC;A4E98NC;EAAwC,gBAAA;A5Ei9NzC;A4Eh9NC;EAAwC,gBAAA;A5Em9NzC;A4El9NC;EAAmC,gBAAA;A5Eq9NpC;A4Ep9NC;EAA+B,gBAAA;A5Eu9NhC;A4Et9NC;EAAgC,gBAAA;A5Ey9NjC;A4Ex9NC;EAA+B,gBAAA;A5E29NhC;A4E19NC;EAAkC,gBAAA;A5E69NnC;A4E59NC;EAAuC,gBAAA;A5E+9NxC;A4E99NC;EAAuC,gBAAA;A5Ei+NxC;A4Eh+NC;EAAgC,gBAAA;A5Em+NjC;A4El+NC;EAAuC,gBAAA;A5Eq+NxC;A4Ep+NC;EAAwC,gBAAA;A5Eu+NzC;A4Et+NC;EAAsC,gBAAA;A5Ey+NvC;A4Ex+NC;EAAuC,gBAAA;A5E2+NxC;A4E1+NC;EAAuC,gBAAA;A5E6+NxC;A4E5+NC;EAAuC,gBAAA;A5E++NxC;A4E9+NC;EAA0C,gBAAA;A5Ei/N3C;A4Eh/NC;EAAsC,gBAAA;A5Em/NvC;A4El/NC;EAAqC,gBAAA;A5Eq/NtC;A4Ep/NC;EAAyC,gBAAA;A5Eu/N1C;A4Et/NC;EAAyC,gBAAA;A5Ey/N1C;A4Ex/NC;EAA8B,gBAAA;A5E2/N/B;A4E1/NC;EAAqC,gBAAA;A5E6/NtC;A4E5/NC;EAAsC,gBAAA;A5E+/NvC;A4E9/NC;EAAmC,gBAAA;A5EigOpC;A4EhgOC;EAAqC,gBAAA;A5EmgOtC;A4ElgOC;;EACgC,gBAAA;A5EqgOjC;A4EpgOC;EAAiC,gBAAA;A5EugOlC;A4EtgOC;EAAmC,gBAAA;A5EygOpC;A4ExgOC;EAA+B,gBAAA;A5E2gOhC;A4E1gOC;EAAgC,gBAAA;A5E6gOjC;A4E5gOC;EAAmC,gBAAA;A5E+gOpC;A4E9gOC;EAA6C,gBAAA;A5EihO9C;A4EhhOC;EAA+B,gBAAA;A5EmhOhC;A4ElhOC;EAA+B,gBAAA;A5EqhOhC;A4EphOC;EAA+B,gBAAA;A5EuhOhC;A4EthOC;EAA8B,gBAAA;A5EyhO/B;A4ExhOC;EAAoC,gBAAA;A5E2hOrC;A4E1hOC;;EAC+C,gBAAA;A5E6hOhD;A4E5hOC;EAAgC,gBAAA;A5E+hOjC;A4E9hOC;EAAmC,gBAAA;A5EiiOpC;A4EhiOC;EAAiC,gBAAA;A5EmiOlC;A4EliOC;EAAkC,gBAAA;A5EqiOnC;A4EpiOC;EAAiC,gBAAA;A5EuiOlC;A4EtiOC;EAAqC,gBAAA;A5EyiOtC;A4ExiOC;EAAuC,gBAAA;A5E2iOxC;A4E1iOC;EAAkC,gBAAA;A5E6iOnC;A4E5iOC;EAAwC,gBAAA;A5E+iOzC;A4E9iOC;EAAiC,gBAAA;A5EijOlC;A4EhjOC;EAAsC,gBAAA;A5EmjOvC;A4EljOC;EAAmC,gBAAA;A5EqjOpC;A4EpjOC;EAAmC,gBAAA;A5EujOpC;A4EtjOC;;EACoC,gBAAA;A5EyjOrC;A4ExjOC;EAAyC,gBAAA;A5E2jO1C;A4E1jOC;EAA0C,gBAAA;A5E6jO3C;A4E5jOC;EAAuC,gBAAA;A5E+jOxC;A4E9jOC;EAA8B,gBAAA;A5EikO/B;A4EhkOC;;EAC+B,gBAAA;A5EmkOhC;A4ElkOC;EAAmC,gBAAA;A5EqkOpC;A4EpkOC;EAAsC,gBAAA;A5EukOvC;A4EtkOC;EAAwC,gBAAA;A5EykOzC;A4ExkOC;EAAoC,gBAAA;A5E2kOrC;A4E1kOC;EAAkC,gBAAA;A5E6kOnC;A4E5kOC;EAAmC,gBAAA;A5E+kOpC;A4E9kOC;EAA0C,gBAAA;A5EilO3C;A4EhlOC;EAAqC,gBAAA;A5EmlOtC;A4EllOC;EAAwC,gBAAA;A5EqlOzC;A4EplOC;EAAkC,gBAAA;A5EulOnC;A4EtlOC;EAAiC,gBAAA;A5EylOlC;A4ExlOC;EAAwC,gBAAA;A5E2lOzC;A4E1lOC;EAAiC,gBAAA;A5E6lOlC;A4E5lOC;EAAkC,gBAAA;A5E+lOnC;A4E9lOC;EAAgC,gBAAA;A5EimOjC;A4EhmOC;EAAmC,gBAAA;A5EmmOpC;A4ElmOC;EAAqC,gBAAA;A5EqmOtC;A4EpmOC;EAAuC,gBAAA;A5EumOxC;A4EtmOC;EAAkC,gBAAA;A5EymOnC;A4ExmOC;;EACmC,gBAAA;A5E2mOpC;A4E1mOC;EAAiC,gBAAA;A5E6mOlC;A4E5mOC;EAAiC,gBAAA;A5E+mOlC;A4E9mOC;EAAsC,gBAAA;A5EinOvC;A4EhnOC;;EAC8B,gBAAA;A5EmnO/B;A4ElnOC;EAAgC,gBAAA;A5EqnOjC;A4EpnOC;EAAmC,gBAAA;A5EunOpC;A4EtnOC;EAA+B,gBAAA;A5EynOhC;A4ExnOC;EAAsC,gBAAA;A5E2nOvC;A4E1nOC;EAAuC,gBAAA;A5E6nOxC;A4E5nOC;EAAsC,gBAAA;A5E+nOvC;A4E9nOC;EAAoC,gBAAA;A5EioOrC;A4EhoOC;EAAsC,gBAAA;A5EmoOvC;A4EloOC;EAA4C,gBAAA;A5EqoO7C;A4EpoOC;EAA6C,gBAAA;A5EuoO9C;A4EtoOC;EAA0C,gBAAA;A5EyoO3C;A4ExoOC;EAA4C,gBAAA;A5E2oO7C;A4E1oOC;EAAgC,gBAAA;A5E6oOjC;A4E5oOC;EAAiC,gBAAA;A5E+oOlC;A4E9oOC;EAAgC,gBAAA;A5EipOjC;A4EhpOC;EAAiC,gBAAA;A5EmpOlC;A4ElpOC;EAAoC,gBAAA;A5EqpOrC;A4EppOC;EAAqC,gBAAA;A5EupOtC;A4EtpOC;;EACgC,gBAAA;A5EypOjC;A4ExpOC;;EAC+B,gBAAA;A5E2pOhC;A4E1pOC;EAAgC,gBAAA;A5E6pOjC;A4E5pOC;EAAgC,gBAAA;A5E+pOjC;A4E9pOC;;EACmC,gBAAA;A5EiqOpC;A4EhqOC;;EACkC,gBAAA;A5EmqOnC;A4ElqOC;EAAoC,gBAAA;A5EqqOrC;A4EpqOC;;EACmC,gBAAA;A5EuqOpC;A4EtqOC;EAAiC,gBAAA;A5EyqOlC;A4ExqOC;;;EAE+B,gBAAA;A5E2qOhC;A4E1qOC;EAAkC,gBAAA;A5E6qOnC;A4E5qOC;EAAkC,gBAAA;A5E+qOnC;A4E9qOC;EAAwC,gBAAA;A5EirOzC;A4EhrOC;EAAoC,gBAAA;A5EmrOrC;A4ElrOC;EAAgC,gBAAA;A5EqrOjC;A4EprOC;EAAgC,gBAAA;A5EurOjC;A4EtrOC;EAAgC,gBAAA;A5EyrOjC;A4ExrOC;EAAoC,gBAAA;A5E2rOrC;A4E1rOC;EAA2C,gBAAA;A5E6rO5C;A4E5rOC;EAA6C,gBAAA;A5E+rO9C;A4E9rOC;EAAsC,gBAAA;A5EisOvC;A4EhsOC;EAAgC,gBAAA;A5EmsOjC;A4ElsOC;EAAqC,gBAAA;A5EqsOtC;A4EpsOC;EAAmC,gBAAA;A5EusOpC;A4EtsOC;EAAqC,gBAAA;A5EysOtC;A4ExsOC;EAAsC,gBAAA;A5E2sOvC;A4E1sOC;EAAkC,gBAAA;A5E6sOnC;A4E5sOC;;EAC+B,gBAAA;A5E+sOhC;A4E9sOC;;EACoC,gBAAA;A5EitOrC;A4EhtOC;;EACmC,gBAAA;A5EmtOpC;A4EltOC;EAAmC,gBAAA;A5EqtOpC;A4EptOC;EAAmC,gBAAA;A5EutOpC;A4EttOC;;EAC+B,gBAAA;A5EytOhC;A4ExtOC;;EACgC,gBAAA;A5E2tOjC;A4E1tOC;;EACqC,gBAAA;A5E6tOtC;A4E5tOC;EAAoC,gBAAA;A5E+tOrC;A4E9tOC;EAAqC,gBAAA;A5EiuOtC;A4EhuOC;;EAC+B,gBAAA;A5EmuOhC;A4EluOC;EAAkC,gBAAA;A5EquOnC;A4EpuOC;EAAmC,gBAAA;A5EuuOpC;A4EtuOC;;EACoC,gBAAA;A5EyuOrC;A4ExuOC;EAAsC,gBAAA;A5E2uOvC;A4E1uOC;EAAmC,gBAAA;A5E6uOpC;A4E5uOC;EAAyC,gBAAA;A5E+uO1C;A4E9uOC;EAAuC,gBAAA;A5EivOxC;A4EhvOC;EAAkC,gBAAA;A5EmvOnC;A4ElvOC;EAAsC,gBAAA;A5EqvOvC;A4EpvOC;EAAmC,gBAAA;A5EuvOpC;A4EtvOC;EAAiC,gBAAA;A5EyvOlC;A4ExvOC;EAAiC,gBAAA;A5E2vOlC;A4E1vOC;EAAkC,gBAAA;A5E6vOnC;A4E5vOC;EAAsC,gBAAA;A5E+vOvC;A4E9vOC;EAAqC,gBAAA;A5EiwOtC;A4EhwOC;EAAqC,gBAAA;A5EmwOtC;A4ElwOC;EAAoC,gBAAA;A5EqwOrC;A4EpwOC;EAAiC,gBAAA;A5EuwOlC;A4EtwOC;EAAsC,gBAAA;A5EywOvC;A4ExwOC;EAA+B,gBAAA;A5E2wOhC;A4E1wOC;EAAmC,gBAAA;A5E6wOpC;A4E5wOC;EAAsC,gBAAA;A5E+wOvC;A4E9wOC;EAA4C,gBAAA;A5EixO7C;A4EhxOC;EAA6C,gBAAA;A5EmxO9C;A4ElxOC;EAA0C,gBAAA;A5EqxO3C;A4EpxOC;EAA4C,gBAAA;A5EuxO7C;A4EtxOC;EAAqC,gBAAA;A5EyxOtC;A4ExxOC;EAAsC,gBAAA;A5E2xOvC;A4E1xOC;EAAmC,gBAAA;A5E6xOpC;A4E5xOC;EAAqC,gBAAA;A5E+xOtC;A4E9xOC;EAAkC,gBAAA;A5EiyOnC;A4EhyOC;EAAiC,gBAAA;A5EmyOlC;A4ElyOC;EAAiC,gBAAA;A5EqyOlC;A4EpyOC;;EACiC,gBAAA;A5EuyOlC;A4EtyOC;EAAmC,gBAAA;A5EyyOpC;A4ExyOC;EAAqC,gBAAA;A5E2yOtC;A4E1yOC;EAAsC,gBAAA;A5E6yOvC;A4E5yOC;EAAkC,gBAAA;A5E+yOnC;A4E9yOC;EAAiC,gBAAA;A5EizOlC;A4EhzOC;;EACgC,gBAAA;A5EmzOjC;A4ElzOC;EAAqC,gBAAA;A5EqzOtC;A4EpzOC;EAAmC,gBAAA;A5EuzOpC;A4EtzOC;EAAwC,gBAAA;A5EyzOzC;A4ExzOC;EAAkC,gBAAA;A5E2zOnC;A4E1zOC;EAAkC,gBAAA;A5E6zOnC;A4E5zOC;EAAgC,gBAAA;A5E+zOjC;A4E9zOC;EAAkC,gBAAA;A5Ei0OnC;A4Eh0OC;EAAqC,gBAAA;A5Em0OtC;A4El0OC;EAAiC,gBAAA;A5Eq0OlC;A4Ep0OC;EAAyC,gBAAA;A5Eu0O1C;A4Et0OC;EAAmC,gBAAA;A5Ey0OpC;A4Ex0OC;EAA+B,gBAAA;A5E20OhC;A4E10OC;;EACoC,gBAAA;A5E60OrC;A4E50OC;;;EAEsC,gBAAA;A5E+0OvC;A4E90OC;EAAyC,gBAAA;A5Ei1O1C;A4Eh1OC;EAA+B,gBAAA;A5Em1OhC;A4El1OC;EAAoC,gBAAA;A5Eq1OrC;A4Ep1OC;;EACuC,gBAAA;A5Eu1OxC;A4Et1OC;EAAmC,gBAAA;A5Ey1OpC;A4Ex1OC;EAA+B,gBAAA;A5E21OhC;A4E11OC;EAAsC,gBAAA;A5E61OvC;A4E51OC;EAAsC,gBAAA;A5E+1OvC;A4E91OC;EAAoC,gBAAA;A5Ei2OrC;A4Eh2OC;EAAiC,gBAAA;A5Em2OlC;A4El2OC;EAAuC,gBAAA;A5Eq2OxC;A4Ep2OC;EAAqC,gBAAA;A5Eu2OtC;A4Et2OC;EAA2C,gBAAA;A5Ey2O5C;A4Ex2OC;EAAiC,gBAAA;A5E22OlC;A4E12OC;EAAqC,gBAAA;A5E62OtC;A4E52OC;EAA4C,gBAAA;A5E+2O7C;A4E92OC;EAAiC,gBAAA;A5Ei3OlC;A4Eh3OC;EAAiC,gBAAA;A5Em3OlC;A4El3OC;EAA8C,gBAAA;A5Eq3O/C;A4Ep3OC;EAA+C,gBAAA;A5Eu3OhD;A4Et3OC;EAA4C,gBAAA;A5Ey3O7C;A4Ex3OC;EAA8C,gBAAA;A5E23O/C;A4E13OC;EAAgC,gBAAA;A5E63OjC;A4E53OC;EAA+B,gBAAA;A5E+3OhC;A4E93OC;EAAiC,gBAAA;A5Ei4OlC;A4Eh4OC;EAAqC,gBAAA;A5Em4OtC;A4El4OC;EAAmC,gBAAA;A5Eq4OpC;A4Ep4OC;EAAqC,gBAAA;A5Eu4OtC;A4Et4OC;EAAqC,gBAAA;A5Ey4OtC;A4Ex4OC;EAAqC,gBAAA;A5E24OtC;A4E14OC;EAAsC,gBAAA;A5E64OvC;A4E54OC;EAAiC,gBAAA;A5E+4OlC;A4E94OC;EAAuC,gBAAA;A5Ei5OxC;A4Eh5OC;EAAyC,gBAAA;A5Em5O1C;A4El5OC;EAAmC,gBAAA;A5Eq5OpC;A4Ep5OC;EAAqC,gBAAA;A5Eu5OtC;A4Et5OC;EAAuC,gBAAA;A5Ey5OxC;A4Ex5OC;EAAwC,gBAAA;A5E25OzC;A4E15OC;EAA+C,gBAAA;A5E65OhD;A4E55OC;EAAuC,gBAAA;A5E+5OxC;A4E95OC;EAAkC,gBAAA;A5Ei6OnC;A4Eh6OC;;EAC8C,gBAAA;A5Em6O/C;A4El6OC;;EAC4C,gBAAA;A5Eq6O7C;A4Ep6OC;;EAC+C,gBAAA;A5Eu6OhD;A4Et6OC;;EAC8B,gBAAA;A5Ey6O/B;A4Ex6OC;EAA8B,gBAAA;A5E26O/B;A4E16OC;;EAC8B,gBAAA;A5E66O/B;A4E56OC;;EAC8B,gBAAA;A5E+6O/B;A4E96OC;;;;EAG8B,gBAAA;A5Ei7O/B;A4Eh7OC;;;EAE8B,gBAAA;A5Em7O/B;A4El7OC;;EAC8B,gBAAA;A5Eq7O/B;A4Ep7OC;;EAC8B,gBAAA;A5Eu7O/B;A4Et7OC;EAA+B,gBAAA;A5Ey7OhC;A4Ex7OC;EAAoC,gBAAA;A5E27OrC;A4E17OC;EAAyC,gBAAA;A5E67O1C;A4E57OC;EAA0C,gBAAA;A5E+7O3C;A4E97OC;EAA0C,gBAAA;A5Ei8O3C;A4Eh8OC;EAA2C,gBAAA;A5Em8O5C;A4El8OC;EAA2C,gBAAA;A5Eq8O5C;A4Ep8OC;EAA4C,gBAAA;A5Eu8O7C;A4Et8OC;EAAoC,gBAAA;A5Ey8OrC;A4Ex8OC;EAAsC,gBAAA;A5E28OvC;A4E18OC;EAAyC,gBAAA;A5E68O1C;A4E58OC;EAAkC,gBAAA;A5E+8OnC;A4E98OC;EAA+B,gBAAA;A5Ei9OhC;A4Eh9OC;EAAsC,gBAAA;A5Em9OvC;A4El9OC;EAAuC,gBAAA;A5Eq9OxC;A4Ep9OC;EAAkC,gBAAA;A5Eu9OnC;A4Et9OC;EAAyC,gBAAA;A5Ey9O1C;A4Ex9OC;EAAoC,gBAAA;A5E29OrC;A4E19OC;EAAiC,gBAAA;A5E69OlC;A4E59OC;EAA8B,gBAAA;A5E+9O/B;A4E99OC;EAAoC,gBAAA;A5Ei+OrC;A4Eh+OC;EAA2C,gBAAA;A5Em+O5C;A4El+OC;EAAiC,gBAAA;A5Eq+OlC;A4Ep+OC;EAAwC,gBAAA;A5Eu+OzC;A4Et+OC;EAA0C,gBAAA;A5Ey+O3C;A4Ex+OC;EAAwC,gBAAA;A5E2+OzC;A4E1+OC;EAA0C,gBAAA;A5E6+O3C;A4E5+OC;EAA2C,gBAAA;A5E++O5C;A4E9+OC;EAAgC,gBAAA;A5Ei/OjC;A4Eh/OC;EAAkC,gBAAA;A5Em/OnC;A4El/OC;EAAkC,gBAAA;A5Eq/OnC;A4Ep/OC;EAAgC,gBAAA;A5Eu/OjC;A4Et/OC;EAAmC,gBAAA;A5Ey/OpC;A4Ex/OC;EAAgC,gBAAA;A5E2/OjC;A4E1/OC;EAAqC,gBAAA;A5E6/OtC;A4E5/OC;EAAiC,gBAAA;A5E+/OlC;A4E9/OC;EAAiC,gBAAA;A5EigPlC;A4EhgPC;EAA+B,gBAAA;A5EmgPhC;A4ElgPC;;EACmC,gBAAA;A5EqgPpC;A4EpgPC;EAAgC,gBAAA;A5EugPjC;A4EtgPC;EAAiC,gBAAA;A5EygPlC;A4ExgPC;EAAkC,gBAAA;A5E2gPnC;A4E1gPC;EAA8B,gBAAA;A5E6gP/B;A4E5gPC;EAA6B,gBAAA;A5E+gP9B;A4E9gPC;EAAgC,gBAAA;A5EihPjC;A4EhhPC;EAAiC,gBAAA;A5EmhPlC;A4ElhPC;EAAoC,gBAAA;A5EqhPrC;A4EphPC;EAAyC,gBAAA;A5EuhP1C;A4EthPC;EAA+C,gBAAA;A5EyhPhD;A4ExhPC;EAA8C,gBAAA;A5E2hP/C;A4E1hPC;;EAC8C,gBAAA;A5E6hP/C;A4E5hPC;EAAuC,gBAAA;A5E+hPxC;A4E9hPC;EAAqC,gBAAA;A5EiiPtC;A4EhiPC;EAAuC,gBAAA;A5EmiPxC;A4EliPC;;EAC8B,gBAAA;A5EqiP/B;A4EpiPC;EAAwC,gBAAA;A5EuiPzC;A4EtiPC;EAAwC,gBAAA;A5EyiPzC;A4ExiPC;EAAgC,gBAAA;A5E2iPjC;A4E1iPC;EAA0C,gBAAA;A5E6iP3C;A4E5iPC;EAAoC,gBAAA;A5E+iPrC;A4E9iPC;EAAiC,gBAAA;A5EijPlC;A4EhjPC;;;EAEqC,gBAAA;A5EmjPtC;A4EljPC;;EACyC,gBAAA;A5EqjP1C;A4EpjPC;EAAgC,gBAAA;A5EujPjC;A4EtjPC;EAAiC,gBAAA;A5EyjPlC;A4ExjPC;EAAiC,gBAAA;A5E2jPlC;A4E1jPC;EAAwC,gBAAA;A5E6jPzC;A4E5jPC;EAA6C,gBAAA;A5E+jP9C;A4E9jPC;EAAsC,gBAAA;A5EikPvC;A4EhkPC;EAAoC,gBAAA;A5EmkPrC;A4ElkPC;EAA+B,gBAAA;A5EqkPhC;A4EpkPC;EAAwC,gBAAA;A5EukPzC;A4EtkPC;EAAyC,gBAAA;A5EykP1C;A4ExkPC;EAAiC,gBAAA;A5E2kPlC;A4E1kPC;EAAiC,gBAAA;A5E6kPlC;A4E5kPC;EAAmC,gBAAA;A5E+kPpC;A4E9kPC;EAA8B,gBAAA;A5EilP/B;A4EhlPC;EAAmC,gBAAA;A5EmlPpC;A4EllPC;EAAgC,gBAAA;A5EqlPjC;A4EplPC;EAA8B,gBAAA;A5EulP/B;A4EtlPC;EAAgC,gBAAA;A5EylPjC;A4ExlPC;EAA+B,gBAAA;A5E2lPhC;A4E1lPC;EAAgC,gBAAA;A5E6lPjC;A4E5lPC;EAAkC,gBAAA;A5E+lPnC;A4E9lPC;EAAyC,gBAAA;A5EimP1C;A4EhmPC;EAAgC,gBAAA;A5EmmPjC;A4ElmPC;EAAuC,gBAAA;A5EqmPxC;A4EpmPC;EAAkC,gBAAA;A5EumPnC;A4EtmPC;;EAC8B,gBAAA;A5EymP/B;A4ExmPC;;EAC+B,gBAAA;A5E2mPhC;A4E1mPC;EAA+B,gBAAA;A5E6mPhC;A4E5mPC;EAAkC,gBAAA;A5E+mPnC;A4E9mPC;EAAqC,gBAAA;A5EinPtC;A4EhnPC;EAAqC,gBAAA;A5EmnPtC;A4ElnPC;EAAmC,gBAAA;A5EqnPpC;A4EpnPC;EAAqC,gBAAA;A5EunPtC;A4EtnPC;EAAsC,gBAAA;A5EynPvC;A4ExnPC;EAAuC,gBAAA;A5E2nPxC;A4E1nPC;EAA4C,gBAAA;A5E6nP7C;A4E5nPC;;;EAEuC,gBAAA;A5E+nPxC;A4E9nPC;;EACyC,gBAAA;A5EioP1C;A4EhoPC;;EACuC,gBAAA;A5EmoPxC;A4EloPC;;EACuC,gBAAA;A5EqoPxC;A4EpoPC;EAAsC,gBAAA;A5EuoPvC;A4EtoPC;EAA+B,gBAAA;A5EyoPhC;A4ExoPC;EAAkC,gBAAA;A5E2oPnC;A4E1oPC;EAAmC,gBAAA;A5E6oPpC;A4E5oPC;;;;;EAIoC,gBAAA;A5E+oPrC;A4E9oPC;EAAyC,gBAAA;A5EipP1C;A4EhpPC;;;EAEgC,gBAAA;A5EmpPjC;A4ElpPC;;EACiC,gBAAA;A5EqpPlC;A4EppPC;EAAqC,gBAAA;A5EupPtC;A4EtpPC;EAA8B,gBAAA;A5EypP/B;A4ExpPC;;;EAEsC,gBAAA;A5E2pPvC;A4E1pPC;EAAwC,gBAAA;A5E6pPzC;A4E5pPC;EAA6B,gBAAA;A5E+pP9B;A4E9pPC;;EACiC,gBAAA;A5EiqPlC;A4EhqPC;;EACsC,gBAAA;A5EmqPvC;A4ElqPC;;EACwC,gBAAA;A5EqqPzC;A4EpqPC;EAAkC,gBAAA;A5EuqPnC;A4EtqPC;EAAsC,gBAAA;A5EyqPvC;A4ExqPC;EAAiC,gBAAA;A5E2qPlC;A4E1qPC;EAAoC,gBAAA;A5E6qPrC;A4E5qPC;EAAkC,gBAAA;A5E+qPnC;A4E9qPC;EAAoC,gBAAA;A5EirPrC;A4EhrPC;EAA2C,gBAAA;A5EmrP5C;A4ElrPC;EAA+B,gBAAA;A5EqrPhC;A4EprPC;;EACmC,gBAAA;A5EurPpC;A4EtrPC;EAA8B,gBAAA;A5EyrP/B;A4ExrPC;EAAqC,gBAAA;A5E2rPtC;A4E1rPC;EAA+B,gBAAA;A5E6rPhC;A4E5rPC;EAAqC,gBAAA;A5E+rPtC;A4E9rPC;EAAiC,gBAAA;A5EisPlC;A4EhsPC;EAA+B,gBAAA;A5EmsPhC;A4ElsPC;EAAsC,gBAAA;A5EqsPvC;A4EpsPC;EAA+B,gBAAA;A5EusPhC;A4EtsPC;EAAqC,gBAAA;A5EysPtC;A4ExsPC;EAAiC,gBAAA;A5E2sPlC;A4E1sPC;EAAwC,gBAAA;A5E6sPzC;A4E5sPC;EAAkC,gBAAA;A5E+sPnC;A4E9sPC;EAAwC,gBAAA;A5EitPzC;A4EhtPC;EAAsC,gBAAA;A5EmtPvC;A4EltPC;EAAkC,gBAAA;A5EqtPnC;A4EptPC;EAAoC,gBAAA;A5EutPrC;A4EttPC;EAAoC,gBAAA;A5EytPrC;A4ExtPC;EAAqC,gBAAA;A5E2tPtC;A4E1tPC;EAAuC,gBAAA;A5E6tPxC;A4E5tPC;EAAgC,gBAAA;A5E+tPjC;A4E9tPC;EAAoC,gBAAA;A5EiuPrC;A4EhuPC;EAA6B,gBAAA;A5EmuP9B;A4EluPC;EAAqC,gBAAA;A5EquPtC;A4EpuPC;EAAsC,gBAAA;A5EuuPvC;A4EtuPC;EAAwC,gBAAA;A5EyuPzC;A4ExuPC;EAAqC,gBAAA;A5E2uPtC;A4E1uPC;EAAoC,gBAAA;A5E6uPrC;A4E5uPC;EAAqC,gBAAA;A5E+uPtC;A4E9uPC;EAAiC,gBAAA;A5EivPlC;A4EhvPC;EAAwC,gBAAA;A5EmvPzC;A4ElvPC;EAAqC,gBAAA;A5EqvPtC;A4EpvPC;EAAoC,gBAAA;A5EuvPrC;A4EtvPC;EAAkC,gBAAA;A5EyvPnC;A4ExvPC;EAA8B,gBAAA;A5E2vP/B;A4E1vPC;EAAkC,gBAAA;A5E6vPnC;A4E5vPC;EAAoC,gBAAA;A5E+vPrC;A4E9vPC;EAA6B,gBAAA;A5EiwP9B;A4EhwPC;;;EAE8B,gBAAA;A5EmwP/B;A4ElwPC;EAAmC,gBAAA;A5EqwPpC;A4EpwPC;EAAqC,gBAAA;A5EuwPtC;A4EtwPC;EAAyC,gBAAA;A5EywP1C;A4ExwPC;EAAmC,gBAAA;A5E2wPpC;A4E1wPC;EAAmC,gBAAA;A5E6wPpC;A4E5wPC;EAAkC,gBAAA;A5E+wPnC;A4E9wPC;EAAiC,gBAAA;A5EixPlC;A4EhxPC;EAAuC,gBAAA;A5EmxPxC;A4ElxPC;EAAsC,gBAAA;A5EqxPvC;A4EpxPC;EAAmC,gBAAA;A5EuxPpC;A4EtxPC;EAAoC,gBAAA;A5EyxPrC;A4ExxPC;EAA0C,gBAAA;A5E2xP3C;A4E1xPC;EAAkC,gBAAA;A5E6xPnC;A4E5xPC;EAA+B,gBAAA;A5E+xPhC;A4E9xPC;EAAsC,gBAAA;A5EiyPvC;A4EhyPC;EAAqC,gBAAA;A5EmyPtC;A4ElyPC;EAAsC,gBAAA;A5EqyPvC;A4EpyPC;EAAoC,gBAAA;A5EuyPrC;A4EtyPC;EAAgC,gBAAA;A5EyyPjC;A4ExyPC;EAA+B,gBAAA;A5E2yPhC;A4E1yPC;EAAkC,gBAAA;A5E6yPnC;A4E5yPC;;EACsC,gBAAA;A5E+yPvC;A4E9yPC;EAA0C,gBAAA;A5EizP3C;A4EhzPC;EAAuC,gBAAA;A5EmzPxC;A4ElzPC;EAAsC,gBAAA;A5EqzPvC;A4EpzPC;EAAqC,gBAAA;A5EuzPtC;A4EtzPC;EAAsC,gBAAA;A5EyzPvC;A4ExzPC;EAAwC,gBAAA;A5E2zPzC;A4E1zPC;EAAwC,gBAAA;A5E6zPzC;A4E5zPC;EAAiC,gBAAA;A5E+zPlC;A4E9zPC;EAAqC,gBAAA;A5Ei0PtC;A4Eh0PC;EAA4C,gBAAA;A5Em0P7C;A4El0PC;EAAsC,gBAAA;A5Eq0PvC;A4Ep0PC;EAAmC,gBAAA;A5Eu0PpC;A4Et0PC;EAAiC,gBAAA;A5Ey0PlC;A4Ex0PC;EAAoC,gBAAA;A5E20PrC;A4E10PC;EAAqC,gBAAA;A5E60PtC;A4E50PC;;EAC8B,gBAAA;A5E+0P/B;A4E90PC;EAAkC,gBAAA;A5Ei1PnC;A4Eh1PC;EAAgC,gBAAA;A5Em1PjC;A4El1PC;EAAiC,gBAAA;A5Eq1PlC;A4Ep1PC;EAAiC,gBAAA;A5Eu1PlC;A4Et1PC;;EACuC,gBAAA;A5Ey1PxC;A4Ex1PC;EAAwC,gBAAA;A5E21PzC;A4E11PC;EAAmC,gBAAA;A5E61PpC;A4E51PC;EAAuC,gBAAA;A5E+1PxC;A4E91PC;;;EAEuC,gBAAA;A5Ei2PxC;A4Eh2PC;;EACiD,gBAAA;A5Em2PlD;A4El2PC;;EACuC,gBAAA;A5Eq2PxC;A4Ep2PC;;EAC0C,gBAAA;A5Eu2P3C;A4Et2PC;;EACwC,gBAAA;A5Ey2PzC;A4Ex2PC;EAAwC,gBAAA;A5E22PzC;A4E12PC;EAAmC,gBAAA;A5E62PpC;A4E52PC;EAAuC,gBAAA;A5E+2PxC;A4E92PC;EAAyC,gBAAA;A5Ei3P1C;A4Eh3PC;EAAsC,gBAAA;A5Em3PvC;A4El3PC;EAAwC,gBAAA;A5Eq3PzC;A4Ep3PC;EAAiC,gBAAA;A5Eu3PlC;A4Et3PC;EAAyC,gBAAA;A5Ey3P1C;A4Ex3PC;EAAgC,gBAAA;A5E23PjC;A4E13PC;EAAwC,gBAAA;A5E63PzC;A4E53PC;EAAsC,gBAAA;A5E+3PvC;A4E93PC;;EAC0C,gBAAA;A5Ei4P3C;A4Eh4PC;;EACyC,gBAAA;A5Em4P1C;A4El4PC;;EACwC,gBAAA;A5Eq4PzC;A4Ep4PC;EAAoC,gBAAA;A5Eu4PrC;A4Et4PC;;EACsC,gBAAA;A5Ey4PvC;A4Ex4PC;;EACuC,gBAAA;A5E24PxC;A4E14PC;EAA0C,gBAAA;A5E64P3C;A4E54PC;EAAwC,gBAAA;A5E+4PzC;A4E94PC;EAAuC,gBAAA;A5Ei5PxC;A4Eh5PC;EAAyC,gBAAA;A5Em5P1C;A4El5PC;EAAuC,gBAAA;A5Eq5PxC;A4Ep5PC;EAAoC,gBAAA;A5Eu5PrC;A4Et5PC;EAAqC,gBAAA;A5Ey5PtC;A4Ex5PC;EAA2C,gBAAA;A5E25P5C;A4E15PC;EAA6B,gBAAA;A5E65P9B;A4E55PC;EAAoC,gBAAA;A5E+5PrC;A4E95PC;EAAsC,gBAAA;A5Ei6PvC;A4Eh6PC;EAAwC,gBAAA;A5Em6PzC;A4El6PC;EAA+C,gBAAA;A5Eq6PhD;A4Ep6PC;EAAqC,gBAAA;A5Eu6PtC;A4Et6PC;EAAsC,gBAAA;A5Ey6PvC;A4Ex6PC;EAAiC,gBAAA;A5E26PlC;A4E16PC;EAAiC,gBAAA;A5E66PlC;A4E56PC;EAAkC,gBAAA;A5E+6PnC;A4E96PC;EAAgC,gBAAA;A5Ei7PjC;A4Eh7PC;EAA4C,gBAAA;A5Em7P7C;A4El7PC;;EACqC,gBAAA;A5Eq7PtC;A4Ep7PC;EAAiC,gBAAA;A5Eu7PlC;A4Et7PC;EAAgC,gBAAA;A5Ey7PjC;A4Ex7PC;EAAiC,gBAAA;A5E27PlC;A4E17PC;EAA0C,gBAAA;A5E67P3C;A4E57PC;EAA2C,gBAAA;A5E+7P5C;A4E97PC;EAA2C,gBAAA;A5Ei8P5C;A4Eh8PC;EAA2C,gBAAA;A5Em8P5C;A4El8PC;EAAmC,gBAAA;A5Eq8PpC;A4Ep8PC;EAAkC,gBAAA;A5Eu8PnC;A4Et8PC;EAAoC,gBAAA;A5Ey8PrC;A4Ex8PC;EAAgC,gBAAA;A5E28PjC;A4E18PC;EAA8B,gBAAA;A5E68P/B;A4E58PC;EAAqC,gBAAA;A5E+8PtC;A4E98PC;EAAuC,gBAAA;A5Ei9PxC;A4Eh9PC;EAAgC,gBAAA;A5Em9PjC;A4El9PC;EAAgC,gBAAA;A5Eq9PjC;A4Ep9PC;EAAoC,gBAAA;A5Eu9PrC;A4Et9PC;EAAoC,gBAAA;A5Ey9PrC;A4Ex9PC;EAAuC,gBAAA;A5E29PxC;A4E19PC;EAA+B,gBAAA;A5E69PhC;A4E59PC;EAA0C,gBAAA;A5E+9P3C;A4E99PC;EAAmC,gBAAA;A5Ei+PpC;A4Eh+PC;EAA+B,gBAAA;A5Em+PhC;A4El+PC;EAAuC,gBAAA;A5Eq+PxC;A4Ep+PC;EAA8B,gBAAA;A5Eu+P/B;A4Et+PC;EAAuC,gBAAA;A5Ey+PxC;A4Ex+PC;EAAmC,gBAAA;A5E2+PpC;A4E1+PC;EAAiC,gBAAA;A5E6+PlC;A4E5+PC;EAAuC,gBAAA;A5E++PxC;A4E9+PC;EAAyC,gBAAA;A5Ei/P1C;A4Eh/PC;EAAsC,gBAAA;A5Em/PvC;A4El/PC;EAAwC,gBAAA;A5Eq/PzC;A4Ep/PC;EAAuC,gBAAA;A5Eu/PxC;A4Et/PC;EAA0C,gBAAA;A5Ey/P3C;A4Ex/PC;EAAkC,gBAAA;A5E2/PnC;A4E1/PC;EAAoC,gBAAA;A5E6/PrC;A4E5/PC;EAAsC,gBAAA;A5E+/PvC;A4E9/PC;EAAkC,gBAAA;A5EigQnC;A4EhgQC;EAAiC,gBAAA;A5EmgQlC;A4ElgQC;EAAqC,gBAAA;A5EqgQtC;A4EpgQC;EAAkC,gBAAA;A5EugQnC;A4EtgQC;EAAiC,gBAAA;A5EygQlC;A4ExgQC;EAA2C,gBAAA;A5E2gQ5C;A4E1gQC;EAAyC,gBAAA;A5E6gQ1C;A4E5gQC;EAA4C,gBAAA;A5E+gQ7C;A4E9gQC;EAAgC,gBAAA;A5EihQjC;A4EhhQC;EAA4C,gBAAA;A5EmhQ7C;A4ElhQC;EAA+C,gBAAA;A5EqhQhD;A4EphQC;EAAkC,gBAAA;A5EuhQnC;A4EthQC;EAAsD,gBAAA;A5EyhQvD;A4ExhQC;;EAC8D,gBAAA;A5E2hQ/D;A4E1hQC;;;EAE+B,gBAAA;A5E6hQhC;A4E5hQC;EAAgC,gBAAA;A5E+hQjC;A4E9hQC;EAAkC,gBAAA;A5EiiQnC;A4EhiQC;;EACwC,gBAAA;A5EmiQzC;A4EliQC;EAAqC,gBAAA;A5EqiQtC;A4EpiQC;EAAiC,gBAAA;A5EuiQlC;A4EtiQC;EAAwC,gBAAA;A5EyiQzC;A4ExiQC;EAAmC,gBAAA;A5E2iQpC;A4E1iQC;EAAyC,gBAAA;A5E6iQ1C;A4E5iQC;EAA0C,gBAAA;A5E+iQ3C;A4E9iQC;EAAqC,gBAAA;A5EijQtC;A4EhjQC;EAAsC,gBAAA;A5EmjQvC;A4EljQC;EAAgC,gBAAA;A5EqjQjC;A4EpjQC;EAAoC,gBAAA;A5EujQrC;A4EtjQC;;EAC+C,gBAAA;A5EyjQhD;A4ExjQC;;EACuC,gBAAA;A5E2jQxC;A4E1jQC;EAAsC,gBAAA;A5E6jQvC;A4E5jQC;EAAwC,gBAAA;A5E+jQzC;A4E9jQC;EAA0C,gBAAA;A5EikQ3C;A4EhkQC;EAAiC,gBAAA;A5EmkQlC;A4ElkQC;EAAuC,gBAAA;A5EqkQxC;A4EpkQC;EAAyC,gBAAA;A5EukQ1C;A4EtkQC;;EACuC,gBAAA;A5EykQxC;A4ExkQC;;EACyC,gBAAA;A5E2kQ1C;A4E1kQC;EAAsC,gBAAA;A5E6kQvC;A4E5kQC;EAAwC,gBAAA;A5E+kQzC;A4E9kQC;EAAiC,gBAAA;A5EilQlC;A4EhlQC;EAAmC,gBAAA;A5EmlQpC;A4EllQC;;EACkC,gBAAA;A5EqlQnC;A4EplQC;;EACoC,gBAAA;A5EulQrC;A4EtlQC;EAAgC,gBAAA;A5EylQjC;A4ExlQC;EAAyC,gBAAA;A5E2lQ1C;A4E1lQC;EAAmC,gBAAA;A5E6lQpC;A4E5lQC;;;EAE2C,gBAAA;A5E+lQ5C;A4E9lQC;;EACqD,gBAAA;A5EimQtD;A4EhmQC;;EAC2C,gBAAA;A5EmmQ5C;A4ElmQC;;EAC8C,gBAAA;A5EqmQ/C;A4EpmQC;;EAC4C,gBAAA;A5EumQ7C;A4EtmQC;EAAiC,gBAAA;A5EymQlC;A4ExmQC;;;EAE+B,gBAAA;A5E2mQhC;A4E1mQC;EAAkC,gBAAA;A5E6mQnC;A4E5mQC;EAA0C,gBAAA;A5E+mQ3C;A4E9mQC;EAA0C,gBAAA;A5EinQ3C;A4EhnQC;EAAyC,gBAAA;A5EmnQ1C;A4ElnQC;;EACuC,gBAAA;A5EqnQxC;A4EpnQC;;EACyC,gBAAA;A5EunQ1C;A4EtnQC;EAAmC,gBAAA;A5EynQpC;A4ExnQC;EAA+B,gBAAA;A5E2nQhC;A4E1nQC;EAA+B,gBAAA;A5E6nQhC;A4E5nQC;EAA+B,gBAAA;A5E+nQhC;A4E9nQC;EAAkC,gBAAA;A5EioQnC;A4EhoQC;EAAkC,gBAAA;A5EmoQnC;A4EloQC;EAAoC,gBAAA;A5EqoQrC;A4EpoQC;EAAsC,gBAAA;A5EuoQvC;A4EtoQC;EAAsC,gBAAA;A5EyoQvC;A4ExoQC;EAAqC,gBAAA;A5E2oQtC;A4E1oQC;EAAiC,gBAAA;A5E6oQlC;A6E95RA;EH8BE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;A1Em4RF;AI/xRE;;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;AJiyRJ;A0El4RE;;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;A1Eo4RJ;A8E77RA;EACI,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;A9E+7RJ;A8Er8RA;E9Eu8RE,mCAAmC;E8E77R7B,cAAA;A9E+7RR;A8E37RA;EACI,iBAAA;EACA,kBAAA;EACA,SAAA;A9E67RJ;A8E17RA;;EACI,cAAA;A9E67RJ;A8E17RA;EACI,gBAAA;A9E47RJ;A+Er9RA;EACI,gBAAA;A/Eu9RJ;A+Er9RI;EAAA;IACE,gBAAA;E/Ew9RJ;AACF;A+E79RA;EAQQ,cAAA;EAEA,kBAAA;EACA,mBAAA;EAEA,sBAAA;EACA,kBAAA;EAEA,cAAA;EAEA,4BAAA;A/Eo9RR;A+Et+RA;EAqBY,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;A/Eo9RZ;A+Ej9RQ;;;EACI,yBAAA;EACA,qBAAA;EACA,4BAAA;A/Eq9RZ;A+Eh9RA;EACE,gBAAA;A/Ek9RF;A+Ej9RE;EAAA;IACE,aAAA;E/Eo9RF;AACF;AgF5/RA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AhF8/RJ;AgF3/RA;EACI,aAAA;EAEA,aAAA;EACA,eAAA;AhF4/RJ;AgFz/RA;;EACI,OAAA;EACA,aAAA;EACA,mBAAA;AhF4/RJ;AgF1/RA;EACE,OAAA;EACA,aAAA;EACA,kBAAA;AhF4/RF;AgFz/RA;EACI,gBAAA;AhF2/RJ;AgFx/RA;EACI,yBAAA;AhF0/RJ;AgFv/RA;EACI,eAAA;EACA,cAAA;EACA,+BAAA;AhFy/RJ;AgFt/RA;EACI,gBAAA;EACA,eAAA;EACA,aAAA;AhFw/RJ;AgFr/RA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AhFu/RJ;AgFp/RA;EACI,gBAAA;AhFs/RJ;AgFn/RA;EACI,iBAAA;AhFq/RJ;AgFl/RA;EACI,aAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AhFo/RJ;AgFj/RA;EACI,cAAA;AhFm/RJ;AgFh/RA;EACI,eAAA;AhFk/RJ;AgF/+RA;EACI,0EAAA;EACA,sCAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AhFi/RJ;AgFv/RA;EAQQ,kBAAA;EACA,4BAAA;EACA,gBAAA;AhFk/RR;AgF9+RA;EACI,kBAAA;EACA,cAAA;EACA,gCAAA;EACA,aAAA;AhFg/RJ;AgF/+RI;;;EACI,qBAAA;EACA,gCAAA;AhFm/RR;AgF/+RA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AhFi/RJ;AgF9+RA;EACI,cAAA;EACA,iBAAA;EACA,qBAAA;AhFg/RJ;AgF7+RA;EACI,YAAA;AhF++RJ;AgF5+RA;EACI,WAAA;EACA,eAAA;AhF8+RJ;AgFv+RA;EACE,yBAAA;AhFy+RF;AgFt+RA;EACI;IACI,eAAA;EhFw+RN;AACF;AgFp+RA;EACI;IACI,eAAA;IACA,gBAAA;EhFs+RN;EgFn+RE;IACI,kBAAA;EhFq+RN;EgFl+RE;IACI,iBAAA;EhFo+RN;EgF59RE;IACI,iBAAA;EhF89RN;EgF39RE;IACI,kBAAA;IACA,sBAAA;IACA,kBAAA;EhF69RN;EgF19RE;IACI,cAAA;EhF49RN;EgFz9RE;IACI,kBAAA;IACA,WAAA;IACA,SAAA;EhF29RN;EgFx9RE;;;IACI,gBAAA;IACA,cAAA;EhF49RN;AACF;AACA;;iEAEiE;AiFjpSjE;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AjFmpSF;AiFhpSA;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;AjFkpSF;AiF/oSA;EAAU,WAAA;AjFkpSV;AiFhpSA;EACE,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,iCAAA;EACA,mBAAA;EACA,qBAAA;EACA,6CAAA;AjFkpSF;AiFhpSE;EAAuB,UAAA;AjFmpSzB;AiFlpSE;EAA6B,uBAAA;AjFqpS/B;AiFppSE;EAA6B,4BAAA;EAA8B,kBAAA;AjFwpS7D;AACA,sCAAsC;AiFrpStC;EACE,kBAAA;EACA,sBAAA;EjFupSA,gCAAgC;AAClC;AiFtpSE;EACE,uCAAA;EACA,YAAA;AjFwpSJ;AiFrpSE;EAAgB,aAAA;AjFwpSlB;AiFrpSE;EACE,WAAA;EACA,iDAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AjFupSJ;AiFnpSA;EACE,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AjFqpSF;AiFlpSA;EACE,eAAA;EACA,0BAAA;EACA,YAAA;EACA,0CAAA;AjFopSF;AiFlpSE;;;EAA6B,UAAA;AjFupS/B;AiFppSA;EAAY,YAAA;AjFupSZ;AACA,qBAAqB;AiFrpSrB;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,gBAAA;EACA,+BAAA;EACA,+BAAA;EACA,sCAAA;EACA,UAAA;EACA,kFAAA;AjFupSF;AiFrpSE;EAAe,mBAAA;AjFwpSjB;AiFtpSE;EACE,4BAAA;EACA,sCAAA;AjFwpSJ;AiFrpSE;EAAc,oBAAA;AjFwpShB;AiF7qSA;EAwBI,uBAAA;EACA,WAAA;EAAa,YAAA;EACb,iBAAA;EACA,wCAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AjFypSJ;AACA,2CAA2C;AiFrpS3C;EACE,mCAAA;EACA,qCAAA;AjFupSF;AiFrpSE;EACE,mCAAA;EACA,oCAAA;AjFupSJ;AACA,uCAAuC;AiFnpSvC;EACE,mCAAA;EACA,qCAAA;AjFqpSF;AiFnpSE;EACE,mCAAA;EACA,oCAAA;AjFqpSJ;AACA,2BAA2B;AiFjpS3B;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;AjFmpSF;AiFxpSA;EAO0B,iBAAA;AjFopS1B;AiF3pSA;EASoB,eAAA;AjFqpSpB;AiFlpSA;EACE,iBAAA;EACA,eAAA;EACA,wBAAA;EACA,mBAAA;AjFopSF;AiFjpSA;EAAkB,aAAA;AjFopSlB;AiFlpSA;;EACuB,aAAA;AjFqpSvB;AiFnpSA;EAAsB,cAAA;AjFspStB;AiFppSA;EACE,OAAA;EACA,sBAAA;EACA,4BAAA;AjFspSF;AiFppSE;EAAA;IACE,4BAAA;EjFupSF;AACF;AiFppSA;EACE,2BAAA;EACA,mBAAA;EACA,mBAAA;AjFspSF;AiFnpSA;EACE,0BAAA;EACA,eAAA;EACA,eAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AjFqpSF;AiF5pSA;EAUI,gBAAA;EACA,4BAAA;EACA,0BAAA;EACA,+BAAA;AjFqpSJ;AiFlpSE;EAAA;IAAqC,eAAA;EjFspSrC;AACF;AiFrpSE;EAAA;IACE,eAAA;IACA,sBAAA;IACA,uBAAA;EjFwpSF;AACF;AiF9qSA;EAyBI,OAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;AjFwpSJ;AiFppSA;EACE,aAAA;EACA,mBAAA;AjFspSF;AiFnpSA;EAAiB,UAAA;AjFspSjB;AACA,4BAA4B;AiFppS5B;EACE,uBAAA;EACA,WAAA;EAAa,YAAA;EACb,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AjFupSF;AiF9pSA;EASM,eAAA;AjFwpSN;AACA,6BAA6B;AiFrpS7B;EACE;IAAO,UAAA;IAAY,iCAAA;EjFypSnB;EiFxpSA;IAAO,UAAA;IAAY,+BAAA;EjF4pSnB;AACF;AiF1pSA;EACE,kBAAA;AjF4pSF;AiF7pSA;EAGI,kBAAA;EACA,SAAA;EACA,0BAAA;AjF6pSJ;AACA,2BAA2B;AiFzpS3B;EACE,wBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AjF2pSF;AiFjqSA;EAQ0B,gBAAA;AjF4pS1B;AiFpqSA;EAWI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,2BAAA;AjF4pSJ;AiFxpSA;EAA2B,eAAA;EAAiB,4BAAA;AjF4pS5C;AiF1pSA;EACE,eAAA;EACA,YAAA;EACA,wBAAA;EACA,wCAAA;AjF4pSF;AiF3pSE;EAAU,4BAAA;AjF8pSZ;AiF5pSE;EAAA;IAAqC,aAAA;EjFgqSrC;AACF;AiF9pSA;EAAqB,kBAAA;AjFiqSrB;AiFhqSA;EAAW,cAAA;AjFmqSX;AACA,gBAAgB;AiFjqShB;EACE,iBAAA;EACA,QAAA;EAAU,SAAA;EACV,WAAA;EAAa,YAAA;EACb,kBAAA;EACA,gCAAA;EACA,0BAAA;EACA,+BAAA;EACA,aAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AjFqqSF;AiFnqSE;EAAA;IAAqC,eAAA;IAAiB,aAAA;EjFwqStD;AACF;AiFvrSA;EAiBI,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;AjFyqSJ;AiFrqSA;EAAwB,aAAA;EAAe,eAAA;AjFyqSvC;AiFvqSA;EACE;IAAwB,eAAA;EjF0qSxB;AACF;AiFxqSA;EAAkC,gBAAA;AjF2qSlC;AiF1qSA;EAAkC,cAAA;AjF6qSlC;AiF5qSA;EAAkC,eAAA;EAAiB,gBAAA;AjFgrSnD;AiF/qSA;EAAkC,cAAA;AjFkrSlC;AiFjrSA;EAAkC,gBAAA;AjForSlC;AiFnrSA;EAAkC,gBAAA;AjFsrSlC;AiFrrSA;EAAkC,wBAAA;AjFwrSlC;AACA,qBAAqB;AiFtrSrB;EAEI;IAAsB,UAAA;EjFwrSxB;EiFrrSA;IACE,gBAAA;IACA,aAAA;IACA,eAAA;EjFurSF;EiF1rSA;IAMI,YAAA;IAAc,WAAA;IACd,iBAAA;IACA,eAAA;IACA,eAAA;EjFwrSJ;EiFprSA;IACE,eAAA;IACA,cAAA;EjFsrSF;EiFnrSA;IAAkB,eAAA;EjFsrSlB;EiFrrSA;IAA0B,eAAA;EjFwrS1B;EiFtrSA;IACE,YAAA;IAAc,WAAA;EjFyrShB;EiF1rSA;IAEM,eAAA;EjF2rSN;EiFxrSA;IACE,QAAA;EjF0rSF;EiF3rSA;IAEc,kBAAA;IAAoB,YAAA;IAAc,SAAA;EjF8rShD;EiF3rSA;;IACwB,mBAAA;EjF8rSxB;AACF;AkFziTA;EACI,sBAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;AlFwiTJ;AkFriTA;;ElFwiTE,+EAA+E;EkFtiT7E,kDAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;ElFwiTF,sCAAsC;EkFriTpC,mCAAA;EACA,kCAAA;AlFuiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AkFpiTA;EACI,gBAAA;AlFsiTJ;AmFptTA;EACE,sBAAA;EACA,WAAA;EACA,kBAAA;AnFstTF;AmFrtTE;EACE,qBAAA;EACA,cAAA;EACA,0BAAA;AnFutTJ;AmFrtTE;EACI,aAAA;EACA,mBAAA;AnFutTN;AmFltTA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBAAA;EACA,qBAAA;EAEA,wDAAA;AnFmtTF;AmFhtTA;EAEE,uBAAA;AnFktTF;AmF/sTA;EAEE,uBAAA;AnFitTF;AmF9sTA;EACI;IACI,kBAAA;IACA,WAAA;EnFgtTN;EmF/sTM;IACI,SAAA;EnFitTV;EmFrtTE;IAOQ,UAAA;IACA,WAAA;EnFitTV;AACF;AmFxsTA;EACE;;;IAEE,mBAAA;EnFstTF;EmFrtTE;IAEA,mBAAA;EnFutTF;AACF;AACA;;;;iEAIiE;AoFnxTjE;EpFqxTE,yBAAyB;EoFnxTzB,aAAA;EpFqxTA,gCAAgC;EoFpxThC,kBAAA;EpFsxTA,mBAAmB;EoFrxTnB,oBAAA;EpFuxTA,iCAAiC;EoFtxTjC,oBAAA;EpFwxTA,yBAAyB;EACzB,2DAA2D;EoFtxT3D,qBAAA;EACA,+BAAA;EpFwxTA,SAAS;EoFrxTT,uBAAA;EACA,yBAAA;EACA,qBAAA;EpFuxTA,WAAW;EoFpxTX,mCAAA;EACA,6BAAA;EpFsxTA,oBAAoB;EoFnxTpB,wBAAA;EACA,wBAAA;EACA,uCAAA;EAEA,wBAAA;EACA,sCAAA;EAEA,uBAAA;EACA,qCAAA;EAEA,wBAAA;EpFkxTA,eAAe;EoF/wTf,qBAAA;EpFixTA,YAAY;EoF9wTZ,yCAAA;EACA,0CAAA;EACA,0CAAA;EACA,2CAAA;EpFgxTA,kBAAkB;EoF7wTlB,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EpF+wTA,gBAAgB;EoF5wThB,6BAAA;EACA,8BAAA;EACA,6BAAA;ApF8wTF;AACA;;iEAEiE;AoF1wTjE;;;EACE,sBAAA;ApF8wTF;AoF3wTA;EACE,+EAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,2BAAA;EACA,mCAAA;EACA,kCAAA;ApF6wTF;AoF1wTA;;;;;;EACE,gCAAA;EACA,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,aAAA;ApFixTF;AoF9wTA;EACE,2BAAA;EACA,qBAAA;EACA,wCAAA;ApFgxTF;AoF9wTE;EACE,2BAAA;EACA,qBAAA;ApFgxTJ;AoF5wTA;EAAI,SAAA;ApF+wTJ;AACA;;iEAEiE;AoF5wTjE;EACE,qCAAA;EACA,uBAAA;EACA,iDAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EpF8wTA,yBAAyB;AAC3B;AoFtxTA;EAUI,qCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;ApF+wTJ;AoF7wTI;EAAU,sCAAA;ApFgxTd;AoF/xTA;EAmBI,2BAAA;ApF+wTJ;AoFlyTA;EAoBgB,uCAAA;ApFixThB;AoFhxTI;EAAU,4BAAA;ApFmxTd;AoFxyTA;EAyBI,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;ApFkxTJ;AoFhxTI;;EACE,qCAAA;EACA,kCAAA;ApFmxTN;AoFpzTA;EAsCI,qCAAA;EACA,kCAAA;ApFixTJ;AoFxzTA;EA4CI,YAAA;EACA,wBAAA;EACA,aAAA;ApF+wTJ;AACA;;iEAEiE;AoF1wTjE;EACE,uCAAA;EACA,qCAAA;EACA,0CAAA;EACA,0CAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,kFAAA;ApF4wTF;AoF1wTE;EACE,6CAAA;EACA,oDAAA;EACA,wBAAA;ApF4wTJ;AoFzwTE;;EACE,mCAAA;ApF4wTJ;AoFxwTA;EACE,YAAA;ApF0wTF;AoFvwTA;EACE,YAAA;EACA,iBAAA;EACA,uCAAA;EACA,0CAAA;ApFywTF;AACA;;iEAEiE;AoFrwTjE;;EACE,uCAAA;EACA,eAAA;ApFwwTF;AoFrwTA;EACE,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,SAAA;ApFuwTF;AqFz8TA;EACE,gCAAA;EACA,eAAA;EACA,gBAAA;ArF28TF;AqFx8TA;EACE,4BAAA;ArF08TF;AqFv8TA;EACE,4BAAA;ArFy8TF;AqFt8TA;EACE,+BAAA;ArFw8TF;AqFr8TA;EACE,gCAAA;EACA,uFAAA;ArFu8TF;AqF/7TA;EACE,iBAAA;ArFi8TF;AqF97TA;EACE,gBAAA;EACA,qBAAA;ArFg8TF;AsF9+TA;EACI,aAAA;EAEA,uBAAA;EACA,iBAAA;AtF++TJ;AsFn/TA;EAMQ,mBAAA;AtFg/TR;AsF5+TI;EAAA;IACI,YAAA;IACA,iBAAA;IACA,kBAAA;EtF++TN;AACF;AsF5+TI;EAAA;IACI,YAAA;IACA,iBAAA;IACA,kBAAA;EtF++TN;AACF;AsF7+TA;EACI,gBAAA;EACA,mBAAA;AtF++TJ;AsF9+TI;EAAA;IACI,gBAAA;IACA,mBAAA;EtFi/TN;AACF;AsF9+TA;EACE,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EDjBA,4BAAA;ArFkgUF;AsF7+TA;EACI,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;ED5BF,4BAAA;ArF4gUF;AsFrhUI;EAAA;IACI,YAAA;IACA,iBAAA;IACA,kBAAA;EtFwhUN;AACF;AsFl/TA;EACE,aAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;ED9BA,+BAAA;ArFmhUF;AsFn/TE;EACE,qBAAA;AtFq/TJ;AsFn/TE;EACE,qBAAA;EACA,iBAAA;EACA,aAAA;AtFq/TJ;AsFj/TA;EACG,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACC,qBAAA;AtFm/TJ;AsFx/TA;EAOQ,mBAAA;AtFo/TR;AsF3/TA;;EAUQ,kBAAA;AtFq/TR;AsFj/TA;EACE,2BAAA;AtFm/TF;AsFh/TA;EACI,aAAA;EACA,qBAAA;EACA,yCAAA;EAYA,gBAAA;AtFu+TJ;AsFl/TI;EAAA;IACE,cAAA;IACA,0BAAA;EtFq/TJ;AACF;AsF5/TA;EASQ,mBAAA;AtFs/TR;AsF//TA;;EAYQ,kBAAA;AtFu/TR;AsFh/TA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EAGA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EDzFF,+BAAA;ArF0kUF;AsF7+TI;EACI,yBAAA;EACA,eAAA;AtF++TR;AsF5+TI;EACI,yBAAA;EACA,eAAA;EACA,aAAA;AtF8+TR;AsF5+TI;EACE,cAAA;AtF8+TN;AsF/+TI;EACE,cAAA;AtF8+TN;AsF5+TI;EtF8+TF,6BAA6B;EsF7+TzB,cAAA;AtF++TN;AsF3+TA;EACI,gBAAA;AtF6+TJ;AsF1+TA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;AtF4+TJ;AsF1+TI;EAAA;IACI,sBAAA;EtF6+TN;AACF;AuFpoUA;EACI,kBAAA;EAEA,UAAA;EAEA,+BAAA;EAEA,aAAA;EAEA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AvFkoUJ;AuFhoUI;EAAA;IACE,WAAA;EvFmoUJ;AACF;AuFnpUA;EAmBQ,OAAA;EACA,uBAAA;EvFmoUN,iBAAiB;EuFjoUX,aAAA;EACA,mBAAA;EvFmoUN,uCAAuC;EuFhoUjC,sBAAA;EACA,YAAA;EvFkoUN,IAAI;AACN;AuF9pUA;EAgCQ,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,0BAAA;EACA,iCAAA;EACA,qCAAA;EACA,4BAAA;EACA,2BAAA;EACA,mCAAA;EACA,sCAAA;AvFioUR;AuF/nUQ;EACI,uCAAA;EACA,4BAAA;AvFioUZ;AuF9nUQ;EAAA;IACI,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,aAAA;EvFioUV;EuFhoUU;IACI,aAAA;EvFkoUd;AACF;AuFhsUA;EAmEQ,2BAAA;AvFgoUR;AuFnsUA;EAuEQ,YAAA;EACA,+BAAA;EACA,YAAA;AvF+nUR;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE;AuFznUF;EAGY,aAAA;AvFynUZ;AuF5nUA;EAOY,gCAAA;AvFwnUZ;AACA,uCAAuC;AACvC,WAAW;AACX,iBAAiB;AACjB,YAAY;AACZ,eAAe;AACf,gBAAgB;AAChB,mBAAmB;AACnB,qBAAqB;AACrB,IAAI;AACJ,IAAI;AACJ,IAAI;AuFlnUJ;EACI,yBAAA;AvFonUJ;AuFjnUA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;AvFmnUF;AuFtnUA;EAMI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,iBAAA;EACA,2BAAA;EACA,iCAAA;EACA,qCAAA;EACA,2BAAA;EACA,mCAAA;EACA,sCAAA;AvFmnUJ;AuFjnUI;EACI,uCAAA;EACA,4BAAA;AvFmnUR;AuFhnUI;EAAA;IACE,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,aAAA;EvFmnUJ;EuFjnUI;IACE,aAAA;EvFmnUN;AACF;AuFvpUA;EAwCM,kBAAA;EACA,cAAA;AvFknUN;AACA;;;;iEAIiE;AACjE,mCAAmC;AwFlyUnC;EACE,aAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,uBAAA;AxFoyUF;AwFjyUA;EACE,uBAAA;AxFmyUF;AwFhyUA;;EAEE,2BAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;AxFkyUF;AwF/xUA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AxFiyUF;AwF9yUA;EAgBI,WAAA;EACA,YAAA;AxFiyUJ;AwF7xUA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AxF+xUF;AwF5xUA;EACE,WAAA;EACA,YAAA;AxF8xUF;AwF3xUA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AxF6xUF;AwF1xUA;EACE,WAAA;EACA,YAAA;AxF4xUF;AwFxxUE;EAAA;IACE,YAAA;IACA,aAAA;ExF2xUF;AACF;AwFxxUA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AxF0xUF;AwFvxUA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AxFyxUF;AACA;;iEAEiE;AwFrxUjE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;ExFuxUA,yBAAyB;EwFtxUzB,0BAAA;AxFwxUF;AACA;;iEAEiE;AwFpxUjE;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oBAAA;AxFsxUF;AwFpxUE;EAAA;IACE,sBAAA;IACA,YAAA;IACA,mBAAA;ExFuxUF;AACF;AACA,gCAAgC;AwFpxUhC;EACE,eAAA;EACA,0BAAA;EACA,+BAAA;EACA,+BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AxFsxUF;AwFpxUE;EAAA;IAA6B,eAAA;ExFwxU7B;AACF;AwFxxUE;EAAA;IAA6B,UAAA;IAAY,YAAA;ExF6xUzC;AACF;AACA,wBAAwB;AwF3xUxB;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,MAAA;AxF6xUF;AACA,+BAA+B;AwF1xU/B;EACE,eAAA;EACA,0BAAA;EACA,+BAAA;EACA,+BAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AxF4xUF;AwF1xUE;EAAA;IAA6B,eAAA;ExF8xU7B;AACF;AwF9xUE;EAAA;IAA6B,UAAA;ExFkyU7B;AACF;AACA;;iEAEiE;AwF/xUjE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,0BAAA;EACA,+BAAA;EACA,+BAAA;EACA,kBAAA;EACA,cAAA;ExFiyUA,yCAAyC;EwF9xUzC,yBAAA;EACA,0BAAA;EACA,2BAAA;AxFgyUF;AwF7xUA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;ExF+xUA,0BAA0B;AAC5B;AwF7xUA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AxF+xUF;AACA,yBAAyB;AwF5xUzB;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,2BAAA;AxF8xUF;AwF3xUA;EACE,kBAAA;EACA,iBAAA;AxF6xUF;AACA;;iEAEiE;AwFzxUjE;EACE,OAAA;EACA,aAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AxF2xUF;AwFzxUE;EAAA;IACE,iBAAA;ExF4xUF;AACF;AwFtyUA;EAaI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,+BAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,iBAAA;AxF4xUJ;AwFpzUA;EA4BI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mCAAA;EACA,wCAAA;EACA,+BAAA;EACA,eAAA;EACA,4BAAA;AxF2xUJ;AACA;;iEAEiE;AwFtxUjE;EACE,WAAA;EACA,gBAAA;EACA,uBAAA;AxFwxUF;AwFrxUA;EACE,OAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;AxFuxUF;AwFrxUE;EAAW,cAAA;AxFwxUb;AwFrxUA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;AxFuxUF;AwFrxUE;EAAW,cAAA;AxFwxUb;AwF9xUA;EASI,uBAAA;EACA,gCAAA;AxFwxUJ;AwFtxUI;EAAA;IAAsC,gBAAA;ExF0xUxC;AACF;AwFvxUA;EACE,kBAAA;EACA,MAAA;EAAQ,OAAA;EACR,WAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;EACA,kCAAA;EACA,0BAAA;EACA,UAAA;EACA,oDAAA;AxF0xUF;AwFvxUA;EACE,kBAAA;EACA,MAAA;EAAQ,OAAA;EACR,WAAA;EAAa,YAAA;EACb,kBAAA;EACA,iCAAA;EACA,UAAA;AxF2xUF;AwFxxUA;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EAAQ,OAAA;EAAS,SAAA;EAAW,QAAA;EAC5B,mBAAA;EACA,uBAAA;EACA,eAAA;AxF6xUF;AwF3xUE;EACE,aAAA;EACA,8BAAA;AxF6xUJ;AwF/xUE;EAGiB,+BAAA;AxF+xUnB;AwFlyUE;EAIiB,6BAAA;AxFiyUnB;AwF9xUE;EACE,aAAA;EACA,qBAAA;AxFgyUJ;AwFlyUE;EAGiB,yBAAA;AxFkyUnB;AwFryUE;EAIiB,cAAA;AxFoyUnB;AACA;;iEAEiE;AwF/xUjE;EACE,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,8BAAA;EACA,0BAAA;EACA,iBAAA;EACA,iCAAA;EACA,+BAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AxFiyUF;AwF9xUA;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,oCAAA;EACA,0CAAA;AxFgyUF;AwF7xUA;EACE,kBAAA;EACA,OAAA;EAAS,SAAA;EACT,WAAA;AxFgyUF;AwFnyUA;EAMI,cAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,kBAAA;AxFgyUJ;AwF9xUI;EAAW,oCAAA;AxFiyUf;AwF7yUA;EAgBI,WAAA;EAAa,YAAA;EACb,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AxFiyUJ;AwF9xUE;EAEI,kCAAA;AxF+xUN;AwF9xUM;EAAW,gCAAA;AxFiyUjB;AwFpyUE;EAKiB,2BAAA;AxFkyUnB;AwF/xUE;EACkB,uBAAA;AxFiyUpB;AwFlyUE;EAEiB,kCAAA;AxFmyUnB;AwFhyUE;EACkB,uBAAA;EAAyB,oCAAA;AxFmyU7C;AwFpyUE;EAEiB,6BAAA;AxFqyUnB;AACA;;iEAEiE;AwFhyUjE;EAAkB,wBAAA;AxFmyUlB;AwFjyUA;EACE,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AxFmyUF;AwFjyUE;ExFmyUA,+CAA+C;AACjD;AwF5yUA;EAYiB,4BAAA;AxFmyUjB;AwFhyUA;EACE,uBAAA;EACA,iBAAA;EACA,OAAA;EAAS,QAAA;EAAU,SAAA;AxFoyUrB;AwFvyUA;EAKW,aAAA;AxFqyUX;AwFlyUA;EAAuB,UAAA;AxFqyUvB;AACA;;iEAEiE;AwFlyUjE;EACE,sBAAA;AxFoyUF;AwFnyUE;EAAA;IAAqC,WAAA;ExFuyUrC;AACF;AACA;;iEAEiE;AwFpyUjE;EACE,cAAA;EACA,aAAA;EACA,mCAAA;EACA,0BAAA;AxFsyUF;AwF1yUA;EAOI,aAAA;EACA,QAAA;AxFsyUJ;AwF9yUA;EAWM,OAAA;EACA,0CAAA;AxFsyUN;AwFlzUA;EAgBM,cAAA;AxFqyUN;AwFrzUA;EAmBQ,0CAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,6CAAA;AxFqyUR;AwFnyUQ;EAAU,gCAAA;AxFsyUlB;AACA;;iEAEiE;AwF/xUjE;EACE,YAAA;EAAc,aAAA;EACd,UAAA;EAAY,gBAAA;EACZ,kBAAA;EAAoB,WAAA;AxFoyUtB;AwFjyUA;EAAsB,qBAAA;AxFoyUtB;AwFnyUA;;EAAqC,eAAA;AxFuyUrC;AwFtyUA;EAA8B,uCAAA;AxFyyU9B;AwFxyUA;EAA0B,oBAAA;AxF2yU1B;AwFzyUA;EACE,aAAA;EACA,mBAAA;AxF2yUF;AACA;;iEAEiE;AwFvyUjE;EACE,kBAAA;EACA,8BAAA;ExFyyUA,gDAAgD;EwFxyUhD,MAAA;EAAQ,SAAA;EAAW,QAAA;EAAU,OAAA;EAC7B,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AxF6yUF;AwFpzUA;EAUI,qCAAA;EACA,0CAAA;EACA,kDAAA;EACA,0CAAA;EACA,8CAAA;EACA,+CAAA;EACA,gDAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;AxF6yUJ;AwFn0UA;EAyBM,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AxF6yUN;AwF5yUM;EAAU,yBAAA;AxF+yUhB;AwF90UA;EAmCM,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AxF8yUN;AwFt1UA;EA4CM,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AxF6yUN;AwF51UA;EAoDI,aAAA;EACA,uBAAA;EACA,SAAA;AxF2yUJ;AwFj2UA;EAyDM,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,kCAAA;AxF2yUN;AwF52UA;EAqEM,mCAAA;EACA,YAAA;EACA,6CAAA;EACA,0CAAA;AxF0yUN;AwFzyUM;EAAU,kCAAA;EAAoC,2BAAA;AxF6yUpD;AwF5yUM;EAAW,0BAAA;AxF+yUjB;AwFz3UA;EA8EM,oCAAA;EACA,cAAA;EACA,0CAAA;AxF8yUN;AwF7yUM;EAAU,oCAAA;AxFgzUhB;AwF/yUM;EAAW,oCAAA;AxFkzUjB;AwF9yUE;EAAA;IACa,aAAA;ExFizUb;EwFlzUA;IAEa,sBAAA;IAAwB,WAAA;IAAa,SAAA;ExFqzUlD;EwFvzUA;IAGoB,WAAA;IAAa,SAAA;ExFwzUjC;AACF;AACA;;iEAEiE;AwFpzUjE;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;AxFszUF;AwF1zUA;EAMM,kBAAA;AxFuzUN;AwFpzUA;EACE,kBAAA;EACA,SAAA;EAAW,WAAA;EACX,eAAA;EACA,eAAA;EACA,4BAAA;EACA,wCAAA;AxFuzUF;AwFtzUE;EAAU,0BAAA;AxFyzUZ;AACA;;iEAEiE;AwFrzUjE;EACE;;IACE,iBAAA;IACA,eAAA;IACA,+BAAA;ExFwzUF;AACF;AwFrzUA;EACE;IACE,eAAA;IACA,kBAAA;IACA,QAAA;ExFuzUF;EwF1zUA;IAK6B,eAAA;ExFwzU7B;EwF7zUA;IAQI,eAAA;IACA,WAAA;IAAa,YAAA;IACb,iBAAA;IACA,mBAAA;ExFyzUJ;EwFp0UA;IAeI,eAAA;IACA,SAAA;IAAW,UAAA;IACX,kBAAA;ExFyzUJ;AACF;AACA,uDAAuD;AyFx9VvD;;;;;;EAGE,sBAAA;AzF+9VF;AACA,uDAAuD;AyF59VvD;EACE,aAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;AzF89VF;AACA,wDAAwD;AyF39VxD;EACE,aAAA;AzF69VF;AACA,wDAAwD;AyF19VxD;EACE,cAAA;AzF49VF;AACA,wDAAwD;AyFz9VxD;EACE,cAAA;AzF29VF;AACA,wDAAwD;AyFx9VxD;EAGE,yCAAA;EACA,kCAAA;EACA,+BAAA;EACA,8BAAA;EACA,6BAAA;EACA,wCAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,0BAAA;AzF09VF;AyFx9VE;EAAA;IACD,uBAAA;IACA,iBAAA;IACA,qCAAA;IACA,qBAAA;IACA,WAAA;EzF29VC;AACF;AACA,yDAAyD;AyFx9VzD;EACE,kBAAA;AzF09VF;AACA,yDAAyD;AyFv9VzD;EAKE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;AzFy9VF;AACA,yDAAyD;AyFt9VzD;EAKE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;AzFw9VF;AACA,yDAAyD;AyFr9VzD;EACE,mBAAA;AzFu9VF;AACA,yDAAyD;AyFp9VzD;EACE,mBAAA;AzFs9VF;AACA,yDAAyD;AyFn9VzD;EACE,iBAAA;EACA,qBAAA;EACA,wCAAA;AzFq9VF;AACA,2DAA2D;A0FtkW3D;EACE,iBAAA;A1FwkWF;AACA,4DAA4D;A0FtkW5D;EACE,kBAAA;A1FwkWF;AACA;;;iEAGiE;A2F7kWjE;EACE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;A3F+kWF;A2F5kWA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,6CAAA;E3F8kWA,oCAAoC;EACpC,oBAAoB;EACpB,6BAA6B;AAC/B;A2F/kWE;EAAuB,UAAA;A3FklWzB;A2FjlWE;EAA6B,uBAAA;A3FolW/B;A2FnlWE;EAA6B,4BAAA;EAA8B,kBAAA;A3FulW7D;A2FrmWA;EAiBI,gBAAA;EACA,cAAA;EACA,YAAA;A3FulWJ;A2F1mWA;EAsBM,cAAA;A3FulWN;A2FtlWM;;;EAA6B,qBAAA;A3F2lWnC;A2FlnWA;EA4BI,gBAAA;EACA,UAAA;EAAY,SAAA;A3F0lWhB;A2FvnWA;EAkCI,kBAAA;A3FwlWJ;A2F1nWA;EAqCM,cAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,sCAAA;A3FwlWN;A2FrlWI;;EAEE,0BAAA;EACA,oCAAA;EACA,qCAAA;A3FulWN;A2F7oWA;EA4DI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,SAAA;A3FolWJ;A2FtpWA;;EAqEM,eAAA;EACA,wBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wCAAA;A3FqlWN;A2FplWM;;EAAU,4BAAA;A3FwlWhB;A2FpqWA;EAkFI,kBAAA;EACA,aAAA;EACA,mBAAA;A3FqlWJ;A2FzqWA;EAuFM,OAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,sCAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A3FqlWN;A2FllWI;EACE,2BAAA;EACA,+BAAA;A3FolWN;A2FjlWI;;EAEE,0BAAA;EACA,mCAAA;EACA,sCAAA;EACA,qBAAA;A3FmlWN;A2FnsWA;EAoHM,cAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;A3FklWN;A2FhlWM;EAAU,UAAA;A3FmlWhB;A2FjlWM;EACE,YAAA;A3FmlWR;A2FllWQ;;;EAA6B,UAAA;A3FulWrC;AACA,4BAA4B;A2FjlW5B;EACE,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;EACA,0BAAA;EACA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,wBAAA;EACA,sBAAA;EACA,+CAAA;A3FmlWF;A2FjlWE;EACE,aAAA;EACA,kCAAA;EACA,yCAAA;A3FmlWJ;A2FhlWE;;EACE,wBAAA;A3FmlWJ;AACA,mEAAmE;A2F/kWnE;EACE,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,0BAAA;A3FilWF;A2F9kWA;EACE,gBAAA;EACA,SAAA;EAAW,UAAA;EACX,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;A3FilWF;A2FxlWA;EAS0B,iBAAA;A3FklW1B;A2FhlWE;EAAA;IAAqC,eAAA;E3FolWrC;AACF;A2FllWA;EAAuB,iBAAA;A3FqlWvB;A2FnlWA;EACE,YAAA;EACA,sCAAA;EACA,aAAA;A3FqlWF;A2FllWA;;;EAGE,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;A3FolWF;A2FllWE;;;;;;;;;EACE,qBAAA;EACA,0BAAA;A3F4lWJ;A2FxlWA;EAAwB,WAAA;A3F2lWxB;A2FzlWA;EACE,kBAAA;EACA,4BAAA;EACA,WAAA;EAAa,SAAA;EACb,eAAA;EACA,eAAA;EACA,+BAAA;EACA,YAAA;EACA,uBAAA;EACA,sCAAA;A3F4lWF;A2F1lWE;;;EACE,0BAAA;EACA,4BAAA;A3F8lWJ;A2F1lWA;EACE,aAAA;A3F4lWF;A2F7lWA;EAGgB,gBAAA;A3F6lWhB;A2FhmWA;EAKW,gBAAA;A3F8lWX;A2F3lWA;EAA8B,eAAA;A3F8lW9B;AACA,kDAAkD;A2F5lWlD;EACE;IACE,6BAAA;IACA,OAAA;IACA,kBAAA;IACA,gBAAA;IACA,0BAAA;IACA,qCAAA;IACA,YAAA;IACA,YAAA;IACA,8CAAA;E3F8lWF;E2F5lWE;IAAW,wBAAA;E3F+lWb;E2F5lWA;IACE,aAAA;IACA,sBAAA;IACA,oBAAA;E3F8lWF;E2F3lWA;IACE,oBAAA;IACA,2BAAA;IACA,mBAAA;E3F6lWF;E2F1lWA;IACE,cAAA;IACA,UAAA;IACA,0BAAA;E3F4lWF;E2FzlWA;;;IAEwB,qBAAA;E3F4lWxB;E2F1lWA;IAAsB,aAAA;E3F6lWtB;AACF;A4FlzWA;EACI,+BAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,6BAAA;EAMA,yBAAA;EAEA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;A5F8yWJ;A4FxzWI;EACI,wBAAA;A5F0zWR;A4FhzWI;;;EACE,qBAAA;A5FozWN;A4FlzWI;EACI,iBAAA;A5FozWR;A4FhzWA;EACE,aAAA;A5FkzWF;A4F/yWA;EACC,sCAAA;EACE,gCAAA;EACA,0BAAA;EACA,qCAAA;A5FizWH;A4FhzWG;EACE,0BAAA;EACG,uBAAA;A5FkzWR;A4F9yWA;EACG,oCAAA;EACA,qEAAA;EACA,WAAA;A5FgzWH;A4F/yWG;EACE,WAAA;A5FizWL;A4F/yWG;EACA,cAAA;A5FizWH;A4F7yWA;EACE,oCAAA;EACA,qEAAA;EACA,WAAA;A5F+yWF;A4F9yWE;EACE,WAAA;A5FgzWJ;A4F5yWA;EACI,6BAAA;EACA,eAAA;A5F8yWJ;A4F3yWA;EACI,0BAAA;A5F6yWJ;A4F3xWA;EAEE,WAAA;A5F4xWF;A4FzxWA;EACI,2BAAA;EACA,0BAAA;A5F2xWJ;AACA;;;;;;CAMC;A6F97WD;EACE,kBAAA;A7Fg8WF;A6F97WA;;;;EAME,sBAAA;A7Fg8WF;A6F97WA;EACE,yBAAA;A7Fg8WF;A6F97WA;EACE,gBAAA;A7Fg8WF;A6F97WA;EACE,eAAA;EACA,oBAAA;A7Fg8WF;A6F97WA;EACE,sBAAA;EACA,kCAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;A7Fg8WF;A6F97WA;EACE,uCAAA;A7Fg8WF;A6F97WA;EACE,aAAA;A7Fg8WF;A6F97WA;EACE,YAAA;A7Fg8WF;A6F97WA;EACE,6BAAA;EACA,4BAAA;EACA,gBAAA;EACA,kCAAA;A7Fg8WF;A6F97WA;EACE,0CAAA;EACA,uBAAA;A7Fg8WF;A6F97WA;EACE,YAAA;A7Fg8WF;A6F97WA;EACE,qBAAA;EACA,kFAAA;A7Fg8WF;A6F97WA;;EAEE,SAAA;EACA,WAAA;EACA,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A7Fg8WF;A6F97WA;;EAEE,WAAA;A7Fg8WF;A6F97WA;;EAEE,eAAA;EACA,qBAAA;A7Fg8WF;A6F97WA;;;;EAIE,cAAA;EACA,aAAA;EACA,0BAAA;A7Fg8WF;A6F97WA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;A7Fg8WF;A6F97WA;EACE,WAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;E7Fg8WA,2BAA2B;E6F97W3B,mBAAA;E7Fg8WA,2BAA2B;E6F97W3B,wBAAA;A7Fg8WF;A6F97WA;EACE,YAAA;A7Fg8WF;A6F97WA;EACE,UAAA;A7Fg8WF;A6F97WA;EACE,aAAA;A7Fg8WF;A6F97WA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;A7Fg8WF;A6F97WA;EAGE,sDAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;A7Fg8WF;A6F97WA;EAGE,wCAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;A7Fg8WF;A6F97WA;EACE,cAAA;A7Fg8WF;A6F97WA;EACE,qBAAA;EACA,eAAA;EACA,cAAA;A7Fg8WF;A6F97WA;EACE,WAAA;A7Fg8WF;A6F97WA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;A7Fg8WF;A6F97WA;EACE,0CAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,SAAA;EACA,QAAA;A7Fg8WF;A6F97WA;;EAEE,sBAAA;A7Fg8WF;A6F97WA;EACE,qBAAA;A7Fg8WF;A6F97WA;EACE,qBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;A7Fg8WF;A6Ft7WA;EACE;IACE,UAAA;E7Fg8WF;E6F97WA;IACE,UAAA;E7Fg8WF;AACF;A6F97WA;EACE,+BAAA;EACA,8BAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uCAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,iCAAA;A7Fg8WF;A6F97WA;EACE,iBAAA;EACA,gBAAA;A7Fg8WF;A6F97WA;EACE,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;A7Fg8WF;A6F97WA;EACE,+BAAA;EACA,8BAAA;A7Fg8WF;A6F97WA;EACE,yBAAA;E7Fg8WA,4BAA4B;E6F97W5B,yCAAA;EACA,WAAA;A7Fg8WF;A6F97WA;EACE,yBAAA;E7Fg8WA,4BAA4B;E6F97W5B,yCAAA;EACA,WAAA;A7Fg8WF;A6F97WA;EACE,cAAA;EACA,eAAA;A7Fg8WF;A6F97WA;EACE,sBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;A7Fg8WF;A6F97WA;EACE,sBAAA;EACA,iBAAA;EACA,UAAA;A7Fg8WF;A6F97WA;EACE,gBAAA;A7Fg8WF;A6F97WA;EACE,yBAAA;E7Fg8WA,4BAA4B;E6F97W5B,yCAAA;EACA,kBAAA;EACA,yBAAA;E7Fg8WA,4BAA4B;E6F97W5B,yCAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;A7Fg8WF;A6F97WA;;EAEE,qBAAA;EACA,sBAAA;A7Fg8WF;A6F97WA;EACE,+BAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;A7Fg8WF;A6F97WA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;A7Fg8WF;A6F97WA;EACE,0BAAA;A7Fg8WF;A6F97WA;EACE,eAAA;EACA,8BAAA;EACA,2BAAA;EACA,+BAAA;E7Fg8WA,4BAA4B;E6F97W5B,+CAAA;EACA,oBAAA;A7Fg8WF;A6F97WA;;EAEE,yBAAA;E7Fg8WA,4BAA4B;E6F97W5B,yCAAA;EACA,cAAA;A7Fg8WF;A6F97WA;EACE,yBAAA;E7Fg8WA,4BAA4B;E6F97W5B,yCAAA;A7Fg8WF;A6F97WA;EACE,yBAAA;EACA,yBAAA;EACA,WAAA;A7Fg8WF;A6F97WA;EACE,mBAAA;EACA,+BAAA;A7Fg8WF;A6F97WA;;;EAGE,yBAAA;A7Fg8WF;A6F97WA;EACE;IACE,wBAAA;E7Fg8WF;AACF;AAMA;;;iEAGiE;AAxxXjE;;;;;;EACE,gCAAA;EACA,gBAAA;EACA,wBAAA;EACA,0BAAA;AA+xXF;AA5xXA;;;EACE,mBAAA;EACA,4BAAA;AAgyXF;AA7xXA;EACI,gCAAA;EACA,gBAAA;EACA,0BAAA;EACA,iCAAA;AA+xXJ;AA5xXA;EACI,SAAA;AA8xXJ;AA3xXA;EACE,eAAA;AA6xXF;AA1xXA;EACI,kBAAA;AA4xXJ;AAzxXA;EWxDE,gBAAA;EACA,uBAAA;EACA,mBAAA;AXo1XF;AA3xXA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AA6xXF;AAjyXA;EAMI,iBAAA;AA8xXJ;AA3xXA;EACE,gBAAA;EACA,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA6xXF;AA3xXA;EqFjEE,gCAAA;EACA,eAAA;EACA,gBAAA;ErFkEE,eAAA;EACA,cAAA;AA8xXJ;AAlyXA;EAOI,cAAA;EACA,iBAAA;AA8xXJ;AA3xXA;EACI,kBAAA;AA6xXJ;AA9xXA;EAGQ,aAAA;AA8xXR;AA3xXA;EACI,yBAAA;AA6xXJ;AA3xXA;EACI;IACI,kBAAA;EA6xXN;EA3xXE;IACI,kBAAA;EA6xXN;AACF;AA1xXA;EACI,gCAAA;EACA,0BAAA;EACA,YAAA;EACA,sBAAA;EqFpFF,+BAAA;ErFsFE,iBAAA;EACA,qCAAA;EACA,sCAAA;EACA,4BAAA;AA4xXJ;AA1xXI;EACI,kCAAA;AA4xXR;AAzxXI;EACI,kCAAA;EACA,4CAAA;EACA,aAAA;AA2xXR;AAxxXI;EACE,4BAAA;AA0xXN;AA3xXI;EACE,4BAAA;AA0xXN;AAxxXI;EACE,4BAAA;AA0xXN;AAtxXA;EACE,YAAA;AAwxXF;AArxXA;EACI,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,gCAAA;EACA,+BAAA;EACA,qCAAA;AAuxXJ;AApxXA;EACI,aAAA;EACA,uBAAA;AAsxXJ;AAnxXA;EACI,gCAAA;EACA,YAAA;EACA,gBAAA;EACA,sCAAA;EACA,+BAAA;EACA,YAAA;AAqxXJ;AAnxXI;EACI,YAAA;EACA,uBAAA;EACA,4BAAA;AAqxXR;AAnxXI;;EACI,YAAA;EACA,uBAAA;AAsxXR;AAlxXA;EACI,kBAAA;EACA,gBAAA;AAoxXJ;AAjxXA;EACI,aAAA;AAmxXJ;AAhxXA;EACI;IAEQ,MAAA;IACA,kBAAA;IACA,WAAA;EAixXV;EA7wXE;IACI,UAAA;EA+wXN;EA5wXE;IACI,aAAA;IACA,OAAA;IACA,aAAA;IACA,gBAAA;IACA,cAAA;IACA,wBAAA;IACA,6BAAA;IACA,2BAAA;IACA,gBAAA;IACA,kCAAA;IACA,yCAAA;IACA,uCAAA;IACA,sBAAA;EA8wXN;EA3xXE;IAeQ,eAAA;IACA,cAAA;IACA,iBAAA;IACA,kBAAA;EA+wXV;EAjyXE;IAqBQ,gBAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;EA+wXV;EAvyXE;IA0BY,cAAA;IACA,cAAA;IACA,mBAAA;EAgxXd;EA7wXM;IACI,wBAAA;IACA,mBAAA;IACA,2CAAA;IACA,yCAAA;EA+wXV;EA3wXE;IACI,aAAA;EA6wXN;AACF;AA1wXA;EACE,gBAAA;AA4wXF;AAzwXA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AA2wXF;AAzwXE;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;AA2wXJ;AApxXA;EAaI,6BAAA;EACA,YAAA;AA0wXJ;AAxxXA;EAiBM,4BAAA;AA0wXN;AAzwXM;;EACE,0BAAA;AA4wXR;AA/xXA;EAwBM,0BAAA;AA0wXN;AAzwXM;;EACE,0BAAA;AA4wXR;AAvwXE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAywXJ;AAvwXI;EAAA;IACE,WAAA;EA0wXJ;AACF;AAtwXA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAwwXJ;AAvwXI;EAAA;IACI,kBAAA;IACA,sBAAA;IACA,uBAAA;EA0wXN;AACF;AAtwXE;EAAA;IAEI,gBAAA;EAwwXJ;AACF;AAnwXI;EAAA;IACI,gCAAA;IACA,kBAAA;IACA,oBAAA;EAswXN;AACF;AAlwXI;EAAA;IACI,gBAAA;EAqwXN;EAtwXE;;IAGQ,0BAAA;EAuwXV;AACF;AAnwXA;EACI,kBAAA;EACA,qBAAA;AAqwXJ;AAnwXA;EACI,gBAAA;AAqwXJ;AAlwXA;EAEI,qBAAA;AAmwXJ;AA7vXA;;EACE,gBAAA;EACA,uBAAA;AAgwXF;AA7vXA;;EAEQ,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AA+vXR;AA1vXI;EAAA;IACI,wBAAA;EA6vXN;AACF;AA1vXA;EAEI,aAAA;AA2vXJ;AAxvXE;EAAA;IAEI,qBAAA;EA0vXJ;AACF;AAvvXE;EAAA;IAEI,aAAA;EAyvXJ;AACF;AArvXA;EAEQ,gBAAA;EACA,gBAAA;EACA,uBAAA;AAsvXR;AAlvXA;EACI,aAAA;AAovXJ;AArvXA;EAGQ,YAAA;EACA,SAAA;EACA,iBAAA;EACA,0BAAA;AAqvXR;AA3vXA;EAUQ,OAAA;AAovXR;AA9vXA;EAcQ,OAAA;AAmvXR;AAjwXA;EAmBQ,gBAAA;AAivXR;AApwXA;EAsBQ,0BAAA;EACA,6BAAA;AAivXR;AAxwXA;EA0BQ,yBAAA;EACA,4BAAA;AAivXR;AA5wXA;EA8BQ,iBAAA;AAivXR;AA9uXI;EAAA;IAEQ,aAAA;EAgvXV;EAlvXE;IAKQ,6BAAA;EAgvXV;AACF;AA5uXA;EACI,8BAAA;AA8uXJ;AA7uXI;EACI,gBAAA;EACA,uBAAA;AA+uXR;AA3uXA;EAEI,eAAA;AA4uXJ;AA9uXA;EAMI,eAAA;AA2uXJ;AAjvXA;EAUI,eAAA;AA0uXJ;AApvXA;EAcI,mBAAA;AAyuXJ;AAtuXE;EAAA;IACE,aAAA;EAyuXF;AACF;AAtuXA;EACE,YAAA;AAwuXF;AAtuXE;EAAA;IACE,YAAA;EAyuXF;AACF","sourcesContent":["@import '../../node_modules/bootstrap/less/bootstrap.less';\n@import '../../node_modules/font-awesome/less/font-awesome.less';\n@import '../../node_modules/animate.css/animate.css';\n\n@import \"breadcrumb.less\";\n@import \"company.less\";\n@import \"customer.less\";\n@import \"event.less\";\n@import \"fonts.less\";\n@import \"loader.less\";\n@import \"lookhere_vars.less\";\n@import \"home.less\";\n@import \"tools.less\";\n@import \"video-chat.less\";\n@import \"offline.less\";\n@import \"offline-german-indicator.less\";\n@import \"order.less\";\n@import \"lh-btn.less\";\n@import \"react-select.less\";\n\n/* ============================================================\n   CUSTOM STYLES – Full modern dark redesign.\n   This must be the LAST import so it takes precedence.\n   ============================================================ */\n@import (css) \"../custom_styles.css\";\n\n\n@body-bg: @gray-lighter;\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Inter', sans-serif;\n  font-weight: 900;\n  letter-spacing: -0.025em;\n  color: var(--text-primary);\n}\n\n.text-sm, .text-muted, .customer-sub-title {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\nbody {\n    font-family: 'Inter', sans-serif;\n    font-weight: 400;\n    color: var(--text-primary);\n    background-color: var(--bg-color);\n}\n\np {\n    margin: 0;\n}\n\na {\n  font-size: 15px;\n}\n\n.relative {\n    position: relative;\n}\n\n.text-overflow {\n    .text-overflow();\n}\n.user-header {\n  margin-top: 22px;\n  text-align: right;\n  position: absolute;\n  right: 40px;\n  a {\n    margin-left: 20px;\n  }\n}\n.panel-title {\n  font-weight: 900;\n  letter-spacing: -0.025em;\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: 18px; // scaled up visually by weight\n  color: inherit;\n}\n.media-body {\n  h4 {\n    .Lato();\n    font-size: 18px;\n    color: #154261;\n  }\n  span {\n    color: #849099;\n    margin-right: 5px;\n  }\n}\n.list-group {\n    margin: 20px 0 0 0;\n    .picture {\n        height: 240px;\n    }\n}\na.list-group-item:hover {\n    background-color: #F7FBFC;\n}\n@media (min-width: @screen-xs-min) {\n    .list-group {\n        margin: 40px 0 0 0;\n    }\n    .list-group-item {\n        padding: 20px 15px;\n    }\n}\n\n.form-control {\n    background: var(--surface-color);\n    color: var(--text-primary);\n    height: 50px;\n    box-sizing: border-box;\n    .roundcorners();\n    padding: 8px 15px;\n    border: 1px solid var(--border-color);\n    transition: all var(--transition-fast);\n    box-shadow: var(--shadow-sm);\n\n    &:hover {\n        border-color: var(--primary-hover);\n    }\n\n    &:focus {\n        border-color: var(--primary-color);\n        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);\n        outline: none;\n    }\n\n    &:placeholder-shown {\n      color: var(--text-secondary);\n    }\n    &::-webkit-input-placeholder {\n      color: var(--text-secondary);\n    }\n}\n\n.search-input .form-control {\n  height: 34px;\n}\n\n.chat-input .form-control {\n    height: 34px;\n    padding: 6px 12px;\n    line-height: 1.42857143;\n    background: var(--surface-color);\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border-color);\n}\n\n.row-centered {\n    display: flex;\n    justify-content: center;\n}\n\n.btn-green {\n    background: var(--success-color);\n    color: white;\n    font-weight: 500;\n    transition: all var(--transition-fast);\n    border-radius: var(--radius-md);\n    border: none;\n    \n    &:hover {\n        color: white;\n        filter: brightness(0.9);\n        box-shadow: var(--shadow-md);\n    }\n    &:active, &:focus {\n        color: white;\n        filter: brightness(0.8);\n    }\n}\n\n#app {\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.user-header i {\n    display: none;\n}\n\n@media (max-width: @screen-md-max) {\n    .header {\n        .edit-user {\n            top: 0;\n            position: absolute;\n            right: 15px;\n        }\n    }\n\n    .container.shrink {\n        padding: 0;\n    }\n\n    .user-header {\n        margin-top: 0;\n        left: 0;\n        padding: 15px;\n        overflow: hidden;\n        z-index: 19999;\n        transform: translateZ(0);\n        transform: translateX(-139px);\n        transition: .2s linear all;\n        text-align: left;\n        background: rgba(255,255,255,0);\n        border-bottom: 1px solid rgba(0,0,0,0);\n        border-left: 1px solid rgba(0,0,0,0);\n        right: auto !important;\n        i {\n            font-size: 20px;\n            display: block;\n            text-align: right;\n            padding-right: 5px;\n        }\n        .menu {\n            margin-top: 10px;\n            margin-right: 42px;\n            text-align: left;\n            background: rgba(255,255,255,1);\n            > * {\n                display: block;\n                margin-left: 0;\n                margin-bottom: 10px;\n            }\n        }\n        &.active {\n            transform: translateX(0);\n            background: rgba(255,255,255,1);\n            border-bottom: 1px solid rgba(0,0,0,0.1);\n            border-left: 1px solid rgba(0,0,0,0.1);\n        }\n    }\n\n    .back-link {\n        display: none;\n    }\n}\n\n.container {\n  overflow: hidden;\n}\n\n.navigation {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n\n  & > .navbar {\n    flex: none;\n    border: none;\n    margin-bottom: 0;\n    background-color: transparent;\n  }\n\n  .navbar-default {\n    background-color: transparent;\n    border: none;\n    \n    .navbar-nav > li > a {\n      color: var(--text-secondary);\n      &:hover, &:focus {\n        color: var(--text-primary);\n      }\n    }\n    \n    .navbar-brand {\n      color: var(--text-primary);\n      &:hover, &:focus {\n        color: var(--text-primary);\n      }\n    }\n  }\n\n  & > .content-bg {\n    flex: auto;\n    display: flex;\n    flex-direction: column;\n    background: transparent;\n    overflow-y: auto;\n\n    @media (max-width: @screen-xs-max) {\n      width: 100%;\n    }\n  }\n}\n\n.navbar-right {\n    display: flex;\n    align-items: center;\n    margin-right: 0;\n    @media (max-width: @screen-xs-max) {\n        padding-left: 10px;\n        flex-direction: column;\n        align-items: flex-start;\n    }\n}\n\n.navbar-collapse {\n  @media (max-width: @screen-xs-max) {\n    a {\n      text-align: left;\n    }\n  }\n}\n\n.breadcrumb-menu {\n    @media (max-width: @screen-xs-max) {\n        border-bottom: 1px solid #d6d6d6;\n        text-align: center;\n        padding-bottom: 10px;\n    }\n}\n\n.user-menu {\n    @media (max-width: @screen-xs-max) {\n        margin-top: 10px;\n        span, a {\n            padding: 10px 0 !important;\n        }\n    }\n}\n\npre {\n    border-radius: 3px;\n    border-color: #d6d6d6;\n}\n.help-block {\n    overflow: hidden;\n}\n\n.dropdown-menu > li > a {\n    // for long order names in order dropdown\n    white-space: pre-wrap;\n}\n\n// ############################\n// Crazy text overflow fixes\n// ###########################\n.company-name, .customer-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.user-menu li {\n    a, span {\n        max-width: 200px;\n        max-height: 50px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n}\n\n.hide-md {\n    @media (max-width: @screen-md-max) {\n        display: none !important;\n    }\n}\n\n.menu-item-responsive {\n  i {\n    display: none;\n  }\n\n  @media (max-width: @screen-md-max) {\n    i {\n      display: inline-block;\n    }\n  }\n\n  @media (min-width: @screen-sm-min) and (max-width: @screen-md-max) {\n    span {\n      display: none;\n    }\n  }\n}\n\n.lh-modal {\n    p {\n        max-width: 560px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n}\n\n.lh-btn-group {\n    display: flex;\n    > * {\n        height: 44px;\n        margin: 0;\n        line-height: 44px;\n        padding: 0 18px !important;\n    }\n\n    pre {\n        flex: 1;\n    }\n\n    button {\n        flex: 0;\n    }\n\n    // stolen from bootstraps btn-group...\n    >*:not(:first-child):not(:last-child) {\n        border-radius: 0;\n    }\n    >*:first-child:not(:last-child) {\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n    >*:last-child:not(:first-child) {\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n    *+* {\n        margin-left: -1px;\n    }\n\n    @media (max-width: @screen-xs-max) {\n        pre {\n            display: none;\n        }\n        >* {\n            border-radius: 3px !important;\n        }\n    }\n}\n\n.dropdown-menu {\n    max-width: ~\"calc(100vw - 150px)\";\n    & > li > a {\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n}\n\n.terms {\n  h1 {\n    font-size: 34px;\n  }\n\n  h2 {\n    font-size: 28px;\n  }\n\n  h3 {\n    font-size: 22px;\n  }\n\n  p {\n    margin-bottom: 10px;\n  }\n\n  @media (max-width: @screen-md-max) {\n    padding: 30px;\n  }\n}\n\nimg.logo {\n  width: 400px;\n\n  @media (max-width: @screen-sm-max) {\n    width: 300px;\n  }\n}\n","// stylelint-disable\n\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */\n\n//\n// 1. Set default font family to sans-serif.\n// 2. Prevent iOS and IE text size adjust after device orientation change,\n//    without disabling user zoom.\n//\n\nhtml {\n  font-family: sans-serif; // 1\n  -ms-text-size-adjust: 100%; // 2\n  -webkit-text-size-adjust: 100%; // 2\n}\n\n//\n// Remove default margin.\n//\n\nbody {\n  margin: 0;\n}\n\n// HTML5 display definitions\n// ==========================================================================\n\n//\n// Correct `block` display not defined for any HTML5 element in IE 8/9.\n// Correct `block` display not defined for `details` or `summary` in IE 10/11\n// and Firefox.\n// Correct `block` display not defined for `main` in IE 11.\n//\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\n\n//\n// 1. Correct `inline-block` display not defined in IE 8/9.\n// 2. Normalize vertical alignment of `progress` in Chrome, Firefox, and Opera.\n//\n\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block; // 1\n  vertical-align: baseline; // 2\n}\n\n//\n// Prevent modern browsers from displaying `audio` without controls.\n// Remove excess height in iOS 5 devices.\n//\n\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n//\n// Address `[hidden]` styling not present in IE 8/9/10.\n// Hide the `template` element in IE 8/9/10/11, Safari, and Firefox < 22.\n//\n\n[hidden],\ntemplate {\n  display: none;\n}\n\n// Links\n// ==========================================================================\n\n//\n// Remove the gray background color from active links in IE 10.\n//\n\na {\n  background-color: transparent;\n}\n\n//\n// Improve readability of focused elements when they are also in an\n// active/hover state.\n//\n\na:active,\na:hover {\n  outline: 0;\n}\n\n// Text-level semantics\n// ==========================================================================\n\n//\n// 1. Remove the bottom border in Chrome 57- and Firefox 39-.\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n//\n\nabbr[title] {\n  border-bottom: none; // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n}\n\n//\n// Address style set to `bolder` in Firefox 4+, Safari, and Chrome.\n//\n\nb,\nstrong {\n  font-weight: bold;\n}\n\n//\n// Address styling not present in Safari and Chrome.\n//\n\ndfn {\n  font-style: italic;\n}\n\n//\n// Address variable `h1` font-size and margin within `section` and `article`\n// contexts in Firefox 4+, Safari, and Chrome.\n//\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n//\n// Address styling not present in IE 8/9.\n//\n\nmark {\n  background: #ff0;\n  color: #000;\n}\n\n//\n// Address inconsistent and variable font size in all browsers.\n//\n\nsmall {\n  font-size: 80%;\n}\n\n//\n// Prevent `sub` and `sup` affecting `line-height` in all browsers.\n//\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsup {\n  top: -0.5em;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\n// Embedded content\n// ==========================================================================\n\n//\n// Remove border when inside `a` element in IE 8/9/10.\n//\n\nimg {\n  border: 0;\n}\n\n//\n// Correct overflow not hidden in IE 9/10/11.\n//\n\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n// Grouping content\n// ==========================================================================\n\n//\n// Address margin not present in IE 8/9 and Safari.\n//\n\nfigure {\n  margin: 1em 40px;\n}\n\n//\n// Address differences between Firefox and other browsers.\n//\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n}\n\n//\n// Contain overflow in all browsers.\n//\n\npre {\n  overflow: auto;\n}\n\n//\n// Address odd `em`-unit font size rendering in all browsers.\n//\n\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n\n// Forms\n// ==========================================================================\n\n//\n// Known limitation: by default, Chrome and Safari on OS X allow very limited\n// styling of `select`, unless a `border` property is set.\n//\n\n//\n// 1. Correct color not being inherited.\n//    Known issue: affects color of disabled elements.\n// 2. Correct font properties not being inherited.\n// 3. Address margins set differently in Firefox 4+, Safari, and Chrome.\n//\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  color: inherit; // 1\n  font: inherit; // 2\n  margin: 0; // 3\n}\n\n//\n// Address `overflow` set to `hidden` in IE 8/9/10/11.\n//\n\nbutton {\n  overflow: visible;\n}\n\n//\n// Address inconsistent `text-transform` inheritance for `button` and `select`.\n// All other form control elements do not inherit `text-transform` values.\n// Correct `button` style inheritance in Firefox, IE 8/9/10/11, and Opera.\n// Correct `select` style inheritance in Firefox.\n//\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n//\n// 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native `audio`\n//    and `video` controls.\n// 2. Correct inability to style clickable `input` types in iOS.\n// 3. Improve usability and consistency of cursor style between image-type\n//    `input` and others.\n//\n\nbutton,\nhtml input[type=\"button\"], // 1\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n  cursor: pointer; // 3\n}\n\n//\n// Re-set default cursor for disabled elements.\n//\n\nbutton[disabled],\nhtml input[disabled] {\n  cursor: default;\n}\n\n//\n// Remove inner padding and border in Firefox 4+.\n//\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n//\n// Address Firefox 4+ setting `line-height` on `input` using `!important` in\n// the UA stylesheet.\n//\n\ninput {\n  line-height: normal;\n}\n\n//\n// It's recommended that you don't attempt to style these elements.\n// Firefox's implementation doesn't respect box-sizing, padding, or width.\n//\n// 1. Address box sizing set to `content-box` in IE 8/9/10.\n// 2. Remove excess padding in IE 8/9/10.\n//\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box; // 1\n  padding: 0; // 2\n}\n\n//\n// Fix the cursor style for Chrome's increment/decrement buttons. For certain\n// `font-size` values of the `input`, it causes the cursor style of the\n// decrement button to change from `default` to `text`.\n//\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n//\n// 1. Address `appearance` set to `searchfield` in Safari and Chrome.\n// 2. Address `box-sizing` set to `border-box` in Safari and Chrome.\n//\n\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  box-sizing: content-box; //2\n}\n\n//\n// Remove inner padding and search cancel button in Safari and Chrome on OS X.\n// Safari (but not Chrome) clips the cancel button when the search input has\n// padding (and `textfield` appearance).\n//\n\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// Define consistent border, margin, and padding.\n//\n\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n\n//\n// 1. Correct `color` not being inherited in IE 8/9/10/11.\n// 2. Remove padding so people aren't caught out if they zero out fieldsets.\n//\n\nlegend {\n  border: 0; // 1\n  padding: 0; // 2\n}\n\n//\n// Remove default vertical scrollbar in IE 8/9/10/11.\n//\n\ntextarea {\n  overflow: auto;\n}\n\n//\n// Don't inherit the `font-weight` (applied by a rule above).\n// NOTE: the default cannot safely be changed in Chrome and Safari on OS X.\n//\n\noptgroup {\n  font-weight: bold;\n}\n\n// Tables\n// ==========================================================================\n\n//\n// Remove most spacing between table cells.\n//\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\ntd,\nth {\n  padding: 0;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request: h5bp.com/r\n// ==========================================================================\n\n@media print {\n  *,\n  *:before,\n  *:after {\n    color: #000 !important; // Black prints faster: h5bp.com/s\n    text-shadow: none !important;\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n\n  a[href]:after {\n    content: \" (\" attr(href) \")\";\n  }\n\n  abbr[title]:after {\n    content: \" (\" attr(title) \")\";\n  }\n\n  // Don't show links that are fragment identifiers,\n  // or use the `javascript:` pseudo protocol\n  a[href^=\"#\"]:after,\n  a[href^=\"javascript:\"]:after {\n    content: \"\";\n  }\n\n  pre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n  }\n\n  thead {\n    display: table-header-group; // h5bp.com/t\n  }\n\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n\n  img {\n    max-width: 100% !important;\n  }\n\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n\n  // Bootstrap specific changes start\n\n  // Bootstrap components\n  .navbar {\n    display: none;\n  }\n  .btn,\n  .dropup > .btn {\n    > .caret {\n      border-top-color: #000 !important;\n    }\n  }\n  .label {\n    border: 1px solid #000;\n  }\n\n  .table {\n    border-collapse: collapse !important;\n\n    td,\n    th {\n      background-color: #fff !important;\n    }\n  }\n  .table-bordered {\n    th,\n    td {\n      border: 1px solid #ddd !important;\n    }\n  }\n}\n","// stylelint-disable value-list-comma-newline-after, value-list-comma-space-after, indentation, declaration-colon-newline-after, font-family-no-missing-generic-family-keyword\n\n//\n// Glyphicons for Bootstrap\n//\n// Since icons are fonts, they can be placed anywhere text is placed and are\n// thus automatically sized to match the surrounding child. To use, create an\n// inline element with the appropriate classes, like so:\n//\n// <a href=\"#\"><span class=\"glyphicon glyphicon-star\"></span> Star</a>\n\n// Import the fonts\n@font-face {\n  font-family: \"Glyphicons Halflings\";\n  src: url(\"@{icon-font-path}@{icon-font-name}.eot\");\n  src: url(\"@{icon-font-path}@{icon-font-name}.eot?#iefix\") format(\"embedded-opentype\"),\n       url(\"@{icon-font-path}@{icon-font-name}.woff2\") format(\"woff2\"),\n       url(\"@{icon-font-path}@{icon-font-name}.woff\") format(\"woff\"),\n       url(\"@{icon-font-path}@{icon-font-name}.ttf\") format(\"truetype\"),\n       url(\"@{icon-font-path}@{icon-font-name}.svg#@{icon-font-svg-id}\") format(\"svg\");\n}\n\n// Catchall baseclass\n.glyphicon {\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  font-family: \"Glyphicons Halflings\";\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// Individual icons\n.glyphicon-asterisk               { &:before { content: \"\\002a\"; } }\n.glyphicon-plus                   { &:before { content: \"\\002b\"; } }\n.glyphicon-euro,\n.glyphicon-eur                    { &:before { content: \"\\20ac\"; } }\n.glyphicon-minus                  { &:before { content: \"\\2212\"; } }\n.glyphicon-cloud                  { &:before { content: \"\\2601\"; } }\n.glyphicon-envelope               { &:before { content: \"\\2709\"; } }\n.glyphicon-pencil                 { &:before { content: \"\\270f\"; } }\n.glyphicon-glass                  { &:before { content: \"\\e001\"; } }\n.glyphicon-music                  { &:before { content: \"\\e002\"; } }\n.glyphicon-search                 { &:before { content: \"\\e003\"; } }\n.glyphicon-heart                  { &:before { content: \"\\e005\"; } }\n.glyphicon-star                   { &:before { content: \"\\e006\"; } }\n.glyphicon-star-empty             { &:before { content: \"\\e007\"; } }\n.glyphicon-user                   { &:before { content: \"\\e008\"; } }\n.glyphicon-film                   { &:before { content: \"\\e009\"; } }\n.glyphicon-th-large               { &:before { content: \"\\e010\"; } }\n.glyphicon-th                     { &:before { content: \"\\e011\"; } }\n.glyphicon-th-list                { &:before { content: \"\\e012\"; } }\n.glyphicon-ok                     { &:before { content: \"\\e013\"; } }\n.glyphicon-remove                 { &:before { content: \"\\e014\"; } }\n.glyphicon-zoom-in                { &:before { content: \"\\e015\"; } }\n.glyphicon-zoom-out               { &:before { content: \"\\e016\"; } }\n.glyphicon-off                    { &:before { content: \"\\e017\"; } }\n.glyphicon-signal                 { &:before { content: \"\\e018\"; } }\n.glyphicon-cog                    { &:before { content: \"\\e019\"; } }\n.glyphicon-trash                  { &:before { content: \"\\e020\"; } }\n.glyphicon-home                   { &:before { content: \"\\e021\"; } }\n.glyphicon-file                   { &:before { content: \"\\e022\"; } }\n.glyphicon-time                   { &:before { content: \"\\e023\"; } }\n.glyphicon-road                   { &:before { content: \"\\e024\"; } }\n.glyphicon-download-alt           { &:before { content: \"\\e025\"; } }\n.glyphicon-download               { &:before { content: \"\\e026\"; } }\n.glyphicon-upload                 { &:before { content: \"\\e027\"; } }\n.glyphicon-inbox                  { &:before { content: \"\\e028\"; } }\n.glyphicon-play-circle            { &:before { content: \"\\e029\"; } }\n.glyphicon-repeat                 { &:before { content: \"\\e030\"; } }\n.glyphicon-refresh                { &:before { content: \"\\e031\"; } }\n.glyphicon-list-alt               { &:before { content: \"\\e032\"; } }\n.glyphicon-lock                   { &:before { content: \"\\e033\"; } }\n.glyphicon-flag                   { &:before { content: \"\\e034\"; } }\n.glyphicon-headphones             { &:before { content: \"\\e035\"; } }\n.glyphicon-volume-off             { &:before { content: \"\\e036\"; } }\n.glyphicon-volume-down            { &:before { content: \"\\e037\"; } }\n.glyphicon-volume-up              { &:before { content: \"\\e038\"; } }\n.glyphicon-qrcode                 { &:before { content: \"\\e039\"; } }\n.glyphicon-barcode                { &:before { content: \"\\e040\"; } }\n.glyphicon-tag                    { &:before { content: \"\\e041\"; } }\n.glyphicon-tags                   { &:before { content: \"\\e042\"; } }\n.glyphicon-book                   { &:before { content: \"\\e043\"; } }\n.glyphicon-bookmark               { &:before { content: \"\\e044\"; } }\n.glyphicon-print                  { &:before { content: \"\\e045\"; } }\n.glyphicon-camera                 { &:before { content: \"\\e046\"; } }\n.glyphicon-font                   { &:before { content: \"\\e047\"; } }\n.glyphicon-bold                   { &:before { content: \"\\e048\"; } }\n.glyphicon-italic                 { &:before { content: \"\\e049\"; } }\n.glyphicon-text-height            { &:before { content: \"\\e050\"; } }\n.glyphicon-text-width             { &:before { content: \"\\e051\"; } }\n.glyphicon-align-left             { &:before { content: \"\\e052\"; } }\n.glyphicon-align-center           { &:before { content: \"\\e053\"; } }\n.glyphicon-align-right            { &:before { content: \"\\e054\"; } }\n.glyphicon-align-justify          { &:before { content: \"\\e055\"; } }\n.glyphicon-list                   { &:before { content: \"\\e056\"; } }\n.glyphicon-indent-left            { &:before { content: \"\\e057\"; } }\n.glyphicon-indent-right           { &:before { content: \"\\e058\"; } }\n.glyphicon-facetime-video         { &:before { content: \"\\e059\"; } }\n.glyphicon-picture                { &:before { content: \"\\e060\"; } }\n.glyphicon-map-marker             { &:before { content: \"\\e062\"; } }\n.glyphicon-adjust                 { &:before { content: \"\\e063\"; } }\n.glyphicon-tint                   { &:before { content: \"\\e064\"; } }\n.glyphicon-edit                   { &:before { content: \"\\e065\"; } }\n.glyphicon-share                  { &:before { content: \"\\e066\"; } }\n.glyphicon-check                  { &:before { content: \"\\e067\"; } }\n.glyphicon-move                   { &:before { content: \"\\e068\"; } }\n.glyphicon-step-backward          { &:before { content: \"\\e069\"; } }\n.glyphicon-fast-backward          { &:before { content: \"\\e070\"; } }\n.glyphicon-backward               { &:before { content: \"\\e071\"; } }\n.glyphicon-play                   { &:before { content: \"\\e072\"; } }\n.glyphicon-pause                  { &:before { content: \"\\e073\"; } }\n.glyphicon-stop                   { &:before { content: \"\\e074\"; } }\n.glyphicon-forward                { &:before { content: \"\\e075\"; } }\n.glyphicon-fast-forward           { &:before { content: \"\\e076\"; } }\n.glyphicon-step-forward           { &:before { content: \"\\e077\"; } }\n.glyphicon-eject                  { &:before { content: \"\\e078\"; } }\n.glyphicon-chevron-left           { &:before { content: \"\\e079\"; } }\n.glyphicon-chevron-right          { &:before { content: \"\\e080\"; } }\n.glyphicon-plus-sign              { &:before { content: \"\\e081\"; } }\n.glyphicon-minus-sign             { &:before { content: \"\\e082\"; } }\n.glyphicon-remove-sign            { &:before { content: \"\\e083\"; } }\n.glyphicon-ok-sign                { &:before { content: \"\\e084\"; } }\n.glyphicon-question-sign          { &:before { content: \"\\e085\"; } }\n.glyphicon-info-sign              { &:before { content: \"\\e086\"; } }\n.glyphicon-screenshot             { &:before { content: \"\\e087\"; } }\n.glyphicon-remove-circle          { &:before { content: \"\\e088\"; } }\n.glyphicon-ok-circle              { &:before { content: \"\\e089\"; } }\n.glyphicon-ban-circle             { &:before { content: \"\\e090\"; } }\n.glyphicon-arrow-left             { &:before { content: \"\\e091\"; } }\n.glyphicon-arrow-right            { &:before { content: \"\\e092\"; } }\n.glyphicon-arrow-up               { &:before { content: \"\\e093\"; } }\n.glyphicon-arrow-down             { &:before { content: \"\\e094\"; } }\n.glyphicon-share-alt              { &:before { content: \"\\e095\"; } }\n.glyphicon-resize-full            { &:before { content: \"\\e096\"; } }\n.glyphicon-resize-small           { &:before { content: \"\\e097\"; } }\n.glyphicon-exclamation-sign       { &:before { content: \"\\e101\"; } }\n.glyphicon-gift                   { &:before { content: \"\\e102\"; } }\n.glyphicon-leaf                   { &:before { content: \"\\e103\"; } }\n.glyphicon-fire                   { &:before { content: \"\\e104\"; } }\n.glyphicon-eye-open               { &:before { content: \"\\e105\"; } }\n.glyphicon-eye-close              { &:before { content: \"\\e106\"; } }\n.glyphicon-warning-sign           { &:before { content: \"\\e107\"; } }\n.glyphicon-plane                  { &:before { content: \"\\e108\"; } }\n.glyphicon-calendar               { &:before { content: \"\\e109\"; } }\n.glyphicon-random                 { &:before { content: \"\\e110\"; } }\n.glyphicon-comment                { &:before { content: \"\\e111\"; } }\n.glyphicon-magnet                 { &:before { content: \"\\e112\"; } }\n.glyphicon-chevron-up             { &:before { content: \"\\e113\"; } }\n.glyphicon-chevron-down           { &:before { content: \"\\e114\"; } }\n.glyphicon-retweet                { &:before { content: \"\\e115\"; } }\n.glyphicon-shopping-cart          { &:before { content: \"\\e116\"; } }\n.glyphicon-folder-close           { &:before { content: \"\\e117\"; } }\n.glyphicon-folder-open            { &:before { content: \"\\e118\"; } }\n.glyphicon-resize-vertical        { &:before { content: \"\\e119\"; } }\n.glyphicon-resize-horizontal      { &:before { content: \"\\e120\"; } }\n.glyphicon-hdd                    { &:before { content: \"\\e121\"; } }\n.glyphicon-bullhorn               { &:before { content: \"\\e122\"; } }\n.glyphicon-bell                   { &:before { content: \"\\e123\"; } }\n.glyphicon-certificate            { &:before { content: \"\\e124\"; } }\n.glyphicon-thumbs-up              { &:before { content: \"\\e125\"; } }\n.glyphicon-thumbs-down            { &:before { content: \"\\e126\"; } }\n.glyphicon-hand-right             { &:before { content: \"\\e127\"; } }\n.glyphicon-hand-left              { &:before { content: \"\\e128\"; } }\n.glyphicon-hand-up                { &:before { content: \"\\e129\"; } }\n.glyphicon-hand-down              { &:before { content: \"\\e130\"; } }\n.glyphicon-circle-arrow-right     { &:before { content: \"\\e131\"; } }\n.glyphicon-circle-arrow-left      { &:before { content: \"\\e132\"; } }\n.glyphicon-circle-arrow-up        { &:before { content: \"\\e133\"; } }\n.glyphicon-circle-arrow-down      { &:before { content: \"\\e134\"; } }\n.glyphicon-globe                  { &:before { content: \"\\e135\"; } }\n.glyphicon-wrench                 { &:before { content: \"\\e136\"; } }\n.glyphicon-tasks                  { &:before { content: \"\\e137\"; } }\n.glyphicon-filter                 { &:before { content: \"\\e138\"; } }\n.glyphicon-briefcase              { &:before { content: \"\\e139\"; } }\n.glyphicon-fullscreen             { &:before { content: \"\\e140\"; } }\n.glyphicon-dashboard              { &:before { content: \"\\e141\"; } }\n.glyphicon-paperclip              { &:before { content: \"\\e142\"; } }\n.glyphicon-heart-empty            { &:before { content: \"\\e143\"; } }\n.glyphicon-link                   { &:before { content: \"\\e144\"; } }\n.glyphicon-phone                  { &:before { content: \"\\e145\"; } }\n.glyphicon-pushpin                { &:before { content: \"\\e146\"; } }\n.glyphicon-usd                    { &:before { content: \"\\e148\"; } }\n.glyphicon-gbp                    { &:before { content: \"\\e149\"; } }\n.glyphicon-sort                   { &:before { content: \"\\e150\"; } }\n.glyphicon-sort-by-alphabet       { &:before { content: \"\\e151\"; } }\n.glyphicon-sort-by-alphabet-alt   { &:before { content: \"\\e152\"; } }\n.glyphicon-sort-by-order          { &:before { content: \"\\e153\"; } }\n.glyphicon-sort-by-order-alt      { &:before { content: \"\\e154\"; } }\n.glyphicon-sort-by-attributes     { &:before { content: \"\\e155\"; } }\n.glyphicon-sort-by-attributes-alt { &:before { content: \"\\e156\"; } }\n.glyphicon-unchecked              { &:before { content: \"\\e157\"; } }\n.glyphicon-expand                 { &:before { content: \"\\e158\"; } }\n.glyphicon-collapse-down          { &:before { content: \"\\e159\"; } }\n.glyphicon-collapse-up            { &:before { content: \"\\e160\"; } }\n.glyphicon-log-in                 { &:before { content: \"\\e161\"; } }\n.glyphicon-flash                  { &:before { content: \"\\e162\"; } }\n.glyphicon-log-out                { &:before { content: \"\\e163\"; } }\n.glyphicon-new-window             { &:before { content: \"\\e164\"; } }\n.glyphicon-record                 { &:before { content: \"\\e165\"; } }\n.glyphicon-save                   { &:before { content: \"\\e166\"; } }\n.glyphicon-open                   { &:before { content: \"\\e167\"; } }\n.glyphicon-saved                  { &:before { content: \"\\e168\"; } }\n.glyphicon-import                 { &:before { content: \"\\e169\"; } }\n.glyphicon-export                 { &:before { content: \"\\e170\"; } }\n.glyphicon-send                   { &:before { content: \"\\e171\"; } }\n.glyphicon-floppy-disk            { &:before { content: \"\\e172\"; } }\n.glyphicon-floppy-saved           { &:before { content: \"\\e173\"; } }\n.glyphicon-floppy-remove          { &:before { content: \"\\e174\"; } }\n.glyphicon-floppy-save            { &:before { content: \"\\e175\"; } }\n.glyphicon-floppy-open            { &:before { content: \"\\e176\"; } }\n.glyphicon-credit-card            { &:before { content: \"\\e177\"; } }\n.glyphicon-transfer               { &:before { content: \"\\e178\"; } }\n.glyphicon-cutlery                { &:before { content: \"\\e179\"; } }\n.glyphicon-header                 { &:before { content: \"\\e180\"; } }\n.glyphicon-compressed             { &:before { content: \"\\e181\"; } }\n.glyphicon-earphone               { &:before { content: \"\\e182\"; } }\n.glyphicon-phone-alt              { &:before { content: \"\\e183\"; } }\n.glyphicon-tower                  { &:before { content: \"\\e184\"; } }\n.glyphicon-stats                  { &:before { content: \"\\e185\"; } }\n.glyphicon-sd-video               { &:before { content: \"\\e186\"; } }\n.glyphicon-hd-video               { &:before { content: \"\\e187\"; } }\n.glyphicon-subtitles              { &:before { content: \"\\e188\"; } }\n.glyphicon-sound-stereo           { &:before { content: \"\\e189\"; } }\n.glyphicon-sound-dolby            { &:before { content: \"\\e190\"; } }\n.glyphicon-sound-5-1              { &:before { content: \"\\e191\"; } }\n.glyphicon-sound-6-1              { &:before { content: \"\\e192\"; } }\n.glyphicon-sound-7-1              { &:before { content: \"\\e193\"; } }\n.glyphicon-copyright-mark         { &:before { content: \"\\e194\"; } }\n.glyphicon-registration-mark      { &:before { content: \"\\e195\"; } }\n.glyphicon-cloud-download         { &:before { content: \"\\e197\"; } }\n.glyphicon-cloud-upload           { &:before { content: \"\\e198\"; } }\n.glyphicon-tree-conifer           { &:before { content: \"\\e199\"; } }\n.glyphicon-tree-deciduous         { &:before { content: \"\\e200\"; } }\n.glyphicon-cd                     { &:before { content: \"\\e201\"; } }\n.glyphicon-save-file              { &:before { content: \"\\e202\"; } }\n.glyphicon-open-file              { &:before { content: \"\\e203\"; } }\n.glyphicon-level-up               { &:before { content: \"\\e204\"; } }\n.glyphicon-copy                   { &:before { content: \"\\e205\"; } }\n.glyphicon-paste                  { &:before { content: \"\\e206\"; } }\n// The following 2 Glyphicons are omitted for the time being because\n// they currently use Unicode codepoints that are outside the\n// Basic Multilingual Plane (BMP). Older buggy versions of WebKit can't handle\n// non-BMP codepoints in CSS string escapes, and thus can't display these two icons.\n// Notably, the bug affects some older versions of the Android Browser.\n// More info: https://github.com/twbs/bootstrap/issues/10106\n// .glyphicon-door                   { &:before { content: \"\\1f6aa\"; } }\n// .glyphicon-key                    { &:before { content: \"\\1f511\"; } }\n.glyphicon-alert                  { &:before { content: \"\\e209\"; } }\n.glyphicon-equalizer              { &:before { content: \"\\e210\"; } }\n.glyphicon-king                   { &:before { content: \"\\e211\"; } }\n.glyphicon-queen                  { &:before { content: \"\\e212\"; } }\n.glyphicon-pawn                   { &:before { content: \"\\e213\"; } }\n.glyphicon-bishop                 { &:before { content: \"\\e214\"; } }\n.glyphicon-knight                 { &:before { content: \"\\e215\"; } }\n.glyphicon-baby-formula           { &:before { content: \"\\e216\"; } }\n.glyphicon-tent                   { &:before { content: \"\\26fa\"; } }\n.glyphicon-blackboard             { &:before { content: \"\\e218\"; } }\n.glyphicon-bed                    { &:before { content: \"\\e219\"; } }\n.glyphicon-apple                  { &:before { content: \"\\f8ff\"; } }\n.glyphicon-erase                  { &:before { content: \"\\e221\"; } }\n.glyphicon-hourglass              { &:before { content: \"\\231b\"; } }\n.glyphicon-lamp                   { &:before { content: \"\\e223\"; } }\n.glyphicon-duplicate              { &:before { content: \"\\e224\"; } }\n.glyphicon-piggy-bank             { &:before { content: \"\\e225\"; } }\n.glyphicon-scissors               { &:before { content: \"\\e226\"; } }\n.glyphicon-bitcoin                { &:before { content: \"\\e227\"; } }\n.glyphicon-btc                    { &:before { content: \"\\e227\"; } }\n.glyphicon-xbt                    { &:before { content: \"\\e227\"; } }\n.glyphicon-yen                    { &:before { content: \"\\00a5\"; } }\n.glyphicon-jpy                    { &:before { content: \"\\00a5\"; } }\n.glyphicon-ruble                  { &:before { content: \"\\20bd\"; } }\n.glyphicon-rub                    { &:before { content: \"\\20bd\"; } }\n.glyphicon-scale                  { &:before { content: \"\\e230\"; } }\n.glyphicon-ice-lolly              { &:before { content: \"\\e231\"; } }\n.glyphicon-ice-lolly-tasted       { &:before { content: \"\\e232\"; } }\n.glyphicon-education              { &:before { content: \"\\e233\"; } }\n.glyphicon-option-horizontal      { &:before { content: \"\\e234\"; } }\n.glyphicon-option-vertical        { &:before { content: \"\\e235\"; } }\n.glyphicon-menu-hamburger         { &:before { content: \"\\e236\"; } }\n.glyphicon-modal-window           { &:before { content: \"\\e237\"; } }\n.glyphicon-oil                    { &:before { content: \"\\e238\"; } }\n.glyphicon-grain                  { &:before { content: \"\\e239\"; } }\n.glyphicon-sunglasses             { &:before { content: \"\\e240\"; } }\n.glyphicon-text-size              { &:before { content: \"\\e241\"; } }\n.glyphicon-text-color             { &:before { content: \"\\e242\"; } }\n.glyphicon-text-background        { &:before { content: \"\\e243\"; } }\n.glyphicon-object-align-top       { &:before { content: \"\\e244\"; } }\n.glyphicon-object-align-bottom    { &:before { content: \"\\e245\"; } }\n.glyphicon-object-align-horizontal{ &:before { content: \"\\e246\"; } }\n.glyphicon-object-align-left      { &:before { content: \"\\e247\"; } }\n.glyphicon-object-align-vertical  { &:before { content: \"\\e248\"; } }\n.glyphicon-object-align-right     { &:before { content: \"\\e249\"; } }\n.glyphicon-triangle-right         { &:before { content: \"\\e250\"; } }\n.glyphicon-triangle-left          { &:before { content: \"\\e251\"; } }\n.glyphicon-triangle-bottom        { &:before { content: \"\\e252\"; } }\n.glyphicon-triangle-top           { &:before { content: \"\\e253\"; } }\n.glyphicon-console                { &:before { content: \"\\e254\"; } }\n.glyphicon-superscript            { &:before { content: \"\\e255\"; } }\n.glyphicon-subscript              { &:before { content: \"\\e256\"; } }\n.glyphicon-menu-left              { &:before { content: \"\\e257\"; } }\n.glyphicon-menu-right             { &:before { content: \"\\e258\"; } }\n.glyphicon-menu-down              { &:before { content: \"\\e259\"; } }\n.glyphicon-menu-up                { &:before { content: \"\\e260\"; } }\n","//\n// Scaffolding\n// --------------------------------------------------\n\n\n// Reset the box-sizing\n//\n// Heads up! This reset may cause conflicts with some third-party widgets.\n// For recommendations on resolving such conflicts, see\n// https://getbootstrap.com/docs/3.4/getting-started/#third-box-sizing\n* {\n  .box-sizing(border-box);\n}\n*:before,\n*:after {\n  .box-sizing(border-box);\n}\n\n\n// Body reset\n\nhtml {\n  font-size: 10px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nbody {\n  font-family: @font-family-base;\n  font-size: @font-size-base;\n  line-height: @line-height-base;\n  color: @text-color;\n  background-color: @body-bg;\n}\n\n// Reset fonts for relevant elements\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n\n// Links\n\na {\n  color: @link-color;\n  text-decoration: none;\n\n  &:hover,\n  &:focus {\n    color: @link-hover-color;\n    text-decoration: @link-hover-decoration;\n  }\n\n  &:focus {\n    .tab-focus();\n  }\n}\n\n\n// Figures\n//\n// We reset this here because previously Normalize had no `figure` margins. This\n// ensures we don't break anyone's use of the element.\n\nfigure {\n  margin: 0;\n}\n\n\n// Images\n\nimg {\n  vertical-align: middle;\n}\n\n// Responsive images (ensure images don't scale beyond their parents)\n.img-responsive {\n  .img-responsive();\n}\n\n// Rounded corners\n.img-rounded {\n  border-radius: @border-radius-large;\n}\n\n// Image thumbnails\n//\n// Heads up! This is mixin-ed into thumbnails.less for `.thumbnail`.\n.img-thumbnail {\n  padding: @thumbnail-padding;\n  line-height: @line-height-base;\n  background-color: @thumbnail-bg;\n  border: 1px solid @thumbnail-border;\n  border-radius: @thumbnail-border-radius;\n  .transition(all .2s ease-in-out);\n\n  // Keep them at most 100% wide\n  .img-responsive(inline-block);\n}\n\n// Perfect circle\n.img-circle {\n  border-radius: 50%; // set radius in percents\n}\n\n\n// Horizontal rules\n\nhr {\n  margin-top: @line-height-computed;\n  margin-bottom: @line-height-computed;\n  border: 0;\n  border-top: 1px solid @hr-border;\n}\n\n\n// Only display content to screen readers\n//\n// See: https://a11yproject.com/posts/how-to-hide-content\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n// Credit: HTML5 Boilerplate\n\n.sr-only-focusable {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n  }\n}\n\n\n// iOS \"clickable elements\" fix for role=\"button\"\n//\n// Fixes \"clickability\" issue (and more generally, the firing of events such as focus as well)\n// for traditionally non-focusable elements with role=\"button\"\n// see https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n[role=\"button\"] {\n  cursor: pointer;\n}\n","// stylelint-disable indentation, property-no-vendor-prefix, selector-no-vendor-prefix\n\n// Vendor Prefixes\n//\n// All vendor mixins are deprecated as of v3.2.0 due to the introduction of\n// Autoprefixer in our Gruntfile. They have been removed in v4.\n\n// - Animations\n// - Backface visibility\n// - Box shadow\n// - Box sizing\n// - Content columns\n// - Hyphens\n// - Placeholder text\n// - Transformations\n// - Transitions\n// - User Select\n\n\n// Animations\n.animation(@animation) {\n  -webkit-animation: @animation;\n       -o-animation: @animation;\n          animation: @animation;\n}\n.animation-name(@name) {\n  -webkit-animation-name: @name;\n          animation-name: @name;\n}\n.animation-duration(@duration) {\n  -webkit-animation-duration: @duration;\n          animation-duration: @duration;\n}\n.animation-timing-function(@timing-function) {\n  -webkit-animation-timing-function: @timing-function;\n          animation-timing-function: @timing-function;\n}\n.animation-delay(@delay) {\n  -webkit-animation-delay: @delay;\n          animation-delay: @delay;\n}\n.animation-iteration-count(@iteration-count) {\n  -webkit-animation-iteration-count: @iteration-count;\n          animation-iteration-count: @iteration-count;\n}\n.animation-direction(@direction) {\n  -webkit-animation-direction: @direction;\n          animation-direction: @direction;\n}\n.animation-fill-mode(@fill-mode) {\n  -webkit-animation-fill-mode: @fill-mode;\n          animation-fill-mode: @fill-mode;\n}\n\n// Backface visibility\n// Prevent browsers from flickering when using CSS 3D transforms.\n// Default value is `visible`, but can be changed to `hidden`\n\n.backface-visibility(@visibility) {\n  -webkit-backface-visibility: @visibility;\n     -moz-backface-visibility: @visibility;\n          backface-visibility: @visibility;\n}\n\n// Drop shadows\n//\n// Note: Deprecated `.box-shadow()` as of v3.1.0 since all of Bootstrap's\n// supported browsers that have box shadow capabilities now support it.\n\n.box-shadow(@shadow) {\n  -webkit-box-shadow: @shadow; // iOS <4.3 & Android <4.1\n          box-shadow: @shadow;\n}\n\n// Box sizing\n.box-sizing(@boxmodel) {\n  -webkit-box-sizing: @boxmodel;\n     -moz-box-sizing: @boxmodel;\n          box-sizing: @boxmodel;\n}\n\n// CSS3 Content Columns\n.content-columns(@column-count; @column-gap: @grid-gutter-width) {\n  -webkit-column-count: @column-count;\n     -moz-column-count: @column-count;\n          column-count: @column-count;\n  -webkit-column-gap: @column-gap;\n     -moz-column-gap: @column-gap;\n          column-gap: @column-gap;\n}\n\n// Optional hyphenation\n.hyphens(@mode: auto) {\n  -webkit-hyphens: @mode;\n     -moz-hyphens: @mode;\n      -ms-hyphens: @mode; // IE10+\n       -o-hyphens: @mode;\n          hyphens: @mode;\n  word-wrap: break-word;\n}\n\n// Placeholder text\n.placeholder(@color: @input-color-placeholder) {\n  // Firefox\n  &::-moz-placeholder {\n    color: @color;\n    opacity: 1; // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526\n  }\n  &:-ms-input-placeholder { color: @color; } // Internet Explorer 10+\n  &::-webkit-input-placeholder  { color: @color; } // Safari and Chrome\n}\n\n// Transformations\n.scale(@ratio) {\n  -webkit-transform: scale(@ratio);\n      -ms-transform: scale(@ratio); // IE9 only\n       -o-transform: scale(@ratio);\n          transform: scale(@ratio);\n}\n.scale(@ratioX; @ratioY) {\n  -webkit-transform: scale(@ratioX, @ratioY);\n      -ms-transform: scale(@ratioX, @ratioY); // IE9 only\n       -o-transform: scale(@ratioX, @ratioY);\n          transform: scale(@ratioX, @ratioY);\n}\n.scaleX(@ratio) {\n  -webkit-transform: scaleX(@ratio);\n      -ms-transform: scaleX(@ratio); // IE9 only\n       -o-transform: scaleX(@ratio);\n          transform: scaleX(@ratio);\n}\n.scaleY(@ratio) {\n  -webkit-transform: scaleY(@ratio);\n      -ms-transform: scaleY(@ratio); // IE9 only\n       -o-transform: scaleY(@ratio);\n          transform: scaleY(@ratio);\n}\n.skew(@x; @y) {\n  -webkit-transform: skewX(@x) skewY(@y);\n      -ms-transform: skewX(@x) skewY(@y); // See https://github.com/twbs/bootstrap/issues/4885; IE9+\n       -o-transform: skewX(@x) skewY(@y);\n          transform: skewX(@x) skewY(@y);\n}\n.translate(@x; @y) {\n  -webkit-transform: translate(@x, @y);\n      -ms-transform: translate(@x, @y); // IE9 only\n       -o-transform: translate(@x, @y);\n          transform: translate(@x, @y);\n}\n.translate3d(@x; @y; @z) {\n  -webkit-transform: translate3d(@x, @y, @z);\n          transform: translate3d(@x, @y, @z);\n}\n.rotate(@degrees) {\n  -webkit-transform: rotate(@degrees);\n      -ms-transform: rotate(@degrees); // IE9 only\n       -o-transform: rotate(@degrees);\n          transform: rotate(@degrees);\n}\n.rotateX(@degrees) {\n  -webkit-transform: rotateX(@degrees);\n      -ms-transform: rotateX(@degrees); // IE9 only\n       -o-transform: rotateX(@degrees);\n          transform: rotateX(@degrees);\n}\n.rotateY(@degrees) {\n  -webkit-transform: rotateY(@degrees);\n      -ms-transform: rotateY(@degrees); // IE9 only\n       -o-transform: rotateY(@degrees);\n          transform: rotateY(@degrees);\n}\n.perspective(@perspective) {\n  -webkit-perspective: @perspective;\n     -moz-perspective: @perspective;\n          perspective: @perspective;\n}\n.perspective-origin(@perspective) {\n  -webkit-perspective-origin: @perspective;\n     -moz-perspective-origin: @perspective;\n          perspective-origin: @perspective;\n}\n.transform-origin(@origin) {\n  -webkit-transform-origin: @origin;\n     -moz-transform-origin: @origin;\n      -ms-transform-origin: @origin; // IE9 only\n          transform-origin: @origin;\n}\n\n\n// Transitions\n\n.transition(@transition) {\n  -webkit-transition: @transition;\n       -o-transition: @transition;\n          transition: @transition;\n}\n.transition-property(@transition-property) {\n  -webkit-transition-property: @transition-property;\n          transition-property: @transition-property;\n}\n.transition-delay(@transition-delay) {\n  -webkit-transition-delay: @transition-delay;\n          transition-delay: @transition-delay;\n}\n.transition-duration(@transition-duration) {\n  -webkit-transition-duration: @transition-duration;\n          transition-duration: @transition-duration;\n}\n.transition-timing-function(@timing-function) {\n  -webkit-transition-timing-function: @timing-function;\n          transition-timing-function: @timing-function;\n}\n.transition-transform(@transition) {\n  -webkit-transition: -webkit-transform @transition;\n     -moz-transition: -moz-transform @transition;\n       -o-transition: -o-transform @transition;\n          transition: transform @transition;\n}\n\n\n// User select\n// For selecting text on the page\n\n.user-select(@select) {\n  -webkit-user-select: @select;\n     -moz-user-select: @select;\n      -ms-user-select: @select; // IE10+\n          user-select: @select;\n}\n","// WebKit-style focus\n\n.tab-focus() {\n  // WebKit-specific. Other browsers will keep their default outline style.\n  // (Initially tried to also force default via `outline: initial`,\n  // but that seems to erroneously remove the outline in Firefox altogether.)\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\n","// stylelint-disable media-feature-name-no-vendor-prefix, media-feature-parentheses-space-inside, media-feature-name-no-unknown, indentation, at-rule-name-space-after\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n.img-responsive(@display: block) {\n  display: @display;\n  max-width: 100%; // Part 1: Set a maximum relative to the parent\n  height: auto; // Part 2: Scale the height according to the width, otherwise you get stretching\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size. Note that the\n// spelling of `min--moz-device-pixel-ratio` is intentional.\n.img-retina(@file-1x; @file-2x; @width-1x; @height-1x) {\n  background-image: url(\"@{file-1x}\");\n\n  @media\n  only screen and (-webkit-min-device-pixel-ratio: 2),\n  only screen and ( min--moz-device-pixel-ratio: 2),\n  only screen and ( -o-min-device-pixel-ratio: 2/1),\n  only screen and ( min-device-pixel-ratio: 2),\n  only screen and ( min-resolution: 192dpi),\n  only screen and ( min-resolution: 2dppx) {\n    background-image: url(\"@{file-2x}\");\n    background-size: @width-1x @height-1x;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after, selector-no-qualifying-type\n\n//\n// Typography\n// --------------------------------------------------\n\n\n// Headings\n// -------------------------\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  font-family: @headings-font-family;\n  font-weight: @headings-font-weight;\n  line-height: @headings-line-height;\n  color: @headings-color;\n\n  small,\n  .small {\n    font-weight: 400;\n    line-height: 1;\n    color: @headings-small-color;\n  }\n}\n\nh1, .h1,\nh2, .h2,\nh3, .h3 {\n  margin-top: @line-height-computed;\n  margin-bottom: (@line-height-computed / 2);\n\n  small,\n  .small {\n    font-size: 65%;\n  }\n}\nh4, .h4,\nh5, .h5,\nh6, .h6 {\n  margin-top: (@line-height-computed / 2);\n  margin-bottom: (@line-height-computed / 2);\n\n  small,\n  .small {\n    font-size: 75%;\n  }\n}\n\nh1, .h1 { font-size: @font-size-h1; }\nh2, .h2 { font-size: @font-size-h2; }\nh3, .h3 { font-size: @font-size-h3; }\nh4, .h4 { font-size: @font-size-h4; }\nh5, .h5 { font-size: @font-size-h5; }\nh6, .h6 { font-size: @font-size-h6; }\n\n\n// Body text\n// -------------------------\n\np {\n  margin: 0 0 (@line-height-computed / 2);\n}\n\n.lead {\n  margin-bottom: @line-height-computed;\n  font-size: floor((@font-size-base * 1.15));\n  font-weight: 300;\n  line-height: 1.4;\n\n  @media (min-width: @screen-sm-min) {\n    font-size: (@font-size-base * 1.5);\n  }\n}\n\n\n// Emphasis & misc\n// -------------------------\n\n// Ex: (12px small font / 14px base font) * 100% = about 85%\nsmall,\n.small {\n  font-size: floor((100% * @font-size-small / @font-size-base));\n}\n\nmark,\n.mark {\n  padding: .2em;\n  background-color: @state-warning-bg;\n}\n\n// Alignment\n.text-left           { text-align: left; }\n.text-right          { text-align: right; }\n.text-center         { text-align: center; }\n.text-justify        { text-align: justify; }\n.text-nowrap         { white-space: nowrap; }\n\n// Transformation\n.text-lowercase      { text-transform: lowercase; }\n.text-uppercase      { text-transform: uppercase; }\n.text-capitalize     { text-transform: capitalize; }\n\n// Contextual colors\n.text-muted {\n  color: @text-muted;\n}\n.text-primary {\n  .text-emphasis-variant(@brand-primary);\n}\n.text-success {\n  .text-emphasis-variant(@state-success-text);\n}\n.text-info {\n  .text-emphasis-variant(@state-info-text);\n}\n.text-warning {\n  .text-emphasis-variant(@state-warning-text);\n}\n.text-danger {\n  .text-emphasis-variant(@state-danger-text);\n}\n\n// Contextual backgrounds\n// For now we'll leave these alongside the text classes until v4 when we can\n// safely shift things around (per SemVer rules).\n.bg-primary {\n  // Given the contrast here, this is the only class to have its color inverted\n  // automatically.\n  color: #fff;\n  .bg-variant(@brand-primary);\n}\n.bg-success {\n  .bg-variant(@state-success-bg);\n}\n.bg-info {\n  .bg-variant(@state-info-bg);\n}\n.bg-warning {\n  .bg-variant(@state-warning-bg);\n}\n.bg-danger {\n  .bg-variant(@state-danger-bg);\n}\n\n\n// Page header\n// -------------------------\n\n.page-header {\n  padding-bottom: ((@line-height-computed / 2) - 1);\n  margin: (@line-height-computed * 2) 0 @line-height-computed;\n  border-bottom: 1px solid @page-header-border-color;\n}\n\n\n// Lists\n// -------------------------\n\n// Unordered and Ordered lists\nul,\nol {\n  margin-top: 0;\n  margin-bottom: (@line-height-computed / 2);\n  ul,\n  ol {\n    margin-bottom: 0;\n  }\n}\n\n// List options\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  .list-unstyled();\n  margin-left: -5px;\n\n  > li {\n    display: inline-block;\n    padding-right: 5px;\n    padding-left: 5px;\n  }\n}\n\n// Description Lists\ndl {\n  margin-top: 0; // Remove browser default\n  margin-bottom: @line-height-computed;\n}\ndt,\ndd {\n  line-height: @line-height-base;\n}\ndt {\n  font-weight: 700;\n}\ndd {\n  margin-left: 0; // Undo browser default\n}\n\n// Horizontal description lists\n//\n// Defaults to being stacked without any of the below styles applied, until the\n// grid breakpoint is reached (default of ~768px).\n\n.dl-horizontal {\n  dd {\n    &:extend(.clearfix all); // Clear the floated `dt` if an empty `dd` is present\n  }\n\n  @media (min-width: @dl-horizontal-breakpoint) {\n    dt {\n      float: left;\n      width: (@dl-horizontal-offset - 20);\n      clear: left;\n      text-align: right;\n      .text-overflow();\n    }\n    dd {\n      margin-left: @dl-horizontal-offset;\n    }\n  }\n}\n\n\n// Misc\n// -------------------------\n\n// Abbreviations and acronyms\n// Add data-* attribute to help out our tooltip plugin, per https://github.com/twbs/bootstrap/issues/5257\nabbr[title],\nabbr[data-original-title] {\n  cursor: help;\n}\n\n.initialism {\n  font-size: 90%;\n  .text-uppercase();\n}\n\n// Blockquotes\nblockquote {\n  padding: (@line-height-computed / 2) @line-height-computed;\n  margin: 0 0 @line-height-computed;\n  font-size: @blockquote-font-size;\n  border-left: 5px solid @blockquote-border-color;\n\n  p,\n  ul,\n  ol {\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  // Note: Deprecated small and .small as of v3.1.0\n  // Context: https://github.com/twbs/bootstrap/issues/11660\n  footer,\n  small,\n  .small {\n    display: block;\n    font-size: 80%; // back to default font-size\n    line-height: @line-height-base;\n    color: @blockquote-small-color;\n\n    &:before {\n      content: \"\\2014 \\00A0\"; // em dash, nbsp\n    }\n  }\n}\n\n// Opposite alignment of blockquote\n//\n// Heads up: `blockquote.pull-right` has been deprecated as of v3.1.0.\n.blockquote-reverse,\nblockquote.pull-right {\n  padding-right: 15px;\n  padding-left: 0;\n  text-align: right;\n  border-right: 5px solid @blockquote-border-color;\n  border-left: 0;\n\n  // Account for citation\n  footer,\n  small,\n  .small {\n    &:before { content: \"\"; }\n    &:after {\n      content: \"\\00A0 \\2014\"; // nbsp, em dash\n    }\n  }\n}\n\n// Addresses\naddress {\n  margin-bottom: @line-height-computed;\n  font-style: normal;\n  line-height: @line-height-base;\n}\n","// Typography\n\n.text-emphasis-variant(@color) {\n  color: @color;\n  a&:hover,\n  a&:focus {\n    color: darken(@color, 10%);\n  }\n}\n","// Contextual backgrounds\n\n.bg-variant(@color) {\n  background-color: @color;\n  a&:hover,\n  a&:focus {\n    background-color: darken(@color, 10%);\n  }\n}\n","// Text overflow\n// Requires inline-block or block for proper styling\n\n.text-overflow() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","//\n// Code (inline and block)\n// --------------------------------------------------\n\n\n// Inline and block code styles\ncode,\nkbd,\npre,\nsamp {\n  font-family: @font-family-monospace;\n}\n\n// Inline code\ncode {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: @code-color;\n  background-color: @code-bg;\n  border-radius: @border-radius-base;\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: 2px 4px;\n  font-size: 90%;\n  color: @kbd-color;\n  background-color: @kbd-bg;\n  border-radius: @border-radius-small;\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);\n\n  kbd {\n    padding: 0;\n    font-size: 100%;\n    font-weight: 700;\n    box-shadow: none;\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  padding: ((@line-height-computed - 1) / 2);\n  margin: 0 0 (@line-height-computed / 2);\n  font-size: (@font-size-base - 1); // 14px to 13px\n  line-height: @line-height-base;\n  color: @pre-color;\n  word-break: break-all;\n  word-wrap: break-word;\n  background-color: @pre-bg;\n  border: 1px solid @pre-border-color;\n  border-radius: @border-radius-base;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    padding: 0;\n    font-size: inherit;\n    color: inherit;\n    white-space: pre-wrap;\n    background-color: transparent;\n    border-radius: 0;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: @pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","//\n// Grid system\n// --------------------------------------------------\n\n\n// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n.container {\n  .container-fixed();\n\n  @media (min-width: @screen-sm-min) {\n    width: @container-sm;\n  }\n  @media (min-width: @screen-md-min) {\n    width: @container-md;\n  }\n  @media (min-width: @screen-lg-min) {\n    width: @container-lg;\n  }\n}\n\n\n// Fluid container\n//\n// Utilizes the mixin meant for fixed width containers, but without any defined\n// width for fluid, full width layouts.\n\n.container-fluid {\n  .container-fixed();\n}\n\n\n// Row\n//\n// Rows contain and clear the floats of your columns.\n\n.row {\n  .make-row();\n}\n\n.row-no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n\n  [class*=\"col-\"] {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n.make-grid-columns();\n\n\n// Extra small grid\n//\n// Columns, offsets, pushes, and pulls for extra small devices like\n// smartphones.\n\n.make-grid(xs);\n\n\n// Small grid\n//\n// Columns, offsets, pushes, and pulls for the small device range, from phones\n// to tablets.\n\n@media (min-width: @screen-sm-min) {\n  .make-grid(sm);\n}\n\n\n// Medium grid\n//\n// Columns, offsets, pushes, and pulls for the desktop device range.\n\n@media (min-width: @screen-md-min) {\n  .make-grid(md);\n}\n\n\n// Large grid\n//\n// Columns, offsets, pushes, and pulls for the large desktop device range.\n\n@media (min-width: @screen-lg-min) {\n  .make-grid(lg);\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n// Centered container element\n.container-fixed(@gutter: @grid-gutter-width) {\n  padding-right: ceil((@gutter / 2));\n  padding-left: floor((@gutter / 2));\n  margin-right: auto;\n  margin-left: auto;\n  &:extend(.clearfix all);\n}\n\n// Creates a wrapper for a series of columns\n.make-row(@gutter: @grid-gutter-width) {\n  margin-right: floor((@gutter / -2));\n  margin-left: ceil((@gutter / -2));\n  &:extend(.clearfix all);\n}\n\n// Generate the extra small columns\n.make-xs-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  float: left;\n  width: percentage((@columns / @grid-columns));\n  min-height: 1px;\n  padding-right: (@gutter / 2);\n  padding-left: (@gutter / 2);\n}\n.make-xs-column-offset(@columns) {\n  margin-left: percentage((@columns / @grid-columns));\n}\n.make-xs-column-push(@columns) {\n  left: percentage((@columns / @grid-columns));\n}\n.make-xs-column-pull(@columns) {\n  right: percentage((@columns / @grid-columns));\n}\n\n// Generate the small columns\n.make-sm-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  min-height: 1px;\n  padding-right: (@gutter / 2);\n  padding-left: (@gutter / 2);\n\n  @media (min-width: @screen-sm-min) {\n    float: left;\n    width: percentage((@columns / @grid-columns));\n  }\n}\n.make-sm-column-offset(@columns) {\n  @media (min-width: @screen-sm-min) {\n    margin-left: percentage((@columns / @grid-columns));\n  }\n}\n.make-sm-column-push(@columns) {\n  @media (min-width: @screen-sm-min) {\n    left: percentage((@columns / @grid-columns));\n  }\n}\n.make-sm-column-pull(@columns) {\n  @media (min-width: @screen-sm-min) {\n    right: percentage((@columns / @grid-columns));\n  }\n}\n\n// Generate the medium columns\n.make-md-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  min-height: 1px;\n  padding-right: (@gutter / 2);\n  padding-left: (@gutter / 2);\n\n  @media (min-width: @screen-md-min) {\n    float: left;\n    width: percentage((@columns / @grid-columns));\n  }\n}\n.make-md-column-offset(@columns) {\n  @media (min-width: @screen-md-min) {\n    margin-left: percentage((@columns / @grid-columns));\n  }\n}\n.make-md-column-push(@columns) {\n  @media (min-width: @screen-md-min) {\n    left: percentage((@columns / @grid-columns));\n  }\n}\n.make-md-column-pull(@columns) {\n  @media (min-width: @screen-md-min) {\n    right: percentage((@columns / @grid-columns));\n  }\n}\n\n// Generate the large columns\n.make-lg-column(@columns; @gutter: @grid-gutter-width) {\n  position: relative;\n  min-height: 1px;\n  padding-right: (@gutter / 2);\n  padding-left: (@gutter / 2);\n\n  @media (min-width: @screen-lg-min) {\n    float: left;\n    width: percentage((@columns / @grid-columns));\n  }\n}\n.make-lg-column-offset(@columns) {\n  @media (min-width: @screen-lg-min) {\n    margin-left: percentage((@columns / @grid-columns));\n  }\n}\n.make-lg-column-push(@columns) {\n  @media (min-width: @screen-lg-min) {\n    left: percentage((@columns / @grid-columns));\n  }\n}\n.make-lg-column-pull(@columns) {\n  @media (min-width: @screen-lg-min) {\n    right: percentage((@columns / @grid-columns));\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `@grid-columns`.\n\n.make-grid-columns() {\n  // Common styles for all sizes of grid columns, widths 1-12\n  .col(@index) { // initial\n    @item: ~\".col-xs-@{index}, .col-sm-@{index}, .col-md-@{index}, .col-lg-@{index}\";\n    .col((@index + 1), @item);\n  }\n  .col(@index, @list) when (@index =< @grid-columns) { // general; \"=<\" isn't a typo\n    @item: ~\".col-xs-@{index}, .col-sm-@{index}, .col-md-@{index}, .col-lg-@{index}\";\n    .col((@index + 1), ~\"@{list}, @{item}\");\n  }\n  .col(@index, @list) when (@index > @grid-columns) { // terminal\n    @{list} {\n      position: relative;\n      // Prevent columns from collapsing when empty\n      min-height: 1px;\n      // Inner gutter via padding\n      padding-right: floor((@grid-gutter-width / 2));\n      padding-left: ceil((@grid-gutter-width / 2));\n    }\n  }\n  .col(1); // kickstart it\n}\n\n.float-grid-columns(@class) {\n  .col(@index) { // initial\n    @item: ~\".col-@{class}-@{index}\";\n    .col((@index + 1), @item);\n  }\n  .col(@index, @list) when (@index =< @grid-columns) { // general\n    @item: ~\".col-@{class}-@{index}\";\n    .col((@index + 1), ~\"@{list}, @{item}\");\n  }\n  .col(@index, @list) when (@index > @grid-columns) { // terminal\n    @{list} {\n      float: left;\n    }\n  }\n  .col(1); // kickstart it\n}\n\n.calc-grid-column(@index, @class, @type) when (@type = width) and (@index > 0) {\n  .col-@{class}-@{index} {\n    width: percentage((@index / @grid-columns));\n  }\n}\n.calc-grid-column(@index, @class, @type) when (@type = push) and (@index > 0) {\n  .col-@{class}-push-@{index} {\n    left: percentage((@index / @grid-columns));\n  }\n}\n.calc-grid-column(@index, @class, @type) when (@type = push) and (@index = 0) {\n  .col-@{class}-push-0 {\n    left: auto;\n  }\n}\n.calc-grid-column(@index, @class, @type) when (@type = pull) and (@index > 0) {\n  .col-@{class}-pull-@{index} {\n    right: percentage((@index / @grid-columns));\n  }\n}\n.calc-grid-column(@index, @class, @type) when (@type = pull) and (@index = 0) {\n  .col-@{class}-pull-0 {\n    right: auto;\n  }\n}\n.calc-grid-column(@index, @class, @type) when (@type = offset) {\n  .col-@{class}-offset-@{index} {\n    margin-left: percentage((@index / @grid-columns));\n  }\n}\n\n// Basic looping in LESS\n.loop-grid-columns(@index, @class, @type) when (@index >= 0) {\n  .calc-grid-column(@index, @class, @type);\n  // next iteration\n  .loop-grid-columns((@index - 1), @class, @type);\n}\n\n// Create grid for specific class\n.make-grid(@class) {\n  .float-grid-columns(@class);\n  .loop-grid-columns(@grid-columns, @class, width);\n  .loop-grid-columns(@grid-columns, @class, pull);\n  .loop-grid-columns(@grid-columns, @class, push);\n  .loop-grid-columns(@grid-columns, @class, offset);\n}\n","// stylelint-disable selector-max-type, selector-max-compound-selectors, selector-no-qualifying-type\n\n//\n// Tables\n// --------------------------------------------------\n\n\ntable {\n  background-color: @table-bg;\n\n  // Table cell sizing\n  //\n  // Reset default table behavior\n\n  col[class*=\"col-\"] {\n    position: static; // Prevent border hiding in Firefox and IE9-11 (see https://github.com/twbs/bootstrap/issues/11623)\n    display: table-column;\n    float: none;\n  }\n\n  td,\n  th {\n    &[class*=\"col-\"] {\n      position: static; // Prevent border hiding in Firefox and IE9-11 (see https://github.com/twbs/bootstrap/issues/11623)\n      display: table-cell;\n      float: none;\n    }\n  }\n}\n\ncaption {\n  padding-top: @table-cell-padding;\n  padding-bottom: @table-cell-padding;\n  color: @text-muted;\n  text-align: left;\n}\n\nth {\n  text-align: left;\n}\n\n\n// Baseline styles\n\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: @line-height-computed;\n  // Cells\n  > thead,\n  > tbody,\n  > tfoot {\n    > tr {\n      > th,\n      > td {\n        padding: @table-cell-padding;\n        line-height: @line-height-base;\n        vertical-align: top;\n        border-top: 1px solid @table-border-color;\n      }\n    }\n  }\n  // Bottom align for column headings\n  > thead > tr > th {\n    vertical-align: bottom;\n    border-bottom: 2px solid @table-border-color;\n  }\n  // Remove top border from thead by default\n  > caption + thead,\n  > colgroup + thead,\n  > thead:first-child {\n    > tr:first-child {\n      > th,\n      > td {\n        border-top: 0;\n      }\n    }\n  }\n  // Account for multiple tbody instances\n  > tbody + tbody {\n    border-top: 2px solid @table-border-color;\n  }\n\n  // Nesting\n  .table {\n    background-color: @body-bg;\n  }\n}\n\n\n// Condensed table w/ half padding\n\n.table-condensed {\n  > thead,\n  > tbody,\n  > tfoot {\n    > tr {\n      > th,\n      > td {\n        padding: @table-condensed-cell-padding;\n      }\n    }\n  }\n}\n\n\n// Bordered version\n//\n// Add borders all around the table and between all the columns.\n\n.table-bordered {\n  border: 1px solid @table-border-color;\n  > thead,\n  > tbody,\n  > tfoot {\n    > tr {\n      > th,\n      > td {\n        border: 1px solid @table-border-color;\n      }\n    }\n  }\n  > thead > tr {\n    > th,\n    > td {\n      border-bottom-width: 2px;\n    }\n  }\n}\n\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  > tbody > tr:nth-of-type(odd) {\n    background-color: @table-bg-accent;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover {\n    background-color: @table-bg-hover;\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n// Generate the contextual variants\n.table-row-variant(active; @table-bg-active);\n.table-row-variant(success; @state-success-bg);\n.table-row-variant(info; @state-info-bg);\n.table-row-variant(warning; @state-warning-bg);\n.table-row-variant(danger; @state-danger-bg);\n\n\n// Responsive tables\n//\n// Wrap your tables in `.table-responsive` and we'll make them mobile friendly\n// by enabling horizontal scrolling. Only applies <768px. Everything above that\n// will display normally.\n\n.table-responsive {\n  min-height: .01%; // Workaround for IE9 bug (see https://github.com/twbs/bootstrap/issues/14837)\n  overflow-x: auto;\n\n  @media screen and (max-width: @screen-xs-max) {\n    width: 100%;\n    margin-bottom: (@line-height-computed * .75);\n    overflow-y: hidden;\n    -ms-overflow-style: -ms-autohiding-scrollbar;\n    border: 1px solid @table-border-color;\n\n    // Tighten up spacing\n    > .table {\n      margin-bottom: 0;\n\n      // Ensure the content doesn't wrap\n      > thead,\n      > tbody,\n      > tfoot {\n        > tr {\n          > th,\n          > td {\n            white-space: nowrap;\n          }\n        }\n      }\n    }\n\n    // Special overrides for the bordered tables\n    > .table-bordered {\n      border: 0;\n\n      // Nuke the appropriate borders so that the parent can handle them\n      > thead,\n      > tbody,\n      > tfoot {\n        > tr {\n          > th:first-child,\n          > td:first-child {\n            border-left: 0;\n          }\n          > th:last-child,\n          > td:last-child {\n            border-right: 0;\n          }\n        }\n      }\n\n      // Only nuke the last row's bottom-border in `tbody` and `tfoot` since\n      // chances are there will be only one `tr` in a `thead` and that would\n      // remove the border altogether.\n      > tbody,\n      > tfoot {\n        > tr:last-child {\n          > th,\n          > td {\n            border-bottom: 0;\n          }\n        }\n      }\n\n    }\n  }\n}\n","// Tables\n\n.table-row-variant(@state; @background) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table > thead > tr,\n  .table > tbody > tr,\n  .table > tfoot > tr {\n    > td.@{state},\n    > th.@{state},\n    &.@{state} > td,\n    &.@{state} > th {\n      background-color: @background;\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover > tbody > tr {\n    > td.@{state}:hover,\n    > th.@{state}:hover,\n    &.@{state}:hover > td,\n    &:hover > .@{state},\n    &.@{state}:hover > th {\n      background-color: darken(@background, 5%);\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type, property-no-vendor-prefix, media-feature-name-no-vendor-prefix\n\n//\n// Forms\n// --------------------------------------------------\n\n\n// Normalize non-controls\n//\n// Restyle and baseline non-control form elements.\n\nfieldset {\n  // Chrome and Firefox set a `min-width: min-content;` on fieldsets,\n  // so we reset that to ensure it behaves more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359.\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin-bottom: @line-height-computed;\n  font-size: (@font-size-base * 1.5);\n  line-height: inherit;\n  color: @legend-color;\n  border: 0;\n  border-bottom: 1px solid @legend-border-color;\n}\n\nlabel {\n  display: inline-block;\n  max-width: 100%; // Force IE8 to wrap long content (see https://github.com/twbs/bootstrap/issues/13141)\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n\n\n// Normalize form controls\n//\n// While most of our form styles require extra classes, some basic normalization\n// is required to ensure optimum display with or without those classes to better\n// address browser inconsistencies.\n\ninput[type=\"search\"] {\n  // Override content-box in Normalize (* isn't specific enough)\n  .box-sizing(border-box);\n\n  // Search inputs in iOS\n  //\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n// Position radios and checkboxes better\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  margin: 4px 0 0;\n  margin-top: 1px \\9; // IE8-9\n  line-height: normal;\n\n  // Apply same disabled cursor tweak as for inputs\n  // Some special care is needed because <label>s don't inherit their parent's `cursor`.\n  //\n  // Note: Neither radios nor checkboxes can be readonly.\n  &[disabled],\n  &.disabled,\n  fieldset[disabled] & {\n    cursor: @cursor-disabled;\n  }\n}\n\ninput[type=\"file\"] {\n  display: block;\n}\n\n// Make range inputs behave like textual form controls\ninput[type=\"range\"] {\n  display: block;\n  width: 100%;\n}\n\n// Make multiple select elements height not fixed\nselect[multiple],\nselect[size] {\n  height: auto;\n}\n\n// Focus for file, radio, and checkbox\ninput[type=\"file\"]:focus,\ninput[type=\"radio\"]:focus,\ninput[type=\"checkbox\"]:focus {\n  .tab-focus();\n}\n\n// Adjust output element\noutput {\n  display: block;\n  padding-top: (@padding-base-vertical + 1);\n  font-size: @font-size-base;\n  line-height: @line-height-base;\n  color: @input-color;\n}\n\n\n// Common form controls\n//\n// Shared size and type resets for form controls. Apply `.form-control` to any\n// of the following form controls:\n//\n// select\n// textarea\n// input[type=\"text\"]\n// input[type=\"password\"]\n// input[type=\"datetime\"]\n// input[type=\"datetime-local\"]\n// input[type=\"date\"]\n// input[type=\"month\"]\n// input[type=\"time\"]\n// input[type=\"week\"]\n// input[type=\"number\"]\n// input[type=\"email\"]\n// input[type=\"url\"]\n// input[type=\"search\"]\n// input[type=\"tel\"]\n// input[type=\"color\"]\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: @input-height-base; // Make inputs at least the height of their button counterpart (base line-height + padding + border)\n  padding: @padding-base-vertical @padding-base-horizontal;\n  font-size: @font-size-base;\n  line-height: @line-height-base;\n  color: @input-color;\n  background-color: @input-bg;\n  background-image: none; // Reset unusual Firefox-on-Android default style; see https://github.com/necolas/normalize.css/issues/214\n  border: 1px solid @input-border;\n  border-radius: @input-border-radius; // Note: This has no effect on <select>s in some browsers, due to the limited stylability of <select>s in CSS.\n  .box-shadow(inset 0 1px 1px rgba(0, 0, 0, .075));\n  .transition(~\"border-color ease-in-out .15s, box-shadow ease-in-out .15s\");\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  .form-control-focus();\n\n  // Placeholder\n  .placeholder();\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &[disabled],\n  &[readonly],\n  fieldset[disabled] & {\n    background-color: @input-bg-disabled;\n    opacity: 1; // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655\n  }\n\n  &[disabled],\n  fieldset[disabled] & {\n    cursor: @cursor-disabled;\n  }\n\n  // Reset height for `textarea`s\n  textarea& {\n    height: auto;\n  }\n}\n\n\n// Special styles for iOS temporal inputs\n//\n// In Mobile Safari, setting `display: block` on temporal inputs causes the\n// text within the input to become vertically misaligned. As a workaround, we\n// set a pixel line-height that matches the given height of the input, but only\n// for Safari. See https://bugs.webkit.org/show_bug.cgi?id=139848\n//\n// Note that as of 9.3, iOS doesn't support `week`.\n\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  input[type=\"date\"],\n  input[type=\"time\"],\n  input[type=\"datetime-local\"],\n  input[type=\"month\"] {\n    &.form-control {\n      line-height: @input-height-base;\n    }\n\n    &.input-sm,\n    .input-group-sm & {\n      line-height: @input-height-small;\n    }\n\n    &.input-lg,\n    .input-group-lg & {\n      line-height: @input-height-large;\n    }\n  }\n}\n\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: @form-group-margin-bottom;\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.radio,\n.checkbox {\n  position: relative;\n  display: block;\n  margin-top: 10px;\n  margin-bottom: 10px;\n\n  // These are used on elements with <label> descendants\n  &.disabled,\n  fieldset[disabled] & {\n    label {\n      cursor: @cursor-disabled;\n    }\n  }\n\n  label {\n    min-height: @line-height-computed; // Ensure the input doesn't jump when there is no text\n    padding-left: 20px;\n    margin-bottom: 0;\n    font-weight: 400;\n    cursor: pointer;\n  }\n}\n.radio input[type=\"radio\"],\n.radio-inline input[type=\"radio\"],\n.checkbox input[type=\"checkbox\"],\n.checkbox-inline input[type=\"checkbox\"] {\n  position: absolute;\n  margin-top: 4px \\9;\n  margin-left: -20px;\n}\n\n.radio + .radio,\n.checkbox + .checkbox {\n  margin-top: -5px; // Move up sibling radios or checkboxes for tighter spacing\n}\n\n// Radios and checkboxes on same line\n.radio-inline,\n.checkbox-inline {\n  position: relative;\n  display: inline-block;\n  padding-left: 20px;\n  margin-bottom: 0;\n  font-weight: 400;\n  vertical-align: middle;\n  cursor: pointer;\n\n  // These are used directly on <label>s\n  &.disabled,\n  fieldset[disabled] & {\n    cursor: @cursor-disabled;\n  }\n}\n.radio-inline + .radio-inline,\n.checkbox-inline + .checkbox-inline {\n  margin-top: 0;\n  margin-left: 10px; // space out consecutive inline controls\n}\n\n\n// Static form control text\n//\n// Apply class to a `p` element to make any string of text align with labels in\n// a horizontal form layout.\n\n.form-control-static {\n  min-height: (@line-height-computed + @font-size-base);\n  // Size it appropriately next to real form controls\n  padding-top: (@padding-base-vertical + 1);\n  padding-bottom: (@padding-base-vertical + 1);\n  // Remove default margin from `p`\n  margin-bottom: 0;\n\n  &.input-lg,\n  &.input-sm {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// The `.form-group-* form-control` variations are sadly duplicated to avoid the\n// issue documented in https://github.com/twbs/bootstrap/issues/15074.\n\n.input-sm {\n  .input-size(@input-height-small; @padding-small-vertical; @padding-small-horizontal; @font-size-small; @line-height-small; @input-border-radius-small);\n}\n.form-group-sm {\n  .form-control {\n    height: @input-height-small;\n    padding: @padding-small-vertical @padding-small-horizontal;\n    font-size: @font-size-small;\n    line-height: @line-height-small;\n    border-radius: @input-border-radius-small;\n  }\n  select.form-control {\n    height: @input-height-small;\n    line-height: @input-height-small;\n  }\n  textarea.form-control,\n  select[multiple].form-control {\n    height: auto;\n  }\n  .form-control-static {\n    height: @input-height-small;\n    min-height: (@line-height-computed + @font-size-small);\n    padding: (@padding-small-vertical + 1) @padding-small-horizontal;\n    font-size: @font-size-small;\n    line-height: @line-height-small;\n  }\n}\n\n.input-lg {\n  .input-size(@input-height-large; @padding-large-vertical; @padding-large-horizontal; @font-size-large; @line-height-large; @input-border-radius-large);\n}\n.form-group-lg {\n  .form-control {\n    height: @input-height-large;\n    padding: @padding-large-vertical @padding-large-horizontal;\n    font-size: @font-size-large;\n    line-height: @line-height-large;\n    border-radius: @input-border-radius-large;\n  }\n  select.form-control {\n    height: @input-height-large;\n    line-height: @input-height-large;\n  }\n  textarea.form-control,\n  select[multiple].form-control {\n    height: auto;\n  }\n  .form-control-static {\n    height: @input-height-large;\n    min-height: (@line-height-computed + @font-size-large);\n    padding: (@padding-large-vertical + 1) @padding-large-horizontal;\n    font-size: @font-size-large;\n    line-height: @line-height-large;\n  }\n}\n\n\n// Form control feedback states\n//\n// Apply contextual and semantic states to individual form controls.\n\n.has-feedback {\n  // Enable absolute positioning\n  position: relative;\n\n  // Ensure icons don't overlap text\n  .form-control {\n    padding-right: (@input-height-base * 1.25);\n  }\n}\n// Feedback icon (requires .glyphicon classes)\n.form-control-feedback {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2; // Ensure icon is above input groups\n  display: block;\n  width: @input-height-base;\n  height: @input-height-base;\n  line-height: @input-height-base;\n  text-align: center;\n  pointer-events: none;\n}\n.input-lg + .form-control-feedback,\n.input-group-lg + .form-control-feedback,\n.form-group-lg .form-control + .form-control-feedback {\n  width: @input-height-large;\n  height: @input-height-large;\n  line-height: @input-height-large;\n}\n.input-sm + .form-control-feedback,\n.input-group-sm + .form-control-feedback,\n.form-group-sm .form-control + .form-control-feedback {\n  width: @input-height-small;\n  height: @input-height-small;\n  line-height: @input-height-small;\n}\n\n// Feedback states\n.has-success {\n  .form-control-validation(@state-success-text; @state-success-text; @state-success-bg);\n}\n.has-warning {\n  .form-control-validation(@state-warning-text; @state-warning-text; @state-warning-bg);\n}\n.has-error {\n  .form-control-validation(@state-danger-text; @state-danger-text; @state-danger-bg);\n}\n\n// Reposition feedback icon if input has visible label above\n.has-feedback label {\n\n  & ~ .form-control-feedback {\n    top: (@line-height-computed + 5); // Height of the `label` and its margin\n  }\n  &.sr-only ~ .form-control-feedback {\n    top: 0;\n  }\n}\n\n\n// Help text\n//\n// Apply to any element you wish to create light text for placement immediately\n// below a form control. Use for general help, formatting, or instructional text.\n\n.help-block {\n  display: block; // account for any element using help-block\n  margin-top: 5px;\n  margin-bottom: 10px;\n  color: lighten(@text-color, 25%); // lighten the text some for contrast\n}\n\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n//\n// Heads up! This is mixin-ed into `.navbar-form` in navbars.less.\n\n.form-inline {\n\n  // Kick in the inline\n  @media (min-width: @screen-sm-min) {\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: inline-block;\n      margin-bottom: 0;\n      vertical-align: middle;\n    }\n\n    // In navbar-form, allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-static {\n      display: inline-block;\n    }\n\n    .input-group {\n      display: inline-table;\n      vertical-align: middle;\n\n      .input-group-addon,\n      .input-group-btn,\n      .form-control {\n        width: auto;\n      }\n    }\n\n    // Input groups need that 100% width though\n    .input-group > .form-control {\n      width: 100%;\n    }\n\n    .control-label {\n      margin-bottom: 0;\n      vertical-align: middle;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .radio,\n    .checkbox {\n      display: inline-block;\n      margin-top: 0;\n      margin-bottom: 0;\n      vertical-align: middle;\n\n      label {\n        padding-left: 0;\n      }\n    }\n    .radio input[type=\"radio\"],\n    .checkbox input[type=\"checkbox\"] {\n      position: relative;\n      margin-left: 0;\n    }\n\n    // Re-override the feedback icon.\n    .has-feedback .form-control-feedback {\n      top: 0;\n    }\n  }\n}\n\n\n// Horizontal forms\n//\n// Horizontal forms are built on grid classes and allow you to create forms with\n// labels on the left and inputs on the right.\n\n.form-horizontal {\n\n  // Consistent vertical alignment of radios and checkboxes\n  //\n  // Labels also get some reset styles, but that is scoped to a media query below.\n  .radio,\n  .checkbox,\n  .radio-inline,\n  .checkbox-inline {\n    padding-top: (@padding-base-vertical + 1); // Default padding plus a border\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  // Account for padding we're adding to ensure the alignment and of help text\n  // and other content below items\n  .radio,\n  .checkbox {\n    min-height: (@line-height-computed + (@padding-base-vertical + 1));\n  }\n\n  // Make form groups behave like rows\n  .form-group {\n    .make-row();\n  }\n\n  // Reset spacing and right align labels, but scope to media queries so that\n  // labels on narrow viewports stack the same as a default form example.\n  @media (min-width: @screen-sm-min) {\n    .control-label {\n      padding-top: (@padding-base-vertical + 1); // Default padding plus a border\n      margin-bottom: 0;\n      text-align: right;\n    }\n  }\n\n  // Validation states\n  //\n  // Reposition the icon because it's now within a grid column and columns have\n  // `position: relative;` on them. Also accounts for the grid gutter padding.\n  .has-feedback .form-control-feedback {\n    right: floor((@grid-gutter-width / 2));\n  }\n\n  // Form group sizes\n  //\n  // Quick utility class for applying `.input-lg` and `.input-sm` styles to the\n  // inputs and labels within a `.form-group`.\n  .form-group-lg {\n    @media (min-width: @screen-sm-min) {\n      .control-label {\n        padding-top: (@padding-large-vertical + 1);\n        font-size: @font-size-large;\n      }\n    }\n  }\n  .form-group-sm {\n    @media (min-width: @screen-sm-min) {\n      .control-label {\n        padding-top: (@padding-small-vertical + 1);\n        font-size: @font-size-small;\n      }\n    }\n  }\n}\n","// Form validation states\n//\n// Used in forms.less to generate the form validation CSS for warnings, errors,\n// and successes.\n\n.form-control-validation(@text-color: #555; @border-color: #ccc; @background-color: #f5f5f5) {\n  // Color the label and help text\n  .help-block,\n  .control-label,\n  .radio,\n  .checkbox,\n  .radio-inline,\n  .checkbox-inline,\n  &.radio label,\n  &.checkbox label,\n  &.radio-inline label,\n  &.checkbox-inline label  {\n    color: @text-color;\n  }\n  // Set the border and box shadow on specific inputs to match\n  .form-control {\n    border-color: @border-color;\n    .box-shadow(inset 0 1px 1px rgba(0, 0, 0, .075)); // Redeclare so transitions work\n    &:focus {\n      border-color: darken(@border-color, 10%);\n      @shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 6px lighten(@border-color, 20%);\n      .box-shadow(@shadow);\n    }\n  }\n  // Set validation states also for addons\n  .input-group-addon {\n    color: @text-color;\n    background-color: @background-color;\n    border-color: @border-color;\n  }\n  // Optional feedback icon\n  .form-control-feedback {\n    color: @text-color;\n  }\n}\n\n\n// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `@input-border-focus` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n.form-control-focus(@color: @input-border-focus) {\n  @color-rgba: rgba(red(@color), green(@color), blue(@color), .6);\n  &:focus {\n    border-color: @color;\n    outline: 0;\n    .box-shadow(~\"inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px @{color-rgba}\");\n  }\n}\n\n// Form control sizing\n//\n// Relative text size, padding, and border-radii changes for form controls. For\n// horizontal sizing, wrap controls in the predefined grid classes. `<select>`\n// element gets special love because it's special, and that's a fact!\n.input-size(@input-height; @padding-vertical; @padding-horizontal; @font-size; @line-height; @border-radius) {\n  height: @input-height;\n  padding: @padding-vertical @padding-horizontal;\n  font-size: @font-size;\n  line-height: @line-height;\n  border-radius: @border-radius;\n\n  select& {\n    height: @input-height;\n    line-height: @input-height;\n  }\n\n  textarea&,\n  select[multiple]& {\n    height: auto;\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Buttons\n// --------------------------------------------------\n\n\n// Base styles\n// --------------------------------------------------\n\n.btn {\n  display: inline-block;\n  margin-bottom: 0; // For input.btn\n  font-weight: @btn-font-weight;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  background-image: none; // Reset unusual Firefox-on-Android default style; see https://github.com/necolas/normalize.css/issues/214\n  border: 1px solid transparent;\n  .button-size(@padding-base-vertical; @padding-base-horizontal; @font-size-base; @line-height-base; @btn-border-radius-base);\n  .user-select(none);\n\n  &,\n  &:active,\n  &.active {\n    &:focus,\n    &.focus {\n      .tab-focus();\n    }\n  }\n\n  &:hover,\n  &:focus,\n  &.focus {\n    color: @btn-default-color;\n    text-decoration: none;\n  }\n\n  &:active,\n  &.active {\n    background-image: none;\n    outline: 0;\n    .box-shadow(inset 0 3px 5px rgba(0, 0, 0, .125));\n  }\n\n  &.disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    cursor: @cursor-disabled;\n    .opacity(.65);\n    .box-shadow(none);\n  }\n\n  a& {\n    &.disabled,\n    fieldset[disabled] & {\n      pointer-events: none; // Future-proof disabling of clicks on `<a>` elements\n    }\n  }\n}\n\n\n// Alternate buttons\n// --------------------------------------------------\n\n.btn-default {\n  .button-variant(@btn-default-color; @btn-default-bg; @btn-default-border);\n}\n.btn-primary {\n  .button-variant(@btn-primary-color; @btn-primary-bg; @btn-primary-border);\n}\n// Success appears as green\n.btn-success {\n  .button-variant(@btn-success-color; @btn-success-bg; @btn-success-border);\n}\n// Info appears as blue-green\n.btn-info {\n  .button-variant(@btn-info-color; @btn-info-bg; @btn-info-border);\n}\n// Warning appears as orange\n.btn-warning {\n  .button-variant(@btn-warning-color; @btn-warning-bg; @btn-warning-border);\n}\n// Danger and error appear as red\n.btn-danger {\n  .button-variant(@btn-danger-color; @btn-danger-bg; @btn-danger-border);\n}\n\n\n// Link buttons\n// -------------------------\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: 400;\n  color: @link-color;\n  border-radius: 0;\n\n  &,\n  &:active,\n  &.active,\n  &[disabled],\n  fieldset[disabled] & {\n    background-color: transparent;\n    .box-shadow(none);\n  }\n  &,\n  &:hover,\n  &:focus,\n  &:active {\n    border-color: transparent;\n  }\n  &:hover,\n  &:focus {\n    color: @link-hover-color;\n    text-decoration: @link-hover-decoration;\n    background-color: transparent;\n  }\n  &[disabled],\n  fieldset[disabled] & {\n    &:hover,\n    &:focus {\n      color: @btn-link-disabled-color;\n      text-decoration: none;\n    }\n  }\n}\n\n\n// Button Sizes\n// --------------------------------------------------\n\n.btn-lg {\n  // line-height: ensure even-numbered height of button next to large input\n  .button-size(@padding-large-vertical; @padding-large-horizontal; @font-size-large; @line-height-large; @btn-border-radius-large);\n}\n.btn-sm {\n  // line-height: ensure proper height of button next to small input\n  .button-size(@padding-small-vertical; @padding-small-horizontal; @font-size-small; @line-height-small; @btn-border-radius-small);\n}\n.btn-xs {\n  .button-size(@padding-xs-vertical; @padding-xs-horizontal; @font-size-small; @line-height-small; @btn-border-radius-small);\n}\n\n\n// Block button\n// --------------------------------------------------\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n\n// Vertically space out multiple block buttons\n.btn-block + .btn-block {\n  margin-top: 5px;\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n.button-variant(@color; @background; @border) {\n  color: @color;\n  background-color: @background;\n  border-color: @border;\n\n  &:focus,\n  &.focus {\n    color: @color;\n    background-color: darken(@background, 10%);\n    border-color: darken(@border, 25%);\n  }\n  &:hover {\n    color: @color;\n    background-color: darken(@background, 10%);\n    border-color: darken(@border, 12%);\n  }\n  &:active,\n  &.active,\n  .open > .dropdown-toggle& {\n    color: @color;\n    background-color: darken(@background, 10%);\n    background-image: none;\n    border-color: darken(@border, 12%);\n\n    &:hover,\n    &:focus,\n    &.focus {\n      color: @color;\n      background-color: darken(@background, 17%);\n      border-color: darken(@border, 25%);\n    }\n  }\n  &.disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &:hover,\n    &:focus,\n    &.focus {\n      background-color: @background;\n      border-color: @border;\n    }\n  }\n\n  .badge {\n    color: @background;\n    background-color: @color;\n  }\n}\n\n// Button sizes\n.button-size(@padding-vertical; @padding-horizontal; @font-size; @line-height; @border-radius) {\n  padding: @padding-vertical @padding-horizontal;\n  font-size: @font-size;\n  line-height: @line-height;\n  border-radius: @border-radius;\n}\n","// Opacity\n\n.opacity(@opacity) {\n  @opacity-ie: (@opacity * 100);  // IE8 filter\n  filter: ~\"alpha(opacity=@{opacity-ie})\";\n  opacity: @opacity;\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Component animations\n// --------------------------------------------------\n\n// Heads up!\n//\n// We don't use the `.opacity()` mixin here since it causes a bug with text\n// fields in IE7-8. Source: https://github.com/twbs/bootstrap/pull/3552.\n\n.fade {\n  opacity: 0;\n  .transition(opacity .15s linear);\n\n  &.in {\n    opacity: 1;\n  }\n}\n\n.collapse {\n  display: none;\n\n  &.in      { display: block; }\n  tr&.in    { display: table-row; }\n  tbody&.in { display: table-row-group; }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  .transition-property(~\"height, visibility\");\n  .transition-duration(.35s);\n  .transition-timing-function(ease);\n}\n","//\n// Dropdown menus\n// --------------------------------------------------\n\n\n// Dropdown arrow/caret\n.caret {\n  display: inline-block;\n  width: 0;\n  height: 0;\n  margin-left: 2px;\n  vertical-align: middle;\n  border-top: @caret-width-base dashed;\n  border-top: @caret-width-base solid ~\"\\9\"; // IE8\n  border-right: @caret-width-base solid transparent;\n  border-left: @caret-width-base solid transparent;\n}\n\n// The dropdown wrapper (div)\n.dropup,\n.dropdown {\n  position: relative;\n}\n\n// Prevent the focus on the dropdown toggle when closing dropdowns\n.dropdown-toggle:focus {\n  outline: 0;\n}\n\n// The dropdown menu (ul)\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: @zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: 160px;\n  padding: 5px 0;\n  margin: 2px 0 0; // override default ul\n  font-size: @font-size-base;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: @dropdown-bg;\n  background-clip: padding-box;\n  border: 1px solid @dropdown-fallback-border; // IE8 fallback\n  border: 1px solid @dropdown-border;\n  border-radius: @border-radius-base;\n  .box-shadow(0 6px 12px rgba(0, 0, 0, .175));\n\n  // Aligns the dropdown menu to right\n  //\n  // Deprecated as of 3.1.0 in favor of `.dropdown-menu-[dir]`\n  &.pull-right {\n    right: 0;\n    left: auto;\n  }\n\n  // Dividers (basically an hr) within the dropdown\n  .divider {\n    .nav-divider(@dropdown-divider-bg);\n  }\n\n  // Links within the dropdown menu\n  > li > a {\n    display: block;\n    padding: 3px 20px;\n    clear: both;\n    font-weight: 400;\n    line-height: @line-height-base;\n    color: @dropdown-link-color;\n    white-space: nowrap; // prevent links from randomly breaking onto new lines\n\n    &:hover,\n    &:focus {\n      color: @dropdown-link-hover-color;\n      text-decoration: none;\n      background-color: @dropdown-link-hover-bg;\n    }\n  }\n}\n\n// Active state\n.dropdown-menu > .active > a {\n  &,\n  &:hover,\n  &:focus {\n    color: @dropdown-link-active-color;\n    text-decoration: none;\n    background-color: @dropdown-link-active-bg;\n    outline: 0;\n  }\n}\n\n// Disabled state\n//\n// Gray out text and ensure the hover/focus state remains gray\n\n.dropdown-menu > .disabled > a {\n  &,\n  &:hover,\n  &:focus {\n    color: @dropdown-link-disabled-color;\n  }\n\n  // Nuke hover/focus effects\n  &:hover,\n  &:focus {\n    text-decoration: none;\n    cursor: @cursor-disabled;\n    background-color: transparent;\n    background-image: none; // Remove CSS gradient\n    .reset-filter();\n  }\n}\n\n// Open state for the dropdown\n.open {\n  // Show the menu\n  > .dropdown-menu {\n    display: block;\n  }\n\n  // Remove the outline when :focus is triggered\n  > a {\n    outline: 0;\n  }\n}\n\n// Menu positioning\n//\n// Add extra class to `.dropdown-menu` to flip the alignment of the dropdown\n// menu with the parent.\n.dropdown-menu-right {\n  right: 0;\n  left: auto; // Reset the default from `.dropdown-menu`\n}\n// With v3, we enabled auto-flipping if you have a dropdown within a right\n// aligned nav component. To enable the undoing of that, we provide an override\n// to restore the default dropdown menu alignment.\n//\n// This is only for left-aligning a dropdown menu within a `.navbar-right` or\n// `.pull-right` nav component.\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: 3px 20px;\n  font-size: @font-size-small;\n  line-height: @line-height-base;\n  color: @dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Backdrop to catch body clicks on mobile, etc.\n.dropdown-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: (@zindex-dropdown - 10);\n}\n\n// Right aligned dropdowns\n.pull-right > .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n//\n// Just add .dropup after the standard .dropdown class and you're set, bro.\n// TODO: abstract this so that the navbar fixed styles are not placed here?\n\n.dropup,\n.navbar-fixed-bottom .dropdown {\n  // Reverse the caret\n  .caret {\n    content: \"\";\n    border-top: 0;\n    border-bottom: @caret-width-base dashed;\n    border-bottom: @caret-width-base solid ~\"\\9\"; // IE8\n  }\n  // Different positioning for bottom up menu\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-bottom: 2px;\n  }\n}\n\n\n// Component alignment\n//\n// Reiterate per navbar.less and the modified component alignment there.\n\n@media (min-width: @grid-float-breakpoint) {\n  .navbar-right {\n    .dropdown-menu {\n      .dropdown-menu-right();\n    }\n    // Necessary for overrides of the default right aligned menu.\n    // Will remove come v4 in all likelihood.\n    .dropdown-menu-left {\n      .dropdown-menu-left();\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n.nav-divider(@color: #e5e5e5) {\n  height: 1px;\n  margin: ((@line-height-computed / 2) - 1) 0;\n  overflow: hidden;\n  background-color: @color;\n}\n","// Reset filters for IE\n//\n// When you need to remove a gradient background, do not forget to use this to reset\n// the IE filter for IE9 and below.\n\n.reset-filter() {\n  filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(enabled = false)\"));\n}\n","// stylelint-disable selector-no-qualifying-type */\n\n//\n// Button groups\n// --------------------------------------------------\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n  > .btn {\n    position: relative;\n    float: left;\n    // Bring the \"active\" button to the front\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 2;\n    }\n  }\n}\n\n// Prevent double borders when buttons are next to each other\n.btn-group {\n  .btn + .btn,\n  .btn + .btn-group,\n  .btn-group + .btn,\n  .btn-group + .btn-group {\n    margin-left: -1px;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  margin-left: -5px; // Offset the first child's margin\n  &:extend(.clearfix all);\n\n  .btn,\n  .btn-group,\n  .input-group {\n    float: left;\n  }\n  > .btn,\n  > .btn-group,\n  > .input-group {\n    margin-left: 5px;\n  }\n}\n\n.btn-group > .btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {\n  border-radius: 0;\n}\n\n// Set corners individual because sometimes a single button can be in a .btn-group and we need :first-child and :last-child to both match\n.btn-group > .btn:first-child {\n  margin-left: 0;\n  &:not(:last-child):not(.dropdown-toggle) {\n    .border-right-radius(0);\n  }\n}\n// Need .dropdown-toggle since :last-child doesn't apply, given that a .dropdown-menu is used immediately after it\n.btn-group > .btn:last-child:not(:first-child),\n.btn-group > .dropdown-toggle:not(:first-child) {\n  .border-left-radius(0);\n}\n\n// Custom edits for including btn-groups within btn-groups (useful for including dropdown buttons within a btn-group)\n.btn-group > .btn-group {\n  float: left;\n}\n.btn-group > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group > .btn-group:first-child:not(:last-child) {\n  > .btn:last-child,\n  > .dropdown-toggle {\n    .border-right-radius(0);\n  }\n}\n.btn-group > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  .border-left-radius(0);\n}\n\n// On active and open, don't show outline\n.btn-group .dropdown-toggle:active,\n.btn-group.open .dropdown-toggle {\n  outline: 0;\n}\n\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-xs > .btn { &:extend(.btn-xs); }\n.btn-group-sm > .btn { &:extend(.btn-sm); }\n.btn-group-lg > .btn { &:extend(.btn-lg); }\n\n\n// Split button dropdowns\n// ----------------------\n\n// Give the line between buttons some depth\n.btn-group > .btn + .dropdown-toggle {\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.btn-group > .btn-lg + .dropdown-toggle {\n  padding-right: 12px;\n  padding-left: 12px;\n}\n\n// The clickable button for toggling the menu\n// Remove the gradient and set the same inset shadow as the :active state\n.btn-group.open .dropdown-toggle {\n  .box-shadow(inset 0 3px 5px rgba(0, 0, 0, .125));\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    .box-shadow(none);\n  }\n}\n\n\n// Reposition the caret\n.btn .caret {\n  margin-left: 0;\n}\n// Carets in other button sizes\n.btn-lg .caret {\n  border-width: @caret-width-large @caret-width-large 0;\n  border-bottom-width: 0;\n}\n// Upside down carets for .dropup\n.dropup .btn-lg .caret {\n  border-width: 0 @caret-width-large @caret-width-large;\n}\n\n\n// Vertical button groups\n// ----------------------\n\n.btn-group-vertical {\n  > .btn,\n  > .btn-group,\n  > .btn-group > .btn {\n    display: block;\n    float: none;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  // Clear floats so dropdown menus can be properly placed\n  > .btn-group {\n    &:extend(.clearfix all);\n    > .btn {\n      float: none;\n    }\n  }\n\n  > .btn + .btn,\n  > .btn + .btn-group,\n  > .btn-group + .btn,\n  > .btn-group + .btn-group {\n    margin-top: -1px;\n    margin-left: 0;\n  }\n}\n\n.btn-group-vertical > .btn {\n  &:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n  &:first-child:not(:last-child) {\n    .border-top-radius(@btn-border-radius-base);\n    .border-bottom-radius(0);\n  }\n  &:last-child:not(:first-child) {\n    .border-top-radius(0);\n    .border-bottom-radius(@btn-border-radius-base);\n  }\n}\n.btn-group-vertical > .btn-group:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.btn-group-vertical > .btn-group:first-child:not(:last-child) {\n  > .btn:last-child,\n  > .dropdown-toggle {\n    .border-bottom-radius(0);\n  }\n}\n.btn-group-vertical > .btn-group:last-child:not(:first-child) > .btn:first-child {\n  .border-top-radius(0);\n}\n\n\n// Justified button groups\n// ----------------------\n\n.btn-group-justified {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: separate;\n  > .btn,\n  > .btn-group {\n    display: table-cell;\n    float: none;\n    width: 1%;\n  }\n  > .btn-group .btn {\n    width: 100%;\n  }\n\n  > .btn-group .dropdown-menu {\n    left: auto;\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n[data-toggle=\"buttons\"] {\n  > .btn,\n  > .btn-group > .btn {\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// Single side border-radius\n\n.border-top-radius(@radius) {\n  border-top-left-radius: @radius;\n  border-top-right-radius: @radius;\n}\n.border-right-radius(@radius) {\n  border-top-right-radius: @radius;\n  border-bottom-right-radius: @radius;\n}\n.border-bottom-radius(@radius) {\n  border-bottom-right-radius: @radius;\n  border-bottom-left-radius: @radius;\n}\n.border-left-radius(@radius) {\n  border-top-left-radius: @radius;\n  border-bottom-left-radius: @radius;\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Input groups\n// --------------------------------------------------\n\n// Base styles\n// -------------------------\n.input-group {\n  position: relative; // For dropdowns\n  display: table;\n  border-collapse: separate; // prevent input groups from inheriting border styles from table cells when placed within a table\n\n  // Undo padding and float of grid classes\n  &[class*=\"col-\"] {\n    float: none;\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .form-control {\n    // Ensure that the input is always above the *appended* addon button for\n    // proper border colors.\n    position: relative;\n    z-index: 2;\n\n    // IE9 fubars the placeholder attribute in text inputs and the arrows on\n    // select elements in input groups. To fix it, we float the input. Details:\n    // https://github.com/twbs/bootstrap/issues/11561#issuecomment-28936855\n    float: left;\n\n    width: 100%;\n    margin-bottom: 0;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n}\n\n// Sizing options\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .input-group-addon,\n.input-group-lg > .input-group-btn > .btn {\n  .input-lg();\n}\n.input-group-sm > .form-control,\n.input-group-sm > .input-group-addon,\n.input-group-sm > .input-group-btn > .btn {\n  .input-sm();\n}\n\n\n// Display as table-cell\n// -------------------------\n.input-group-addon,\n.input-group-btn,\n.input-group .form-control {\n  display: table-cell;\n\n  &:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n}\n// Addon and addon wrapper for buttons\n.input-group-addon,\n.input-group-btn {\n  width: 1%;\n  white-space: nowrap;\n  vertical-align: middle; // Match the inputs\n}\n\n// Text input groups\n// -------------------------\n.input-group-addon {\n  padding: @padding-base-vertical @padding-base-horizontal;\n  font-size: @font-size-base;\n  font-weight: 400;\n  line-height: 1;\n  color: @input-color;\n  text-align: center;\n  background-color: @input-group-addon-bg;\n  border: 1px solid @input-group-addon-border-color;\n  border-radius: @input-border-radius;\n\n  // Sizing\n  &.input-sm {\n    padding: @padding-small-vertical @padding-small-horizontal;\n    font-size: @font-size-small;\n    border-radius: @input-border-radius-small;\n  }\n  &.input-lg {\n    padding: @padding-large-vertical @padding-large-horizontal;\n    font-size: @font-size-large;\n    border-radius: @input-border-radius-large;\n  }\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n// Reset rounded corners\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .btn,\n.input-group-btn:first-child > .btn-group > .btn,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group-btn:last-child > .btn-group:not(:last-child) > .btn {\n  .border-right-radius(0);\n}\n.input-group-addon:first-child {\n  border-right: 0;\n}\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .btn,\n.input-group-btn:last-child > .btn-group > .btn,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child),\n.input-group-btn:first-child > .btn-group:not(:first-child) > .btn {\n  .border-left-radius(0);\n}\n.input-group-addon:last-child {\n  border-left: 0;\n}\n\n// Button input groups\n// -------------------------\n.input-group-btn {\n  position: relative;\n  // Jankily prevent input button groups from wrapping with `white-space` and\n  // `font-size` in combination with `inline-block` on buttons.\n  font-size: 0;\n  white-space: nowrap;\n\n  // Negative margin for spacing, position for bringing hovered/focused/actived\n  // element above the siblings.\n  > .btn {\n    position: relative;\n    + .btn {\n      margin-left: -1px;\n    }\n    // Bring the \"active\" button to the front\n    &:hover,\n    &:focus,\n    &:active {\n      z-index: 2;\n    }\n  }\n\n  // Negative margin to only have a 1px border between the two\n  &:first-child {\n    > .btn,\n    > .btn-group {\n      margin-right: -1px;\n    }\n  }\n  &:last-child {\n    > .btn,\n    > .btn-group {\n      z-index: 2;\n      margin-left: -1px;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type, selector-max-type\n\n//\n// Navs\n// --------------------------------------------------\n\n\n// Base class\n// --------------------------------------------------\n\n.nav {\n  padding-left: 0; // Override default ul/ol\n  margin-bottom: 0;\n  list-style: none;\n  &:extend(.clearfix all);\n\n  > li {\n    position: relative;\n    display: block;\n\n    > a {\n      position: relative;\n      display: block;\n      padding: @nav-link-padding;\n      &:hover,\n      &:focus {\n        text-decoration: none;\n        background-color: @nav-link-hover-bg;\n      }\n    }\n\n    // Disabled state sets text to gray and nukes hover/tab effects\n    &.disabled > a {\n      color: @nav-disabled-link-color;\n\n      &:hover,\n      &:focus {\n        color: @nav-disabled-link-hover-color;\n        text-decoration: none;\n        cursor: @cursor-disabled;\n        background-color: transparent;\n      }\n    }\n  }\n\n  // Open dropdowns\n  .open > a {\n    &,\n    &:hover,\n    &:focus {\n      background-color: @nav-link-hover-bg;\n      border-color: @link-color;\n    }\n  }\n\n  // Nav dividers (deprecated with v3.0.1)\n  //\n  // This should have been removed in v3 with the dropping of `.nav-list`, but\n  // we missed it. We don't currently support this anywhere, but in the interest\n  // of maintaining backward compatibility in case you use it, it's deprecated.\n  .nav-divider {\n    .nav-divider();\n  }\n\n  // Prevent IE8 from misplacing imgs\n  //\n  // See https://github.com/h5bp/html5-boilerplate/issues/984#issuecomment-3985989\n  > li > a > img {\n    max-width: none;\n  }\n}\n\n\n// Tabs\n// -------------------------\n\n// Give the tabs something to sit on\n.nav-tabs {\n  border-bottom: 1px solid @nav-tabs-border-color;\n  > li {\n    float: left;\n    // Make the list-items overlay the bottom border\n    margin-bottom: -1px;\n\n    // Actual tabs (as links)\n    > a {\n      margin-right: 2px;\n      line-height: @line-height-base;\n      border: 1px solid transparent;\n      border-radius: @border-radius-base @border-radius-base 0 0;\n      &:hover {\n        border-color: @nav-tabs-link-hover-border-color @nav-tabs-link-hover-border-color @nav-tabs-border-color;\n      }\n    }\n\n    // Active state, and its :hover to override normal :hover\n    &.active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @nav-tabs-active-link-hover-color;\n        cursor: default;\n        background-color: @nav-tabs-active-link-hover-bg;\n        border: 1px solid @nav-tabs-active-link-hover-border-color;\n        border-bottom-color: transparent;\n      }\n    }\n  }\n  // pulling this in mainly for less shorthand\n  &.nav-justified {\n    .nav-justified();\n    .nav-tabs-justified();\n  }\n}\n\n\n// Pills\n// -------------------------\n.nav-pills {\n  > li {\n    float: left;\n\n    // Links rendered as pills\n    > a {\n      border-radius: @nav-pills-border-radius;\n    }\n    + li {\n      margin-left: 2px;\n    }\n\n    // Active state\n    &.active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @nav-pills-active-link-hover-color;\n        background-color: @nav-pills-active-link-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Stacked pills\n.nav-stacked {\n  > li {\n    float: none;\n    + li {\n      margin-top: 2px;\n      margin-left: 0; // no need for this gap between nav items\n    }\n  }\n}\n\n\n// Nav variations\n// --------------------------------------------------\n\n// Justified nav links\n// -------------------------\n\n.nav-justified {\n  width: 100%;\n\n  > li {\n    float: none;\n    > a {\n      margin-bottom: 5px;\n      text-align: center;\n    }\n  }\n\n  > .dropdown .dropdown-menu {\n    top: auto;\n    left: auto;\n  }\n\n  @media (min-width: @screen-sm-min) {\n    > li {\n      display: table-cell;\n      width: 1%;\n      > a {\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n\n// Move borders to anchors instead of bottom of list\n//\n// Mixin for adding on top the shared `.nav-justified` styles for our tabs\n.nav-tabs-justified {\n  border-bottom: 0;\n\n  > li > a {\n    // Override margin from .nav-tabs\n    margin-right: 0;\n    border-radius: @border-radius-base;\n  }\n\n  > .active > a,\n  > .active > a:hover,\n  > .active > a:focus {\n    border: 1px solid @nav-tabs-justified-link-border-color;\n  }\n\n  @media (min-width: @screen-sm-min) {\n    > li > a {\n      border-bottom: 1px solid @nav-tabs-justified-link-border-color;\n      border-radius: @border-radius-base @border-radius-base 0 0;\n    }\n    > .active > a,\n    > .active > a:hover,\n    > .active > a:focus {\n      border-bottom-color: @nav-tabs-justified-active-link-border-color;\n    }\n  }\n}\n\n\n// Tabbable tabs\n// -------------------------\n\n// Hide tabbable panes to start, show them when `.active`\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n\n\n// Dropdowns\n// -------------------------\n\n// Specific dropdowns\n.nav-tabs .dropdown-menu {\n  // make dropdown border overlap tab border\n  margin-top: -1px;\n  // Remove the top rounded corners here since there is a hard edge above the menu\n  .border-top-radius(0);\n}\n","// stylelint-disable selector-max-type, selector-max-compound-selectors, selector-max-combinators, selector-max-class, declaration-no-important, selector-no-qualifying-type\n\n//\n// Navbars\n// --------------------------------------------------\n\n\n// Wrapper and base class\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  min-height: @navbar-height; // Ensure a navbar always shows (e.g., without a .navbar-brand in collapsed mode)\n  margin-bottom: @navbar-margin-bottom;\n  border: 1px solid transparent;\n\n  // Prevent floats from breaking the navbar\n  &:extend(.clearfix all);\n\n  @media (min-width: @grid-float-breakpoint) {\n    border-radius: @navbar-border-radius;\n  }\n}\n\n\n// Navbar heading\n//\n// Groups `.navbar-brand` and `.navbar-toggle` into a single component for easy\n// styling of responsive aspects.\n\n.navbar-header {\n  &:extend(.clearfix all);\n\n  @media (min-width: @grid-float-breakpoint) {\n    float: left;\n  }\n}\n\n\n// Navbar collapse (body)\n//\n// Group your navbar content into this for easy collapsing and expanding across\n// various device sizes. By default, this content is collapsed when <768px, but\n// will expand past that for a horizontal display.\n//\n// To start (on mobile devices) the navbar links, forms, and buttons are stacked\n// vertically and include a `max-height` to overflow in case you have too much\n// content for the user's viewport.\n\n.navbar-collapse {\n  padding-right: @navbar-padding-horizontal;\n  padding-left: @navbar-padding-horizontal;\n  overflow-x: visible;\n  border-top: 1px solid transparent;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1);\n  &:extend(.clearfix all);\n  -webkit-overflow-scrolling: touch;\n\n  &.in {\n    overflow-y: auto;\n  }\n\n  @media (min-width: @grid-float-breakpoint) {\n    width: auto;\n    border-top: 0;\n    box-shadow: none;\n\n    &.collapse {\n      display: block !important;\n      height: auto !important;\n      padding-bottom: 0; // Override default setting\n      overflow: visible !important;\n    }\n\n    &.in {\n      overflow-y: visible;\n    }\n\n    // Undo the collapse side padding for navbars with containers to ensure\n    // alignment of right-aligned contents.\n    .navbar-fixed-top &,\n    .navbar-static-top &,\n    .navbar-fixed-bottom & {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n.navbar-fixed-top,\n.navbar-fixed-bottom {\n  .navbar-collapse {\n    max-height: @navbar-collapse-max-height;\n\n    @media (max-device-width: @screen-xs-min) and (orientation: landscape) {\n      max-height: 200px;\n    }\n  }\n\n  // Fix the top/bottom navbars when screen real estate supports it\n  position: fixed;\n  right: 0;\n  left: 0;\n  z-index: @zindex-navbar-fixed;\n\n  // Undo the rounded corners\n  @media (min-width: @grid-float-breakpoint) {\n    border-radius: 0;\n  }\n}\n\n.navbar-fixed-top {\n  top: 0;\n  border-width: 0 0 1px;\n}\n.navbar-fixed-bottom {\n  bottom: 0;\n  margin-bottom: 0; // override .navbar defaults\n  border-width: 1px 0 0;\n}\n\n\n// Both navbar header and collapse\n//\n// When a container is present, change the behavior of the header and collapse.\n\n.container,\n.container-fluid {\n  > .navbar-header,\n  > .navbar-collapse {\n    margin-right: -@navbar-padding-horizontal;\n    margin-left: -@navbar-padding-horizontal;\n\n    @media (min-width: @grid-float-breakpoint) {\n      margin-right: 0;\n      margin-left: 0;\n    }\n  }\n}\n\n\n//\n// Navbar alignment options\n//\n// Display the navbar across the entirety of the page or fixed it to the top or\n// bottom of the page.\n\n// Static top (unfixed, but 100% wide) navbar\n.navbar-static-top {\n  z-index: @zindex-navbar;\n  border-width: 0 0 1px;\n\n  @media (min-width: @grid-float-breakpoint) {\n    border-radius: 0;\n  }\n}\n\n\n// Brand/project name\n\n.navbar-brand {\n  float: left;\n  height: @navbar-height;\n  padding: @navbar-padding-vertical @navbar-padding-horizontal;\n  font-size: @font-size-large;\n  line-height: @line-height-computed;\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n  }\n\n  > img {\n    display: block;\n  }\n\n  @media (min-width: @grid-float-breakpoint) {\n    .navbar > .container &,\n    .navbar > .container-fluid & {\n      margin-left: -@navbar-padding-horizontal;\n    }\n  }\n}\n\n\n// Navbar toggle\n//\n// Custom button for toggling the `.navbar-collapse`, powered by the collapse\n// JavaScript plugin.\n\n.navbar-toggle {\n  position: relative;\n  float: right;\n  padding: 9px 10px;\n  margin-right: @navbar-padding-horizontal;\n  .navbar-vertical-align(34px);\n  background-color: transparent;\n  background-image: none; // Reset unusual Firefox-on-Android default style; see https://github.com/necolas/normalize.css/issues/214\n  border: 1px solid transparent;\n  border-radius: @border-radius-base;\n\n  // We remove the `outline` here, but later compensate by attaching `:hover`\n  // styles to `:focus`.\n  &:focus {\n    outline: 0;\n  }\n\n  // Bars\n  .icon-bar {\n    display: block;\n    width: 22px;\n    height: 2px;\n    border-radius: 1px;\n  }\n  .icon-bar + .icon-bar {\n    margin-top: 4px;\n  }\n\n  @media (min-width: @grid-float-breakpoint) {\n    display: none;\n  }\n}\n\n\n// Navbar nav links\n//\n// Builds on top of the `.nav` components with its own modifier class to make\n// the nav the full height of the horizontal nav (above 768px).\n\n.navbar-nav {\n  margin: (@navbar-padding-vertical / 2) -@navbar-padding-horizontal;\n\n  > li > a {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    line-height: @line-height-computed;\n  }\n\n  @media (max-width: @grid-float-breakpoint-max) {\n    // Dropdowns get custom display when collapsed\n    .open .dropdown-menu {\n      position: static;\n      float: none;\n      width: auto;\n      margin-top: 0;\n      background-color: transparent;\n      border: 0;\n      box-shadow: none;\n      > li > a,\n      .dropdown-header {\n        padding: 5px 15px 5px 25px;\n      }\n      > li > a {\n        line-height: @line-height-computed;\n        &:hover,\n        &:focus {\n          background-image: none;\n        }\n      }\n    }\n  }\n\n  // Uncollapse the nav\n  @media (min-width: @grid-float-breakpoint) {\n    float: left;\n    margin: 0;\n\n    > li {\n      float: left;\n      > a {\n        padding-top: @navbar-padding-vertical;\n        padding-bottom: @navbar-padding-vertical;\n      }\n    }\n  }\n}\n\n\n// Navbar form\n//\n// Extension of the `.form-inline` with some extra flavor for optimum display in\n// our navbars.\n\n.navbar-form {\n  padding: 10px @navbar-padding-horizontal;\n  margin-right: -@navbar-padding-horizontal;\n  margin-left: -@navbar-padding-horizontal;\n  border-top: 1px solid transparent;\n  border-bottom: 1px solid transparent;\n  @shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .1);\n  .box-shadow(@shadow);\n\n  // Mixin behavior for optimum display\n  .form-inline();\n\n  .form-group {\n    @media (max-width: @grid-float-breakpoint-max) {\n      margin-bottom: 5px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  // Vertically center in expanded, horizontal navbar\n  .navbar-vertical-align(@input-height-base);\n\n  // Undo 100% width for pull classes\n  @media (min-width: @grid-float-breakpoint) {\n    width: auto;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-right: 0;\n    margin-left: 0;\n    border: 0;\n    .box-shadow(none);\n  }\n}\n\n\n// Dropdown menus\n\n// Menu position and menu carets\n.navbar-nav > li > .dropdown-menu {\n  margin-top: 0;\n  .border-top-radius(0);\n}\n// Menu position and menu caret support for dropups via extra dropup class\n.navbar-fixed-bottom .navbar-nav > li > .dropdown-menu {\n  margin-bottom: 0;\n  .border-top-radius(@navbar-border-radius);\n  .border-bottom-radius(0);\n}\n\n\n// Buttons in navbars\n//\n// Vertically center a button within a navbar (when *not* in a form).\n\n.navbar-btn {\n  .navbar-vertical-align(@input-height-base);\n\n  &.btn-sm {\n    .navbar-vertical-align(@input-height-small);\n  }\n  &.btn-xs {\n    .navbar-vertical-align(22);\n  }\n}\n\n\n// Text in navbars\n//\n// Add a class to make any element properly align itself vertically within the navbars.\n\n.navbar-text {\n  .navbar-vertical-align(@line-height-computed);\n\n  @media (min-width: @grid-float-breakpoint) {\n    float: left;\n    margin-right: @navbar-padding-horizontal;\n    margin-left: @navbar-padding-horizontal;\n  }\n}\n\n\n// Component alignment\n//\n// Repurpose the pull utilities as their own navbar utilities to avoid specificity\n// issues with parents and chaining. Only do this when the navbar is uncollapsed\n// though so that navbar contents properly stack and align in mobile.\n//\n// Declared after the navbar components to ensure more specificity on the margins.\n\n@media (min-width: @grid-float-breakpoint) {\n  .navbar-left  { .pull-left(); }\n  .navbar-right {\n    .pull-right();\n    margin-right: -@navbar-padding-horizontal;\n\n    ~ .navbar-right {\n      margin-right: 0;\n    }\n  }\n}\n\n\n// Alternate navbars\n// --------------------------------------------------\n\n// Default navbar\n.navbar-default {\n  background-color: @navbar-default-bg;\n  border-color: @navbar-default-border;\n\n  .navbar-brand {\n    color: @navbar-default-brand-color;\n    &:hover,\n    &:focus {\n      color: @navbar-default-brand-hover-color;\n      background-color: @navbar-default-brand-hover-bg;\n    }\n  }\n\n  .navbar-text {\n    color: @navbar-default-color;\n  }\n\n  .navbar-nav {\n    > li > a {\n      color: @navbar-default-link-color;\n\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-hover-color;\n        background-color: @navbar-default-link-hover-bg;\n      }\n    }\n    > .active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-active-color;\n        background-color: @navbar-default-link-active-bg;\n      }\n    }\n    > .disabled > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-disabled-color;\n        background-color: @navbar-default-link-disabled-bg;\n      }\n    }\n\n    // Dropdown menu items\n    // Remove background color from open dropdown\n    > .open > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-active-color;\n        background-color: @navbar-default-link-active-bg;\n      }\n    }\n\n    @media (max-width: @grid-float-breakpoint-max) {\n      // Dropdowns get custom display when collapsed\n      .open .dropdown-menu {\n        > li > a {\n          color: @navbar-default-link-color;\n          &:hover,\n          &:focus {\n            color: @navbar-default-link-hover-color;\n            background-color: @navbar-default-link-hover-bg;\n          }\n        }\n        > .active > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-default-link-active-color;\n            background-color: @navbar-default-link-active-bg;\n          }\n        }\n        > .disabled > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-default-link-disabled-color;\n            background-color: @navbar-default-link-disabled-bg;\n          }\n        }\n      }\n    }\n  }\n\n  .navbar-toggle {\n    border-color: @navbar-default-toggle-border-color;\n    &:hover,\n    &:focus {\n      background-color: @navbar-default-toggle-hover-bg;\n    }\n    .icon-bar {\n      background-color: @navbar-default-toggle-icon-bar-bg;\n    }\n  }\n\n  .navbar-collapse,\n  .navbar-form {\n    border-color: @navbar-default-border;\n  }\n\n\n  // Links in navbars\n  //\n  // Add a class to ensure links outside the navbar nav are colored correctly.\n\n  .navbar-link {\n    color: @navbar-default-link-color;\n    &:hover {\n      color: @navbar-default-link-hover-color;\n    }\n  }\n\n  .btn-link {\n    color: @navbar-default-link-color;\n    &:hover,\n    &:focus {\n      color: @navbar-default-link-hover-color;\n    }\n    &[disabled],\n    fieldset[disabled] & {\n      &:hover,\n      &:focus {\n        color: @navbar-default-link-disabled-color;\n      }\n    }\n  }\n}\n\n// Inverse navbar\n\n.navbar-inverse {\n  background-color: @navbar-inverse-bg;\n  border-color: @navbar-inverse-border;\n\n  .navbar-brand {\n    color: @navbar-inverse-brand-color;\n    &:hover,\n    &:focus {\n      color: @navbar-inverse-brand-hover-color;\n      background-color: @navbar-inverse-brand-hover-bg;\n    }\n  }\n\n  .navbar-text {\n    color: @navbar-inverse-color;\n  }\n\n  .navbar-nav {\n    > li > a {\n      color: @navbar-inverse-link-color;\n\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-hover-color;\n        background-color: @navbar-inverse-link-hover-bg;\n      }\n    }\n    > .active > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-active-color;\n        background-color: @navbar-inverse-link-active-bg;\n      }\n    }\n    > .disabled > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-disabled-color;\n        background-color: @navbar-inverse-link-disabled-bg;\n      }\n    }\n\n    // Dropdowns\n    > .open > a {\n      &,\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-active-color;\n        background-color: @navbar-inverse-link-active-bg;\n      }\n    }\n\n    @media (max-width: @grid-float-breakpoint-max) {\n      // Dropdowns get custom display\n      .open .dropdown-menu {\n        > .dropdown-header {\n          border-color: @navbar-inverse-border;\n        }\n        .divider {\n          background-color: @navbar-inverse-border;\n        }\n        > li > a {\n          color: @navbar-inverse-link-color;\n          &:hover,\n          &:focus {\n            color: @navbar-inverse-link-hover-color;\n            background-color: @navbar-inverse-link-hover-bg;\n          }\n        }\n        > .active > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-inverse-link-active-color;\n            background-color: @navbar-inverse-link-active-bg;\n          }\n        }\n        > .disabled > a {\n          &,\n          &:hover,\n          &:focus {\n            color: @navbar-inverse-link-disabled-color;\n            background-color: @navbar-inverse-link-disabled-bg;\n          }\n        }\n      }\n    }\n  }\n\n  // Darken the responsive nav toggle\n  .navbar-toggle {\n    border-color: @navbar-inverse-toggle-border-color;\n    &:hover,\n    &:focus {\n      background-color: @navbar-inverse-toggle-hover-bg;\n    }\n    .icon-bar {\n      background-color: @navbar-inverse-toggle-icon-bar-bg;\n    }\n  }\n\n  .navbar-collapse,\n  .navbar-form {\n    border-color: darken(@navbar-inverse-bg, 7%);\n  }\n\n  .navbar-link {\n    color: @navbar-inverse-link-color;\n    &:hover {\n      color: @navbar-inverse-link-hover-color;\n    }\n  }\n\n  .btn-link {\n    color: @navbar-inverse-link-color;\n    &:hover,\n    &:focus {\n      color: @navbar-inverse-link-hover-color;\n    }\n    &[disabled],\n    fieldset[disabled] & {\n      &:hover,\n      &:focus {\n        color: @navbar-inverse-link-disabled-color;\n      }\n    }\n  }\n}\n","// Navbar vertical align\n//\n// Vertically center elements in the navbar.\n// Example: an element has a height of 30px, so write out `.navbar-vertical-align(30px);` to calculate the appropriate top margin.\n\n.navbar-vertical-align(@element-height) {\n  margin-top: ((@navbar-height - @element-height) / 2);\n  margin-bottom: ((@navbar-height - @element-height) / 2);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utility classes\n// --------------------------------------------------\n\n\n// Floats\n// -------------------------\n\n.clearfix {\n  .clearfix();\n}\n.center-block {\n  .center-block();\n}\n.pull-right {\n  float: right !important;\n}\n.pull-left {\n  float: left !important;\n}\n\n\n// Toggling content\n// -------------------------\n\n// Note: Deprecated .hide in favor of .hidden or .sr-only (as appropriate) in v3.0.1\n.hide {\n  display: none !important;\n}\n.show {\n  display: block !important;\n}\n.invisible {\n  visibility: hidden;\n}\n.text-hide {\n  .text-hide();\n}\n\n\n// Hide from screenreaders and browsers\n//\n// Credit: HTML5 Boilerplate\n\n.hidden {\n  display: none !important;\n}\n\n\n// For Affix plugin\n// -------------------------\n\n.affix {\n  position: fixed;\n}\n","// Bordered & Pulled\n// -------------------------\n\n.@{fa-css-prefix}-border {\n  padding: .2em .25em .15em;\n  border: solid .08em @fa-border-color;\n  border-radius: .1em;\n}\n\n.@{fa-css-prefix}-pull-left { float: left; }\n.@{fa-css-prefix}-pull-right { float: right; }\n\n.@{fa-css-prefix} {\n  &.@{fa-css-prefix}-pull-left { margin-right: .3em; }\n  &.@{fa-css-prefix}-pull-right { margin-left: .3em; }\n}\n\n/* Deprecated as of 4.4.0 */\n.pull-right { float: right; }\n.pull-left { float: left; }\n\n.@{fa-css-prefix} {\n  &.pull-left { margin-right: .3em; }\n  &.pull-right { margin-left: .3em; }\n}\n","//\n// Breadcrumbs\n// --------------------------------------------------\n\n\n.breadcrumb {\n  padding: @breadcrumb-padding-vertical @breadcrumb-padding-horizontal;\n  margin-bottom: @line-height-computed;\n  list-style: none;\n  background-color: @breadcrumb-bg;\n  border-radius: @border-radius-base;\n\n  > li {\n    display: inline-block;\n\n    + li:before {\n      padding: 0 5px;\n      color: @breadcrumb-color;\n      content: \"@{breadcrumb-separator}\\00a0\"; // Unicode space added since inline-block means non-collapsing white-space\n    }\n  }\n\n  > .active {\n    color: @breadcrumb-active-color;\n  }\n}\n","//\n// Pagination (multiple pages)\n// --------------------------------------------------\n.pagination {\n  display: inline-block;\n  padding-left: 0;\n  margin: @line-height-computed 0;\n  border-radius: @border-radius-base;\n\n  > li {\n    display: inline; // Remove list-style and block-level defaults\n    > a,\n    > span {\n      position: relative;\n      float: left; // Collapse white-space\n      padding: @padding-base-vertical @padding-base-horizontal;\n      margin-left: -1px;\n      line-height: @line-height-base;\n      color: @pagination-color;\n      text-decoration: none;\n      background-color: @pagination-bg;\n      border: 1px solid @pagination-border;\n\n      &:hover,\n      &:focus {\n        z-index: 2;\n        color: @pagination-hover-color;\n        background-color: @pagination-hover-bg;\n        border-color: @pagination-hover-border;\n      }\n    }\n    &:first-child {\n      > a,\n      > span {\n        margin-left: 0;\n        .border-left-radius(@border-radius-base);\n      }\n    }\n    &:last-child {\n      > a,\n      > span {\n        .border-right-radius(@border-radius-base);\n      }\n    }\n  }\n\n  > .active > a,\n  > .active > span {\n    &,\n    &:hover,\n    &:focus {\n      z-index: 3;\n      color: @pagination-active-color;\n      cursor: default;\n      background-color: @pagination-active-bg;\n      border-color: @pagination-active-border;\n    }\n  }\n\n  > .disabled {\n    > span,\n    > span:hover,\n    > span:focus,\n    > a,\n    > a:hover,\n    > a:focus {\n      color: @pagination-disabled-color;\n      cursor: @cursor-disabled;\n      background-color: @pagination-disabled-bg;\n      border-color: @pagination-disabled-border;\n    }\n  }\n}\n\n// Sizing\n// --------------------------------------------------\n\n// Large\n.pagination-lg {\n  .pagination-size(@padding-large-vertical; @padding-large-horizontal; @font-size-large; @line-height-large; @border-radius-large);\n}\n\n// Small\n.pagination-sm {\n  .pagination-size(@padding-small-vertical; @padding-small-horizontal; @font-size-small; @line-height-small; @border-radius-small);\n}\n","// Pagination\n\n.pagination-size(@padding-vertical; @padding-horizontal; @font-size; @line-height; @border-radius) {\n  > li {\n    > a,\n    > span {\n      padding: @padding-vertical @padding-horizontal;\n      font-size: @font-size;\n      line-height: @line-height;\n    }\n    &:first-child {\n      > a,\n      > span {\n        .border-left-radius(@border-radius);\n      }\n    }\n    &:last-child {\n      > a,\n      > span {\n        .border-right-radius(@border-radius);\n      }\n    }\n  }\n}\n","//\n// Pager pagination\n// --------------------------------------------------\n\n\n.pager {\n  padding-left: 0;\n  margin: @line-height-computed 0;\n  text-align: center;\n  list-style: none;\n  &:extend(.clearfix all);\n  li {\n    display: inline;\n    > a,\n    > span {\n      display: inline-block;\n      padding: 5px 14px;\n      background-color: @pager-bg;\n      border: 1px solid @pager-border;\n      border-radius: @pager-border-radius;\n    }\n\n    > a:hover,\n    > a:focus {\n      text-decoration: none;\n      background-color: @pager-hover-bg;\n    }\n  }\n\n  .next {\n    > a,\n    > span {\n      float: right;\n    }\n  }\n\n  .previous {\n    > a,\n    > span {\n      float: left;\n    }\n  }\n\n  .disabled {\n    > a,\n    > a:hover,\n    > a:focus,\n    > span {\n      color: @pager-disabled-color;\n      cursor: @cursor-disabled;\n      background-color: @pager-bg;\n    }\n  }\n}\n","//\n// Labels\n// --------------------------------------------------\n\n.label {\n  display: inline;\n  padding: .2em .6em .3em;\n  font-size: 75%;\n  font-weight: 700;\n  line-height: 1;\n  color: @label-color;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: .25em;\n\n  // Add hover effects, but only for links\n  a& {\n    &:hover,\n    &:focus {\n      color: @label-link-hover-color;\n      text-decoration: none;\n      cursor: pointer;\n    }\n  }\n\n  // Empty labels collapse automatically (not available in IE8)\n  &:empty {\n    display: none;\n  }\n\n  // Quick fix for labels in buttons\n  .btn & {\n    position: relative;\n    top: -1px;\n  }\n}\n\n// Colors\n// Contextual variations (linked labels get darker on :hover)\n\n.label-default {\n  .label-variant(@label-default-bg);\n}\n\n.label-primary {\n  .label-variant(@label-primary-bg);\n}\n\n.label-success {\n  .label-variant(@label-success-bg);\n}\n\n.label-info {\n  .label-variant(@label-info-bg);\n}\n\n.label-warning {\n  .label-variant(@label-warning-bg);\n}\n\n.label-danger {\n  .label-variant(@label-danger-bg);\n}\n","// Labels\n\n.label-variant(@color) {\n  background-color: @color;\n\n  &[href] {\n    &:hover,\n    &:focus {\n      background-color: darken(@color, 10%);\n    }\n  }\n}\n","//\n// Badges\n// --------------------------------------------------\n\n\n// Base class\n.badge {\n  display: inline-block;\n  min-width: 10px;\n  padding: 3px 7px;\n  font-size: @font-size-small;\n  font-weight: @badge-font-weight;\n  line-height: @badge-line-height;\n  color: @badge-color;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  background-color: @badge-bg;\n  border-radius: @badge-border-radius;\n\n  // Empty badges collapse automatically (not available in IE8)\n  &:empty {\n    display: none;\n  }\n\n  // Quick fix for badges in buttons\n  .btn & {\n    position: relative;\n    top: -1px;\n  }\n\n  .btn-xs &,\n  .btn-group-xs > .btn & {\n    top: 0;\n    padding: 1px 5px;\n  }\n\n  // Hover state, but only for links\n  a& {\n    &:hover,\n    &:focus {\n      color: @badge-link-hover-color;\n      text-decoration: none;\n      cursor: pointer;\n    }\n  }\n\n  // Account for badges in navs\n  .list-group-item.active > &,\n  .nav-pills > .active > a > & {\n    color: @badge-active-color;\n    background-color: @badge-active-bg;\n  }\n\n  .list-group-item > & {\n    float: right;\n  }\n\n  .list-group-item > & + & {\n    margin-right: 5px;\n  }\n\n  .nav-pills > li > a > & {\n    margin-left: 3px;\n  }\n}\n","//\n// Jumbotron\n// --------------------------------------------------\n\n\n.jumbotron {\n  padding-top: @jumbotron-padding;\n  padding-bottom: @jumbotron-padding;\n  margin-bottom: @jumbotron-padding;\n  color: @jumbotron-color;\n  background-color: @jumbotron-bg;\n\n  h1,\n  .h1 {\n    color: @jumbotron-heading-color;\n  }\n\n  p {\n    margin-bottom: (@jumbotron-padding / 2);\n    font-size: @jumbotron-font-size;\n    font-weight: 200;\n  }\n\n  > hr {\n    border-top-color: darken(@jumbotron-bg, 10%);\n  }\n\n  .container &,\n  .container-fluid & {\n    padding-right: (@grid-gutter-width / 2);\n    padding-left: (@grid-gutter-width / 2);\n    border-radius: @border-radius-large; // Only round corners at higher resolutions if contained in a container\n  }\n\n  .container {\n    max-width: 100%;\n  }\n\n  @media screen and (min-width: @screen-sm-min) {\n    padding-top: (@jumbotron-padding * 1.6);\n    padding-bottom: (@jumbotron-padding * 1.6);\n\n    .container &,\n    .container-fluid & {\n      padding-right: (@jumbotron-padding * 2);\n      padding-left: (@jumbotron-padding * 2);\n    }\n\n    h1,\n    .h1 {\n      font-size: @jumbotron-heading-font-size;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Thumbnails\n// --------------------------------------------------\n\n\n// Mixin and adjust the regular image class\n.thumbnail {\n  display: block;\n  padding: @thumbnail-padding;\n  margin-bottom: @line-height-computed;\n  line-height: @line-height-base;\n  background-color: @thumbnail-bg;\n  border: 1px solid @thumbnail-border;\n  border-radius: @thumbnail-border-radius;\n  .transition(border .2s ease-in-out);\n\n  > img,\n  a > img {\n    &:extend(.img-responsive);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  // Add a hover state for linked versions only\n  a&:hover,\n  a&:focus,\n  a&.active {\n    border-color: @link-color;\n  }\n\n  // Image captions\n  .caption {\n    padding: @thumbnail-caption-padding;\n    color: @thumbnail-caption-color;\n  }\n}\n","//\n// Alerts\n// --------------------------------------------------\n\n\n// Base styles\n// -------------------------\n\n.alert {\n  padding: @alert-padding;\n  margin-bottom: @line-height-computed;\n  border: 1px solid transparent;\n  border-radius: @alert-border-radius;\n\n  // Headings for larger alerts\n  h4 {\n    margin-top: 0;\n    color: inherit; // Specified for the h4 to prevent conflicts of changing @headings-color\n  }\n\n  // Provide class for links that match alerts\n  .alert-link {\n    font-weight: @alert-link-font-weight;\n  }\n\n  // Improve alignment and spacing of inner content\n  > p,\n  > ul {\n    margin-bottom: 0;\n  }\n\n  > p + p {\n    margin-top: 5px;\n  }\n}\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n// The misspelled .alert-dismissable was deprecated in 3.2.0.\n.alert-dismissable,\n.alert-dismissible {\n  padding-right: (@alert-padding + 20);\n\n  // Adjust close link position\n  .close {\n    position: relative;\n    top: -2px;\n    right: -21px;\n    color: inherit;\n  }\n}\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n.alert-success {\n  .alert-variant(@alert-success-bg; @alert-success-border; @alert-success-text);\n}\n\n.alert-info {\n  .alert-variant(@alert-info-bg; @alert-info-border; @alert-info-text);\n}\n\n.alert-warning {\n  .alert-variant(@alert-warning-bg; @alert-warning-border; @alert-warning-text);\n}\n\n.alert-danger {\n  .alert-variant(@alert-danger-bg; @alert-danger-border; @alert-danger-text);\n}\n","// Alerts\n\n.alert-variant(@background; @border; @text-color) {\n  color: @text-color;\n  background-color: @background;\n  border-color: @border;\n\n  hr {\n    border-top-color: darken(@border, 5%);\n  }\n\n  .alert-link {\n    color: darken(@text-color, 10%);\n  }\n}\n","// stylelint-disable at-rule-no-vendor-prefix\n\n//\n// Progress bars\n// --------------------------------------------------\n\n\n// Bar animations\n// -------------------------\n\n// WebKit\n@-webkit-keyframes progress-bar-stripes {\n  from  { background-position: 40px 0; }\n  to    { background-position: 0 0; }\n}\n\n// Spec and IE10+\n@keyframes progress-bar-stripes {\n  from  { background-position: 40px 0; }\n  to    { background-position: 0 0; }\n}\n\n\n// Bar itself\n// -------------------------\n\n// Outer container\n.progress {\n  height: @line-height-computed;\n  margin-bottom: @line-height-computed;\n  overflow: hidden;\n  background-color: @progress-bg;\n  border-radius: @progress-border-radius;\n  .box-shadow(inset 0 1px 2px rgba(0, 0, 0, .1));\n}\n\n// Bar of progress\n.progress-bar {\n  float: left;\n  width: 0%;\n  height: 100%;\n  font-size: @font-size-small;\n  line-height: @line-height-computed;\n  color: @progress-bar-color;\n  text-align: center;\n  background-color: @progress-bar-bg;\n  .box-shadow(inset 0 -1px 0 rgba(0, 0, 0, .15));\n  .transition(width .6s ease);\n}\n\n// Striped bars\n//\n// `.progress-striped .progress-bar` is deprecated as of v3.2.0 in favor of the\n// `.progress-bar-striped` class, which you just add to an existing\n// `.progress-bar`.\n.progress-striped .progress-bar,\n.progress-bar-striped {\n  #gradient > .striped();\n  background-size: 40px 40px;\n}\n\n// Call animation for the active one\n//\n// `.progress.active .progress-bar` is deprecated as of v3.2.0 in favor of the\n// `.progress-bar.active` approach.\n.progress.active .progress-bar,\n.progress-bar.active {\n  .animation(progress-bar-stripes 2s linear infinite);\n}\n\n\n// Variations\n// -------------------------\n\n.progress-bar-success {\n  .progress-bar-variant(@progress-bar-success-bg);\n}\n\n.progress-bar-info {\n  .progress-bar-variant(@progress-bar-info-bg);\n}\n\n.progress-bar-warning {\n  .progress-bar-variant(@progress-bar-warning-bg);\n}\n\n.progress-bar-danger {\n  .progress-bar-variant(@progress-bar-danger-bg);\n}\n","// stylelint-disable value-no-vendor-prefix, selector-max-id\n\n#gradient {\n\n  // Horizontal gradient, from left to right\n  //\n  // Creates two color stops, start and end, by specifying a color and position for each color stop.\n  // Color stops are not available in IE9 and below.\n  .horizontal(@start-color: #555; @end-color: #333; @start-percent: 0%; @end-percent: 100%) {\n    background-image: -webkit-linear-gradient(left, @start-color @start-percent, @end-color @end-percent); // Safari 5.1-6, Chrome 10+\n    background-image: -o-linear-gradient(left, @start-color @start-percent, @end-color @end-percent); // Opera 12\n    background-image: linear-gradient(to right, @start-color @start-percent, @end-color @end-percent); // Standard, IE10, Firefox 16+, Opera 12.10+, Safari 7+, Chrome 26+\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=1)\", argb(@start-color), argb(@end-color))); // IE9 and down\n    background-repeat: repeat-x;\n  }\n\n  // Vertical gradient, from top to bottom\n  //\n  // Creates two color stops, start and end, by specifying a color and position for each color stop.\n  // Color stops are not available in IE9 and below.\n  .vertical(@start-color: #555; @end-color: #333; @start-percent: 0%; @end-percent: 100%) {\n    background-image: -webkit-linear-gradient(top, @start-color @start-percent, @end-color @end-percent);  // Safari 5.1-6, Chrome 10+\n    background-image: -o-linear-gradient(top, @start-color @start-percent, @end-color @end-percent);  // Opera 12\n    background-image: linear-gradient(to bottom, @start-color @start-percent, @end-color @end-percent); // Standard, IE10, Firefox 16+, Opera 12.10+, Safari 7+, Chrome 26+\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=0)\", argb(@start-color), argb(@end-color))); // IE9 and down\n    background-repeat: repeat-x;\n  }\n\n  .directional(@start-color: #555; @end-color: #333; @deg: 45deg) {\n    background-image: -webkit-linear-gradient(@deg, @start-color, @end-color); // Safari 5.1-6, Chrome 10+\n    background-image: -o-linear-gradient(@deg, @start-color, @end-color); // Opera 12\n    background-image: linear-gradient(@deg, @start-color, @end-color); // Standard, IE10, Firefox 16+, Opera 12.10+, Safari 7+, Chrome 26+\n    background-repeat: repeat-x;\n  }\n  .horizontal-three-colors(@start-color: #00b3ee; @mid-color: #7a43b6; @color-stop: 50%; @end-color: #c3325f) {\n    background-image: -webkit-linear-gradient(left, @start-color, @mid-color @color-stop, @end-color);\n    background-image: -o-linear-gradient(left, @start-color, @mid-color @color-stop, @end-color);\n    background-image: linear-gradient(to right, @start-color, @mid-color @color-stop, @end-color);\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=1)\", argb(@start-color), argb(@end-color))); // IE9 and down, gets no color-stop at all for proper fallback\n    background-repeat: no-repeat;\n  }\n  .vertical-three-colors(@start-color: #00b3ee; @mid-color: #7a43b6; @color-stop: 50%; @end-color: #c3325f) {\n    background-image: -webkit-linear-gradient(@start-color, @mid-color @color-stop, @end-color);\n    background-image: -o-linear-gradient(@start-color, @mid-color @color-stop, @end-color);\n    background-image: linear-gradient(@start-color, @mid-color @color-stop, @end-color);\n    filter: e(%(\"progid:DXImageTransform.Microsoft.gradient(startColorstr='%d', endColorstr='%d', GradientType=0)\", argb(@start-color), argb(@end-color))); // IE9 and down, gets no color-stop at all for proper fallback\n    background-repeat: no-repeat;\n  }\n  .radial(@inner-color: #555; @outer-color: #333) {\n    background-image: -webkit-radial-gradient(circle, @inner-color, @outer-color);\n    background-image: radial-gradient(circle, @inner-color, @outer-color);\n    background-repeat: no-repeat;\n  }\n  .striped(@color: rgba(255, 255, 255, .15); @angle: 45deg) {\n    background-image: -webkit-linear-gradient(@angle, @color 25%, transparent 25%, transparent 50%, @color 50%, @color 75%, transparent 75%, transparent);\n    background-image: -o-linear-gradient(@angle, @color 25%, transparent 25%, transparent 50%, @color 50%, @color 75%, transparent 75%, transparent);\n    background-image: linear-gradient(@angle, @color 25%, transparent 25%, transparent 50%, @color 50%, @color 75%, transparent 75%, transparent);\n  }\n}\n","// Progress bars\n\n.progress-bar-variant(@color) {\n  background-color: @color;\n\n  // Deprecated parent class requirement as of v3.2.0\n  .progress-striped & {\n    #gradient > .striped();\n  }\n}\n",".media {\n  // Proper spacing between instances of .media\n  margin-top: 15px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n}\n\n.media,\n.media-body {\n  overflow: hidden;\n  zoom: 1;\n}\n\n.media-body {\n  width: 10000px;\n}\n\n.media-object {\n  display: block;\n\n  // Fix collapse in webkit from max-width: 100% and display: table-cell.\n  &.img-thumbnail {\n    max-width: none;\n  }\n}\n\n.media-right,\n.media > .pull-right {\n  padding-left: 10px;\n}\n\n.media-left,\n.media > .pull-left {\n  padding-right: 10px;\n}\n\n.media-left,\n.media-right,\n.media-body {\n  display: table-cell;\n  vertical-align: top;\n}\n\n.media-middle {\n  vertical-align: middle;\n}\n\n.media-bottom {\n  vertical-align: bottom;\n}\n\n// Reset margins on headings for tighter default spacing\n.media-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n\n// Media list variation\n//\n// Undo default ul/ol styles\n.media-list {\n  padding-left: 0;\n  list-style: none;\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// List groups\n// --------------------------------------------------\n\n\n// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 20px;\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 10px 15px;\n  // Place the border on the list items and negative margin up for better styling\n  margin-bottom: -1px;\n  background-color: @list-group-bg;\n  border: 1px solid @list-group-border;\n\n  // Round the first and last items\n  &:first-child {\n    .border-top-radius(@list-group-border-radius);\n  }\n  &:last-child {\n    margin-bottom: 0;\n    .border-bottom-radius(@list-group-border-radius);\n  }\n\n  // Disabled state\n  &.disabled,\n  &.disabled:hover,\n  &.disabled:focus {\n    color: @list-group-disabled-color;\n    cursor: @cursor-disabled;\n    background-color: @list-group-disabled-bg;\n\n    // Force color to inherit for custom content\n    .list-group-item-heading {\n      color: inherit;\n    }\n    .list-group-item-text {\n      color: @list-group-disabled-text-color;\n    }\n  }\n\n  // Active class on item itself, not parent\n  &.active,\n  &.active:hover,\n  &.active:focus {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: @list-group-active-color;\n    background-color: @list-group-active-bg;\n    border-color: @list-group-active-border;\n\n    // Force color to inherit for custom content\n    .list-group-item-heading,\n    .list-group-item-heading > small,\n    .list-group-item-heading > .small {\n      color: inherit;\n    }\n    .list-group-item-text {\n      color: @list-group-active-text-color;\n    }\n  }\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive items.\n// Includes an extra `.active` modifier class for showing selected items.\n\na.list-group-item,\nbutton.list-group-item {\n  color: @list-group-link-color;\n\n  .list-group-item-heading {\n    color: @list-group-link-heading-color;\n  }\n\n  // Hover state\n  &:hover,\n  &:focus {\n    color: @list-group-link-hover-color;\n    text-decoration: none;\n    background-color: @list-group-hover-bg;\n  }\n}\n\nbutton.list-group-item {\n  width: 100%;\n  text-align: left;\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n.list-group-item-variant(success; @state-success-bg; @state-success-text);\n.list-group-item-variant(info; @state-info-bg; @state-info-text);\n.list-group-item-variant(warning; @state-warning-bg; @state-warning-text);\n.list-group-item-variant(danger; @state-danger-bg; @state-danger-text);\n\n\n// Custom content options\n//\n// Extra classes for creating well-formatted content within `.list-group-item`s.\n\n.list-group-item-heading {\n  margin-top: 0;\n  margin-bottom: 5px;\n}\n.list-group-item-text {\n  margin-bottom: 0;\n  line-height: 1.3;\n}\n","// List Groups\n\n.list-group-item-variant(@state; @background; @color) {\n  .list-group-item-@{state} {\n    color: @color;\n    background-color: @background;\n\n    a&,\n    button& {\n      color: @color;\n\n      .list-group-item-heading {\n        color: inherit;\n      }\n\n      &:hover,\n      &:focus {\n        color: @color;\n        background-color: darken(@background, 5%);\n      }\n      &.active,\n      &.active:hover,\n      &.active:focus {\n        color: #fff;\n        background-color: @color;\n        border-color: @color;\n      }\n    }\n  }\n}\n","// stylelint-disable selector-max-type, selector-max-compound-selectors, selector-max-combinators, no-duplicate-selectors\n\n//\n// Panels\n// --------------------------------------------------\n\n\n// Base class\n.panel {\n  margin-bottom: @line-height-computed;\n  background-color: @panel-bg;\n  border: 1px solid transparent;\n  border-radius: @panel-border-radius;\n  .box-shadow(0 1px 1px rgba(0, 0, 0, .05));\n}\n\n// Panel contents\n.panel-body {\n  padding: @panel-body-padding;\n  &:extend(.clearfix all);\n}\n\n// Optional heading\n.panel-heading {\n  padding: @panel-heading-padding;\n  border-bottom: 1px solid transparent;\n  .border-top-radius((@panel-border-radius - 1));\n\n  > .dropdown .dropdown-toggle {\n    color: inherit;\n  }\n}\n\n// Within heading, strip any `h*` tag of its default margins for spacing.\n.panel-title {\n  margin-top: 0;\n  margin-bottom: 0;\n  font-size: ceil((@font-size-base * 1.125));\n  color: inherit;\n\n  > a,\n  > small,\n  > .small,\n  > small > a,\n  > .small > a {\n    color: inherit;\n  }\n}\n\n// Optional footer (stays gray in every modifier class)\n.panel-footer {\n  padding: @panel-footer-padding;\n  background-color: @panel-footer-bg;\n  border-top: 1px solid @panel-inner-border;\n  .border-bottom-radius((@panel-border-radius - 1));\n}\n\n\n// List groups in panels\n//\n// By default, space out list group content from panel headings to account for\n// any kind of custom content between the two.\n\n.panel {\n  > .list-group,\n  > .panel-collapse > .list-group {\n    margin-bottom: 0;\n\n    .list-group-item {\n      border-width: 1px 0;\n      border-radius: 0;\n    }\n\n    // Add border top radius for first one\n    &:first-child {\n      .list-group-item:first-child {\n        border-top: 0;\n        .border-top-radius((@panel-border-radius - 1));\n      }\n    }\n\n    // Add border bottom radius for last one\n    &:last-child {\n      .list-group-item:last-child {\n        border-bottom: 0;\n        .border-bottom-radius((@panel-border-radius - 1));\n      }\n    }\n  }\n  > .panel-heading + .panel-collapse > .list-group {\n    .list-group-item:first-child {\n      .border-top-radius(0);\n    }\n  }\n}\n// Collapse space between when there's no additional content.\n.panel-heading + .list-group {\n  .list-group-item:first-child {\n    border-top-width: 0;\n  }\n}\n.list-group + .panel-footer {\n  border-top-width: 0;\n}\n\n// Tables in panels\n//\n// Place a non-bordered `.table` within a panel (not within a `.panel-body`) and\n// watch it go full width.\n\n.panel {\n  > .table,\n  > .table-responsive > .table,\n  > .panel-collapse > .table {\n    margin-bottom: 0;\n\n    caption {\n      padding-right: @panel-body-padding;\n      padding-left: @panel-body-padding;\n    }\n  }\n  // Add border top radius for first one\n  > .table:first-child,\n  > .table-responsive:first-child > .table:first-child {\n    .border-top-radius((@panel-border-radius - 1));\n\n    > thead:first-child,\n    > tbody:first-child {\n      > tr:first-child {\n        border-top-left-radius: (@panel-border-radius - 1);\n        border-top-right-radius: (@panel-border-radius - 1);\n\n        td:first-child,\n        th:first-child {\n          border-top-left-radius: (@panel-border-radius - 1);\n        }\n        td:last-child,\n        th:last-child {\n          border-top-right-radius: (@panel-border-radius - 1);\n        }\n      }\n    }\n  }\n  // Add border bottom radius for last one\n  > .table:last-child,\n  > .table-responsive:last-child > .table:last-child {\n    .border-bottom-radius((@panel-border-radius - 1));\n\n    > tbody:last-child,\n    > tfoot:last-child {\n      > tr:last-child {\n        border-bottom-right-radius: (@panel-border-radius - 1);\n        border-bottom-left-radius: (@panel-border-radius - 1);\n\n        td:first-child,\n        th:first-child {\n          border-bottom-left-radius: (@panel-border-radius - 1);\n        }\n        td:last-child,\n        th:last-child {\n          border-bottom-right-radius: (@panel-border-radius - 1);\n        }\n      }\n    }\n  }\n  > .panel-body + .table,\n  > .panel-body + .table-responsive,\n  > .table + .panel-body,\n  > .table-responsive + .panel-body {\n    border-top: 1px solid @table-border-color;\n  }\n  > .table > tbody:first-child > tr:first-child th,\n  > .table > tbody:first-child > tr:first-child td {\n    border-top: 0;\n  }\n  > .table-bordered,\n  > .table-responsive > .table-bordered {\n    border: 0;\n    > thead,\n    > tbody,\n    > tfoot {\n      > tr {\n        > th:first-child,\n        > td:first-child {\n          border-left: 0;\n        }\n        > th:last-child,\n        > td:last-child {\n          border-right: 0;\n        }\n      }\n    }\n    > thead,\n    > tbody {\n      > tr:first-child {\n        > td,\n        > th {\n          border-bottom: 0;\n        }\n      }\n    }\n    > tbody,\n    > tfoot {\n      > tr:last-child {\n        > td,\n        > th {\n          border-bottom: 0;\n        }\n      }\n    }\n  }\n  > .table-responsive {\n    margin-bottom: 0;\n    border: 0;\n  }\n}\n\n\n// Collapsible panels (aka, accordion)\n//\n// Wrap a series of panels in `.panel-group` to turn them into an accordion with\n// the help of our collapse JavaScript plugin.\n\n.panel-group {\n  margin-bottom: @line-height-computed;\n\n  // Tighten up margin so it's only between panels\n  .panel {\n    margin-bottom: 0;\n    border-radius: @panel-border-radius;\n\n    + .panel {\n      margin-top: 5px;\n    }\n  }\n\n  .panel-heading {\n    border-bottom: 0;\n\n    + .panel-collapse > .panel-body,\n    + .panel-collapse > .list-group {\n      border-top: 1px solid @panel-inner-border;\n    }\n  }\n\n  .panel-footer {\n    border-top: 0;\n    + .panel-collapse .panel-body {\n      border-bottom: 1px solid @panel-inner-border;\n    }\n  }\n}\n\n\n// Contextual variations\n.panel-default {\n  .panel-variant(@panel-default-border; @panel-default-text; @panel-default-heading-bg; @panel-default-border);\n}\n.panel-primary {\n  .panel-variant(@panel-primary-border; @panel-primary-text; @panel-primary-heading-bg; @panel-primary-border);\n}\n.panel-success {\n  .panel-variant(@panel-success-border; @panel-success-text; @panel-success-heading-bg; @panel-success-border);\n}\n.panel-info {\n  .panel-variant(@panel-info-border; @panel-info-text; @panel-info-heading-bg; @panel-info-border);\n}\n.panel-warning {\n  .panel-variant(@panel-warning-border; @panel-warning-text; @panel-warning-heading-bg; @panel-warning-border);\n}\n.panel-danger {\n  .panel-variant(@panel-danger-border; @panel-danger-text; @panel-danger-heading-bg; @panel-danger-border);\n}\n","// Panels\n\n.panel-variant(@border; @heading-text-color; @heading-bg-color; @heading-border) {\n  border-color: @border;\n\n  & > .panel-heading {\n    color: @heading-text-color;\n    background-color: @heading-bg-color;\n    border-color: @heading-border;\n\n    + .panel-collapse > .panel-body {\n      border-top-color: @border;\n    }\n    .badge {\n      color: @heading-bg-color;\n      background-color: @heading-text-color;\n    }\n  }\n  & > .panel-footer {\n    + .panel-collapse > .panel-body {\n      border-bottom-color: @border;\n    }\n  }\n}\n","// Embeds responsive\n//\n// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  height: 0;\n  padding: 0;\n  overflow: hidden;\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n// Modifier class for 16:9 aspect ratio\n.embed-responsive-16by9 {\n  padding-bottom: 56.25%;\n}\n\n// Modifier class for 4:3 aspect ratio\n.embed-responsive-4by3 {\n  padding-bottom: 75%;\n}\n","//\n// Wells\n// --------------------------------------------------\n\n\n// Base class\n.well {\n  min-height: 20px;\n  padding: 19px;\n  margin-bottom: 20px;\n  background-color: @well-bg;\n  border: 1px solid @well-border;\n  border-radius: @border-radius-base;\n  .box-shadow(inset 0 1px 1px rgba(0, 0, 0, .05));\n  blockquote {\n    border-color: #ddd;\n    border-color: rgba(0, 0, 0, .15);\n  }\n}\n\n// Sizes\n.well-lg {\n  padding: 24px;\n  border-radius: @border-radius-large;\n}\n.well-sm {\n  padding: 9px;\n  border-radius: @border-radius-small;\n}\n","// stylelint-disable property-no-vendor-prefix\n\n//\n// Close icons\n// --------------------------------------------------\n\n\n.close {\n  float: right;\n  font-size: (@font-size-base * 1.5);\n  font-weight: @close-font-weight;\n  line-height: 1;\n  color: @close-color;\n  text-shadow: @close-text-shadow;\n  .opacity(.2);\n\n  &:hover,\n  &:focus {\n    color: @close-color;\n    text-decoration: none;\n    cursor: pointer;\n    .opacity(.5);\n  }\n\n  // Additional properties for button version\n  // iOS requires the button element instead of an anchor tag.\n  // If you want the anchor version, it requires `href=\"#\"`.\n  // See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n  button& {\n    padding: 0;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    -webkit-appearance: none;\n    appearance: none;\n  }\n}\n","//\n// Modals\n// --------------------------------------------------\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and shit\n\n// Kill the scroll on the body\n.modal-open {\n  overflow: hidden;\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: @zindex-modal;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n\n  // When fading in the modal, animate it to slide down\n  &.fade .modal-dialog {\n    .translate(0, -25%);\n    .transition-transform(~\"0.3s ease-out\");\n  }\n  &.in .modal-dialog { .translate(0, 0); }\n}\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 10px;\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  background-color: @modal-content-bg;\n  background-clip: padding-box;\n  border: 1px solid @modal-content-fallback-border-color; //old browsers fallback (ie8 etc)\n  border: 1px solid @modal-content-border-color;\n  border-radius: @border-radius-large;\n  .box-shadow(0 3px 9px rgba(0, 0, 0, .5));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: @zindex-modal-background;\n  background-color: @modal-backdrop-bg;\n  // Fade for backdrop\n  &.fade { .opacity(0); }\n  &.in { .opacity(@modal-backdrop-opacity); }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  padding: @modal-title-padding;\n  border-bottom: 1px solid @modal-header-border-color;\n  &:extend(.clearfix all);\n}\n// Close icon\n.modal-header .close {\n  margin-top: -2px;\n}\n\n// Title text within header\n.modal-title {\n  margin: 0;\n  line-height: @modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  padding: @modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  padding: @modal-inner-padding;\n  text-align: right; // right align buttons\n  border-top: 1px solid @modal-footer-border-color;\n  &:extend(.clearfix all); // clear it in case folks use .pull-* classes on buttons\n\n  // Properly space out buttons\n  .btn + .btn {\n    margin-bottom: 0; // account for input[type=\"submit\"] which gets the bottom margin like all other inputs\n    margin-left: 5px;\n  }\n  // but override that for button groups\n  .btn-group .btn + .btn {\n    margin-left: -1px;\n  }\n  // and override it for block buttons as well\n  .btn-block + .btn-block {\n    margin-left: 0;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@media (min-width: @screen-sm-min) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    width: @modal-md;\n    margin: 30px auto;\n  }\n  .modal-content {\n    .box-shadow(0 5px 15px rgba(0, 0, 0, .5));\n  }\n\n  // Modal sizes\n  .modal-sm { width: @modal-sm; }\n}\n\n@media (min-width: @screen-md-min) {\n  .modal-lg { width: @modal-lg; }\n}\n","//\n// Tooltips\n// --------------------------------------------------\n\n\n// Base class\n.tooltip {\n  position: absolute;\n  z-index: @zindex-tooltip;\n  display: block;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  .reset-text();\n  font-size: @font-size-small;\n\n  .opacity(0);\n\n  &.in { .opacity(@tooltip-opacity); }\n  &.top {\n    padding: @tooltip-arrow-width 0;\n    margin-top: -3px;\n  }\n  &.right {\n    padding: 0 @tooltip-arrow-width;\n    margin-left: 3px;\n  }\n  &.bottom {\n    padding: @tooltip-arrow-width 0;\n    margin-top: 3px;\n  }\n  &.left {\n    padding: 0 @tooltip-arrow-width;\n    margin-left: -3px;\n  }\n\n  // Note: Deprecated .top-left, .top-right, .bottom-left, and .bottom-right as of v3.3.1\n  &.top .tooltip-arrow {\n    bottom: 0;\n    left: 50%;\n    margin-left: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-top-color: @tooltip-arrow-color;\n  }\n  &.top-left .tooltip-arrow {\n    right: @tooltip-arrow-width;\n    bottom: 0;\n    margin-bottom: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-top-color: @tooltip-arrow-color;\n  }\n  &.top-right .tooltip-arrow {\n    bottom: 0;\n    left: @tooltip-arrow-width;\n    margin-bottom: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-top-color: @tooltip-arrow-color;\n  }\n  &.right .tooltip-arrow {\n    top: 50%;\n    left: 0;\n    margin-top: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width @tooltip-arrow-width @tooltip-arrow-width 0;\n    border-right-color: @tooltip-arrow-color;\n  }\n  &.left .tooltip-arrow {\n    top: 50%;\n    right: 0;\n    margin-top: -@tooltip-arrow-width;\n    border-width: @tooltip-arrow-width 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-left-color: @tooltip-arrow-color;\n  }\n  &.bottom .tooltip-arrow {\n    top: 0;\n    left: 50%;\n    margin-left: -@tooltip-arrow-width;\n    border-width: 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-bottom-color: @tooltip-arrow-color;\n  }\n  &.bottom-left .tooltip-arrow {\n    top: 0;\n    right: @tooltip-arrow-width;\n    margin-top: -@tooltip-arrow-width;\n    border-width: 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-bottom-color: @tooltip-arrow-color;\n  }\n  &.bottom-right .tooltip-arrow {\n    top: 0;\n    left: @tooltip-arrow-width;\n    margin-top: -@tooltip-arrow-width;\n    border-width: 0 @tooltip-arrow-width @tooltip-arrow-width;\n    border-bottom-color: @tooltip-arrow-color;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: @tooltip-max-width;\n  padding: 3px 8px;\n  color: @tooltip-color;\n  text-align: center;\n  background-color: @tooltip-bg;\n  border-radius: @border-radius-base;\n}\n\n// Arrows\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n",".reset-text() {\n  font-family: @font-family-base;\n  // We deliberately do NOT reset font-size.\n  font-style: normal;\n  font-weight: 400;\n  line-height: @line-height-base;\n  line-break: auto;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  word-wrap: normal;\n  white-space: normal;\n}\n","//\n// Popovers\n// --------------------------------------------------\n\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: @zindex-popover;\n  display: none;\n  max-width: @popover-max-width;\n  padding: 1px;\n  // Our parent element can be arbitrary since popovers are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  .reset-text();\n  font-size: @font-size-base;\n  background-color: @popover-bg;\n  background-clip: padding-box;\n  border: 1px solid @popover-fallback-border-color;\n  border: 1px solid @popover-border-color;\n  border-radius: @border-radius-large;\n  .box-shadow(0 5px 10px rgba(0, 0, 0, .2));\n\n  // Offset the popover to account for the popover arrow\n  &.top { margin-top: -@popover-arrow-width; }\n  &.right { margin-left: @popover-arrow-width; }\n  &.bottom { margin-top: @popover-arrow-width; }\n  &.left { margin-left: -@popover-arrow-width; }\n\n  // Arrows\n  // .arrow is outer, .arrow:after is inner\n  > .arrow {\n    border-width: @popover-arrow-outer-width;\n\n    &,\n    &:after {\n      position: absolute;\n      display: block;\n      width: 0;\n      height: 0;\n      border-color: transparent;\n      border-style: solid;\n    }\n\n    &:after {\n      content: \"\";\n      border-width: @popover-arrow-width;\n    }\n  }\n\n  &.top > .arrow {\n    bottom: -@popover-arrow-outer-width;\n    left: 50%;\n    margin-left: -@popover-arrow-outer-width;\n    border-top-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-top-color: @popover-arrow-outer-color;\n    border-bottom-width: 0;\n    &:after {\n      bottom: 1px;\n      margin-left: -@popover-arrow-width;\n      content: \" \";\n      border-top-color: @popover-arrow-color;\n      border-bottom-width: 0;\n    }\n  }\n  &.right > .arrow {\n    top: 50%;\n    left: -@popover-arrow-outer-width;\n    margin-top: -@popover-arrow-outer-width;\n    border-right-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-right-color: @popover-arrow-outer-color;\n    border-left-width: 0;\n    &:after {\n      bottom: -@popover-arrow-width;\n      left: 1px;\n      content: \" \";\n      border-right-color: @popover-arrow-color;\n      border-left-width: 0;\n    }\n  }\n  &.bottom > .arrow {\n    top: -@popover-arrow-outer-width;\n    left: 50%;\n    margin-left: -@popover-arrow-outer-width;\n    border-top-width: 0;\n    border-bottom-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-bottom-color: @popover-arrow-outer-color;\n    &:after {\n      top: 1px;\n      margin-left: -@popover-arrow-width;\n      content: \" \";\n      border-top-width: 0;\n      border-bottom-color: @popover-arrow-color;\n    }\n  }\n\n  &.left > .arrow {\n    top: 50%;\n    right: -@popover-arrow-outer-width;\n    margin-top: -@popover-arrow-outer-width;\n    border-right-width: 0;\n    border-left-color: @popover-arrow-outer-fallback-color; // IE8 fallback\n    border-left-color: @popover-arrow-outer-color;\n    &:after {\n      right: 1px;\n      bottom: -@popover-arrow-width;\n      content: \" \";\n      border-right-width: 0;\n      border-left-color: @popover-arrow-color;\n    }\n  }\n}\n\n.popover-title {\n  padding: 8px 14px;\n  margin: 0; // reset heading margin\n  font-size: @font-size-base;\n  background-color: @popover-title-bg;\n  border-bottom: 1px solid darken(@popover-title-bg, 5%);\n  border-radius: (@border-radius-large - 1) (@border-radius-large - 1) 0 0;\n}\n\n.popover-content {\n  padding: 9px 14px;\n}\n","// stylelint-disable media-feature-name-no-unknown\n\n//\n// Carousel\n// --------------------------------------------------\n\n\n// Wrapper for the slide container and indicators\n.carousel {\n  position: relative;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n\n  > .item {\n    position: relative;\n    display: none;\n    .transition(.6s ease-in-out left);\n\n    // Account for jankitude on images\n    > img,\n    > a > img {\n      &:extend(.img-responsive);\n      line-height: 1;\n    }\n\n    // WebKit CSS3 transforms for supported devices\n    @media all and (transform-3d), (-webkit-transform-3d) {\n      .transition-transform(~\"0.6s ease-in-out\");\n      .backface-visibility(~\"hidden\");\n      .perspective(1000px);\n\n      &.next,\n      &.active.right {\n        .translate3d(100%, 0, 0);\n        left: 0;\n      }\n      &.prev,\n      &.active.left {\n        .translate3d(-100%, 0, 0);\n        left: 0;\n      }\n      &.next.left,\n      &.prev.right,\n      &.active {\n        .translate3d(0, 0, 0);\n        left: 0;\n      }\n    }\n  }\n\n  > .active,\n  > .next,\n  > .prev {\n    display: block;\n  }\n\n  > .active {\n    left: 0;\n  }\n\n  > .next,\n  > .prev {\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n\n  > .next {\n    left: 100%;\n  }\n  > .prev {\n    left: -100%;\n  }\n  > .next.left,\n  > .prev.right {\n    left: 0;\n  }\n\n  > .active.left {\n    left: -100%;\n  }\n  > .active.right {\n    left: 100%;\n  }\n\n}\n\n// Left/right controls for nav\n// ---------------------------\n\n.carousel-control {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: @carousel-control-width;\n  font-size: @carousel-control-font-size;\n  color: @carousel-control-color;\n  text-align: center;\n  text-shadow: @carousel-text-shadow;\n  background-color: rgba(0, 0, 0, 0); // Fix IE9 click-thru bug\n  .opacity(@carousel-control-opacity);\n  // We can't have this transition here because WebKit cancels the carousel\n  // animation if you trip this while in the middle of another animation.\n\n  // Set gradients for backgrounds\n  &.left {\n    #gradient > .horizontal(@start-color: rgba(0, 0, 0, .5); @end-color: rgba(0, 0, 0, .0001));\n  }\n  &.right {\n    right: 0;\n    left: auto;\n    #gradient > .horizontal(@start-color: rgba(0, 0, 0, .0001); @end-color: rgba(0, 0, 0, .5));\n  }\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: @carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    .opacity(.9);\n  }\n\n  // Toggles\n  .icon-prev,\n  .icon-next,\n  .glyphicon-chevron-left,\n  .glyphicon-chevron-right {\n    position: absolute;\n    top: 50%;\n    z-index: 5;\n    display: inline-block;\n    margin-top: -10px;\n  }\n  .icon-prev,\n  .glyphicon-chevron-left {\n    left: 50%;\n    margin-left: -10px;\n  }\n  .icon-next,\n  .glyphicon-chevron-right {\n    right: 50%;\n    margin-right: -10px;\n  }\n  .icon-prev,\n  .icon-next {\n    width: 20px;\n    height: 20px;\n    font-family: serif;\n    line-height: 1;\n  }\n\n  .icon-prev {\n    &:before {\n      content: \"\\2039\";// SINGLE LEFT-POINTING ANGLE QUOTATION MARK (U+2039)\n    }\n  }\n  .icon-next {\n    &:before {\n      content: \"\\203a\";// SINGLE RIGHT-POINTING ANGLE QUOTATION MARK (U+203A)\n    }\n  }\n}\n\n// Optional indicator pips\n//\n// Add an unordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  z-index: 15;\n  width: 60%;\n  padding-left: 0;\n  margin-left: -30%;\n  text-align: center;\n  list-style: none;\n\n  li {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    margin: 1px;\n    text-indent: -999px;\n    cursor: pointer;\n    // IE8-9 hack for event handling\n    //\n    // Internet Explorer 8-9 does not support clicks on elements without a set\n    // `background-color`. We cannot use `filter` since that's not viewed as a\n    // background color by the browser. Thus, a hack is needed.\n    // See https://developer.mozilla.org/en-US/docs/Web/Events/click#Internet_Explorer\n    //\n    // For IE8, we set solid black as it doesn't support `rgba()`. For IE9, we\n    // set alpha transparency for the best results possible.\n    background-color: #000 \\9; // IE8\n    background-color: rgba(0, 0, 0, 0); // IE9\n\n    border: 1px solid @carousel-indicator-border-color;\n    border-radius: 10px;\n  }\n\n  .active {\n    width: 12px;\n    height: 12px;\n    margin: 0;\n    background-color: @carousel-indicator-active-bg;\n  }\n}\n\n// Optional captions\n// -----------------------------\n// Hidden by default for smaller viewports\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: @carousel-caption-color;\n  text-align: center;\n  text-shadow: @carousel-text-shadow;\n\n  & .btn {\n    text-shadow: none; // No shadow for button elements in carousel-caption\n  }\n}\n\n\n// Scale up controls for tablets and up\n@media screen and (min-width: @screen-sm-min) {\n\n  // Scale up the controls a smidge\n  .carousel-control {\n    .glyphicon-chevron-left,\n    .glyphicon-chevron-right,\n    .icon-prev,\n    .icon-next {\n      width: (@carousel-control-font-size * 1.5);\n      height: (@carousel-control-font-size * 1.5);\n      margin-top: (@carousel-control-font-size / -2);\n      font-size: (@carousel-control-font-size * 1.5);\n    }\n    .glyphicon-chevron-left,\n    .icon-prev {\n      margin-left: (@carousel-control-font-size / -2);\n    }\n    .glyphicon-chevron-right,\n    .icon-next {\n      margin-right: (@carousel-control-font-size / -2);\n    }\n  }\n\n  // Show and left align the captions\n  .carousel-caption {\n    right: 20%;\n    left: 20%;\n    padding-bottom: 30px;\n  }\n\n  // Move up the indicators\n  .carousel-indicators {\n    bottom: 20px;\n  }\n}\n","// Clearfix\n//\n// For modern browsers\n// 1. The space content is one way to avoid an Opera bug when the\n//    contenteditable attribute is included anywhere else in the document.\n//    Otherwise it causes space to appear at the top and bottom of elements\n//    that are clearfixed.\n// 2. The use of `table` rather than `block` is only necessary if using\n//    `:before` to contain the top-margins of child elements.\n//\n// Source: http://nicolasgallagher.com/micro-clearfix-hack/\n\n.clearfix() {\n  &:before,\n  &:after {\n    display: table; // 2\n    content: \" \"; // 1\n  }\n  &:after {\n    clear: both;\n  }\n}\n","// Center-align a block level element\n\n.center-block() {\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n}\n","// stylelint-disable font-family-name-quotes, font-family-no-missing-generic-family-keyword\n\n// CSS image replacement\n//\n// Heads up! v3 launched with only `.hide-text()`, but per our pattern for\n// mixins being reused as classes with the same name, this doesn't hold up. As\n// of v3.0.1 we have added `.text-hide()` and deprecated `.hide-text()`.\n//\n// Source: https://github.com/h5bp/html5-boilerplate/commit/aa0396eae757\n\n// Deprecated as of v3.0.1 (has been removed in v4)\n.hide-text() {\n  font: ~\"0/0\" a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n// New mixin to use as of v3.0.1\n.text-hide() {\n  .hide-text();\n}\n","// stylelint-disable declaration-no-important, at-rule-no-vendor-prefix\n\n//\n// Responsive: Utility classes\n// --------------------------------------------------\n\n\n// IE10 in Windows (Phone) 8\n//\n// Support for responsive views via media queries is kind of borked in IE10, for\n// Surface/desktop in split view and for Windows Phone 8. This particular fix\n// must be accompanied by a snippet of JavaScript to sniff the user agent and\n// apply some conditional CSS to *only* the Surface/desktop Windows 8. Look at\n// our Getting Started page for more information on this bug.\n//\n// For more information, see the following:\n//\n// Issue: https://github.com/twbs/bootstrap/issues/10497\n// Docs: https://getbootstrap.com/docs/3.4/getting-started/#support-ie10-width\n// Source: https://timkadlec.com/2013/01/windows-phone-8-and-device-width/\n// Source: https://timkadlec.com/2012/10/ie10-snap-mode-and-responsive-design/\n\n@-ms-viewport {\n  width: device-width;\n}\n\n\n// Visibility utilities\n// Note: Deprecated .visible-xs, .visible-sm, .visible-md, and .visible-lg as of v3.2.0\n.visible-xs,\n.visible-sm,\n.visible-md,\n.visible-lg {\n  .responsive-invisibility();\n}\n\n.visible-xs-block,\n.visible-xs-inline,\n.visible-xs-inline-block,\n.visible-sm-block,\n.visible-sm-inline,\n.visible-sm-inline-block,\n.visible-md-block,\n.visible-md-inline,\n.visible-md-inline-block,\n.visible-lg-block,\n.visible-lg-inline,\n.visible-lg-inline-block {\n  display: none !important;\n}\n\n.visible-xs {\n  @media (max-width: @screen-xs-max) {\n    .responsive-visibility();\n  }\n}\n.visible-xs-block {\n  @media (max-width: @screen-xs-max) {\n    display: block !important;\n  }\n}\n.visible-xs-inline {\n  @media (max-width: @screen-xs-max) {\n    display: inline !important;\n  }\n}\n.visible-xs-inline-block {\n  @media (max-width: @screen-xs-max) {\n    display: inline-block !important;\n  }\n}\n\n.visible-sm {\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    .responsive-visibility();\n  }\n}\n.visible-sm-block {\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    display: block !important;\n  }\n}\n.visible-sm-inline {\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    display: inline !important;\n  }\n}\n.visible-sm-inline-block {\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    display: inline-block !important;\n  }\n}\n\n.visible-md {\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    .responsive-visibility();\n  }\n}\n.visible-md-block {\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    display: block !important;\n  }\n}\n.visible-md-inline {\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    display: inline !important;\n  }\n}\n.visible-md-inline-block {\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    display: inline-block !important;\n  }\n}\n\n.visible-lg {\n  @media (min-width: @screen-lg-min) {\n    .responsive-visibility();\n  }\n}\n.visible-lg-block {\n  @media (min-width: @screen-lg-min) {\n    display: block !important;\n  }\n}\n.visible-lg-inline {\n  @media (min-width: @screen-lg-min) {\n    display: inline !important;\n  }\n}\n.visible-lg-inline-block {\n  @media (min-width: @screen-lg-min) {\n    display: inline-block !important;\n  }\n}\n\n.hidden-xs {\n  @media (max-width: @screen-xs-max) {\n    .responsive-invisibility();\n  }\n}\n.hidden-sm {\n  @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max) {\n    .responsive-invisibility();\n  }\n}\n.hidden-md {\n  @media (min-width: @screen-md-min) and (max-width: @screen-md-max) {\n    .responsive-invisibility();\n  }\n}\n.hidden-lg {\n  @media (min-width: @screen-lg-min) {\n    .responsive-invisibility();\n  }\n}\n\n\n// Print utilities\n//\n// Media queries are placed on the inside to be mixin-friendly.\n\n// Note: Deprecated .visible-print as of v3.2.0\n.visible-print {\n  .responsive-invisibility();\n\n  @media print {\n    .responsive-visibility();\n  }\n}\n.visible-print-block {\n  display: none !important;\n\n  @media print {\n    display: block !important;\n  }\n}\n.visible-print-inline {\n  display: none !important;\n\n  @media print {\n    display: inline !important;\n  }\n}\n.visible-print-inline-block {\n  display: none !important;\n\n  @media print {\n    display: inline-block !important;\n  }\n}\n\n.hidden-print {\n  @media print {\n    .responsive-invisibility();\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.responsive-visibility() {\n  display: block !important;\n  table&  { display: table !important; }\n  tr&     { display: table-row !important; }\n  th&,\n  td&     { display: table-cell !important; }\n}\n\n.responsive-invisibility() {\n  display: none !important;\n}\n","/* FONT PATH\n * -------------------------- */\n\n@font-face {\n  font-family: 'FontAwesome';\n  src: url('@{fa-font-path}/fontawesome-webfont.eot?v=@{fa-version}');\n  src: url('@{fa-font-path}/fontawesome-webfont.eot?#iefix&v=@{fa-version}') format('embedded-opentype'),\n    url('@{fa-font-path}/fontawesome-webfont.woff2?v=@{fa-version}') format('woff2'),\n    url('@{fa-font-path}/fontawesome-webfont.woff?v=@{fa-version}') format('woff'),\n    url('@{fa-font-path}/fontawesome-webfont.ttf?v=@{fa-version}') format('truetype'),\n    url('@{fa-font-path}/fontawesome-webfont.svg?v=@{fa-version}#fontawesomeregular') format('svg');\n  // src: url('@{fa-font-path}/FontAwesome.otf') format('opentype'); // used when developing fonts\n  font-weight: normal;\n  font-style: normal;\n}\n","// Base Class Definition\n// -------------------------\n\n.@{fa-css-prefix} {\n  display: inline-block;\n  font: normal normal normal @fa-font-size-base/@fa-line-height-base FontAwesome; // shortening font declaration\n  font-size: inherit; // can't have font-size inherit on line above, so need to override\n  text-rendering: auto; // optimizelegibility throws things off #1094\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n}\n","// Icon Sizes\n// -------------------------\n\n/* makes the font 33% larger relative to the icon container */\n.@{fa-css-prefix}-lg {\n  font-size: (4em / 3);\n  line-height: (3em / 4);\n  vertical-align: -15%;\n}\n.@{fa-css-prefix}-2x { font-size: 2em; }\n.@{fa-css-prefix}-3x { font-size: 3em; }\n.@{fa-css-prefix}-4x { font-size: 4em; }\n.@{fa-css-prefix}-5x { font-size: 5em; }\n","// Fixed Width Icons\n// -------------------------\n.@{fa-css-prefix}-fw {\n  width: (18em / 14);\n  text-align: center;\n}\n","// List Icons\n// -------------------------\n\n.@{fa-css-prefix}-ul {\n  padding-left: 0;\n  margin-left: @fa-li-width;\n  list-style-type: none;\n  > li { position: relative; }\n}\n.@{fa-css-prefix}-li {\n  position: absolute;\n  left: -@fa-li-width;\n  width: @fa-li-width;\n  top: (2em / 14);\n  text-align: center;\n  &.@{fa-css-prefix}-lg {\n    left: (-@fa-li-width + (4em / 14));\n  }\n}\n","// Animated Icons\n// --------------------------\n\n.@{fa-css-prefix}-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.@{fa-css-prefix}-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n  }\n}\n","// Rotated & Flipped Icons\n// -------------------------\n\n.@{fa-css-prefix}-rotate-90  { .fa-icon-rotate(90deg, 1);  }\n.@{fa-css-prefix}-rotate-180 { .fa-icon-rotate(180deg, 2); }\n.@{fa-css-prefix}-rotate-270 { .fa-icon-rotate(270deg, 3); }\n\n.@{fa-css-prefix}-flip-horizontal { .fa-icon-flip(-1, 1, 0); }\n.@{fa-css-prefix}-flip-vertical   { .fa-icon-flip(1, -1, 2); }\n\n// Hook for IE8-9\n// -------------------------\n\n:root .@{fa-css-prefix}-rotate-90,\n:root .@{fa-css-prefix}-rotate-180,\n:root .@{fa-css-prefix}-rotate-270,\n:root .@{fa-css-prefix}-flip-horizontal,\n:root .@{fa-css-prefix}-flip-vertical {\n  filter: none;\n}\n","// Mixins\n// --------------------------\n\n.fa-icon() {\n  display: inline-block;\n  font: normal normal normal @fa-font-size-base/@fa-line-height-base FontAwesome; // shortening font declaration\n  font-size: inherit; // can't have font-size inherit on line above, so need to override\n  text-rendering: auto; // optimizelegibility throws things off #1094\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n}\n\n.fa-icon-rotate(@degrees, @rotation) {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=@{rotation})\";\n  -webkit-transform: rotate(@degrees);\n      -ms-transform: rotate(@degrees);\n          transform: rotate(@degrees);\n}\n\n.fa-icon-flip(@horiz, @vert, @rotation) {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=@{rotation}, mirror=1)\";\n  -webkit-transform: scale(@horiz, @vert);\n      -ms-transform: scale(@horiz, @vert);\n          transform: scale(@horiz, @vert);\n}\n\n\n// Only display content to screen readers. A la Bootstrap 4.\n//\n// See: http://a11yproject.com/posts/how-to-hide-content/\n\n.sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0,0,0,0);\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see http://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n.sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n  }\n}\n","// Stacked Icons\n// -------------------------\n\n.@{fa-css-prefix}-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n.@{fa-css-prefix}-stack-1x, .@{fa-css-prefix}-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n.@{fa-css-prefix}-stack-1x { line-height: inherit; }\n.@{fa-css-prefix}-stack-2x { font-size: 2em; }\n.@{fa-css-prefix}-inverse { color: @fa-inverse; }\n","/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\n   readers do not read off random characters that represent icons */\n\n.@{fa-css-prefix}-glass:before { content: @fa-var-glass; }\n.@{fa-css-prefix}-music:before { content: @fa-var-music; }\n.@{fa-css-prefix}-search:before { content: @fa-var-search; }\n.@{fa-css-prefix}-envelope-o:before { content: @fa-var-envelope-o; }\n.@{fa-css-prefix}-heart:before { content: @fa-var-heart; }\n.@{fa-css-prefix}-star:before { content: @fa-var-star; }\n.@{fa-css-prefix}-star-o:before { content: @fa-var-star-o; }\n.@{fa-css-prefix}-user:before { content: @fa-var-user; }\n.@{fa-css-prefix}-film:before { content: @fa-var-film; }\n.@{fa-css-prefix}-th-large:before { content: @fa-var-th-large; }\n.@{fa-css-prefix}-th:before { content: @fa-var-th; }\n.@{fa-css-prefix}-th-list:before { content: @fa-var-th-list; }\n.@{fa-css-prefix}-check:before { content: @fa-var-check; }\n.@{fa-css-prefix}-remove:before,\n.@{fa-css-prefix}-close:before,\n.@{fa-css-prefix}-times:before { content: @fa-var-times; }\n.@{fa-css-prefix}-search-plus:before { content: @fa-var-search-plus; }\n.@{fa-css-prefix}-search-minus:before { content: @fa-var-search-minus; }\n.@{fa-css-prefix}-power-off:before { content: @fa-var-power-off; }\n.@{fa-css-prefix}-signal:before { content: @fa-var-signal; }\n.@{fa-css-prefix}-gear:before,\n.@{fa-css-prefix}-cog:before { content: @fa-var-cog; }\n.@{fa-css-prefix}-trash-o:before { content: @fa-var-trash-o; }\n.@{fa-css-prefix}-home:before { content: @fa-var-home; }\n.@{fa-css-prefix}-file-o:before { content: @fa-var-file-o; }\n.@{fa-css-prefix}-clock-o:before { content: @fa-var-clock-o; }\n.@{fa-css-prefix}-road:before { content: @fa-var-road; }\n.@{fa-css-prefix}-download:before { content: @fa-var-download; }\n.@{fa-css-prefix}-arrow-circle-o-down:before { content: @fa-var-arrow-circle-o-down; }\n.@{fa-css-prefix}-arrow-circle-o-up:before { content: @fa-var-arrow-circle-o-up; }\n.@{fa-css-prefix}-inbox:before { content: @fa-var-inbox; }\n.@{fa-css-prefix}-play-circle-o:before { content: @fa-var-play-circle-o; }\n.@{fa-css-prefix}-rotate-right:before,\n.@{fa-css-prefix}-repeat:before { content: @fa-var-repeat; }\n.@{fa-css-prefix}-refresh:before { content: @fa-var-refresh; }\n.@{fa-css-prefix}-list-alt:before { content: @fa-var-list-alt; }\n.@{fa-css-prefix}-lock:before { content: @fa-var-lock; }\n.@{fa-css-prefix}-flag:before { content: @fa-var-flag; }\n.@{fa-css-prefix}-headphones:before { content: @fa-var-headphones; }\n.@{fa-css-prefix}-volume-off:before { content: @fa-var-volume-off; }\n.@{fa-css-prefix}-volume-down:before { content: @fa-var-volume-down; }\n.@{fa-css-prefix}-volume-up:before { content: @fa-var-volume-up; }\n.@{fa-css-prefix}-qrcode:before { content: @fa-var-qrcode; }\n.@{fa-css-prefix}-barcode:before { content: @fa-var-barcode; }\n.@{fa-css-prefix}-tag:before { content: @fa-var-tag; }\n.@{fa-css-prefix}-tags:before { content: @fa-var-tags; }\n.@{fa-css-prefix}-book:before { content: @fa-var-book; }\n.@{fa-css-prefix}-bookmark:before { content: @fa-var-bookmark; }\n.@{fa-css-prefix}-print:before { content: @fa-var-print; }\n.@{fa-css-prefix}-camera:before { content: @fa-var-camera; }\n.@{fa-css-prefix}-font:before { content: @fa-var-font; }\n.@{fa-css-prefix}-bold:before { content: @fa-var-bold; }\n.@{fa-css-prefix}-italic:before { content: @fa-var-italic; }\n.@{fa-css-prefix}-text-height:before { content: @fa-var-text-height; }\n.@{fa-css-prefix}-text-width:before { content: @fa-var-text-width; }\n.@{fa-css-prefix}-align-left:before { content: @fa-var-align-left; }\n.@{fa-css-prefix}-align-center:before { content: @fa-var-align-center; }\n.@{fa-css-prefix}-align-right:before { content: @fa-var-align-right; }\n.@{fa-css-prefix}-align-justify:before { content: @fa-var-align-justify; }\n.@{fa-css-prefix}-list:before { content: @fa-var-list; }\n.@{fa-css-prefix}-dedent:before,\n.@{fa-css-prefix}-outdent:before { content: @fa-var-outdent; }\n.@{fa-css-prefix}-indent:before { content: @fa-var-indent; }\n.@{fa-css-prefix}-video-camera:before { content: @fa-var-video-camera; }\n.@{fa-css-prefix}-photo:before,\n.@{fa-css-prefix}-image:before,\n.@{fa-css-prefix}-picture-o:before { content: @fa-var-picture-o; }\n.@{fa-css-prefix}-pencil:before { content: @fa-var-pencil; }\n.@{fa-css-prefix}-map-marker:before { content: @fa-var-map-marker; }\n.@{fa-css-prefix}-adjust:before { content: @fa-var-adjust; }\n.@{fa-css-prefix}-tint:before { content: @fa-var-tint; }\n.@{fa-css-prefix}-edit:before,\n.@{fa-css-prefix}-pencil-square-o:before { content: @fa-var-pencil-square-o; }\n.@{fa-css-prefix}-share-square-o:before { content: @fa-var-share-square-o; }\n.@{fa-css-prefix}-check-square-o:before { content: @fa-var-check-square-o; }\n.@{fa-css-prefix}-arrows:before { content: @fa-var-arrows; }\n.@{fa-css-prefix}-step-backward:before { content: @fa-var-step-backward; }\n.@{fa-css-prefix}-fast-backward:before { content: @fa-var-fast-backward; }\n.@{fa-css-prefix}-backward:before { content: @fa-var-backward; }\n.@{fa-css-prefix}-play:before { content: @fa-var-play; }\n.@{fa-css-prefix}-pause:before { content: @fa-var-pause; }\n.@{fa-css-prefix}-stop:before { content: @fa-var-stop; }\n.@{fa-css-prefix}-forward:before { content: @fa-var-forward; }\n.@{fa-css-prefix}-fast-forward:before { content: @fa-var-fast-forward; }\n.@{fa-css-prefix}-step-forward:before { content: @fa-var-step-forward; }\n.@{fa-css-prefix}-eject:before { content: @fa-var-eject; }\n.@{fa-css-prefix}-chevron-left:before { content: @fa-var-chevron-left; }\n.@{fa-css-prefix}-chevron-right:before { content: @fa-var-chevron-right; }\n.@{fa-css-prefix}-plus-circle:before { content: @fa-var-plus-circle; }\n.@{fa-css-prefix}-minus-circle:before { content: @fa-var-minus-circle; }\n.@{fa-css-prefix}-times-circle:before { content: @fa-var-times-circle; }\n.@{fa-css-prefix}-check-circle:before { content: @fa-var-check-circle; }\n.@{fa-css-prefix}-question-circle:before { content: @fa-var-question-circle; }\n.@{fa-css-prefix}-info-circle:before { content: @fa-var-info-circle; }\n.@{fa-css-prefix}-crosshairs:before { content: @fa-var-crosshairs; }\n.@{fa-css-prefix}-times-circle-o:before { content: @fa-var-times-circle-o; }\n.@{fa-css-prefix}-check-circle-o:before { content: @fa-var-check-circle-o; }\n.@{fa-css-prefix}-ban:before { content: @fa-var-ban; }\n.@{fa-css-prefix}-arrow-left:before { content: @fa-var-arrow-left; }\n.@{fa-css-prefix}-arrow-right:before { content: @fa-var-arrow-right; }\n.@{fa-css-prefix}-arrow-up:before { content: @fa-var-arrow-up; }\n.@{fa-css-prefix}-arrow-down:before { content: @fa-var-arrow-down; }\n.@{fa-css-prefix}-mail-forward:before,\n.@{fa-css-prefix}-share:before { content: @fa-var-share; }\n.@{fa-css-prefix}-expand:before { content: @fa-var-expand; }\n.@{fa-css-prefix}-compress:before { content: @fa-var-compress; }\n.@{fa-css-prefix}-plus:before { content: @fa-var-plus; }\n.@{fa-css-prefix}-minus:before { content: @fa-var-minus; }\n.@{fa-css-prefix}-asterisk:before { content: @fa-var-asterisk; }\n.@{fa-css-prefix}-exclamation-circle:before { content: @fa-var-exclamation-circle; }\n.@{fa-css-prefix}-gift:before { content: @fa-var-gift; }\n.@{fa-css-prefix}-leaf:before { content: @fa-var-leaf; }\n.@{fa-css-prefix}-fire:before { content: @fa-var-fire; }\n.@{fa-css-prefix}-eye:before { content: @fa-var-eye; }\n.@{fa-css-prefix}-eye-slash:before { content: @fa-var-eye-slash; }\n.@{fa-css-prefix}-warning:before,\n.@{fa-css-prefix}-exclamation-triangle:before { content: @fa-var-exclamation-triangle; }\n.@{fa-css-prefix}-plane:before { content: @fa-var-plane; }\n.@{fa-css-prefix}-calendar:before { content: @fa-var-calendar; }\n.@{fa-css-prefix}-random:before { content: @fa-var-random; }\n.@{fa-css-prefix}-comment:before { content: @fa-var-comment; }\n.@{fa-css-prefix}-magnet:before { content: @fa-var-magnet; }\n.@{fa-css-prefix}-chevron-up:before { content: @fa-var-chevron-up; }\n.@{fa-css-prefix}-chevron-down:before { content: @fa-var-chevron-down; }\n.@{fa-css-prefix}-retweet:before { content: @fa-var-retweet; }\n.@{fa-css-prefix}-shopping-cart:before { content: @fa-var-shopping-cart; }\n.@{fa-css-prefix}-folder:before { content: @fa-var-folder; }\n.@{fa-css-prefix}-folder-open:before { content: @fa-var-folder-open; }\n.@{fa-css-prefix}-arrows-v:before { content: @fa-var-arrows-v; }\n.@{fa-css-prefix}-arrows-h:before { content: @fa-var-arrows-h; }\n.@{fa-css-prefix}-bar-chart-o:before,\n.@{fa-css-prefix}-bar-chart:before { content: @fa-var-bar-chart; }\n.@{fa-css-prefix}-twitter-square:before { content: @fa-var-twitter-square; }\n.@{fa-css-prefix}-facebook-square:before { content: @fa-var-facebook-square; }\n.@{fa-css-prefix}-camera-retro:before { content: @fa-var-camera-retro; }\n.@{fa-css-prefix}-key:before { content: @fa-var-key; }\n.@{fa-css-prefix}-gears:before,\n.@{fa-css-prefix}-cogs:before { content: @fa-var-cogs; }\n.@{fa-css-prefix}-comments:before { content: @fa-var-comments; }\n.@{fa-css-prefix}-thumbs-o-up:before { content: @fa-var-thumbs-o-up; }\n.@{fa-css-prefix}-thumbs-o-down:before { content: @fa-var-thumbs-o-down; }\n.@{fa-css-prefix}-star-half:before { content: @fa-var-star-half; }\n.@{fa-css-prefix}-heart-o:before { content: @fa-var-heart-o; }\n.@{fa-css-prefix}-sign-out:before { content: @fa-var-sign-out; }\n.@{fa-css-prefix}-linkedin-square:before { content: @fa-var-linkedin-square; }\n.@{fa-css-prefix}-thumb-tack:before { content: @fa-var-thumb-tack; }\n.@{fa-css-prefix}-external-link:before { content: @fa-var-external-link; }\n.@{fa-css-prefix}-sign-in:before { content: @fa-var-sign-in; }\n.@{fa-css-prefix}-trophy:before { content: @fa-var-trophy; }\n.@{fa-css-prefix}-github-square:before { content: @fa-var-github-square; }\n.@{fa-css-prefix}-upload:before { content: @fa-var-upload; }\n.@{fa-css-prefix}-lemon-o:before { content: @fa-var-lemon-o; }\n.@{fa-css-prefix}-phone:before { content: @fa-var-phone; }\n.@{fa-css-prefix}-square-o:before { content: @fa-var-square-o; }\n.@{fa-css-prefix}-bookmark-o:before { content: @fa-var-bookmark-o; }\n.@{fa-css-prefix}-phone-square:before { content: @fa-var-phone-square; }\n.@{fa-css-prefix}-twitter:before { content: @fa-var-twitter; }\n.@{fa-css-prefix}-facebook-f:before,\n.@{fa-css-prefix}-facebook:before { content: @fa-var-facebook; }\n.@{fa-css-prefix}-github:before { content: @fa-var-github; }\n.@{fa-css-prefix}-unlock:before { content: @fa-var-unlock; }\n.@{fa-css-prefix}-credit-card:before { content: @fa-var-credit-card; }\n.@{fa-css-prefix}-feed:before,\n.@{fa-css-prefix}-rss:before { content: @fa-var-rss; }\n.@{fa-css-prefix}-hdd-o:before { content: @fa-var-hdd-o; }\n.@{fa-css-prefix}-bullhorn:before { content: @fa-var-bullhorn; }\n.@{fa-css-prefix}-bell:before { content: @fa-var-bell; }\n.@{fa-css-prefix}-certificate:before { content: @fa-var-certificate; }\n.@{fa-css-prefix}-hand-o-right:before { content: @fa-var-hand-o-right; }\n.@{fa-css-prefix}-hand-o-left:before { content: @fa-var-hand-o-left; }\n.@{fa-css-prefix}-hand-o-up:before { content: @fa-var-hand-o-up; }\n.@{fa-css-prefix}-hand-o-down:before { content: @fa-var-hand-o-down; }\n.@{fa-css-prefix}-arrow-circle-left:before { content: @fa-var-arrow-circle-left; }\n.@{fa-css-prefix}-arrow-circle-right:before { content: @fa-var-arrow-circle-right; }\n.@{fa-css-prefix}-arrow-circle-up:before { content: @fa-var-arrow-circle-up; }\n.@{fa-css-prefix}-arrow-circle-down:before { content: @fa-var-arrow-circle-down; }\n.@{fa-css-prefix}-globe:before { content: @fa-var-globe; }\n.@{fa-css-prefix}-wrench:before { content: @fa-var-wrench; }\n.@{fa-css-prefix}-tasks:before { content: @fa-var-tasks; }\n.@{fa-css-prefix}-filter:before { content: @fa-var-filter; }\n.@{fa-css-prefix}-briefcase:before { content: @fa-var-briefcase; }\n.@{fa-css-prefix}-arrows-alt:before { content: @fa-var-arrows-alt; }\n.@{fa-css-prefix}-group:before,\n.@{fa-css-prefix}-users:before { content: @fa-var-users; }\n.@{fa-css-prefix}-chain:before,\n.@{fa-css-prefix}-link:before { content: @fa-var-link; }\n.@{fa-css-prefix}-cloud:before { content: @fa-var-cloud; }\n.@{fa-css-prefix}-flask:before { content: @fa-var-flask; }\n.@{fa-css-prefix}-cut:before,\n.@{fa-css-prefix}-scissors:before { content: @fa-var-scissors; }\n.@{fa-css-prefix}-copy:before,\n.@{fa-css-prefix}-files-o:before { content: @fa-var-files-o; }\n.@{fa-css-prefix}-paperclip:before { content: @fa-var-paperclip; }\n.@{fa-css-prefix}-save:before,\n.@{fa-css-prefix}-floppy-o:before { content: @fa-var-floppy-o; }\n.@{fa-css-prefix}-square:before { content: @fa-var-square; }\n.@{fa-css-prefix}-navicon:before,\n.@{fa-css-prefix}-reorder:before,\n.@{fa-css-prefix}-bars:before { content: @fa-var-bars; }\n.@{fa-css-prefix}-list-ul:before { content: @fa-var-list-ul; }\n.@{fa-css-prefix}-list-ol:before { content: @fa-var-list-ol; }\n.@{fa-css-prefix}-strikethrough:before { content: @fa-var-strikethrough; }\n.@{fa-css-prefix}-underline:before { content: @fa-var-underline; }\n.@{fa-css-prefix}-table:before { content: @fa-var-table; }\n.@{fa-css-prefix}-magic:before { content: @fa-var-magic; }\n.@{fa-css-prefix}-truck:before { content: @fa-var-truck; }\n.@{fa-css-prefix}-pinterest:before { content: @fa-var-pinterest; }\n.@{fa-css-prefix}-pinterest-square:before { content: @fa-var-pinterest-square; }\n.@{fa-css-prefix}-google-plus-square:before { content: @fa-var-google-plus-square; }\n.@{fa-css-prefix}-google-plus:before { content: @fa-var-google-plus; }\n.@{fa-css-prefix}-money:before { content: @fa-var-money; }\n.@{fa-css-prefix}-caret-down:before { content: @fa-var-caret-down; }\n.@{fa-css-prefix}-caret-up:before { content: @fa-var-caret-up; }\n.@{fa-css-prefix}-caret-left:before { content: @fa-var-caret-left; }\n.@{fa-css-prefix}-caret-right:before { content: @fa-var-caret-right; }\n.@{fa-css-prefix}-columns:before { content: @fa-var-columns; }\n.@{fa-css-prefix}-unsorted:before,\n.@{fa-css-prefix}-sort:before { content: @fa-var-sort; }\n.@{fa-css-prefix}-sort-down:before,\n.@{fa-css-prefix}-sort-desc:before { content: @fa-var-sort-desc; }\n.@{fa-css-prefix}-sort-up:before,\n.@{fa-css-prefix}-sort-asc:before { content: @fa-var-sort-asc; }\n.@{fa-css-prefix}-envelope:before { content: @fa-var-envelope; }\n.@{fa-css-prefix}-linkedin:before { content: @fa-var-linkedin; }\n.@{fa-css-prefix}-rotate-left:before,\n.@{fa-css-prefix}-undo:before { content: @fa-var-undo; }\n.@{fa-css-prefix}-legal:before,\n.@{fa-css-prefix}-gavel:before { content: @fa-var-gavel; }\n.@{fa-css-prefix}-dashboard:before,\n.@{fa-css-prefix}-tachometer:before { content: @fa-var-tachometer; }\n.@{fa-css-prefix}-comment-o:before { content: @fa-var-comment-o; }\n.@{fa-css-prefix}-comments-o:before { content: @fa-var-comments-o; }\n.@{fa-css-prefix}-flash:before,\n.@{fa-css-prefix}-bolt:before { content: @fa-var-bolt; }\n.@{fa-css-prefix}-sitemap:before { content: @fa-var-sitemap; }\n.@{fa-css-prefix}-umbrella:before { content: @fa-var-umbrella; }\n.@{fa-css-prefix}-paste:before,\n.@{fa-css-prefix}-clipboard:before { content: @fa-var-clipboard; }\n.@{fa-css-prefix}-lightbulb-o:before { content: @fa-var-lightbulb-o; }\n.@{fa-css-prefix}-exchange:before { content: @fa-var-exchange; }\n.@{fa-css-prefix}-cloud-download:before { content: @fa-var-cloud-download; }\n.@{fa-css-prefix}-cloud-upload:before { content: @fa-var-cloud-upload; }\n.@{fa-css-prefix}-user-md:before { content: @fa-var-user-md; }\n.@{fa-css-prefix}-stethoscope:before { content: @fa-var-stethoscope; }\n.@{fa-css-prefix}-suitcase:before { content: @fa-var-suitcase; }\n.@{fa-css-prefix}-bell-o:before { content: @fa-var-bell-o; }\n.@{fa-css-prefix}-coffee:before { content: @fa-var-coffee; }\n.@{fa-css-prefix}-cutlery:before { content: @fa-var-cutlery; }\n.@{fa-css-prefix}-file-text-o:before { content: @fa-var-file-text-o; }\n.@{fa-css-prefix}-building-o:before { content: @fa-var-building-o; }\n.@{fa-css-prefix}-hospital-o:before { content: @fa-var-hospital-o; }\n.@{fa-css-prefix}-ambulance:before { content: @fa-var-ambulance; }\n.@{fa-css-prefix}-medkit:before { content: @fa-var-medkit; }\n.@{fa-css-prefix}-fighter-jet:before { content: @fa-var-fighter-jet; }\n.@{fa-css-prefix}-beer:before { content: @fa-var-beer; }\n.@{fa-css-prefix}-h-square:before { content: @fa-var-h-square; }\n.@{fa-css-prefix}-plus-square:before { content: @fa-var-plus-square; }\n.@{fa-css-prefix}-angle-double-left:before { content: @fa-var-angle-double-left; }\n.@{fa-css-prefix}-angle-double-right:before { content: @fa-var-angle-double-right; }\n.@{fa-css-prefix}-angle-double-up:before { content: @fa-var-angle-double-up; }\n.@{fa-css-prefix}-angle-double-down:before { content: @fa-var-angle-double-down; }\n.@{fa-css-prefix}-angle-left:before { content: @fa-var-angle-left; }\n.@{fa-css-prefix}-angle-right:before { content: @fa-var-angle-right; }\n.@{fa-css-prefix}-angle-up:before { content: @fa-var-angle-up; }\n.@{fa-css-prefix}-angle-down:before { content: @fa-var-angle-down; }\n.@{fa-css-prefix}-desktop:before { content: @fa-var-desktop; }\n.@{fa-css-prefix}-laptop:before { content: @fa-var-laptop; }\n.@{fa-css-prefix}-tablet:before { content: @fa-var-tablet; }\n.@{fa-css-prefix}-mobile-phone:before,\n.@{fa-css-prefix}-mobile:before { content: @fa-var-mobile; }\n.@{fa-css-prefix}-circle-o:before { content: @fa-var-circle-o; }\n.@{fa-css-prefix}-quote-left:before { content: @fa-var-quote-left; }\n.@{fa-css-prefix}-quote-right:before { content: @fa-var-quote-right; }\n.@{fa-css-prefix}-spinner:before { content: @fa-var-spinner; }\n.@{fa-css-prefix}-circle:before { content: @fa-var-circle; }\n.@{fa-css-prefix}-mail-reply:before,\n.@{fa-css-prefix}-reply:before { content: @fa-var-reply; }\n.@{fa-css-prefix}-github-alt:before { content: @fa-var-github-alt; }\n.@{fa-css-prefix}-folder-o:before { content: @fa-var-folder-o; }\n.@{fa-css-prefix}-folder-open-o:before { content: @fa-var-folder-open-o; }\n.@{fa-css-prefix}-smile-o:before { content: @fa-var-smile-o; }\n.@{fa-css-prefix}-frown-o:before { content: @fa-var-frown-o; }\n.@{fa-css-prefix}-meh-o:before { content: @fa-var-meh-o; }\n.@{fa-css-prefix}-gamepad:before { content: @fa-var-gamepad; }\n.@{fa-css-prefix}-keyboard-o:before { content: @fa-var-keyboard-o; }\n.@{fa-css-prefix}-flag-o:before { content: @fa-var-flag-o; }\n.@{fa-css-prefix}-flag-checkered:before { content: @fa-var-flag-checkered; }\n.@{fa-css-prefix}-terminal:before { content: @fa-var-terminal; }\n.@{fa-css-prefix}-code:before { content: @fa-var-code; }\n.@{fa-css-prefix}-mail-reply-all:before,\n.@{fa-css-prefix}-reply-all:before { content: @fa-var-reply-all; }\n.@{fa-css-prefix}-star-half-empty:before,\n.@{fa-css-prefix}-star-half-full:before,\n.@{fa-css-prefix}-star-half-o:before { content: @fa-var-star-half-o; }\n.@{fa-css-prefix}-location-arrow:before { content: @fa-var-location-arrow; }\n.@{fa-css-prefix}-crop:before { content: @fa-var-crop; }\n.@{fa-css-prefix}-code-fork:before { content: @fa-var-code-fork; }\n.@{fa-css-prefix}-unlink:before,\n.@{fa-css-prefix}-chain-broken:before { content: @fa-var-chain-broken; }\n.@{fa-css-prefix}-question:before { content: @fa-var-question; }\n.@{fa-css-prefix}-info:before { content: @fa-var-info; }\n.@{fa-css-prefix}-exclamation:before { content: @fa-var-exclamation; }\n.@{fa-css-prefix}-superscript:before { content: @fa-var-superscript; }\n.@{fa-css-prefix}-subscript:before { content: @fa-var-subscript; }\n.@{fa-css-prefix}-eraser:before { content: @fa-var-eraser; }\n.@{fa-css-prefix}-puzzle-piece:before { content: @fa-var-puzzle-piece; }\n.@{fa-css-prefix}-microphone:before { content: @fa-var-microphone; }\n.@{fa-css-prefix}-microphone-slash:before { content: @fa-var-microphone-slash; }\n.@{fa-css-prefix}-shield:before { content: @fa-var-shield; }\n.@{fa-css-prefix}-calendar-o:before { content: @fa-var-calendar-o; }\n.@{fa-css-prefix}-fire-extinguisher:before { content: @fa-var-fire-extinguisher; }\n.@{fa-css-prefix}-rocket:before { content: @fa-var-rocket; }\n.@{fa-css-prefix}-maxcdn:before { content: @fa-var-maxcdn; }\n.@{fa-css-prefix}-chevron-circle-left:before { content: @fa-var-chevron-circle-left; }\n.@{fa-css-prefix}-chevron-circle-right:before { content: @fa-var-chevron-circle-right; }\n.@{fa-css-prefix}-chevron-circle-up:before { content: @fa-var-chevron-circle-up; }\n.@{fa-css-prefix}-chevron-circle-down:before { content: @fa-var-chevron-circle-down; }\n.@{fa-css-prefix}-html5:before { content: @fa-var-html5; }\n.@{fa-css-prefix}-css3:before { content: @fa-var-css3; }\n.@{fa-css-prefix}-anchor:before { content: @fa-var-anchor; }\n.@{fa-css-prefix}-unlock-alt:before { content: @fa-var-unlock-alt; }\n.@{fa-css-prefix}-bullseye:before { content: @fa-var-bullseye; }\n.@{fa-css-prefix}-ellipsis-h:before { content: @fa-var-ellipsis-h; }\n.@{fa-css-prefix}-ellipsis-v:before { content: @fa-var-ellipsis-v; }\n.@{fa-css-prefix}-rss-square:before { content: @fa-var-rss-square; }\n.@{fa-css-prefix}-play-circle:before { content: @fa-var-play-circle; }\n.@{fa-css-prefix}-ticket:before { content: @fa-var-ticket; }\n.@{fa-css-prefix}-minus-square:before { content: @fa-var-minus-square; }\n.@{fa-css-prefix}-minus-square-o:before { content: @fa-var-minus-square-o; }\n.@{fa-css-prefix}-level-up:before { content: @fa-var-level-up; }\n.@{fa-css-prefix}-level-down:before { content: @fa-var-level-down; }\n.@{fa-css-prefix}-check-square:before { content: @fa-var-check-square; }\n.@{fa-css-prefix}-pencil-square:before { content: @fa-var-pencil-square; }\n.@{fa-css-prefix}-external-link-square:before { content: @fa-var-external-link-square; }\n.@{fa-css-prefix}-share-square:before { content: @fa-var-share-square; }\n.@{fa-css-prefix}-compass:before { content: @fa-var-compass; }\n.@{fa-css-prefix}-toggle-down:before,\n.@{fa-css-prefix}-caret-square-o-down:before { content: @fa-var-caret-square-o-down; }\n.@{fa-css-prefix}-toggle-up:before,\n.@{fa-css-prefix}-caret-square-o-up:before { content: @fa-var-caret-square-o-up; }\n.@{fa-css-prefix}-toggle-right:before,\n.@{fa-css-prefix}-caret-square-o-right:before { content: @fa-var-caret-square-o-right; }\n.@{fa-css-prefix}-euro:before,\n.@{fa-css-prefix}-eur:before { content: @fa-var-eur; }\n.@{fa-css-prefix}-gbp:before { content: @fa-var-gbp; }\n.@{fa-css-prefix}-dollar:before,\n.@{fa-css-prefix}-usd:before { content: @fa-var-usd; }\n.@{fa-css-prefix}-rupee:before,\n.@{fa-css-prefix}-inr:before { content: @fa-var-inr; }\n.@{fa-css-prefix}-cny:before,\n.@{fa-css-prefix}-rmb:before,\n.@{fa-css-prefix}-yen:before,\n.@{fa-css-prefix}-jpy:before { content: @fa-var-jpy; }\n.@{fa-css-prefix}-ruble:before,\n.@{fa-css-prefix}-rouble:before,\n.@{fa-css-prefix}-rub:before { content: @fa-var-rub; }\n.@{fa-css-prefix}-won:before,\n.@{fa-css-prefix}-krw:before { content: @fa-var-krw; }\n.@{fa-css-prefix}-bitcoin:before,\n.@{fa-css-prefix}-btc:before { content: @fa-var-btc; }\n.@{fa-css-prefix}-file:before { content: @fa-var-file; }\n.@{fa-css-prefix}-file-text:before { content: @fa-var-file-text; }\n.@{fa-css-prefix}-sort-alpha-asc:before { content: @fa-var-sort-alpha-asc; }\n.@{fa-css-prefix}-sort-alpha-desc:before { content: @fa-var-sort-alpha-desc; }\n.@{fa-css-prefix}-sort-amount-asc:before { content: @fa-var-sort-amount-asc; }\n.@{fa-css-prefix}-sort-amount-desc:before { content: @fa-var-sort-amount-desc; }\n.@{fa-css-prefix}-sort-numeric-asc:before { content: @fa-var-sort-numeric-asc; }\n.@{fa-css-prefix}-sort-numeric-desc:before { content: @fa-var-sort-numeric-desc; }\n.@{fa-css-prefix}-thumbs-up:before { content: @fa-var-thumbs-up; }\n.@{fa-css-prefix}-thumbs-down:before { content: @fa-var-thumbs-down; }\n.@{fa-css-prefix}-youtube-square:before { content: @fa-var-youtube-square; }\n.@{fa-css-prefix}-youtube:before { content: @fa-var-youtube; }\n.@{fa-css-prefix}-xing:before { content: @fa-var-xing; }\n.@{fa-css-prefix}-xing-square:before { content: @fa-var-xing-square; }\n.@{fa-css-prefix}-youtube-play:before { content: @fa-var-youtube-play; }\n.@{fa-css-prefix}-dropbox:before { content: @fa-var-dropbox; }\n.@{fa-css-prefix}-stack-overflow:before { content: @fa-var-stack-overflow; }\n.@{fa-css-prefix}-instagram:before { content: @fa-var-instagram; }\n.@{fa-css-prefix}-flickr:before { content: @fa-var-flickr; }\n.@{fa-css-prefix}-adn:before { content: @fa-var-adn; }\n.@{fa-css-prefix}-bitbucket:before { content: @fa-var-bitbucket; }\n.@{fa-css-prefix}-bitbucket-square:before { content: @fa-var-bitbucket-square; }\n.@{fa-css-prefix}-tumblr:before { content: @fa-var-tumblr; }\n.@{fa-css-prefix}-tumblr-square:before { content: @fa-var-tumblr-square; }\n.@{fa-css-prefix}-long-arrow-down:before { content: @fa-var-long-arrow-down; }\n.@{fa-css-prefix}-long-arrow-up:before { content: @fa-var-long-arrow-up; }\n.@{fa-css-prefix}-long-arrow-left:before { content: @fa-var-long-arrow-left; }\n.@{fa-css-prefix}-long-arrow-right:before { content: @fa-var-long-arrow-right; }\n.@{fa-css-prefix}-apple:before { content: @fa-var-apple; }\n.@{fa-css-prefix}-windows:before { content: @fa-var-windows; }\n.@{fa-css-prefix}-android:before { content: @fa-var-android; }\n.@{fa-css-prefix}-linux:before { content: @fa-var-linux; }\n.@{fa-css-prefix}-dribbble:before { content: @fa-var-dribbble; }\n.@{fa-css-prefix}-skype:before { content: @fa-var-skype; }\n.@{fa-css-prefix}-foursquare:before { content: @fa-var-foursquare; }\n.@{fa-css-prefix}-trello:before { content: @fa-var-trello; }\n.@{fa-css-prefix}-female:before { content: @fa-var-female; }\n.@{fa-css-prefix}-male:before { content: @fa-var-male; }\n.@{fa-css-prefix}-gittip:before,\n.@{fa-css-prefix}-gratipay:before { content: @fa-var-gratipay; }\n.@{fa-css-prefix}-sun-o:before { content: @fa-var-sun-o; }\n.@{fa-css-prefix}-moon-o:before { content: @fa-var-moon-o; }\n.@{fa-css-prefix}-archive:before { content: @fa-var-archive; }\n.@{fa-css-prefix}-bug:before { content: @fa-var-bug; }\n.@{fa-css-prefix}-vk:before { content: @fa-var-vk; }\n.@{fa-css-prefix}-weibo:before { content: @fa-var-weibo; }\n.@{fa-css-prefix}-renren:before { content: @fa-var-renren; }\n.@{fa-css-prefix}-pagelines:before { content: @fa-var-pagelines; }\n.@{fa-css-prefix}-stack-exchange:before { content: @fa-var-stack-exchange; }\n.@{fa-css-prefix}-arrow-circle-o-right:before { content: @fa-var-arrow-circle-o-right; }\n.@{fa-css-prefix}-arrow-circle-o-left:before { content: @fa-var-arrow-circle-o-left; }\n.@{fa-css-prefix}-toggle-left:before,\n.@{fa-css-prefix}-caret-square-o-left:before { content: @fa-var-caret-square-o-left; }\n.@{fa-css-prefix}-dot-circle-o:before { content: @fa-var-dot-circle-o; }\n.@{fa-css-prefix}-wheelchair:before { content: @fa-var-wheelchair; }\n.@{fa-css-prefix}-vimeo-square:before { content: @fa-var-vimeo-square; }\n.@{fa-css-prefix}-turkish-lira:before,\n.@{fa-css-prefix}-try:before { content: @fa-var-try; }\n.@{fa-css-prefix}-plus-square-o:before { content: @fa-var-plus-square-o; }\n.@{fa-css-prefix}-space-shuttle:before { content: @fa-var-space-shuttle; }\n.@{fa-css-prefix}-slack:before { content: @fa-var-slack; }\n.@{fa-css-prefix}-envelope-square:before { content: @fa-var-envelope-square; }\n.@{fa-css-prefix}-wordpress:before { content: @fa-var-wordpress; }\n.@{fa-css-prefix}-openid:before { content: @fa-var-openid; }\n.@{fa-css-prefix}-institution:before,\n.@{fa-css-prefix}-bank:before,\n.@{fa-css-prefix}-university:before { content: @fa-var-university; }\n.@{fa-css-prefix}-mortar-board:before,\n.@{fa-css-prefix}-graduation-cap:before { content: @fa-var-graduation-cap; }\n.@{fa-css-prefix}-yahoo:before { content: @fa-var-yahoo; }\n.@{fa-css-prefix}-google:before { content: @fa-var-google; }\n.@{fa-css-prefix}-reddit:before { content: @fa-var-reddit; }\n.@{fa-css-prefix}-reddit-square:before { content: @fa-var-reddit-square; }\n.@{fa-css-prefix}-stumbleupon-circle:before { content: @fa-var-stumbleupon-circle; }\n.@{fa-css-prefix}-stumbleupon:before { content: @fa-var-stumbleupon; }\n.@{fa-css-prefix}-delicious:before { content: @fa-var-delicious; }\n.@{fa-css-prefix}-digg:before { content: @fa-var-digg; }\n.@{fa-css-prefix}-pied-piper-pp:before { content: @fa-var-pied-piper-pp; }\n.@{fa-css-prefix}-pied-piper-alt:before { content: @fa-var-pied-piper-alt; }\n.@{fa-css-prefix}-drupal:before { content: @fa-var-drupal; }\n.@{fa-css-prefix}-joomla:before { content: @fa-var-joomla; }\n.@{fa-css-prefix}-language:before { content: @fa-var-language; }\n.@{fa-css-prefix}-fax:before { content: @fa-var-fax; }\n.@{fa-css-prefix}-building:before { content: @fa-var-building; }\n.@{fa-css-prefix}-child:before { content: @fa-var-child; }\n.@{fa-css-prefix}-paw:before { content: @fa-var-paw; }\n.@{fa-css-prefix}-spoon:before { content: @fa-var-spoon; }\n.@{fa-css-prefix}-cube:before { content: @fa-var-cube; }\n.@{fa-css-prefix}-cubes:before { content: @fa-var-cubes; }\n.@{fa-css-prefix}-behance:before { content: @fa-var-behance; }\n.@{fa-css-prefix}-behance-square:before { content: @fa-var-behance-square; }\n.@{fa-css-prefix}-steam:before { content: @fa-var-steam; }\n.@{fa-css-prefix}-steam-square:before { content: @fa-var-steam-square; }\n.@{fa-css-prefix}-recycle:before { content: @fa-var-recycle; }\n.@{fa-css-prefix}-automobile:before,\n.@{fa-css-prefix}-car:before { content: @fa-var-car; }\n.@{fa-css-prefix}-cab:before,\n.@{fa-css-prefix}-taxi:before { content: @fa-var-taxi; }\n.@{fa-css-prefix}-tree:before { content: @fa-var-tree; }\n.@{fa-css-prefix}-spotify:before { content: @fa-var-spotify; }\n.@{fa-css-prefix}-deviantart:before { content: @fa-var-deviantart; }\n.@{fa-css-prefix}-soundcloud:before { content: @fa-var-soundcloud; }\n.@{fa-css-prefix}-database:before { content: @fa-var-database; }\n.@{fa-css-prefix}-file-pdf-o:before { content: @fa-var-file-pdf-o; }\n.@{fa-css-prefix}-file-word-o:before { content: @fa-var-file-word-o; }\n.@{fa-css-prefix}-file-excel-o:before { content: @fa-var-file-excel-o; }\n.@{fa-css-prefix}-file-powerpoint-o:before { content: @fa-var-file-powerpoint-o; }\n.@{fa-css-prefix}-file-photo-o:before,\n.@{fa-css-prefix}-file-picture-o:before,\n.@{fa-css-prefix}-file-image-o:before { content: @fa-var-file-image-o; }\n.@{fa-css-prefix}-file-zip-o:before,\n.@{fa-css-prefix}-file-archive-o:before { content: @fa-var-file-archive-o; }\n.@{fa-css-prefix}-file-sound-o:before,\n.@{fa-css-prefix}-file-audio-o:before { content: @fa-var-file-audio-o; }\n.@{fa-css-prefix}-file-movie-o:before,\n.@{fa-css-prefix}-file-video-o:before { content: @fa-var-file-video-o; }\n.@{fa-css-prefix}-file-code-o:before { content: @fa-var-file-code-o; }\n.@{fa-css-prefix}-vine:before { content: @fa-var-vine; }\n.@{fa-css-prefix}-codepen:before { content: @fa-var-codepen; }\n.@{fa-css-prefix}-jsfiddle:before { content: @fa-var-jsfiddle; }\n.@{fa-css-prefix}-life-bouy:before,\n.@{fa-css-prefix}-life-buoy:before,\n.@{fa-css-prefix}-life-saver:before,\n.@{fa-css-prefix}-support:before,\n.@{fa-css-prefix}-life-ring:before { content: @fa-var-life-ring; }\n.@{fa-css-prefix}-circle-o-notch:before { content: @fa-var-circle-o-notch; }\n.@{fa-css-prefix}-ra:before,\n.@{fa-css-prefix}-resistance:before,\n.@{fa-css-prefix}-rebel:before { content: @fa-var-rebel; }\n.@{fa-css-prefix}-ge:before,\n.@{fa-css-prefix}-empire:before { content: @fa-var-empire; }\n.@{fa-css-prefix}-git-square:before { content: @fa-var-git-square; }\n.@{fa-css-prefix}-git:before { content: @fa-var-git; }\n.@{fa-css-prefix}-y-combinator-square:before,\n.@{fa-css-prefix}-yc-square:before,\n.@{fa-css-prefix}-hacker-news:before { content: @fa-var-hacker-news; }\n.@{fa-css-prefix}-tencent-weibo:before { content: @fa-var-tencent-weibo; }\n.@{fa-css-prefix}-qq:before { content: @fa-var-qq; }\n.@{fa-css-prefix}-wechat:before,\n.@{fa-css-prefix}-weixin:before { content: @fa-var-weixin; }\n.@{fa-css-prefix}-send:before,\n.@{fa-css-prefix}-paper-plane:before { content: @fa-var-paper-plane; }\n.@{fa-css-prefix}-send-o:before,\n.@{fa-css-prefix}-paper-plane-o:before { content: @fa-var-paper-plane-o; }\n.@{fa-css-prefix}-history:before { content: @fa-var-history; }\n.@{fa-css-prefix}-circle-thin:before { content: @fa-var-circle-thin; }\n.@{fa-css-prefix}-header:before { content: @fa-var-header; }\n.@{fa-css-prefix}-paragraph:before { content: @fa-var-paragraph; }\n.@{fa-css-prefix}-sliders:before { content: @fa-var-sliders; }\n.@{fa-css-prefix}-share-alt:before { content: @fa-var-share-alt; }\n.@{fa-css-prefix}-share-alt-square:before { content: @fa-var-share-alt-square; }\n.@{fa-css-prefix}-bomb:before { content: @fa-var-bomb; }\n.@{fa-css-prefix}-soccer-ball-o:before,\n.@{fa-css-prefix}-futbol-o:before { content: @fa-var-futbol-o; }\n.@{fa-css-prefix}-tty:before { content: @fa-var-tty; }\n.@{fa-css-prefix}-binoculars:before { content: @fa-var-binoculars; }\n.@{fa-css-prefix}-plug:before { content: @fa-var-plug; }\n.@{fa-css-prefix}-slideshare:before { content: @fa-var-slideshare; }\n.@{fa-css-prefix}-twitch:before { content: @fa-var-twitch; }\n.@{fa-css-prefix}-yelp:before { content: @fa-var-yelp; }\n.@{fa-css-prefix}-newspaper-o:before { content: @fa-var-newspaper-o; }\n.@{fa-css-prefix}-wifi:before { content: @fa-var-wifi; }\n.@{fa-css-prefix}-calculator:before { content: @fa-var-calculator; }\n.@{fa-css-prefix}-paypal:before { content: @fa-var-paypal; }\n.@{fa-css-prefix}-google-wallet:before { content: @fa-var-google-wallet; }\n.@{fa-css-prefix}-cc-visa:before { content: @fa-var-cc-visa; }\n.@{fa-css-prefix}-cc-mastercard:before { content: @fa-var-cc-mastercard; }\n.@{fa-css-prefix}-cc-discover:before { content: @fa-var-cc-discover; }\n.@{fa-css-prefix}-cc-amex:before { content: @fa-var-cc-amex; }\n.@{fa-css-prefix}-cc-paypal:before { content: @fa-var-cc-paypal; }\n.@{fa-css-prefix}-cc-stripe:before { content: @fa-var-cc-stripe; }\n.@{fa-css-prefix}-bell-slash:before { content: @fa-var-bell-slash; }\n.@{fa-css-prefix}-bell-slash-o:before { content: @fa-var-bell-slash-o; }\n.@{fa-css-prefix}-trash:before { content: @fa-var-trash; }\n.@{fa-css-prefix}-copyright:before { content: @fa-var-copyright; }\n.@{fa-css-prefix}-at:before { content: @fa-var-at; }\n.@{fa-css-prefix}-eyedropper:before { content: @fa-var-eyedropper; }\n.@{fa-css-prefix}-paint-brush:before { content: @fa-var-paint-brush; }\n.@{fa-css-prefix}-birthday-cake:before { content: @fa-var-birthday-cake; }\n.@{fa-css-prefix}-area-chart:before { content: @fa-var-area-chart; }\n.@{fa-css-prefix}-pie-chart:before { content: @fa-var-pie-chart; }\n.@{fa-css-prefix}-line-chart:before { content: @fa-var-line-chart; }\n.@{fa-css-prefix}-lastfm:before { content: @fa-var-lastfm; }\n.@{fa-css-prefix}-lastfm-square:before { content: @fa-var-lastfm-square; }\n.@{fa-css-prefix}-toggle-off:before { content: @fa-var-toggle-off; }\n.@{fa-css-prefix}-toggle-on:before { content: @fa-var-toggle-on; }\n.@{fa-css-prefix}-bicycle:before { content: @fa-var-bicycle; }\n.@{fa-css-prefix}-bus:before { content: @fa-var-bus; }\n.@{fa-css-prefix}-ioxhost:before { content: @fa-var-ioxhost; }\n.@{fa-css-prefix}-angellist:before { content: @fa-var-angellist; }\n.@{fa-css-prefix}-cc:before { content: @fa-var-cc; }\n.@{fa-css-prefix}-shekel:before,\n.@{fa-css-prefix}-sheqel:before,\n.@{fa-css-prefix}-ils:before { content: @fa-var-ils; }\n.@{fa-css-prefix}-meanpath:before { content: @fa-var-meanpath; }\n.@{fa-css-prefix}-buysellads:before { content: @fa-var-buysellads; }\n.@{fa-css-prefix}-connectdevelop:before { content: @fa-var-connectdevelop; }\n.@{fa-css-prefix}-dashcube:before { content: @fa-var-dashcube; }\n.@{fa-css-prefix}-forumbee:before { content: @fa-var-forumbee; }\n.@{fa-css-prefix}-leanpub:before { content: @fa-var-leanpub; }\n.@{fa-css-prefix}-sellsy:before { content: @fa-var-sellsy; }\n.@{fa-css-prefix}-shirtsinbulk:before { content: @fa-var-shirtsinbulk; }\n.@{fa-css-prefix}-simplybuilt:before { content: @fa-var-simplybuilt; }\n.@{fa-css-prefix}-skyatlas:before { content: @fa-var-skyatlas; }\n.@{fa-css-prefix}-cart-plus:before { content: @fa-var-cart-plus; }\n.@{fa-css-prefix}-cart-arrow-down:before { content: @fa-var-cart-arrow-down; }\n.@{fa-css-prefix}-diamond:before { content: @fa-var-diamond; }\n.@{fa-css-prefix}-ship:before { content: @fa-var-ship; }\n.@{fa-css-prefix}-user-secret:before { content: @fa-var-user-secret; }\n.@{fa-css-prefix}-motorcycle:before { content: @fa-var-motorcycle; }\n.@{fa-css-prefix}-street-view:before { content: @fa-var-street-view; }\n.@{fa-css-prefix}-heartbeat:before { content: @fa-var-heartbeat; }\n.@{fa-css-prefix}-venus:before { content: @fa-var-venus; }\n.@{fa-css-prefix}-mars:before { content: @fa-var-mars; }\n.@{fa-css-prefix}-mercury:before { content: @fa-var-mercury; }\n.@{fa-css-prefix}-intersex:before,\n.@{fa-css-prefix}-transgender:before { content: @fa-var-transgender; }\n.@{fa-css-prefix}-transgender-alt:before { content: @fa-var-transgender-alt; }\n.@{fa-css-prefix}-venus-double:before { content: @fa-var-venus-double; }\n.@{fa-css-prefix}-mars-double:before { content: @fa-var-mars-double; }\n.@{fa-css-prefix}-venus-mars:before { content: @fa-var-venus-mars; }\n.@{fa-css-prefix}-mars-stroke:before { content: @fa-var-mars-stroke; }\n.@{fa-css-prefix}-mars-stroke-v:before { content: @fa-var-mars-stroke-v; }\n.@{fa-css-prefix}-mars-stroke-h:before { content: @fa-var-mars-stroke-h; }\n.@{fa-css-prefix}-neuter:before { content: @fa-var-neuter; }\n.@{fa-css-prefix}-genderless:before { content: @fa-var-genderless; }\n.@{fa-css-prefix}-facebook-official:before { content: @fa-var-facebook-official; }\n.@{fa-css-prefix}-pinterest-p:before { content: @fa-var-pinterest-p; }\n.@{fa-css-prefix}-whatsapp:before { content: @fa-var-whatsapp; }\n.@{fa-css-prefix}-server:before { content: @fa-var-server; }\n.@{fa-css-prefix}-user-plus:before { content: @fa-var-user-plus; }\n.@{fa-css-prefix}-user-times:before { content: @fa-var-user-times; }\n.@{fa-css-prefix}-hotel:before,\n.@{fa-css-prefix}-bed:before { content: @fa-var-bed; }\n.@{fa-css-prefix}-viacoin:before { content: @fa-var-viacoin; }\n.@{fa-css-prefix}-train:before { content: @fa-var-train; }\n.@{fa-css-prefix}-subway:before { content: @fa-var-subway; }\n.@{fa-css-prefix}-medium:before { content: @fa-var-medium; }\n.@{fa-css-prefix}-yc:before,\n.@{fa-css-prefix}-y-combinator:before { content: @fa-var-y-combinator; }\n.@{fa-css-prefix}-optin-monster:before { content: @fa-var-optin-monster; }\n.@{fa-css-prefix}-opencart:before { content: @fa-var-opencart; }\n.@{fa-css-prefix}-expeditedssl:before { content: @fa-var-expeditedssl; }\n.@{fa-css-prefix}-battery-4:before,\n.@{fa-css-prefix}-battery:before,\n.@{fa-css-prefix}-battery-full:before { content: @fa-var-battery-full; }\n.@{fa-css-prefix}-battery-3:before,\n.@{fa-css-prefix}-battery-three-quarters:before { content: @fa-var-battery-three-quarters; }\n.@{fa-css-prefix}-battery-2:before,\n.@{fa-css-prefix}-battery-half:before { content: @fa-var-battery-half; }\n.@{fa-css-prefix}-battery-1:before,\n.@{fa-css-prefix}-battery-quarter:before { content: @fa-var-battery-quarter; }\n.@{fa-css-prefix}-battery-0:before,\n.@{fa-css-prefix}-battery-empty:before { content: @fa-var-battery-empty; }\n.@{fa-css-prefix}-mouse-pointer:before { content: @fa-var-mouse-pointer; }\n.@{fa-css-prefix}-i-cursor:before { content: @fa-var-i-cursor; }\n.@{fa-css-prefix}-object-group:before { content: @fa-var-object-group; }\n.@{fa-css-prefix}-object-ungroup:before { content: @fa-var-object-ungroup; }\n.@{fa-css-prefix}-sticky-note:before { content: @fa-var-sticky-note; }\n.@{fa-css-prefix}-sticky-note-o:before { content: @fa-var-sticky-note-o; }\n.@{fa-css-prefix}-cc-jcb:before { content: @fa-var-cc-jcb; }\n.@{fa-css-prefix}-cc-diners-club:before { content: @fa-var-cc-diners-club; }\n.@{fa-css-prefix}-clone:before { content: @fa-var-clone; }\n.@{fa-css-prefix}-balance-scale:before { content: @fa-var-balance-scale; }\n.@{fa-css-prefix}-hourglass-o:before { content: @fa-var-hourglass-o; }\n.@{fa-css-prefix}-hourglass-1:before,\n.@{fa-css-prefix}-hourglass-start:before { content: @fa-var-hourglass-start; }\n.@{fa-css-prefix}-hourglass-2:before,\n.@{fa-css-prefix}-hourglass-half:before { content: @fa-var-hourglass-half; }\n.@{fa-css-prefix}-hourglass-3:before,\n.@{fa-css-prefix}-hourglass-end:before { content: @fa-var-hourglass-end; }\n.@{fa-css-prefix}-hourglass:before { content: @fa-var-hourglass; }\n.@{fa-css-prefix}-hand-grab-o:before,\n.@{fa-css-prefix}-hand-rock-o:before { content: @fa-var-hand-rock-o; }\n.@{fa-css-prefix}-hand-stop-o:before,\n.@{fa-css-prefix}-hand-paper-o:before { content: @fa-var-hand-paper-o; }\n.@{fa-css-prefix}-hand-scissors-o:before { content: @fa-var-hand-scissors-o; }\n.@{fa-css-prefix}-hand-lizard-o:before { content: @fa-var-hand-lizard-o; }\n.@{fa-css-prefix}-hand-spock-o:before { content: @fa-var-hand-spock-o; }\n.@{fa-css-prefix}-hand-pointer-o:before { content: @fa-var-hand-pointer-o; }\n.@{fa-css-prefix}-hand-peace-o:before { content: @fa-var-hand-peace-o; }\n.@{fa-css-prefix}-trademark:before { content: @fa-var-trademark; }\n.@{fa-css-prefix}-registered:before { content: @fa-var-registered; }\n.@{fa-css-prefix}-creative-commons:before { content: @fa-var-creative-commons; }\n.@{fa-css-prefix}-gg:before { content: @fa-var-gg; }\n.@{fa-css-prefix}-gg-circle:before { content: @fa-var-gg-circle; }\n.@{fa-css-prefix}-tripadvisor:before { content: @fa-var-tripadvisor; }\n.@{fa-css-prefix}-odnoklassniki:before { content: @fa-var-odnoklassniki; }\n.@{fa-css-prefix}-odnoklassniki-square:before { content: @fa-var-odnoklassniki-square; }\n.@{fa-css-prefix}-get-pocket:before { content: @fa-var-get-pocket; }\n.@{fa-css-prefix}-wikipedia-w:before { content: @fa-var-wikipedia-w; }\n.@{fa-css-prefix}-safari:before { content: @fa-var-safari; }\n.@{fa-css-prefix}-chrome:before { content: @fa-var-chrome; }\n.@{fa-css-prefix}-firefox:before { content: @fa-var-firefox; }\n.@{fa-css-prefix}-opera:before { content: @fa-var-opera; }\n.@{fa-css-prefix}-internet-explorer:before { content: @fa-var-internet-explorer; }\n.@{fa-css-prefix}-tv:before,\n.@{fa-css-prefix}-television:before { content: @fa-var-television; }\n.@{fa-css-prefix}-contao:before { content: @fa-var-contao; }\n.@{fa-css-prefix}-500px:before { content: @fa-var-500px; }\n.@{fa-css-prefix}-amazon:before { content: @fa-var-amazon; }\n.@{fa-css-prefix}-calendar-plus-o:before { content: @fa-var-calendar-plus-o; }\n.@{fa-css-prefix}-calendar-minus-o:before { content: @fa-var-calendar-minus-o; }\n.@{fa-css-prefix}-calendar-times-o:before { content: @fa-var-calendar-times-o; }\n.@{fa-css-prefix}-calendar-check-o:before { content: @fa-var-calendar-check-o; }\n.@{fa-css-prefix}-industry:before { content: @fa-var-industry; }\n.@{fa-css-prefix}-map-pin:before { content: @fa-var-map-pin; }\n.@{fa-css-prefix}-map-signs:before { content: @fa-var-map-signs; }\n.@{fa-css-prefix}-map-o:before { content: @fa-var-map-o; }\n.@{fa-css-prefix}-map:before { content: @fa-var-map; }\n.@{fa-css-prefix}-commenting:before { content: @fa-var-commenting; }\n.@{fa-css-prefix}-commenting-o:before { content: @fa-var-commenting-o; }\n.@{fa-css-prefix}-houzz:before { content: @fa-var-houzz; }\n.@{fa-css-prefix}-vimeo:before { content: @fa-var-vimeo; }\n.@{fa-css-prefix}-black-tie:before { content: @fa-var-black-tie; }\n.@{fa-css-prefix}-fonticons:before { content: @fa-var-fonticons; }\n.@{fa-css-prefix}-reddit-alien:before { content: @fa-var-reddit-alien; }\n.@{fa-css-prefix}-edge:before { content: @fa-var-edge; }\n.@{fa-css-prefix}-credit-card-alt:before { content: @fa-var-credit-card-alt; }\n.@{fa-css-prefix}-codiepie:before { content: @fa-var-codiepie; }\n.@{fa-css-prefix}-modx:before { content: @fa-var-modx; }\n.@{fa-css-prefix}-fort-awesome:before { content: @fa-var-fort-awesome; }\n.@{fa-css-prefix}-usb:before { content: @fa-var-usb; }\n.@{fa-css-prefix}-product-hunt:before { content: @fa-var-product-hunt; }\n.@{fa-css-prefix}-mixcloud:before { content: @fa-var-mixcloud; }\n.@{fa-css-prefix}-scribd:before { content: @fa-var-scribd; }\n.@{fa-css-prefix}-pause-circle:before { content: @fa-var-pause-circle; }\n.@{fa-css-prefix}-pause-circle-o:before { content: @fa-var-pause-circle-o; }\n.@{fa-css-prefix}-stop-circle:before { content: @fa-var-stop-circle; }\n.@{fa-css-prefix}-stop-circle-o:before { content: @fa-var-stop-circle-o; }\n.@{fa-css-prefix}-shopping-bag:before { content: @fa-var-shopping-bag; }\n.@{fa-css-prefix}-shopping-basket:before { content: @fa-var-shopping-basket; }\n.@{fa-css-prefix}-hashtag:before { content: @fa-var-hashtag; }\n.@{fa-css-prefix}-bluetooth:before { content: @fa-var-bluetooth; }\n.@{fa-css-prefix}-bluetooth-b:before { content: @fa-var-bluetooth-b; }\n.@{fa-css-prefix}-percent:before { content: @fa-var-percent; }\n.@{fa-css-prefix}-gitlab:before { content: @fa-var-gitlab; }\n.@{fa-css-prefix}-wpbeginner:before { content: @fa-var-wpbeginner; }\n.@{fa-css-prefix}-wpforms:before { content: @fa-var-wpforms; }\n.@{fa-css-prefix}-envira:before { content: @fa-var-envira; }\n.@{fa-css-prefix}-universal-access:before { content: @fa-var-universal-access; }\n.@{fa-css-prefix}-wheelchair-alt:before { content: @fa-var-wheelchair-alt; }\n.@{fa-css-prefix}-question-circle-o:before { content: @fa-var-question-circle-o; }\n.@{fa-css-prefix}-blind:before { content: @fa-var-blind; }\n.@{fa-css-prefix}-audio-description:before { content: @fa-var-audio-description; }\n.@{fa-css-prefix}-volume-control-phone:before { content: @fa-var-volume-control-phone; }\n.@{fa-css-prefix}-braille:before { content: @fa-var-braille; }\n.@{fa-css-prefix}-assistive-listening-systems:before { content: @fa-var-assistive-listening-systems; }\n.@{fa-css-prefix}-asl-interpreting:before,\n.@{fa-css-prefix}-american-sign-language-interpreting:before { content: @fa-var-american-sign-language-interpreting; }\n.@{fa-css-prefix}-deafness:before,\n.@{fa-css-prefix}-hard-of-hearing:before,\n.@{fa-css-prefix}-deaf:before { content: @fa-var-deaf; }\n.@{fa-css-prefix}-glide:before { content: @fa-var-glide; }\n.@{fa-css-prefix}-glide-g:before { content: @fa-var-glide-g; }\n.@{fa-css-prefix}-signing:before,\n.@{fa-css-prefix}-sign-language:before { content: @fa-var-sign-language; }\n.@{fa-css-prefix}-low-vision:before { content: @fa-var-low-vision; }\n.@{fa-css-prefix}-viadeo:before { content: @fa-var-viadeo; }\n.@{fa-css-prefix}-viadeo-square:before { content: @fa-var-viadeo-square; }\n.@{fa-css-prefix}-snapchat:before { content: @fa-var-snapchat; }\n.@{fa-css-prefix}-snapchat-ghost:before { content: @fa-var-snapchat-ghost; }\n.@{fa-css-prefix}-snapchat-square:before { content: @fa-var-snapchat-square; }\n.@{fa-css-prefix}-pied-piper:before { content: @fa-var-pied-piper; }\n.@{fa-css-prefix}-first-order:before { content: @fa-var-first-order; }\n.@{fa-css-prefix}-yoast:before { content: @fa-var-yoast; }\n.@{fa-css-prefix}-themeisle:before { content: @fa-var-themeisle; }\n.@{fa-css-prefix}-google-plus-circle:before,\n.@{fa-css-prefix}-google-plus-official:before { content: @fa-var-google-plus-official; }\n.@{fa-css-prefix}-fa:before,\n.@{fa-css-prefix}-font-awesome:before { content: @fa-var-font-awesome; }\n.@{fa-css-prefix}-handshake-o:before { content: @fa-var-handshake-o; }\n.@{fa-css-prefix}-envelope-open:before { content: @fa-var-envelope-open; }\n.@{fa-css-prefix}-envelope-open-o:before { content: @fa-var-envelope-open-o; }\n.@{fa-css-prefix}-linode:before { content: @fa-var-linode; }\n.@{fa-css-prefix}-address-book:before { content: @fa-var-address-book; }\n.@{fa-css-prefix}-address-book-o:before { content: @fa-var-address-book-o; }\n.@{fa-css-prefix}-vcard:before,\n.@{fa-css-prefix}-address-card:before { content: @fa-var-address-card; }\n.@{fa-css-prefix}-vcard-o:before,\n.@{fa-css-prefix}-address-card-o:before { content: @fa-var-address-card-o; }\n.@{fa-css-prefix}-user-circle:before { content: @fa-var-user-circle; }\n.@{fa-css-prefix}-user-circle-o:before { content: @fa-var-user-circle-o; }\n.@{fa-css-prefix}-user-o:before { content: @fa-var-user-o; }\n.@{fa-css-prefix}-id-badge:before { content: @fa-var-id-badge; }\n.@{fa-css-prefix}-drivers-license:before,\n.@{fa-css-prefix}-id-card:before { content: @fa-var-id-card; }\n.@{fa-css-prefix}-drivers-license-o:before,\n.@{fa-css-prefix}-id-card-o:before { content: @fa-var-id-card-o; }\n.@{fa-css-prefix}-quora:before { content: @fa-var-quora; }\n.@{fa-css-prefix}-free-code-camp:before { content: @fa-var-free-code-camp; }\n.@{fa-css-prefix}-telegram:before { content: @fa-var-telegram; }\n.@{fa-css-prefix}-thermometer-4:before,\n.@{fa-css-prefix}-thermometer:before,\n.@{fa-css-prefix}-thermometer-full:before { content: @fa-var-thermometer-full; }\n.@{fa-css-prefix}-thermometer-3:before,\n.@{fa-css-prefix}-thermometer-three-quarters:before { content: @fa-var-thermometer-three-quarters; }\n.@{fa-css-prefix}-thermometer-2:before,\n.@{fa-css-prefix}-thermometer-half:before { content: @fa-var-thermometer-half; }\n.@{fa-css-prefix}-thermometer-1:before,\n.@{fa-css-prefix}-thermometer-quarter:before { content: @fa-var-thermometer-quarter; }\n.@{fa-css-prefix}-thermometer-0:before,\n.@{fa-css-prefix}-thermometer-empty:before { content: @fa-var-thermometer-empty; }\n.@{fa-css-prefix}-shower:before { content: @fa-var-shower; }\n.@{fa-css-prefix}-bathtub:before,\n.@{fa-css-prefix}-s15:before,\n.@{fa-css-prefix}-bath:before { content: @fa-var-bath; }\n.@{fa-css-prefix}-podcast:before { content: @fa-var-podcast; }\n.@{fa-css-prefix}-window-maximize:before { content: @fa-var-window-maximize; }\n.@{fa-css-prefix}-window-minimize:before { content: @fa-var-window-minimize; }\n.@{fa-css-prefix}-window-restore:before { content: @fa-var-window-restore; }\n.@{fa-css-prefix}-times-rectangle:before,\n.@{fa-css-prefix}-window-close:before { content: @fa-var-window-close; }\n.@{fa-css-prefix}-times-rectangle-o:before,\n.@{fa-css-prefix}-window-close-o:before { content: @fa-var-window-close-o; }\n.@{fa-css-prefix}-bandcamp:before { content: @fa-var-bandcamp; }\n.@{fa-css-prefix}-grav:before { content: @fa-var-grav; }\n.@{fa-css-prefix}-etsy:before { content: @fa-var-etsy; }\n.@{fa-css-prefix}-imdb:before { content: @fa-var-imdb; }\n.@{fa-css-prefix}-ravelry:before { content: @fa-var-ravelry; }\n.@{fa-css-prefix}-eercast:before { content: @fa-var-eercast; }\n.@{fa-css-prefix}-microchip:before { content: @fa-var-microchip; }\n.@{fa-css-prefix}-snowflake-o:before { content: @fa-var-snowflake-o; }\n.@{fa-css-prefix}-superpowers:before { content: @fa-var-superpowers; }\n.@{fa-css-prefix}-wpexplorer:before { content: @fa-var-wpexplorer; }\n.@{fa-css-prefix}-meetup:before { content: @fa-var-meetup; }\n","// Screen Readers\n// -------------------------\n\n.sr-only { .sr-only(); }\n.sr-only-focusable { .sr-only-focusable(); }\n",".breadcrumb {\n    background-color: transparent;\n    border-radius: none;\n    padding: 15px 0;\n    margin-bottom: 2px;\n    display: inline-block;\n    margin-left: 8px;\n\n    > .active a {\n        /*color: @breadcrumb-active-color;*/\n        color: @menu-a;\n    }\n}\n\n.edit-user {\n    margin-left: 15px;\n    position: relative;\n    top: -5px;\n}\n\n.breadcrumb a, .edit-user {\n    color: @menu-a;\n}\n\n.breadcrumb {\n    margin-top: -7px;\n    \n}\n",".company-list {\n    margin-top: 40px;\n\n    @media (max-width: @screen-xs-max) {\n      margin-top: 20px;\n    }\n\n    .company-item {\n        display: block;\n\n        padding: 15px 30px;\n        margin-bottom: 15px;\n\n        border: 1px solid #ccc;\n        border-radius: 4px;\n\n        color: #849099;\n\n        box-shadow: 2px 2px 2px #999;\n\n        h4 {\n            font-family: \"Lato\", sans-serif;\n            font-size: 18px;\n            font-weight: bold;\n            color: #154261;\n            margin: 0 0 10px 0;\n        }\n\n        &:hover, &:focus, &:active {\n            background-color: #F7FBFC;\n            text-decoration: none;\n            box-shadow: 2px 2px 2px #ccc;\n        }\n    }\n}\n\n.company-header {\n  margin-top: 40px;\n  @media (max-width: @screen-xs-max) {\n    margin-top: 0;\n  }\n}\n",".avatar {\n    display: block;\n    width: 52px;\n    height: 52px;\n    line-height: 52px;\n    border-radius: 32px;\n    border: 1px solid #366382;\n    text-align: center;\n    text-transform: uppercase;\n}\n\n.customer-list-header {\n    padding: 20px;\n    // background: #E4E6E7;\n    display: flex;\n    margin: 0 -15px;\n}\n\n.customer-list-header-right-col, .customer-list-header-left-col  {\n    flex: 1;\n    display: flex;\n    align-items: center;\n}\n.customer-list-header-middle-col{\n  flex: 1;\n  display: flex;\n  align-items: right;\n}\n\n.customer-list-header-left-col {\n    overflow: hidden;\n}\n\n.customer-list-header-right-col {\n    justify-content: flex-end;\n}\n\n.customer-list-header-title {\n    font-size: 24px;\n    line-height: 1;\n    font-family: \"Lato\", sans-serif;\n}\n\n.customer-list-header-extra {\n    margin-left: 5px;\n    font-size: 18px;\n    padding: 15px;\n}\n\n.customer-single-element {\n    display: flex;\n    align-items: center;\n    min-width: 250px;\n}\n\n.customer-list-row .customer-single-element {\n    min-width: 300px;\n}\n\n.customer-single-element-right {\n    margin-left: 20px;\n}\n\n.customer-sub-title {\n    margin-top: 0;\n    margin-bottom: 5px;\n    color: @dark-blue;\n    display: inline-block;\n}\n\n.customer-single-element-right-phone {\n    color: @dark-blue;\n}\n\n.customer-list {\n    margin: 0 -15px;\n}\n\n.no-video-container {\n    background: linear-gradient(135deg, var(--surface-color) 0%, #1e293b 100%);\n    border: 1px dashed var(--border-color);\n    border-radius: var(--radius-lg);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    h3 {\n        text-align: center;\n        color: var(--text-secondary);\n        font-weight: 500;\n    }\n}\n\n.customer-list-row {\n    padding: 25px 40px;\n    display: block;\n    border-bottom : 1px solid #d6d6d6;\n    display: flex;\n    &:hover, &:active, &:focus {\n        text-decoration: none;\n        background: rgba(0,0,0,.025);\n    }\n}\n\n.customer-list-row-last-event {\n    margin-left: 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.customer-list-row-last-event-time-clock {\n    color: @dark-blue;\n    margin-left: 20px;\n    display: inline-block;\n}\n\n.customer-list-row-text {\n    color: black;\n}\n\n.customer-list-row-text-small {\n    color: #777;\n    font-size: 12px;\n}\n\n.customer-list-row-last-event-time {\n\n}\n\n.customer-list-row-deleted {\n  background-color: #cecece;\n}\n\n@media (max-width: @screen-md-max) {\n    .customer-list-header-title {\n        font-size: 20px;\n    }\n}\n\n\n@media (max-width: @screen-xs-max) {\n    .customer-list-header-title {\n        font-size: 16px;\n        line-height: 1.3;\n    }\n\n    .customer-list-header {\n        padding: 30px 15px;\n    }\n\n    .customer-single-element-right {\n        margin-left: 15px;\n    }\n\n    // .lh-btn {\n    //     padding: 8px 11px !important;\n    //     font-size: 10px !important;\n    // }\n\n    .customer-list-header-extra {\n        margin-left: 10px;\n    }\n\n    .customer-list-row {\n        padding: 20px 15px;\n        flex-direction: column;\n        position: relative;\n    }\n\n    .customer-list-row-last-event {\n        margin-left: 0;\n    }\n\n    .customer-list-row-last-event-time {\n        position: absolute;\n        right: 15px;\n        top: 46px;\n    }\n\n    .customer-list-row-last-event-text, .customer-list-row-last-event-empty, .customer-list-row-text {\n        margin-top: 15px;\n        display: block;\n    }\n}\n","/* ============================================================\n   EVENT LIST (Right Column – Timeline)\n   ============================================================ */\n\n.middle {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n  position: relative;\n}\n\n.no-entries {\n  margin: 16px;\n  display: block;\n  font-size: 13px;\n  color: var(--text-muted);\n  text-align: center;\n  padding: 32px 0;\n}\n\n.spread { width: 100%; }\n\n.event-items {\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n  -webkit-overflow-scrolling: touch;\n  padding: 12px 0 8px;\n  scrollbar-width: thin;\n  scrollbar-color: var(--surface-3) transparent;\n\n  &::-webkit-scrollbar { width: 4px; }\n  &::-webkit-scrollbar-track { background: transparent; }\n  &::-webkit-scrollbar-thumb { background: var(--surface-3); border-radius: 4px; }\n}\n\n/* ── Individual call entry group ── */\n.call {\n  position: relative;\n  box-sizing: border-box;\n\n  &.dragging {\n    border: 1px dashed var(--primary-color);\n    opacity: 0.8;\n  }\n\n  &:first-child { margin-top: 0; }\n\n  /* Vertical timeline connector */\n  &.show-dots::before {\n    content: '';\n    border-left: 2px dashed rgba(255, 255, 255, 0.06);\n    top: 28px;\n    bottom: 20px;\n    left: 51px;\n    position: absolute;\n    z-index: 1;\n  }\n}\n\n.call-title {\n  color: var(--text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  margin: auto;\n  margin-left: 0;\n}\n\n.remove-event {\n  cursor: pointer;\n  color: var(--danger-color);\n  opacity: 0.5;\n  transition: opacity var(--transition-fast);\n\n  &:hover, &:active, &:focus { opacity: 1; }\n}\n\n.can-drag { cursor: move; }\n\n/* ── Event card ── */\n.event-row {\n  display: flex;\n  min-height: 60px;\n  position: relative;\n  padding: 12px 14px;\n  box-sizing: border-box;\n  background: var(--surface-2);\n  margin: 6px 10px;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  animation: fadeInUp 0.3s ease-out both;\n  z-index: 2;\n  transition: border-color var(--transition-fast), background var(--transition-fast);\n\n  &:last-child { margin-bottom: 16px; }\n\n  &:hover {\n    background: var(--surface-3);\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n\n  &.has-order { padding-bottom: 18px; }\n\n  .avatar {\n    background: transparent;\n    width: 36px; height: 36px;\n    line-height: 36px;\n    border: 1.5px solid var(--primary-color);\n    color: var(--primary-color);\n    font-size: 12px;\n    font-weight: 700;\n    border-radius: 50%;\n    text-align: center;\n    flex-shrink: 0;\n  }\n}\n\n/* ── Event: call begin (green accent) ── */\n.call-begin {\n  background: rgba(34, 197, 94, 0.05);\n  border-color: rgba(34, 197, 94, 0.15);\n\n  &:hover {\n    background: rgba(34, 197, 94, 0.08);\n    border-color: rgba(34, 197, 94, 0.2);\n  }\n}\n\n/* ── Event: call end (red accent) ── */\n.call-end {\n  background: rgba(239, 68, 68, 0.05);\n  border-color: rgba(239, 68, 68, 0.15);\n\n  &:hover {\n    background: rgba(239, 68, 68, 0.08);\n    border-color: rgba(239, 68, 68, 0.2);\n  }\n}\n\n/* ── Event row layout ── */\n.event-row-header {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex: 0 0 50px;\n  overflow: visible;\n\n  > *:not(:first-child) { margin-left: 10px; }\n\n  .event-row-text { margin-right: 0; }\n}\n\n.event-row-header-date-time {\n  text-align: right;\n  font-size: 11px;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n.event-row-body { display: flex; }\n\n.event-row-left-col,\n.event-row-right-col { display: flex; }\n\n.event-row-left-col { flex: 0 0 48px; }\n\n.event-row-right-col {\n  flex: 1;\n  flex-direction: column;\n  max-width: ~\"calc(100% - 48px)\";\n\n  @media (max-width: @screen-xs-max) {\n    max-width: ~\"calc(100% - 36px)\";\n  }\n}\n\n.event-row-right-col-waiting {\n  justify-content: flex-start;\n  align-items: center;\n  flex-direction: row;\n}\n\n.event-row-text {\n  color: var(--text-primary);\n  font-size: 13px;\n  margin-right: 0;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n\n  textarea.form-control {\n    margin-top: 10px;\n    background: var(--surface-3);\n    color: var(--text-primary);\n    border: 1px solid var(--border);\n  }\n\n  @media (max-width: @screen-md-max) { margin-right: 0; }\n\n  @media (max-width: @screen-xs-max) {\n    margin-right: 0;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  p {\n    flex: 1;\n    overflow: hidden;\n    max-width: 100%;\n    text-overflow: ellipsis;\n    font-size: 13px;\n    color: var(--text-secondary);\n  }\n}\n\n.valign {\n  display: flex;\n  align-items: center;\n}\n\n.img-thumbnail { width: 33%; }\n\n/* ── Event icon circle ── */\n.event-icon {\n  background: transparent;\n  width: 36px; height: 36px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n\n  i { font-size: 14px; }\n}\n\n/* ── Keyframe animation ── */\n@keyframes fadeInUp {\n  from { opacity: 0; transform: translate3d(0, 8px, 0); }\n  to   { opacity: 1; transform: translate3d(0, 0, 0); }\n}\n\n.vertical-center {\n  position: relative;\n  * {\n    position: absolute;\n    top: -50%;\n    transform: translateY(50%);\n  }\n}\n\n/* ── Ordered in label ── */\n.ordered-in {\n  color: var(--text-muted);\n  font-size: 12px;\n  display: flex;\n  margin: auto;\n  margin-left: 0;\n  overflow-x: hidden;\n\n  > *:not(:first-child) { margin-left: 6px; }\n\n  a {\n    font-size: 12px;\n    font-weight: 600;\n    display: inline-block;\n    color: var(--primary-color);\n  }\n}\n\n.event-row-text-end-note { font-size: 13px; color: var(--text-secondary); }\n\n.drag-handle {\n  font-size: 16px;\n  cursor: move;\n  color: var(--text-muted);\n  transition: color var(--transition-fast);\n  &:hover { color: var(--text-secondary); }\n\n  @media (max-width: @screen-xs-max) { display: none; }\n}\n\n.note-without-call { position: relative; }\n.no-flex { display: block; }\n\n/* ── Modal ── */\n.lh-modal {\n  z-index: 20000000;\n  top: 50%; left: 50%;\n  right: auto; bottom: auto;\n  margin-right: -50%;\n  transform: translate(-50%, -50%);\n  background: var(--surface);\n  border: 1px solid var(--border);\n  padding: 32px;\n  border-radius: var(--radius-xl);\n  position: fixed;\n  max-width: 560px;\n  box-shadow: var(--shadow-xl);\n\n  @media (max-width: @screen-xs-max) { max-width: 100%; padding: 20px; }\n\n  p {\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: var(--text-secondary);\n  }\n}\n\n.call-end-modal-title { margin-top: 0; font-size: 20px; }\n\n@media (max-width: @screen-xs-max) {\n  .call-end-modal-title { font-size: 18px; }\n}\n\n.call-end-modal-duration-title  { margin-top: 16px; }\n.call-end-modal-note-is-ended   { margin: 16px 0; }\n.call-end-modal-duration-value  { margin-top: 4px; font-weight: 600; }\n.call-end-modal-end-note        { margin: 24px 0; }\n.call-end-modal-select          { margin-top: 16px; }\n.call-end-modal-submit          { margin-top: 16px; }\n.call-end-modal-textarea        { padding: 12px !important; }\n\n/* ── Responsive ── */\n@media (max-width: @screen-xs-max) {\n  .call {\n    &.show-dots::before { left: 21px; }\n  }\n\n  .event-row {\n    min-height: 50px;\n    padding: 10px;\n    margin: 4px 8px;\n\n    .avatar {\n      height: 28px; width: 28px;\n      line-height: 28px;\n      font-size: 10px;\n      margin-top: 4px;\n    }\n  }\n\n  .event-row-left-col {\n    padding-left: 0;\n    flex: 0 0 36px;\n  }\n\n  .event-row-text { font-size: 13px; }\n  .event-row-text-waiting { margin-right: 0; }\n\n  .event-icon {\n    height: 28px; width: 28px;\n    i { font-size: 12px; }\n  }\n\n  .event-row-right-col-date {\n    top: 5px;\n    .dropdown { position: absolute; right: -10px; top: 24px; }\n  }\n\n  .call-end, .call-begin {\n    .event-row-left-col { align-items: center; }\n  }\n}\n","@font-face {\n    font-family: 'icomoon';\n    src:    url('fonts/icomoon.eot?xckv5r');\n    src:    url('fonts/icomoon.eot?xckv5r#iefix') format('embedded-opentype'),\n        url('fonts/icomoon.ttf?xckv5r') format('truetype'),\n        url('fonts/icomoon.woff?xckv5r') format('woff'),\n        url('fonts/icomoon.svg?xckv5r#icomoon') format('svg');\n    font-weight: normal;\n    font-style: normal;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n    /* use !important to prevent issues with browser extensions that change fonts */\n    font-family: 'icomoon', 'Lucida Grande' !important; // , sans-serif, 'icomoon'\n    speak: none;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n\n    /* Better Font Rendering =========== */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-auftraege:before {\n    content: \"\\e900\";\n}\n.icon-auftrag-download:before {\n    content: \"\\e901\";\n}\n.icon-auftrag-edit:before {\n    content: \"\\e902\";\n}\n.icon-auftrag-settings:before {\n    content: \"\\e903\";\n}\n.icon-auftrag-success:before {\n    content: \"\\e904\";\n}\n.icon-auftrag:before {\n    content: \"\\e905\";\n}\n.icon-bank:before {\n    content: \"\\e906\";\n}\n.icon-phone-down2:before {\n    content: \"\\e907\";\n}\n.icon-call-end2:before {\n    content: \"\\e908\";\n}\n.icon-call-time:before {\n    content: \"\\e909\";\n}\n.icon-phone2:before {\n    content: \"\\e90a\";\n}\n.icon-camera-turn:before {\n    content: \"\\e90b\";\n}\n.icon-camera:before {\n    content: \"\\e90c\";\n}\n.icon-datum:before {\n    content: \"\\e90d\";\n}\n.icon-edit2:before {\n    content: \"\\e90e\";\n}\n.icon-fail:before {\n    content: \"\\e90f\";\n}\n.icon-fullscreen:before {\n    content: \"\\e910\";\n}\n.icon-fullsreen2:before {\n    content: \"\\e911\";\n}\n.icon-lock:before {\n    content: \"\\e912\";\n}\n.icon-mail:before {\n    content: \"\\e913\";\n}\n.icon-notiz:before {\n    content: \"\\e914\";\n}\n.icon-plus:before {\n    content: \"\\e915\";\n}\n.icon-small-menu:before {\n    content: \"\\e916\";\n}\n.icon-sms:before {\n    content: \"\\e917\";\n}\n.icon-user-remove:before {\n    content: \"\\e918\";\n}\n.icon-user-settings:before {\n    content: \"\\e919\";\n}\n.icon-user-success:before {\n    content: \"\\e91a\";\n}\n.icon-user:before {\n    content: \"\\e91b\";\n}\n.icon-userliste:before {\n    content: \"\\e91c\";\n}\n.icon-video-placeholder:before {\n    content: \"\\e91d\";\n}\n.icon-paper-clip:before {\n    content: \"\\e001\";\n}\n.icon-mic:before {\n    content: \"\\e00f\";\n}\n.icon-mic_none:before {\n    content: \"\\e010\";\n}\n.icon-mic_off:before {\n    content: \"\\e011\";\n}\n.icon-screen2:before {\n    content: \"\\e016\";\n}\n.icon-ring_volume:before {\n    content: \"\\e05a\";\n}\n.icon-head:before {\n    content: \"\\e074\";\n}\n.icon-screen:before {\n    content: \"\\e108\";\n}\n.icon-down:before {\n    content: \"\\e10f\";\n}\n.icon-left:before {\n    content: \"\\e110\";\n}\n.icon-right:before {\n    content: \"\\e111\";\n}\n.icon-up:before {\n    content: \"\\e112\";\n}\n.icon-file:before {\n    content: \"\\e124\";\n}\n.icon-music_note:before {\n    content: \"\\e197\";\n}\n.icon-bubble:before {\n    content: \"\\e601\";\n}\n.icon-phone:before {\n    content: \"\\e602\";\n}\n.icon-phone-down:before {\n    content: \"\\e603\";\n}\n.icon-video2:before {\n    content: \"\\e604\";\n}\n.icon-bubble2:before {\n    content: \"\\e605\";\n}\n.icon-params:before {\n    content: \"\\e606\";\n}\n\n",".spinner {\n  margin: 50px auto 50px;\n  width: 60px;\n  text-align: center;\n  &.inline {\n    display: inline-block;\n    margin: 0 10px;\n    transform: translateY(2px);\n  }\n  &.flex {\n      display: flex;\n      align-items: center;\n  }\n}\n\n\n.spinner > div {\n  width: 18px;\n  height: 18px;\n  background-color: #999;\n\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n\n.spinner .bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.spinner .bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@media (max-width: @screen-md-max) {\n    .spinner {\n        margin: 0 auto 0px;\n        width: 35px;\n        &.inline {\n            margin: 0;\n        }\n        > div {\n            width: 9px;\n            height: 9px;\n        }\n    }\n}\n\n@-webkit-keyframes sk-bouncedelay {\n  0%, 80%, 100% { -webkit-transform: scale(0) }\n  40% { -webkit-transform: scale(1.0) }\n}\n\n@keyframes sk-bouncedelay {\n  0%, 80%, 100% { \n    -webkit-transform: scale(0);\n    transform: scale(0);\n  } 40% { \n    -webkit-transform: scale(1.0);\n    transform: scale(1.0);\n  }\n}\n","@import (css) url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');\n\n/* ============================================================\n   DESIGN SYSTEM – Dark Theme (Global)\n   Inspired by the mockup: deep navy bg, elevated surface panels,\n   accent blue, clean Inter typography.\n   ============================================================ */\n\n:root {\n  /* Background hierarchy */\n  --bg:           #0d1117;   /* outermost – page background */\n  --surface:      #161b27;   /* panels / cards */\n  --surface-2:    #1e2636;   /* elevated items within panels */\n  --surface-3:    #28334a;   /* hover states, inputs */\n\n  /* Legacy aliases (some components still reference these) */\n  --bg-color:      var(--bg);\n  --surface-color: var(--surface);\n\n  /* Text */\n  --text-primary:   #f0f4ff;\n  --text-secondary: #8899aa;\n  --text-muted:     #505e70;\n\n  /* Border */\n  --border:       rgba(255, 255, 255, 0.07);\n  --border-color: var(--border);\n\n  /* Brand / Accents */\n  --primary-color:  #0284c7;\n  --primary-hover:  #2563eb;\n  --primary-glow:   rgba(2, 132, 199, 0.25);\n\n  --success-color:  #22c55e;\n  --success-glow:   rgba(34, 197, 94, 0.2);\n\n  --danger-color:   #ef4444;\n  --danger-glow:    rgba(239, 68, 68, 0.2);\n\n  --warning-color:  #f59e0b;\n\n  /* Menu links */\n  --menu-color: #8899aa;\n\n  /* Shadows */\n  --shadow-sm:  0 1px 3px rgba(0, 0, 0, 0.4);\n  --shadow-md:  0 4px 12px rgba(0, 0, 0, 0.5);\n  --shadow-lg:  0 8px 24px rgba(0, 0, 0, 0.6);\n  --shadow-xl:  0 16px 40px rgba(0, 0, 0, 0.7);\n\n  /* Border radius */\n  --radius-xs:   6px;\n  --radius-sm:   8px;\n  --radius-md:   12px;\n  --radius-lg:   16px;\n  --radius-xl:   24px;\n  --radius-pill: 9999px;\n\n  /* Transitions */\n  --transition-fast:   0.12s ease;\n  --transition-normal: 0.2s ease;\n  --transition-slow:   0.35s ease;\n}\n\n/* ============================================================\n   BASE RESET\n   ============================================================ */\n\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--text-primary);\n  background-color: var(--bg);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: var(--text-primary);\n  margin-top: 0;\n}\n\na {\n  color: var(--primary-color);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n\n  &:hover {\n    color: var(--primary-hover);\n    text-decoration: none;\n  }\n}\n\np { margin: 0; }\n\n/* ============================================================\n   NAVBAR – Modern pill/link style over dark background\n   ============================================================ */\n\n.navbar.navbar-default {\n  background: var(--surface) !important;\n  border: none !important;\n  border-bottom: 1px solid var(--border) !important;\n  border-radius: 0 !important;\n  min-height: 56px;\n  margin-bottom: 0;\n  box-shadow: var(--shadow-sm);\n\n  .navbar-brand {\n    color: var(--text-primary) !important;\n    font-weight: 700;\n    font-size: 16px;\n    padding: 16px 20px;\n\n    &:hover { color: var(--primary-color) !important; }\n  }\n\n  .navbar-toggle {\n    border-color: var(--border);\n    .icon-bar { background-color: var(--text-secondary); }\n    &:hover { background: var(--surface-2); }\n  }\n\n  .navbar-nav > li > a {\n    color: var(--text-secondary) !important;\n    font-size: 13px;\n    font-weight: 500;\n    padding: 18px 14px;\n    transition: color var(--transition-fast);\n\n    &:hover, &:focus {\n      color: var(--text-primary) !important;\n      background: transparent !important;\n    }\n  }\n\n  .navbar-nav > li.active > a {\n    color: var(--text-primary) !important;\n    background: transparent !important;\n  }\n\n  /* Breadcrumb separator */\n  .breadcrumb-menu li:not(:first-child)::before {\n    content: '/';\n    color: var(--text-muted);\n    margin: 0 4px;\n  }\n}\n\n/* ============================================================\n   FORMS\n   ============================================================ */\n\n.form-control {\n  background: var(--surface-2) !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius-md) !important;\n  height: 40px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-family: 'Inter', sans-serif;\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n\n  &:focus {\n    border-color: var(--primary-color) !important;\n    box-shadow: 0 0 0 3px var(--primary-glow) !important;\n    outline: none !important;\n  }\n\n  &::placeholder, &::-webkit-input-placeholder {\n    color: var(--text-muted) !important;\n  }\n}\n\n.search-input .form-control {\n  height: 36px;\n}\n\n.chat-input .form-control {\n  height: 36px;\n  padding: 6px 14px;\n  background: var(--surface-2) !important;\n  border-radius: var(--radius-sm) !important;\n}\n\n/* ============================================================\n   UTILITY\n   ============================================================ */\n\n.text-muted, .customer-sub-title {\n  color: var(--text-secondary) !important;\n  font-size: 12px;\n}\n\n.panel-title {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 14px;\n  margin: 0;\n}\n","@import \"theme.less\";\n\n@text-color: #1e293b;\n@margin: 20px;\n@menu-a: #475569;\n\n// Keep as hex for LESS darken/lighten functions in old code\n@active-green: #10b981; \n@background-green: #d1fae5;\n@active-red: #ef4444;\n@background-red: #fee2e2;\n@blue: #2563eb;\n@dark-blue: #1e293b;\n\n.Lato {\n  font-family: 'Inter', sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n}\n\n.box-shadow {\n  box-shadow: var(--shadow-lg);\n}\n\n.small-box-shadow {\n  box-shadow: var(--shadow-md);\n}\n\n.roundcorners {\n  border-radius: var(--radius-md);\n}\n\n.gradient_blue {\n  background: var(--primary-color);\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 100%);\n}\n\n.gradient (@startColor: #26A7DF, @endColor: #1494E0) {\n  background: @startColor;\n  background: linear-gradient(135deg, @startColor, @endColor);\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.max400 {\n  max-width: 400px;\n  display: inline-block;\n}\n","@import \"lookhere_vars.less\";\n\n.flex {\n    display: flex;\n    //align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    h1 {\n        margin-bottom: 30px;\n    }\n}\n.w-xs {\n    @media (min-width: @screen-xs-min) {\n        width: @screen-xs - 80px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}\n.w-sm {\n    @media (min-width: @screen-sm-min) {\n        width: @screen-sm - 128px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n}\n.m40 {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    @media (min-width: @screen-xs-min) {\n        margin-top: 40px;\n        margin-bottom: 40px;\n    }\n}\n\n.content-block {\n  display: inline-block;\n  background: #FFFFFF;\n  padding: 15px;\n  flex-direction: column;\n  .box-shadow();\n}\n\n.flex-box {\n    display: flex;\n    height: ~'calc(100vh - 80px)';\n    background: #FFFFFF;\n    padding: 15px;\n    padding-top: 0;\n    flex-direction: column;\n    overflow-y: scroll;\n    .box-shadow();\n    .w-xs();\n}\n\nselect {\n  padding: 10px;\n  border: 0 none;\n  width: 100%;\n  margin-bottom: 10px;\n  border: 1px solid #E3EDF7;\n  .roundcorners();\n  &:hover{\n    border-color: darken(#E3EDF7, 10%);\n  }\n  &:focus{\n    border-color: darken(#E3EDF7, 20%);\n    border-width: 1px;\n    outline: none;\n  }\n}\n\n.home-content {\n  \tpadding-top: 15px;\n  \tpadding-left: 40px;\n  \tpadding-right: 40px;\n  \tpadding-bottom: 15px;\n    display: inline-block;\n    h3 {\n        font-weight: normal;\n    }\n    h3, p {\n        margin: 0 0 20px 0;\n    }\n}\n\n.w750 {\n  max-width: 550px !important;\n}\n\n.room-content {\n    padding: 40px;\n    display: inline-block;\n    border-left: 1px solid rgba(0, 0, 0, .2);\n    @media (max-width: @screen-xs-max) {\n      padding-top: 0;\n      border-left: 0px!important;\n    }\n    h3 {\n        font-weight: normal;\n    }\n    h3, p {\n        margin: 0 0 30px 0;\n    }\n\n    max-width: 833px;\n}\n\n\n.inputfield {\n    width: 100%;\n    height: 50px;\n    text-align: left;\n    padding: 0 15px;\n\n\n    border: none;\n    border-radius: 0;\n    color: #1D5F96;\n    background: #E3EDF7;\n    .roundcorners();\n\n\n    &:hover {\n        border: 1px solid #3383C4;\n        padding: 0 14px;\n    }\n\n    &:focus {\n        border: 1px solid #3383C4;\n        padding: 0 14px;\n        outline: none;\n    }\n    &:placeholder-shown {\n      color: @text-color;\n    }\n    &::-webkit-input-placeholder { /* Safari, Chrome and Opera */\n      color: @text-color;\n    }\n}\n\n.login-page {\n    max-width: 833px;\n}\n\n.login-row {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n\n    @media (max-width: @screen-xs-max) {\n        flex-direction: column;\n    }\n}\n",".tools {\n    position: absolute;\n\n    z-index: 9;\n\n    font-family: \"Lato\", sans-serif;\n\n    display: flex;\n\n    left: auto;\n    right: 15px;\n    width: 50px;\n    bottom: 15px;\n\n    @media (max-width: @screen-sm-max) {\n      width: 40px;\n    }\n\n    .middle {\n        flex: 1;\n        justify-content: center;\n        /*height: 100px;*/\n        display: flex;\n        align-items: center;\n\n        /*@media (max-width: @screen-lg-max) {*/\n        flex-direction: column;\n        height: auto;\n        /*}*/\n    }\n\n    .button {\n        display: block;\n        width: 55px;\n        height: 55px;\n        margin: 5px 0;\n        font-size: 24px;\n        text-align: center;\n        background: var(--glass-bg);\n        line-height: 55px;\n        cursor: pointer;\n        color: var(--danger-color);\n        border-radius: var(--radius-pill);\n        border: 1px solid var(--glass-border);\n        box-shadow: var(--shadow-sm);\n        backdrop-filter: blur(10px);\n        -webkit-backdrop-filter: blur(10px);\n        transition: all var(--transition-fast);\n\n        &:hover {\n            transform: translateY(-2px) scale(1.05);\n            box-shadow: var(--shadow-md);\n        }\n\n        @media (max-width: @screen-sm-max) {\n            width: 40px;\n            height: 40px;\n            line-height: 40px;\n            font-size: 20px;\n            margin: 4px 0;\n            &:first-child {\n                margin-top: 0;\n            }\n        }\n    }\n\n    .button.active {\n        color: var(--primary-color);\n    }\n\n    .button-phone-down {\n        color: white;\n        background: var(--danger-color);\n        border: none;\n    }\n\n}\n\n/*.landscape {\n    .fullscreen {\n        .tools {\n            position: fixed;\n            right: 20px;\n            @media (max-width: @screen-sm-max) {\n                right: 10px;\n            }\n        }\n        .timer {\n            position: fixed;\n        }\n    }\n}\n\n.portrait {\n    .fullscreen, .video-wrapper.customer {\n        .tools {\n            width: 300px;\n            left: ~\"calc(50% - 150px)\";\n            .middle {\n                flex-direction: row;\n            }\n            .button {\n                margin: 0 5px;\n            }\n        }\n    }\n}*/\n\n.video-chat-embedded {\n    .tools {\n        .camera-form {\n            display: none;\n        }\n        // only show for user\n        .remote-picture {\n            display: inline-block !important;\n        }\n    }\n}\n\n/*@media (max-width: @screen-md-max) {*/\n    /*.tools {*/\n        /*bottom: -20px;*/\n        /*.button {*/\n            /*width: 36px;*/\n            /*height: 36px;*/\n            /*font-size: 14px;*/\n            /*line-height: 36px;*/\n        /*}*/\n    /*}*/\n/*}*/\n\n.highlighted {\n    color: @active-red !important;\n}\n\n.costIndicator {\n  position: absolute;\n  left: 15px;\n  bottom: 15px;\n\n  .button {\n    position: relative;\n    display: block;\n    width: 55px;\n    height: 55px;\n    margin: 5px 0;\n    font-size: 24px;\n    text-align: center;\n    background: var(--glass-bg);\n    line-height: 55px;\n    color: var(--primary-color);\n    border-radius: var(--radius-pill);\n    border: 1px solid var(--glass-border);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    transition: all var(--transition-fast);\n\n    &:hover {\n        transform: translateY(-2px) scale(1.05);\n        box-shadow: var(--shadow-md);\n    }\n\n    @media (max-width: @screen-sm-max) {\n      width: 40px;\n      height: 40px;\n      line-height: 40px;\n      font-size: 20px;\n      margin: 4px 0;\n\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n\n    .crossed {\n      position: absolute;\n      color: @active-red;\n    }\n  }\n}\n","/* ============================================================\n   VIDEO CHAT LAYOUT – Modern 3-Column Dashboard\n   Matches the provided mockup: dark panels, rounded corners,\n   center video box, event stream on right.\n   ============================================================ */\n\n/* ── Opentok / Video wrappers ── */\n.video-wrapper {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  justify-content: center;\n  background: transparent;\n}\n\nvideo {\n  background: transparent;\n}\n\nbody:has(.publisher-video-screen),\nhtml:has(.publisher-video-screen) {\n  overflow: hidden !important;\n  position: fixed !important;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.publisher-video-screen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  overflow: hidden;\n  z-index: 9999;\n\n  #opentok-container {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.videomode:not(.fullscreen) #opentok-container.horizontal {\n  align-self: center;\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  max-width: 854px;\n  max-height: 480px;\n}\n\n.videomode:not(.fullscreen) .video-box.embedded #opentok-container.horizontal {\n  width: 100%;\n  height: 100%;\n}\n\n.videomode:not(.fullscreen) #opentok-container.vertical {\n  align-self: center;\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  max-width: 480px;\n  max-height: 640px;\n}\n\n.videomode:not(.fullscreen) .video-box.embedded #opentok-container.vertical {\n  width: 100%;\n  height: 100%;\n}\n\n.videomode.customer:not(.fullscreen) #opentok-container {\n  @media (max-width: 639px) {\n    width: 100vw;\n    height: 100vh;\n  }\n}\n\n.fullscreen #opentok-container.horizontal {\n  align-self: center;\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  max-width: 1280px;\n  max-height: 720px;\n}\n\n.fullscreen #opentok-container.vertical {\n  align-self: center;\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  max-width: 720px;\n  max-height: 1280px;\n}\n\n/* ============================================================\n   CUSTOMER SINGLE PAGE – Root wrapper\n   ============================================================ */\n\n.customer-single {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n  background: transparent;\n  min-height: calc(100vh - 56px); /* 56px = navbar height */\n  color: var(--text-primary);\n}\n\n/* ============================================================\n   3-COLUMN LAYOUT\n   ============================================================ */\n\n.layout-3-col {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  gap: 16px;\n  padding: 16px;\n  min-height: calc(100vh - 56px);\n  box-sizing: border-box;\n  align-items: stretch;\n\n  @media (max-width: 992px) {\n    flex-direction: column;\n    height: auto;\n    overflow-y: visible;\n  }\n}\n\n/* ── LEFT: Project sidebar ── */\n.layout-left {\n  flex: 0 0 260px;\n  background: var(--surface);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--border);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n\n  @media (max-width: 1280px) { flex: 0 0 220px; }\n  @media (max-width: 992px)  { flex: none; height: auto; }\n}\n\n/* ── CENTER: Video ── */\n.layout-center {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  gap: 0;\n}\n\n/* ── RIGHT: Events stream ── */\n.layout-right {\n  flex: 0 0 340px;\n  background: var(--surface);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--border);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n\n  @media (max-width: 1280px) { flex: 0 0 300px; }\n  @media (max-width: 992px)  { flex: none; }\n}\n\n/* ============================================================\n   CENTER COLUMN: CUSTOMER HEADER BAR\n   ============================================================ */\n\n.video-chat-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: var(--surface);\n  border-radius: var(--radius-xl);\n  border: 1px solid var(--border);\n  padding: 12px 18px;\n  flex-shrink: 0;\n\n  /* Reset old Bootstrap negative margins */\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.video-chat-header-left-col {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0; /* allow text truncation */\n}\n\n.video-chat-header-right-col {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  gap: 8px;\n}\n\n/* URL input + copy row */\n.customer-begincall-url-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 0 !important;\n}\n\n.customer-begincall {\n  align-self: center;\n  line-height: 36px;\n}\n\n/* ============================================================\n   CENTER COLUMN: VIDEO BOX\n   ============================================================ */\n\n.video-status-container {\n  flex: 1;\n  display: flex;\n  justify-content: stretch;\n  background: transparent;\n  position: relative;\n  min-height: 0;\n\n  @media (max-width: @screen-xs-max) {\n    min-height: 200px;\n  }\n\n  .video-status-message {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: var(--surface);\n    border-radius: var(--radius-xl);\n    border: 1px solid var(--border);\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--text-secondary);\n    letter-spacing: 0;\n  }\n\n  .video-status-error {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: rgba(239, 68, 68, 0.08);\n    border: 1px solid rgba(239, 68, 68, 0.2);\n    border-radius: var(--radius-xl);\n    font-size: 14px;\n    color: var(--text-secondary);\n  }\n}\n\n/* ============================================================\n   VIDEO ELEMENTS\n   ============================================================ */\n\n.video-chat {\n  width: 100%;\n  min-height: 100%;\n  background: transparent;\n}\n\n.video-box {\n  flex: 1;\n  display: flex;\n  text-align: center;\n  position: relative;\n  background: transparent;\n  line-height: 0;\n\n  &.active { padding-top: 0; }\n}\n\n.video-container {\n  position: relative;\n  line-height: 0;\n  width: 100%;\n  padding-top: 56.25%;\n\n  &.active { padding-top: 0; }\n\n  video {\n    background: transparent;\n    transition: 0.5s all ease-in-out;\n\n    @media (max-height: @screen-xs-max) { margin-top: 20px; }\n  }\n}\n\n.video-overlay {\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%;\n  padding: 16px;\n  text-align: center;\n  color: var(--text-primary);\n  background: rgba(13, 17, 23, 0.85);\n  backdrop-filter: blur(8px);\n  z-index: 5;\n  border-radius: var(--radius-xl) var(--radius-xl) 0 0;\n}\n\n.video-overlay-scribbled {\n  position: absolute;\n  top: 0; left: 0;\n  width: 100%; height: 100%;\n  text-align: center;\n  background: rgba(13, 17, 23, 0.5);\n  z-index: 5;\n}\n\n.video-state {\n  display: none;\n  position: absolute;\n  top: 0; left: 0; bottom: 0; right: 0;\n  align-items: center;\n  justify-content: center;\n  font-size: 80px;\n\n  &:not(.active) {\n    display: flex;\n    background: rgba(0, 0, 0, 0.4);\n    .fa-stack-1x { color: rgba(255, 255, 255, 0.6); }\n    .fa-stack-2x { color: rgba(239, 68, 68, 0.8); }\n  }\n\n  &.paused {\n    display: flex;\n    background: var(--bg);\n    .fa-stack-1x { color: rgba(0, 0, 0, 0.5); }\n    .fa-stack-2x { color: rgba(240, 68, 46, 1); }\n  }\n}\n\n/* ============================================================\n   CALL CONTROLS BAR (bottom of center column)\n   ============================================================ */\n\n.timer {\n  color: var(--text-primary);\n  font-weight: 600;\n  font-size: 13px;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(8px);\n  padding: 8px 12px;\n  border-radius: var(--radius-pill);\n  border: 1px solid var(--border);\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 6;\n}\n\n.touch {\n  position: absolute;\n  display: block;\n  z-index: 10000000000;\n  background: rgba(255, 255, 255, 0.4);\n  border: 2px solid rgba(255, 255, 255, 0.7);\n}\n\n.volume-meter {\n  position: absolute;\n  left: 0; bottom: 0;\n  width: 40px;\n\n  .volume-level {\n    display: block;\n    height: 10px;\n    border: 1px solid rgba(255,255,255,0.3);\n    border-radius: 3px;\n    margin: 0 10px 5px;\n\n    &.active { background: rgba(255,255,255,0.6); }\n  }\n\n  .volume-icon {\n    width: 40px; height: 40px;\n    line-height: 40px;\n    border-radius: 3px;\n    color: white;\n    font-size: 20px;\n    text-align: center;\n  }\n\n  &.speaking:not(.muted) {\n    .volume-level {\n      border-color: var(--success-color);\n      &.active { background: var(--success-color); }\n    }\n    .volume-icon { color: var(--success-color); }\n  }\n\n  &.muted {\n    .volume-level { background: transparent; }\n    .volume-icon { background: rgba(239, 68, 68, 0.4); }\n  }\n\n  &:not(.active) {\n    .volume-level { background: transparent; border-color: rgba(239, 68, 68, 0.4); }\n    .volume-icon { color: rgba(239, 68, 68, 0.6); }\n  }\n}\n\n/* ============================================================\n   VIDEO EMBEDDED / FULLSCREEN\n   ============================================================ */\n\n.remote-picture { display: none !important; }\n\n.video-chat-embedded {\n  align-items: center;\n  position: relative;\n  flex: 1;\n  margin: 0;\n  width: 100%;\n  height: 100%;\n\n  &.active {\n    /* Kept for backwards compatibility if needed */\n  }\n\n  .text-center { transform: translateY(-50px); }\n}\n\n.fullscreen {\n  background: transparent;\n  top: 0 !important;\n  left: 0; right: 0; bottom: 0;\n\n  .tools { bottom: 105px; }\n}\n\n.OT_widget-container { z-index: 5; }\n\n/* ============================================================\n   START CALL / COMMON BUTTONS\n   ============================================================ */\n\n.start-call {\n  width: auto !important;\n  @media (max-width: @screen-xs-max) { width: 100%; }\n}\n\n/* ============================================================\n   CHAT INPUT (bottom of right column)\n   ============================================================ */\n\n.chat-input {\n  flex-shrink: 0;\n  padding: 12px;\n  border-top: 1px solid var(--border);\n  background: var(--surface);\n\n  .input-group {\n    display: flex;\n    gap: 8px;\n\n    .form-control {\n      flex: 1;\n      border-radius: var(--radius-md) !important;\n    }\n\n    .input-group-btn {\n      flex: 0 0 auto;\n\n      .btn {\n        border-radius: var(--radius-md) !important;\n        background: var(--primary-color);\n        color: white;\n        border: none;\n        font-size: 13px;\n        font-weight: 500;\n        height: 36px;\n        padding: 0 14px;\n        cursor: pointer;\n        transition: background var(--transition-fast);\n\n        &:hover { background: var(--primary-hover); }\n      }\n    }\n  }\n}\n\n/* ============================================================\n   CAMERA INPUT (hidden file input)\n   ============================================================ */\n\n.camera-input {\n  width: 0.1px; height: 0.1px;\n  opacity: 0; overflow: hidden;\n  position: absolute; z-index: -1;\n}\n\n.camera-input-label { display: inline-block; }\n.camera-input, .camera-input-label { cursor: pointer; }\n.camera-input:focus + label { outline: 2px solid var(--primary-color); }\n.camera-input + label * { pointer-events: none; }\n\n.flexCenter {\n  display: flex;\n  align-items: center;\n}\n\n/* ============================================================\n   AUDIO REQUEST MODAL\n   ============================================================ */\n\n.audio-request-modal {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.1); /* Very light background so the glass pops out */\n  top: 0; bottom: 0; right: 0; left: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .content {\n    background: rgba(255, 255, 255, 0.25);\n    backdrop-filter: blur(25px) saturate(200%);\n    -webkit-backdrop-filter: blur(25px) saturate(200%);\n    border: 1px solid rgba(255, 255, 255, 0.4);\n    border-top: 1px solid rgba(255, 255, 255, 0.8);\n    border-left: 1px solid rgba(255, 255, 255, 0.8);\n    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.25);\n    border-radius: 20px;\n    padding: 32px;\n    max-width: 420px;\n    width: 90%;\n    position: relative;\n    text-align: center;\n\n    .close-icon {\n      position: absolute;\n      top: 16px;\n      right: 16px;\n      cursor: pointer;\n      color: rgba(0, 0, 0, 0.4);\n      font-size: 20px;\n      &:hover { color: rgba(0, 0, 0, 0.8); }\n    }\n\n    h3 {\n      color: #1d1d1f;\n      font-size: 20px;\n      margin-top: 0;\n      margin-bottom: 12px;\n      font-weight: 600;\n      line-height: 1.3;\n    }\n\n    p {\n      color: #374151;\n      font-size: 15px;\n      line-height: 1.5;\n      margin-bottom: 24px;\n    }\n  }\n\n  .buttons {\n    display: flex;\n    justify-content: center;\n    gap: 12px;\n\n    button {\n      padding: 12px 24px;\n      border-radius: 12px;\n      font-weight: 600;\n      font-size: 15px;\n      border: none;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      backdrop-filter: blur(5px);\n      -webkit-backdrop-filter: blur(5px);\n    }\n\n    .lh-btn-primary {\n      background: rgba(0, 122, 255, 0.85);\n      color: white;\n      box-shadow: 0 4px 12px rgba(0, 122, 255, 0.2);\n      border: 1px solid rgba(255, 255, 255, 0.3);\n      &:hover { background: rgba(0, 98, 204, 0.95); transform: translateY(-1px); }\n      &:active { transform: translateY(1px); }\n    }\n\n    .lh-btn-default {\n      background: rgba(255, 255, 255, 0.4);\n      color: #1d1d1f;\n      border: 1px solid rgba(255, 255, 255, 0.5);\n      &:hover { background: rgba(255, 255, 255, 0.6); }\n      &:active { background: rgba(255, 255, 255, 0.8); }\n    }\n  }\n\n  @media (max-width: @screen-xs-max) {\n    .content { padding: 24px; }\n    .buttons { flex-direction: column; width: 100%; gap: 10px; }\n    .buttons button { width: 100%; margin: 0; }\n  }\n}\n\n/* ============================================================\n   VIDEO CHAT ERROR STATE\n   ============================================================ */\n\n.video-chat-error {\n  font-size: 16px;\n  padding: 40px 30px;\n  text-align: center;\n  color: var(--text-secondary);\n\n  p { margin-bottom: 1em; }\n}\n\n.close-icon {\n  position: absolute;\n  top: 10px; right: 10px;\n  cursor: pointer;\n  font-size: 18px;\n  color: var(--text-secondary);\n  transition: color var(--transition-fast);\n  &:hover { color: var(--text-primary); }\n}\n\n/* ============================================================\n   RESPONSIVE BREAKPOINTS\n   ============================================================ */\n\n@media (max-width: @screen-md-max) {\n  .start-call, .btn-danger {\n    padding: 7px 12px;\n    font-size: 13px;\n    border-radius: var(--radius-md);\n  }\n}\n\n@media (max-width: @screen-xs-max) {\n  .video-chat-header {\n    flex-wrap: wrap;\n    padding: 10px 12px;\n    gap: 8px;\n\n    .customer-single-element { min-width: auto; }\n\n    .avatar {\n      font-size: 10px;\n      width: 32px; height: 32px;\n      line-height: 32px;\n      border-radius: 16px;\n    }\n\n    .customer-sub-title {\n      font-size: 13px;\n      margin: 0; padding: 0;\n      margin-bottom: 2px;\n    }\n  }\n}\n","/* line 3, ../sass/_offline-theme-base-indicator.sass */\n.offline-ui, .offline-ui *, .offline-ui::before, .offline-ui::after, .offline-ui *::before, .offline-ui *::after {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n/* line 6, ../sass/_offline-theme-base-indicator.sass */\n.offline-ui {\n  display: none;\n  position: fixed;\n  background: white;\n  z-index: 2000;\n  display: inline-block;\n}\n\n/* line 13, ../sass/_offline-theme-base-indicator.sass */\n.offline-ui .offline-ui-retry {\n  display: none;\n}\n\n/* line 16, ../sass/_offline-theme-base-indicator.sass */\n.offline-ui .offline-ui-up {\n  display: block;\n}\n\n/* line 19, ../sass/_offline-theme-base-indicator.sass */\n.offline-ui .offline-ui-down {\n  display: block;\n}\n\n/* line 8, ../sass/offline-theme-chrome-indicator.sass */\n.offline-ui {\n  -webkit-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);\n  -moz-box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);\n  -webkit-border-radius: 4px 4px 0 0;\n  -moz-border-radius: 4px 4px 0 0;\n  -ms-border-radius: 4px 4px 0 0;\n  -o-border-radius: 4px 4px 0 0;\n  font-family: \"Lucida Grande\", sans-serif;\n  font-size: 12px;\n  padding: 7px;\n  background: #f6f6f6;\n  color: #888;\n  left: 0;\n  bottom: 80px;\n  border-radius: 0 4px 4px 0;\n\n  @media (max-width: @screen-xs-max) {\n\tbottom: auto !important;\n\ttop: 0 !important;\n\tborder-radius: 0 0 4px 4px !important;\n\tleft: 55px !important;\n\tright: auto;\n  }\n}\n\n/* line 19, ../sass/offline-theme-chrome-indicator.sass */\n.offline-ui .offline-ui-content {\n  padding-left: 16px;\n}\n\n/* line 22, ../sass/offline-theme-chrome-indicator.sass */\n.offline-ui .offline-ui-up .offline-ui-content::after {\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  border-radius: 50%;\n  content: \" \";\n  display: block;\n  position: absolute;\n  top: 0;\n  bottom: 1px;\n  left: 8px;\n  margin: 10px auto;\n  height: 9px;\n  width: 9px;\n}\n\n/* line 22, ../sass/offline-theme-chrome-indicator.sass */\n.offline-ui .offline-ui-down .offline-ui-content::after {\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  border-radius: 50%;\n  content: \" \";\n  display: block;\n  position: absolute;\n  top: 0;\n  bottom: 1px;\n  left: 8px;\n  margin: 10px auto;\n  height: 9px;\n  width: 9px;\n}\n\n/* line 36, ../sass/offline-theme-chrome-indicator.sass */\n.offline-ui .offline-ui-up .offline-ui-content::after {\n  background: #80d580;\n}\n\n/* line 41, ../sass/offline-theme-chrome-indicator.sass */\n.offline-ui .offline-ui-down .offline-ui-content::after {\n  background: #ec8787;\n}\n\n/* line 19, ../sass/offline-theme-chrome-indicator.sass */\n.offline-ui .member-ui-content {\n  padding-left: 6px;\n  display: inline-block;\n  font-family: \"Lucida Grande\", sans-serif;\n}\n","/* line 5, ../sass/offline-language-german-indicator.sass */\n.offline-ui .offline-ui-up .offline-ui-content::before {\n  content: \"Online\";\n}\n/* line 10, ../sass/offline-language-german-indicator.sass */\n.offline-ui .offline-ui-down .offline-ui-content::before {\n  content: \"Offline\";\n}\n","/* ============================================================\n   ORDER SIDEBAR (Left Column)\n   Modern dark nav style matching the mockup\n   ============================================================ */\n\n.inner-middle {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.order-sidebar {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding: 0;\n  background: transparent;\n  text-align: left;\n  width: 100%;\n  scrollbar-width: thin;\n  scrollbar-color: var(--surface-3) transparent;\n\n  &::-webkit-scrollbar { width: 4px; }\n  &::-webkit-scrollbar-track { background: transparent; }\n  &::-webkit-scrollbar-thumb { background: var(--surface-3); border-radius: 4px; }\n\n  .orders-wrapper {\n    overflow-y: auto;\n    padding: 0 8px;\n    height: 100%;\n\n    a {\n      display: block;\n      &:hover, &:focus, &:active { text-decoration: none; }\n    }\n  }\n\n  .orders {\n    list-style: none;\n    padding: 0; margin: 0;\n  }\n\n  /* \"Alle Ereignisse\" button at top */\n  .order.all-events {\n    margin-bottom: 8px;\n\n    .text {\n      display: block;\n      padding: 9px 14px;\n      border-radius: var(--radius-md);\n      font-size: 13px;\n      font-weight: 600;\n      cursor: pointer;\n      width: 100%;\n      color: var(--text-secondary);\n      background: transparent;\n      border: 1px solid transparent;\n      transition: all var(--transition-fast);\n    }\n\n    &.active .text,\n    &:hover .text {\n      color: var(--text-primary);\n      background: rgba(59, 130, 246, 0.12);\n      border-color: rgba(59, 130, 246, 0.3);\n    }\n  }\n\n  /* Section heading */\n  h4 {\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--text-muted);\n    padding: 16px 14px 8px;\n    margin: 0;\n\n    a, small {\n      font-size: 10px;\n      color: var(--text-muted);\n      font-weight: 500;\n      text-transform: none;\n      letter-spacing: 0;\n      margin-left: 6px;\n      transition: color var(--transition-fast);\n      &:hover { color: var(--text-secondary); }\n    }\n  }\n\n  /* Individual project items */\n  .order {\n    margin-bottom: 2px;\n    display: flex;\n    align-items: center;\n\n    .text {\n      flex: 1;\n      padding: 8px 14px;\n      border-radius: var(--radius-md);\n      font-size: 13px;\n      font-weight: 400;\n      cursor: pointer;\n      color: var(--text-secondary);\n      background: transparent;\n      border: 1px solid transparent;\n      transition: all var(--transition-fast);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    &.over .text {\n      color: var(--success-color);\n      background: var(--success-glow);\n    }\n\n    &.active .text,\n    &:hover .text {\n      color: var(--text-primary);\n      background: rgba(59, 130, 246, 0.1);\n      border-color: rgba(59, 130, 246, 0.25);\n      text-decoration: none;\n    }\n\n    i.finish {\n      flex: 0 0 20px;\n      color: var(--success-color);\n      opacity: 0.4;\n      margin-left: 4px;\n      font-size: 12px;\n      transition: opacity var(--transition-fast);\n\n      &:hover { opacity: 1; }\n\n      &.active {\n        opacity: 0.2;\n        &:hover, &:active, &:focus { opacity: 1; }\n      }\n    }\n  }\n}\n\n/* ── New project input ── */\n.new-order {\n  margin: 12px 14px 0;\n  padding: 9px 14px;\n  font-size: 13px;\n  font-family: 'Inter', sans-serif;\n  color: var(--text-primary);\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  width: calc(100% - 28px);\n  box-sizing: border-box;\n  transition: border-color var(--transition-fast);\n\n  &:focus {\n    outline: none;\n    border-color: var(--primary-color);\n    box-shadow: 0 0 0 3px var(--primary-glow);\n  }\n\n  &::placeholder, &::-webkit-input-placeholder {\n    color: var(--text-muted);\n  }\n}\n\n/* ── Order header (inside right panel when order is selected) ── */\n.order-header {\n  border-bottom: 1px solid var(--border);\n  padding: 14px 16px;\n  flex-shrink: 0;\n  background: var(--surface);\n}\n\n.order-header-title {\n  text-align: left;\n  margin: 0; padding: 0;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  color: var(--text-primary);\n\n  > *:not(:first-child) { padding-left: 7px; }\n\n  @media (max-width: @screen-sm-max) { font-size: 13px; }\n}\n\n.order-header-button { margin-left: 16px; }\n\n.order-header-mobile {\n  padding: 5px;\n  border-bottom: 1px solid var(--border);\n  display: none;\n}\n\n.order-header-back,\n.order-header-mobile-toggle,\n.order-sidebar-toggle {\n  font-size: 24px;\n  color: var(--text-secondary);\n  margin-right: 16px;\n  cursor: pointer;\n  display: none;\n\n  &:hover, &:focus, &:active {\n    text-decoration: none;\n    color: var(--text-primary);\n  }\n}\n\n.order-sidebar-toggle { right: 15px; }\n\n.order-header-close {\n  position: absolute;\n  color: var(--text-secondary);\n  right: 16px; top: 12px;\n  font-size: 24px;\n  cursor: pointer;\n  border-radius: var(--radius-md);\n  border: none;\n  background: transparent;\n  transition: all var(--transition-fast);\n\n  &:active, &:focus, &:hover {\n    color: var(--text-primary);\n    background: var(--surface-2);\n  }\n}\n\n.order-rename-form {\n  display: flex;\n\n  .form-group { margin-bottom: 0; }\n\n  button { margin-left: 8px; }\n}\n\n.order-header-mobile-toggle { font-size: 28px; }\n\n/* ── Responsive: slide-out sidebar on mobile ── */\n@media (max-width: @screen-sm-max) {\n  .order-sidebar {\n    transform: translateX(-300px);\n    flex: 0;\n    position: absolute;\n    padding-top: 5px;\n    background: var(--surface);\n    border-right: 1px solid var(--border);\n    height: 100%;\n    z-index: 100;\n    transition: transform var(--transition-normal);\n\n    &.active { transform: translateX(0); }\n  }\n\n  .order-sidebar-wrapper {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 200px;\n  }\n\n  .order-sidebar-toggle {\n    align-self: flex-end;\n    transform: translateX(30px);\n    padding-bottom: 5px;\n  }\n\n  .order-header-mobile {\n    display: block;\n    z-index: 1;\n    background: var(--surface);\n  }\n\n  .order-header-back,\n  .order-header-mobile-toggle,\n  .order-sidebar-toggle { display: inline-block; }\n\n  .order-header-close { display: none; }\n}\n","// .action-button {\n//     display: block;\n//   .gradient_blue();\n//   color: #fff;\n//   .Lato;\n//   width: 100%;\n//   text-align: center;\n//   border: 0 none;\n//   padding: 20px 20px; // !important;\n//   .roundcorners;\n//   cursor: pointer;\n//   position: relative;\n//   outline: none;\n//   &.top {\n//     margin-top: 30px;\n//     width: 250px;\n//     margin-bottom: 50px;\n//     display: block;\n//     line-height: 1.3;\n//     border-radius: 6px;\n//     color: #fff;\n//     background-color: #26A7DF !important;\n//     text-align: center;\n//     text-decoration: none!important;\n//     background : -webkit-linear-gradient(top, #26A7DF, #1494E0) !important;\n//      &:hover{\n//        color: white;\n//      }\n//   }\n//   &:before {\n//     position: absolute;\n//     z-index: 3;\n//     height: 15px;\n//     left: 0;\n//     bottom: 0;\n//     width: 100%;\n//     display: inline-block;\n//     margin-bottom: -15px;\n//     background: rgba(179,179,179,0.58);\n//     background: -moz-linear-gradient(top, rgba(179,179,179,0.58) 0%, rgba(255,255,255,0) 100%);\n//     background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(179,179,179,0.58)), color-stop(100%, rgba(255,255,255,0)));\n//     background: -webkit-linear-gradient(top, rgba(179,179,179,0.58) 0%, rgba(255,255,255,0) 100%);\n//     background: -o-linear-gradient(top, rgba(179,179,179,0.58) 0%, rgba(255,255,255,0) 100%);\n//     background: -ms-linear-gradient(top, rgba(179,179,179,0.58) 0%, rgba(255,255,255,0) 100%);\n//     background: linear-gradient(to bottom, rgba(179,179,179,0.58) 0%, rgba(255,255,255,0) 100%);\n//     filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#b3b3b3', endColorstr='#ffffff', GradientType=0 );\n//     content: '';\n//\n//   }\n//\n//   &:hover, &:focus {\n//     background: lighten(#51A8E1, 5%);\n//     color: darken(#fff, 5%);\n//     text-decoration: none;\n//   }\n//\n//   &.klein {\n//     width: auto;\n//     padding-left: 25px;\n//     padding-right: 25px;\n//   }\n//   span{ margin-right: 15px;}\n// }\n\n.inner-shadow (@x: 0, @y: 0, @blur: 0, @spread: 1.5px, @alpha: 0.25) {\n\t-webkit-box-shadow: inset @x @y @blur @spread rgba(0, 0, 0, @alpha);\n\t-moz-box-shadow:    inset @x @y @blur @spread rgba(0, 0, 0, @alpha);\n\tbox-shadow:         inset @x @y @blur @spread rgba(0, 0, 0, @alpha);\n}\n\n.lh-btn {\n    font-family: \"Lato\", sans-serif;\n    display: inline-block;\n    align-items: center;\n    width: auto;\n    font-size: 14px;\n    padding: 15px 25px !important;\n    &::before {\n        display: none !important;\n    }\n    // .inner-shadow() !important;\n\n    text-transform: uppercase;\n    // line-height: 1.4em;\n    border-radius: 3px;\n    border: none;\n    text-align: center;\n    text-decoration: none;\n    &:hover, &:focus, &:active {\n      text-decoration: none;\n    }\n    &>*:not(:first-child) {\n        padding-left: 5px;\n    }\n}\n\n.lh-btn-flex {\n  display: flex;\n}\n\n.lh-btn-default {\n\tbackground-color: var(--surface-color);\n  \tbackground: var(--surface-color);\n  \tcolor: var(--text-primary);\n  \tborder: 1px solid var(--border-color);\n  \t&:hover{\n    \tcolor: var(--text-primary);\n        filter: brightness(1.2);\n  \t}\n}\n\n.lh-btn-primary {\n  \tbackground-color: #26A7DF !important;\n  \tbackground : -webkit-linear-gradient(top, #26A7DF, #1494E0) !important;\n  \tcolor: #fff;\n  \t&:hover{\n    \tcolor: #eee;\n  \t}\n  \t&:disabled{\n\t  color: #dedede;\n\t}\n}\n\n.lh-btn-warning {\n  background-color: #26A7DF !important;\n  background : -webkit-linear-gradient(top, lighten(@active-red, 5%), @active-red) !important;\n  color: #fff;\n  &:hover{\n    color: #eee;\n  }\n}\n\n.lh-btn-small {\n    padding: 11px 12px !important;\n    font-size: 12px;\n}\n\n.lh-btn-extra-small {\n    font-size: 10px !important;\n}\n\n// .lh-btn-small {\n//     font-family: \"Lato\", sans-serif;\n//     display: inline-block !important;\n//     text-transform: uppercase;\n//     width: auto !important;\n//     font-size: 13px !important;\n//     font-weight: bold;\n//     padding: 13px 35px !important;\n//     &::before {\n//         display: none !important;\n//     }\n//     .gradient() !important;\n//     .inner-shadow() !important;\n// }\n\n.lh-btn-block {\n\t// display: flex;\n  width: 100%;\n}\n\n.lh-button-event-list-call-end {\n    max-height: 44px !important;\n    padding: 0 12px !important;\n}\n","/**\n * React Select\n * ============\n * Created by Jed Watson and Joss Mackison for KeystoneJS, http://www.keystonejs.com/\n * https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n * MIT License: https://github.com/JedWatson/react-select\n*/\n.Select {\n  position: relative;\n}\n.Select,\n.Select div,\n.Select input,\n.Select span {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.Select.is-disabled > .Select-control {\n  background-color: #f9f9f9;\n}\n.Select.is-disabled > .Select-control:hover {\n  box-shadow: none;\n}\n.Select.is-disabled .Select-arrow-zone {\n  cursor: default;\n  pointer-events: none;\n}\n.Select-control {\n  background-color: #fff;\n  border-color: #d9d9d9 #ccc #b3b3b3;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  color: #333;\n  cursor: default;\n  display: table;\n  border-spacing: 0;\n  border-collapse: separate;\n  height: 36px;\n  outline: none;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.Select-control:hover {\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n}\n.Select-control .Select-input:focus {\n  outline: none;\n}\n.is-searchable.is-open > .Select-control {\n  cursor: text;\n}\n.is-open > .Select-control {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  background: #fff;\n  border-color: #b3b3b3 #ccc #d9d9d9;\n}\n.is-open > .Select-control > .Select-arrow {\n  border-color: transparent transparent #999;\n  border-width: 0 5px 5px;\n}\n.is-searchable.is-focused:not(.is-open) > .Select-control {\n  cursor: text;\n}\n.is-focused:not(.is-open) > .Select-control {\n  border-color: #007eff;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1);\n}\n.Select-placeholder,\n.Select--single > .Select-control .Select-value {\n  bottom: 0;\n  color: #aaa;\n  left: 0;\n  line-height: 34px;\n  padding-left: 10px;\n  padding-right: 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.has-value.Select--single > .Select-control .Select-value .Select-value-label,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label {\n  color: #333;\n}\n.has-value.Select--single > .Select-control .Select-value a.Select-value-label,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label {\n  cursor: pointer;\n  text-decoration: none;\n}\n.has-value.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:hover,\n.has-value.Select--single > .Select-control .Select-value a.Select-value-label:focus,\n.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:focus {\n  color: #007eff;\n  outline: none;\n  text-decoration: underline;\n}\n.Select-input {\n  height: 34px;\n  padding-left: 10px;\n  padding-right: 10px;\n  vertical-align: middle;\n}\n.Select-input > input {\n  width: 100%;\n  background: none transparent;\n  border: 0 none;\n  box-shadow: none;\n  cursor: default;\n  display: inline-block;\n  font-family: inherit;\n  font-size: inherit;\n  margin: 0;\n  outline: none;\n  line-height: 14px;\n  /* For IE 8 compatibility */\n  padding: 8px 0 12px;\n  /* For IE 8 compatibility */\n  -webkit-appearance: none;\n}\n.is-focused .Select-input > input {\n  cursor: text;\n}\n.has-value.is-pseudo-focused .Select-input {\n  opacity: 0;\n}\n.Select-control:not(.is-searchable) > .Select-input {\n  outline: none;\n}\n.Select-loading-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 16px;\n}\n.Select-loading {\n  -webkit-animation: Select-animation-spin 400ms infinite linear;\n  -o-animation: Select-animation-spin 400ms infinite linear;\n  animation: Select-animation-spin 400ms infinite linear;\n  width: 16px;\n  height: 16px;\n  box-sizing: border-box;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n  border-right-color: #333;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n}\n.Select-clear-zone {\n  -webkit-animation: Select-animation-fadeIn 200ms;\n  -o-animation: Select-animation-fadeIn 200ms;\n  animation: Select-animation-fadeIn 200ms;\n  color: #999;\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 17px;\n}\n.Select-clear-zone:hover {\n  color: #D0021B;\n}\n.Select-clear {\n  display: inline-block;\n  font-size: 18px;\n  line-height: 1;\n}\n.Select--multi .Select-clear-zone {\n  width: 17px;\n}\n.Select-arrow-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 25px;\n  padding-right: 5px;\n}\n.Select-arrow {\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 2.5px;\n  display: inline-block;\n  height: 0;\n  width: 0;\n}\n.is-open .Select-arrow,\n.Select-arrow-zone:hover > .Select-arrow {\n  border-top-color: #666;\n}\n.Select--multi .Select-multi-value-wrapper {\n  display: inline-block;\n}\n.Select .Select-aria-only {\n  display: inline-block;\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  clip: rect(0, 0, 0, 0);\n  overflow: hidden;\n}\n@-webkit-keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.Select-menu-outer {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-top-color: #e6e6e6;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: -1px;\n  max-height: 200px;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 1;\n  -webkit-overflow-scrolling: touch;\n}\n.Select-menu {\n  max-height: 198px;\n  overflow-y: auto;\n}\n.Select-option {\n  box-sizing: border-box;\n  background-color: #fff;\n  color: #666666;\n  cursor: pointer;\n  display: block;\n  padding: 8px 10px;\n}\n.Select-option:last-child {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.Select-option.is-selected {\n  background-color: #f5faff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.04);\n  color: #333;\n}\n.Select-option.is-focused {\n  background-color: #ebf5ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.08);\n  color: #333;\n}\n.Select-option.is-disabled {\n  color: #cccccc;\n  cursor: default;\n}\n.Select-noresults {\n  box-sizing: border-box;\n  color: #999999;\n  cursor: default;\n  display: block;\n  padding: 8px 10px;\n}\n.Select--multi .Select-input {\n  vertical-align: middle;\n  margin-left: 10px;\n  padding: 0;\n}\n.Select--multi.has-value .Select-input {\n  margin-left: 5px;\n}\n.Select--multi .Select-value {\n  background-color: #ebf5ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.08);\n  border-radius: 2px;\n  border: 1px solid #c2e0ff;\n  /* Fallback color for IE 8 */\n  border: 1px solid rgba(0, 126, 255, 0.24);\n  color: #007eff;\n  display: inline-block;\n  font-size: 0.9em;\n  line-height: 1.4;\n  margin-left: 5px;\n  margin-top: 5px;\n  vertical-align: top;\n}\n.Select--multi .Select-value-icon,\n.Select--multi .Select-value-label {\n  display: inline-block;\n  vertical-align: middle;\n}\n.Select--multi .Select-value-label {\n  border-bottom-right-radius: 2px;\n  border-top-right-radius: 2px;\n  cursor: default;\n  padding: 2px 5px;\n}\n.Select--multi a.Select-value-label {\n  color: #007eff;\n  cursor: pointer;\n  text-decoration: none;\n}\n.Select--multi a.Select-value-label:hover {\n  text-decoration: underline;\n}\n.Select--multi .Select-value-icon {\n  cursor: pointer;\n  border-bottom-left-radius: 2px;\n  border-top-left-radius: 2px;\n  border-right: 1px solid #c2e0ff;\n  /* Fallback color for IE 8 */\n  border-right: 1px solid rgba(0, 126, 255, 0.24);\n  padding: 1px 5px 3px;\n}\n.Select--multi .Select-value-icon:hover,\n.Select--multi .Select-value-icon:focus {\n  background-color: #d8eafd;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 113, 230, 0.08);\n  color: #0071e6;\n}\n.Select--multi .Select-value-icon:active {\n  background-color: #c2e0ff;\n  /* Fallback color for IE 8 */\n  background-color: rgba(0, 126, 255, 0.24);\n}\n.Select--multi.is-disabled .Select-value {\n  background-color: #fcfcfc;\n  border: 1px solid #e3e3e3;\n  color: #333;\n}\n.Select--multi.is-disabled .Select-value-icon {\n  cursor: not-allowed;\n  border-right: 1px solid #e3e3e3;\n}\n.Select--multi.is-disabled .Select-value-icon:hover,\n.Select--multi.is-disabled .Select-value-icon:focus,\n.Select--multi.is-disabled .Select-value-icon:active {\n  background-color: #fcfcfc;\n}\n@keyframes Select-animation-spin {\n  to {\n    transform: rotate(1turn);\n  }\n}\n@-webkit-keyframes Select-animation-spin {\n  to {\n    -webkit-transform: rotate(1turn);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
